// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"gwEZR":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "ktRd5": "dataWorker.e52b883c.js",
    "fKZxD": "raptorWorker.fd0407c6.js",
    "lkrLs": "bus-tiny.3fbef928.png",
    "1mZqJ": "stop.43e1f1bb.png",
    "eVywM": "stop-end.6bca41b1.png",
    "d20QM": "stop-active.94018e5c.png",
    "bEn0N": "passing-routes-blue.073957f1.svg",
    "kOgQG": "icon.cb61c99c.svg",
    "5wan8": "bus-tiny-map.c41183e0.png",
    "73tV7": "metro-station-sdf.5f09cbd1.svg",
    "6BQE0": "rail-station.f40036eb.svg",
    "djSW0": "monorail-station.08e55645.svg",
    "3cARN": "service-worker.js"
});

},{}],"iC1JR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _i18N = require("./i18n");
var _theme = require("./utils/theme");
var _config = require("./config");
var _cityConfig = require("./city-config");
var _normalizeNames = require("./utils/normalizeNames");
var _search = require("./utils/search");
var _geometry = require("./utils/geometry");
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _maplibreGl = require("maplibre-gl");
var _maplibreGlDefault = parcelHelpers.interopDefault(_maplibreGl);
var _polyline = require("@mapbox/polyline");
var _cheapRuler = require("cheap-ruler");
var _cheapRulerDefault = parcelHelpers.interopDefault(_cheapRuler);
var _reactI18Next = require("react-i18next");
var _workerClient = require("./utils/workerClient");
var _parsePoisCsv = require("./utils/parsePoisCsv");
var _geocode = require("./utils/geocode");
var _specialID = require("./utils/specialID");
var _raptor = require("./utils/raptor");
var _raptorWorkerClient = require("./utils/raptorWorkerClient");
var _bus = require("./utils/bus");
var _fetchCache = require("./utils/fetchCache");
var _fetchCacheDefault = parcelHelpers.interopDefault(_fetchCache);
var _getRoute = require("./utils/getRoute");
var _getRouteDefault = parcelHelpers.interopDefault(_getRoute);
var _fetchArrivals = require("./utils/fetchArrivals");
var _getWalkingMinutes = require("./utils/getWalkingMinutes");
var _getWalkingMinutesDefault = parcelHelpers.interopDefault(_getWalkingMinutes);
var _usePrevious = require("./utils/usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _fetchVehicles = require("./utils/fetchVehicles");
var _vehicleLookup = require("./utils/vehicleLookup");
var _vehicleChip = require("./components/VehicleChip");
var _vehicleChipDefault = parcelHelpers.interopDefault(_vehicleChip);
var _vehiclePanel = require("./components/VehiclePanel");
var _vehiclePanelDefault = parcelHelpers.interopDefault(_vehiclePanel);
var _rafInterval = require("./utils/rafInterval");
var _metricsPage = require("./utils/metricsPage");
var _mobilePane = require("./utils/mobilePane");
var _mapOptimizations = require("./utils/mapOptimizations");
var _boundedNearest = require("./utils/boundedNearest");
var _searchLimits = require("./utils/searchLimits");
var _busServicesArrival = require("./components/BusServicesArrival");
var _busServicesArrivalDefault = parcelHelpers.interopDefault(_busServicesArrival);
var _closeControl = require("./components/CloseControl");
var _geolocateControl = require("./components/GeolocateControl");
var _geolocateControlDefault = parcelHelpers.interopDefault(_geolocateControl);
var _betweenRoutes = require("./components/BetweenRoutes");
var _betweenRoutesDefault = parcelHelpers.interopDefault(_betweenRoutes);
var _scrollableContainer = require("./components/ScrollableContainer");
var _scrollableContainerDefault = parcelHelpers.interopDefault(_scrollableContainer);
var _stopsListJsx = require("./components/StopsList.jsx");
var _stopsListJsxDefault = parcelHelpers.interopDefault(_stopsListJsx);
var _liveDataIndicatorJsx = require("./components/LiveDataIndicator.jsx");
var _liveDataIndicatorJsxDefault = parcelHelpers.interopDefault(_liveDataIndicatorJsx);
var _stopPng = require("./images/stop.png");
var _stopPngDefault = parcelHelpers.interopDefault(_stopPng);
var _stopEndPng = require("./images/stop-end.png");
var _stopEndPngDefault = parcelHelpers.interopDefault(_stopEndPng);
var _stopActivePng = require("./images/stop-active.png");
var _stopActivePngDefault = parcelHelpers.interopDefault(_stopActivePng);
var _passingRoutesBlueSvg = require("./images/passing-routes-blue.svg");
var _passingRoutesBlueSvgDefault = parcelHelpers.interopDefault(_passingRoutesBlueSvg);
var _iconSvg = require("../icons/icon.svg");
var _iconSvgDefault = parcelHelpers.interopDefault(_iconSvg);
var _busTinyMapPng = require("./images/bus-tiny-map.png");
var _busTinyMapPngDefault = parcelHelpers.interopDefault(_busTinyMapPng);
var _metroStationSdfSvg = require("./images/metro-station-sdf.svg");
var _metroStationSdfSvgDefault = parcelHelpers.interopDefault(_metroStationSdfSvg);
var _railStationSvg = require("./images/rail-station.svg");
var _railStationSvgDefault = parcelHelpers.interopDefault(_railStationSvg);
var _monorailStationSvg = require("./images/monorail-station.svg");
var _monorailStationSvgDefault = parcelHelpers.interopDefault(_monorailStationSvg);
let city = (0, _config.getCurrentCity)();
if (city === 'all' && !(0, _cityConfig.isAlphaEnabled)()) {
    // #/all is an alpha feature — softlock it behind the same flag as other alpha features
    location.hash = `/${0, _config.DEFAULT_CITY}`;
    city = (0, _config.DEFAULT_CITY);
}
const IS_ALL_MODE = city === 'all';
const dataPath = `/data/${city}`;
const routesJSONPath = `${dataPath}/routes.min.json`;
const stopsJSONPath = `${dataPath}/stops.min.json`;
const servicesJSONPath = `${dataPath}/services.min.json`;
const railJSONPath = `${dataPath}/rail.json`;
const $map = document.getElementById('map');
const STORE = {};
// All-mode: keyed by city code, holds loaded city data and tracks loading state
const cityDataMap = new Map();
const loadedCities = new Set();
const loadingCities = new Set();
const loadCityPromises = new Map(); // cityCode → Promise — allows callers to await an in-progress load
let onCityLoadedCallback = null; // set by App component to refresh search after a city loads
let onCityUnloadedCallback = null; // set by App component to refresh search after a city unloads
const activeSelectionCities = new Set();
// All-mode: city code → { lowerLat, upperLat, lowerLong, upperLong } computed from that
// city's actual stops.min.json extent (+ 4km buffer), populated by preindexAllCities.
// Used instead of the hand-authored CITY_CONFIGS bounds so the viewport-overlap check
// reflects real stop coverage rather than a manually maintained bbox.
const cityStopsBounds = new Map();
// Flat search indices populated as cities load — searched client-side in all-mode
const allModeServicesIdx = []; // { number, name, city }
const allModeStopsIdx = []; // { number, name, suffix, city }
const allModePoisIdx = []; // { id, name, type, lat, lon, color, city } — alpha "locations" feature
// Adjacent/overlapping cities' pois.csv commonly share the same real-world POI
// (each is independently queried from OSM over its own padded bbox), so
// de-dupe by coordinate when merging into the cross-city index.
const allModePoisSeen = new Set();
const indexedCities = new Set();
const indexedPoiCities = new Set();
let allModeSearchListCache = null;
const pushAllModePois = (pois, cityCode)=>{
    pois.forEach((poi, i)=>{
        const key = locationKey(poi.lat, poi.lon);
        if (allModePoisSeen.has(key)) return;
        allModePoisSeen.add(key);
        allModePoisIdx.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, poi), {
            id: `${cityCode}-${i}`,
            city: cityCode
        }));
    });
};
// Both all-mode load paths (the full per-city load in loadCity, and the
// lightweight name-only preindexAllCities) need the same "have we already
// indexed this city's services/stops/pois" dedup-and-push, just from
// differently-shaped source data (full stop/service objects vs raw JSON
// keyed by number) — this is the one shared entry point for both.
const AllModeIndex = {
    hasCity: (cityCode)=>indexedCities.has(cityCode),
    hasPois: (cityCode)=>indexedPoiCities.has(cityCode),
    addCity: (cityCode, { services, stops, pois } = {})=>{
        if (!AllModeIndex.hasCity(cityCode)) {
            services === null || services === void 0 ? void 0 : services.forEach(({ number, name })=>{
                allModeServicesIdx.push({
                    number,
                    name: name || '',
                    city: cityCode
                });
            });
            stops === null || stops === void 0 ? void 0 : stops.forEach(({ number, name, suffix })=>{
                allModeStopsIdx.push({
                    number,
                    name: name || '',
                    suffix,
                    city: cityCode
                });
            });
            indexedCities.add(cityCode);
            allModeSearchListCache = null;
        }
        if (pois && !AllModeIndex.hasPois(cityCode)) {
            pushAllModePois(pois, cityCode);
            indexedPoiCities.add(cityCode);
        }
    }
};
// Splits a stop list (as flattened across every selected service's route
// variants) into its unique stops and the ones repeated across 2+ services
// ("intersecting" stops, i.e. shared interchange points) — an O(n) counting
// pass replacing the previous `arr.indexOf(el) === pos` + `.includes()`
// combination, which was O(n²) over what can be hundreds of stops.
const uniqueAndIntersectingStops = (arr)=>{
    const counts = new Map();
    arr.forEach((el)=>counts.set(el, (counts.get(el) || 0) + 1));
    const unique = [
        ...counts.keys()
    ];
    const intersecting = unique.filter((el)=>counts.get(el) > 1).sort();
    return {
        unique,
        intersecting
    };
};
const BREAKPOINT = ()=>window.innerWidth > 640;
// Stacking for the mobile sheets (the `zIndex` pane option in
// mobilePane.js). The stop sheet rides above whatever it takes over from;
// all stay below `.mobile-floating-footer`'s 20 (app.css).
const PANE_Z = {
    search: 10,
    base: 11,
    stop: 12
};
const supportsHover = window.matchMedia && matchMedia('(any-hover: hover)').matches;
const supportsTouch = window.matchMedia && matchMedia('(any-pointer: coarse)').matches || 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
const ruler = new (0, _cheapRulerDefault.default)(1.3);
// Pane-managed popovers are display:none (0 offsetHeight/Width) until
// CupertinoPane presents them, so map-pan/fitBounds calculations that need
// a popover's expanded size have to estimate against the pane's own
// middle-break height instead of measuring the DOM node — see
// mobilePane.js's breaks config. Falls back to the real DOM measurement on
// desktop / non-touch, where the popover is still a plain CSS floating card.
const paneOrOffsetHeight = (el)=>(0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT) ? Math.round(window.innerHeight * 0.5) : el === null || el === void 0 ? void 0 : el.offsetHeight;
// Compute closest stops across all loaded cities for all-mode (main-thread, no worker needed)
const computeAllModeClosestStops = (lng, lat)=>{
    const results = [];
    for (const [cityCode, cityData] of cityDataMap){
        if (!(cityData === null || cityData === void 0 ? void 0 : cityData.stopsDataArr)) continue;
        for (const stop of cityData.stopsDataArr){
            const dist = ruler.distance([
                lng,
                lat
            ], stop.coordinates);
            if (dist <= 5) (0, _boundedNearest.insertNearest)(results, {
                stop,
                city: cityCode,
                distance: dist
            });
        }
    }
    return results.map(({ stop, city, distance })=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, stop), {
            city,
            distance
        }));
};
// Helper to decode polylines with caching
const decodePolyline = (encoded)=>(0, _geometry.decodePolylineCached)(encoded, (0, _polyline.toGeoJSON));
const DIRECTIONS_SVG = (0, _preact.h)("svg", {
    viewBox: "0 0 24 24",
    width: "16",
    height: "16",
    fill: "currentColor",
    "aria-hidden": "true"
}, (0, _preact.h)("path", {
    d: "M21.71 11.29l-9-9a1 1 0 00-1.42 0l-9 9a1 1 0 000 1.42l9 9a1 1 0 001.42 0l9-9a1 1 0 000-1.42zM14 14.5V12h-4v3a1 1 0 01-2 0v-4a1 1 0 011-1h5V7.5a.5.5 0 01.85-.36l3.15 3.36a.5.5 0 010 .71l-3.15 3.15a.5.5 0 01-.85-.36z"
}));
const TIMETABLE_SVG = (0, _preact.h)("svg", {
    viewBox: "0 0 24 24",
    width: "15",
    height: "15",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
}, (0, _preact.h)("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
}), (0, _preact.h)("line", {
    x1: "16",
    y1: "2",
    x2: "16",
    y2: "6"
}), (0, _preact.h)("line", {
    x1: "8",
    y1: "2",
    x2: "8",
    y2: "6"
}), (0, _preact.h)("line", {
    x1: "3",
    y1: "10",
    x2: "21",
    y2: "10"
}));
function parseRouteKey(routeKey) {
    const first = routeKey.indexOf('|');
    const second = routeKey.indexOf('|', first + 1);
    if (first === -1 || second === -1) return null;
    return {
        service: routeKey.slice(0, first),
        destination: routeKey.slice(first + 1, second),
        variantIdx: routeKey.slice(second + 1)
    };
}
const serviceRoutesCache = new WeakMap();
const getServiceRoutes = (serviceData)=>{
    if (!serviceData || typeof serviceData !== 'object') return [];
    if (serviceRoutesCache.has(serviceData)) return serviceRoutesCache.get(serviceData);
    const routes = Object.entries(serviceData).filter(([key, value])=>key !== 'name' && Array.isArray(value)).flatMap(([, value])=>value);
    serviceRoutesCache.set(serviceData, routes);
    return routes;
};
const $logo = document.getElementById('logo');
// City drawer functionality
const createCityDrawer = ()=>{
    const overlay = document.createElement('div');
    overlay.id = 'city-drawer-overlay';
    const drawer = document.createElement('div');
    drawer.id = 'city-drawer';
    const handle = document.createElement('div');
    handle.className = 'drawer-handle';
    handle.innerHTML = '<span></span>';
    drawer.appendChild(handle);
    const intro = document.createElement('div');
    intro.className = 'drawer-intro';
    intro.innerHTML = `
    <h2>TransitRouter</h2>
    <p>Explore transit stops and routes across cities on an interactive map.</p>
    <p>Source code on <a href="https://github.com/Vonter/transitrouter" target="_blank">GitHub</a>. Inspired by <a href="https://busrouter.sg" target="_blank" rel="noopener">busrouter.sg</a></p>
  `;
    const divider = document.createElement('hr');
    divider.className = 'drawer-divider';
    const citiesSection = document.createElement('div');
    citiesSection.className = 'drawer-cities';
    const citiesLabel = document.createElement('p');
    citiesLabel.className = 'drawer-cities-label';
    citiesLabel.textContent = 'Regions';
    citiesSection.appendChild(citiesLabel);
    const cityList = document.createElement('ul');
    cityList.className = 'drawer-city-list';
    // "All Cities" entry at the top — alpha-gated, same flag as #/all itself
    if ((0, _cityConfig.isAlphaEnabled)()) {
        const allItem = document.createElement('li');
        allItem.className = 'drawer-city-item';
        const allFlag = document.createElement('span');
        allFlag.className = 'drawer-city-flag';
        allFlag.textContent = "\uD83D\uDDFA\uFE0F";
        allFlag.setAttribute('aria-hidden', 'true');
        const allName = document.createElement('span');
        allName.className = 'drawer-city-name';
        allName.textContent = '(Test) All Sources';
        allItem.appendChild(allFlag);
        allItem.appendChild(allName);
        allItem.onclick = ()=>{
            hideDrawer();
            location.hash = '/all/';
            if (!IS_ALL_MODE) location.reload();
        };
        cityList.appendChild(allItem);
    }
    (0, _config.AVAILABLE_CITIES).forEach((cityCode)=>{
        const cityConfig = (0, _config.getConfigForCity)(cityCode);
        const item = document.createElement('li');
        item.className = 'drawer-city-item';
        const flag = document.createElement('span');
        flag.className = 'drawer-city-flag';
        flag.textContent = cityConfig.city.flag || '';
        flag.setAttribute('aria-hidden', 'true');
        const name = document.createElement('span');
        name.className = 'drawer-city-name';
        name.textContent = cityConfig.city.name;
        item.appendChild(flag);
        item.appendChild(name);
        item.onclick = ()=>{
            hideDrawer();
            window.location.hash = `/${cityCode}/`;
            window.location.reload();
        };
        cityList.appendChild(item);
    });
    citiesSection.appendChild(cityList);
    drawer.appendChild(intro);
    drawer.appendChild(divider);
    drawer.appendChild(citiesSection);
    // Settings section
    const settingsDivider = document.createElement('hr');
    settingsDivider.className = 'drawer-divider';
    drawer.appendChild(settingsDivider);
    const settingsLabel = document.createElement('p');
    settingsLabel.className = 'drawer-cities-label';
    settingsLabel.textContent = 'Settings';
    drawer.appendChild(settingsLabel);
    const themeSection = document.createElement('div');
    themeSection.className = 'drawer-theme';
    const themeLabel = document.createElement('span');
    themeLabel.className = 'drawer-theme-label';
    themeLabel.textContent = 'Dark Mode';
    const track = document.createElement('div');
    track.className = 'theme-toggle-track';
    track.title = (0, _theme.isDark) ? 'Switch to light mode' : 'Switch to dark mode';
    track.setAttribute('role', 'switch');
    track.setAttribute('aria-checked', String((0, _theme.isDark)));
    track.setAttribute('aria-label', 'Dark Mode');
    track.tabIndex = 0;
    track.innerHTML = '<span class="theme-toggle-icons"><svg class="theme-toggle-sun" viewBox="0 0 20 20" fill="currentColor"><circle cx="10" cy="10" r="4"/><path d="M10 1v2m0 14v2M3.5 3.5l1.4 1.4m10.2 10.2l1.4 1.4M1 10h2m14 0h2M3.5 16.5l1.4-1.4m10.2-10.2l1.4-1.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg><svg class="theme-toggle-moon" viewBox="0 0 20 20" fill="currentColor"><path d="M17.3 13.3A8 8 0 0 1 6.7 2.7a8 8 0 1 0 10.6 10.6z"/></svg></span><span class="theme-toggle-thumb"></span>';
    const toggleTheme = ()=>{
        const nowDark = document.documentElement.classList.contains('dark');
        localStorage.setItem('theme', nowDark ? 'light' : 'dark');
        location.reload();
    };
    track.onclick = toggleTheme;
    track.onkeydown = (e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleTheme();
        }
    };
    themeSection.appendChild(themeLabel);
    themeSection.appendChild(track);
    drawer.appendChild(themeSection);
    // Helper: create a setting row with label + control
    const settingRow = (labelText, control, className = 'drawer-theme')=>{
        const row = document.createElement('div');
        row.className = className;
        const label = document.createElement('span');
        label.className = 'drawer-theme-label';
        label.textContent = labelText;
        row.append(label, control);
        return row;
    };
    // Helper: create a toggle switch bound to a localStorage key
    const createToggle = (key, ariaLabel, onChange)=>{
        const on = localStorage.getItem(key) === 'true';
        const track = document.createElement('div');
        track.className = 'dev-toggle-track' + (on ? ' active' : '');
        track.setAttribute('role', 'switch');
        track.setAttribute('aria-checked', String(on));
        track.setAttribute('aria-label', ariaLabel);
        track.tabIndex = 0;
        track.innerHTML = '<span class="dev-toggle-thumb"></span>';
        const toggle = ()=>{
            const nowOn = localStorage.getItem(key) === 'true';
            localStorage.setItem(key, String(!nowOn));
            track.classList.toggle('active', !nowOn);
            track.setAttribute('aria-checked', String(!nowOn));
            onChange === null || onChange === void 0 ? void 0 : onChange(!nowOn);
        };
        track.onclick = toggle;
        track.onkeydown = (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggle();
            }
        };
        return track;
    };
    // Helper: create a <select> bound to a localStorage key
    const createSelect = (key, options, fallback)=>{
        const sel = document.createElement('select');
        sel.className = 'drawer-select';
        const stored = localStorage.getItem(key) || fallback;
        options.forEach(([val, text])=>{
            const opt = document.createElement('option');
            opt.value = val;
            opt.textContent = text;
            if (val === stored) opt.selected = true;
            sel.appendChild(opt);
        });
        sel.onchange = ()=>localStorage.setItem(key, sel.value);
        return sel;
    };
    // Default City select
    const storedDefault = localStorage.getItem('defaultCity');
    const cityOptions = (0, _config.AVAILABLE_CITIES).map((code)=>{
        const cfg = (0, _config.getConfigForCity)(code);
        return [
            code,
            `${cfg.city.flag || ''} ${cfg.city.name}`
        ];
    });
    // "all" (every city combined — see IS_ALL_MODE) is an alpha feature,
    // same gate the /all/ route itself is softlocked behind (see the
    // city==='all' redirect guard near the top of this file) — offering it
    // as a default here without that gate would pick a default that then
    // immediately bounces back to FALLBACK_CITY for anyone without alpha
    // features on.
    if ((0, _cityConfig.isAlphaEnabled)()) cityOptions.unshift([
        'all',
        "\uD83C\uDF10 All"
    ]);
    cityOptions.unshift([
        'auto',
        'Automatic'
    ]);
    const citySelect = createSelect('defaultCity', cityOptions, storedDefault || 'blr');
    drawer.appendChild(settingRow('Default City', citySelect));
    // Developer Mode toggle + dev settings panel
    const devSettings = document.createElement('div');
    devSettings.className = 'drawer-dev-settings';
    devSettings.style.display = (0, _cityConfig.isDevMode)() ? '' : 'none';
    const devModeToggle = createToggle('devMode', 'Developer Mode', (on)=>{
        devSettings.style.display = on ? '' : 'none';
        if (!on) {
            localStorage.removeItem('disableApi');
            localStorage.removeItem('refreshInterval');
            localStorage.removeItem('alphaFeatures');
        }
    });
    drawer.appendChild(settingRow('Developer Mode', devModeToggle));
    // Dev-only settings
    devSettings.appendChild(settingRow('Alpha Features', createToggle('alphaFeatures', 'Alpha Features (Not recommended)'), 'drawer-theme drawer-dev-item'));
    devSettings.appendChild(settingRow('Offline Mode', createToggle('disableApi', 'Offline Mode'), 'drawer-theme drawer-dev-item'));
    devSettings.appendChild(settingRow('Auto-Refresh Interval', createSelect('refreshInterval', [
        [
            '0',
            'Off'
        ],
        [
            '30',
            '30 seconds'
        ],
        [
            '60',
            '1 minute'
        ],
        [
            '120',
            '2 minutes'
        ]
    ], '60'), 'drawer-theme drawer-dev-item'));
    drawer.appendChild(devSettings);
    overlay.appendChild(drawer);
    overlay.addEventListener('click', (e)=>{
        if (!drawer.contains(e.target)) hideDrawer();
    });
    return overlay;
};
const drawerOverlay = createCityDrawer();
document.body.appendChild(drawerOverlay);
const showDrawer = ()=>{
    drawerOverlay.classList.add('open');
};
const hideDrawer = ()=>{
    drawerOverlay.classList.remove('open');
};
$logo.addEventListener('click', (e)=>{
    e.stopPropagation();
    drawerOverlay.classList.contains('open') ? hideDrawer() : showDrawer();
});
document.addEventListener('keydown', (e)=>{
    if (e.key === 'Escape' && drawerOverlay.classList.contains('open')) hideDrawer();
});
// Auto-locate nearest city when default is "auto" and user is at root.
function nearestCityTo(latitude, longitude) {
    let nearest = null;
    let minDist = Infinity;
    (0, _config.AVAILABLE_CITIES).forEach((code)=>{
        const cfg = (0, _config.getConfigForCity)(code);
        const b = cfg.city.bounds;
        if (latitude >= b.lowerLat && latitude <= b.upperLat && longitude >= b.lowerLong && longitude <= b.upperLong) {
            const dist = Math.hypot(latitude - (b.lowerLat + b.upperLat) / 2, longitude - (b.lowerLong + b.upperLong) / 2);
            if (dist < minDist) {
                minDist = dist;
                nearest = code;
            }
        }
    });
    return nearest;
}
if (localStorage.getItem('defaultCity') === 'auto' && (!location.hash || location.hash === '#' || location.hash === '#/')) // Fast path: Cloudflare's edge-populated request.cf (city/lat/lon), read via
// a same-origin Function (functions/api/map/geolocator.js) - no
// navigator.geolocation permission prompt, and no external IP-lookup
// service (the data is already on the request that reaches the Function).
fetch('/api/map/geolocator').then((res)=>res.json()).catch(()=>null).then((geo)=>{
    var // Fallback: geolocator gave nothing usable (e.g. local dev without a
    // real Cloudflare edge, or no city-bbox match) - fall back to the
    // browser's own (slower, permission-gated) geolocation.
    _navigator_geolocation;
    const nearest = geo && nearestCityTo(geo.latitude, geo.longitude);
    if (nearest && nearest !== city) {
        location.hash = `/${nearest}/`;
        location.reload();
        return;
    }
    if (nearest) return; // matched current city, nothing to do
    (_navigator_geolocation = navigator.geolocation) === null || _navigator_geolocation === void 0 ? void 0 : _navigator_geolocation.getCurrentPosition((pos)=>{
        const { latitude, longitude } = pos.coords;
        const geoNearest = nearestCityTo(latitude, longitude);
        if ((geoNearest || city) !== city) {
            location.hash = `/${geoNearest}/`;
            location.reload();
        }
    }, ()=>{}, {
        timeout: 5000
    });
});
// Pins the document at scroll 0 while the keyboard opens — html/body sit a hair
// taller than the viewport (the safe-area min-height in app.css), so iOS
// scrolling a focused input into view drags the whole fixed layout with it.
//
// Time-boxed rather than cancelled on the popover's transitionend: a
// pane-managed popover has `transition: none !important` and no transitioning
// children, so that event never arrived and the loop ran at 60fps for the rest
// of the session, fighting the browser's own focus handling every frame.
const SCROLL_PIN_MS = 600;
let rafST = null;
let rafSTUntil = 0;
const rafScrollTop = ()=>{
    if (window.scrollY !== 0) window.scrollTo(0, 0);
    if (performance.now() >= rafSTUntil) {
        rafST = null;
        return;
    }
    rafST = requestAnimationFrame(rafScrollTop);
};
const pinScrollTop = ()=>{
    // Extend the window rather than start a second, independent chain.
    rafSTUntil = performance.now() + SCROLL_PIN_MS;
    if (!rafST) rafST = requestAnimationFrame(rafScrollTop);
};
const $tooltip = document.getElementById('tooltip');
function showStopTooltip(data) {
    $tooltip.innerHTML = `<span class="stop-tag">${data.number}</span> ${data.name}`;
    $tooltip.classList.add('show');
    const { x, y: top } = data;
    const left = Math.max(5 + $map.offsetLeft, Math.min(window.innerWidth - $tooltip.offsetWidth - 5, x + $map.offsetLeft - 5));
    $tooltip.style.transform = `translate(${left}px, ${top}px)`;
}
function hideStopTooltip() {
    $tooltip.classList.remove('show');
}
window.requestIdleCallback = window.requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const [lowerLong, lowerLat, upperLong, upperLat] = (0, _config.getCityBounds)();
const CACHE_TIME = 1440; // 1 day
let map;
let servicesDataArr = [];
let stopsDataArr = [];
let servicesData = {};
let stopsData = {};
let routesData = {};
let poisData = []; // [{id,name,type,lat,lon,color}] — alpha "locations" feature
// Alpha "locations" feature — name resolution cache for lat,lon-only URLs.
// Populated when a search result is clicked (so the popover doesn't need a
// round trip for a name it was just shown) and by reverse-geocode lookups.
const LOCATION_KEY_PRECISION = 5; // ~1m — matches the precision search results are rendered with
const locationKey = (lat, lon)=>`${lat.toFixed(LOCATION_KEY_PRECISION)},${lon.toFixed(LOCATION_KEY_PRECISION)}`;
const locationNameCache = new Map(); // locationKey → {name,type,color}
// A location matches a known POI if within ~30m of it (nearby stops/POIs are
// often a few meters apart at the same station, so this stays tight).
const POI_MATCH_DEGREES = 0.0003;
const findMatchingPoi = (lat, lon)=>{
    let best = null;
    let bestDist = POI_MATCH_DEGREES;
    const scan = (pois)=>{
        for (const poi of pois || []){
            const d = Math.hypot(poi.lat - lat, poi.lon - lon);
            if (d < bestDist) {
                bestDist = d;
                best = poi;
            }
        }
    };
    if (IS_ALL_MODE) for (const cityData of cityDataMap.values())scan(cityData === null || cityData === void 0 ? void 0 : cityData.poisData);
    else scan(poisData);
    return best;
};
// Best-effort synchronous name for a location endpoint (click-time cache or
// a known POI, same lookup order as the location popover) without waiting
// on a reverse-geocode round trip — used anywhere a location's identity
// needs to show up immediately (between-popover header while the search is
// still running), falling back to a generic label rather than the raw
// "loc:{lat},{lon}" URL token or coordinates.
const friendlyLocationName = (lat, lon)=>{
    const cached = locationNameCache.get(locationKey(lat, lon)) || findMatchingPoi(lat, lon);
    return (cached === null || cached === void 0 ? void 0 : cached.name) || 'Selected Location';
};
// Alpha "location-to-location directions" feature — `between` endpoint
// tokens. A stop endpoint is its plain number (single-city) or
// "{city}^{number}" (all-mode, unchanged from before). A location endpoint
// is "loc:{lat},{lon}" — the `loc:` prefix is required because `,` can't be
// used as the sole marker (it's also the lat/lon separator) and `-` can't be
// either (longitudes are negative for e.g. the nyc dataset). The two
// endpoint tokens are joined with `~`, matching the separator convention
// already used elsewhere (multi-select service ids, all-mode value pairs).
// Old `{start}-{end}`/`{start},{end}` stop-only URLs (no `~`) still parse via
// the legacy fallback, so existing bookmarked between links keep working.
const encodeBetweenToken = (endpoint)=>{
    if (endpoint.type === 'location') return `loc:${endpoint.lat},${endpoint.lon}`;
    return endpoint.city ? `${endpoint.city}^${endpoint.number}` : endpoint.number;
};
const decodeBetweenToken = (token)=>{
    if (token.startsWith('loc:')) {
        const [rawLat, rawLon] = token.slice(4).split(',');
        const lat = parseFloat(rawLat);
        const lon = parseFloat(rawLon);
        if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
        return {
            type: 'location',
            lat,
            lon
        };
    }
    const caret = token.indexOf('^');
    return caret !== -1 ? {
        type: 'stop',
        city: token.slice(0, caret),
        number: token.slice(caret + 1)
    } : {
        type: 'stop',
        number: token
    };
};
const buildBetweenUrl = (startEndpoint, endEndpoint)=>`${encodeBetweenToken(startEndpoint)}~${encodeBetweenToken(endEndpoint)}`;
const parseBetweenValue = (value)=>{
    const parts = value.includes('~') ? value.split('~') : value.split(/[,-]/);
    if (parts.length !== 2) return null;
    const start = decodeBetweenToken(parts[0]);
    const end = decodeBetweenToken(parts[1]);
    return start && end ? [
        start,
        end
    ] : null;
};
// `.catch()` alone only guards against *rejection* — if the underlying
// fetch/worker round-trip just stalls (slow network, worker never replies),
// the promise never settles at all and a `.then()`-driven loading state gets
// stuck forever. This races the real promise against a timeout so callers
// always reach a final state.
const withTimeout = (promise, ms, fallback)=>Promise.race([
        promise,
        new Promise((resolve)=>setTimeout(()=>resolve(fallback), ms))
    ]);
const LOCATION_FETCH_TIMEOUT_MS = 8000;
// Same cap transfers.py applies to every Voronoi cell (MAX_RADIUS_METERS
// there) — capping the nearest-stop distance to this radius is the cheap
// equivalent of a true point-in-polygon test against that stop's Voronoi
// cell (for the *nearest* site, "inside its cell" and "is the nearest site"
// are the same statement), without shipping/parsing cell geometry
// client-side. Beyond this range, no stop is close enough to call "nearby".
const MAX_RANGE_KM = 1; // ruler.distance() returns kilometers
// Mirrors dataWorker.js's NEARBY_STOPS_MAX — a large BUFFER_METERS (see
// transfers.py) can single-link-chain many stops into one cluster at a busy
// multi-modal hub, so this is a safety cap, not an expected typical size.
const NEARBY_STOPS_MAX = 20;
// Memoized per-city clusters.min.json fetches (alpha "locations" feature) —
// keyed by city code since IS_ALL_MODE locations may belong to any city.
// clusters.min.json holds same-place stop groups (intra-cluster Voronoi
// edges) — see transfers.py's docstring for how this differs from
// transfers.min.json (inter-cluster walking transfers, used by RAPTOR).
// Deliberately NOT timeout-wrapped here — this promise is memoized and
// reused for the lifetime of the page, so racing it against a timeout would
// permanently "poison" the cache with an empty result the first time the
// fetch is merely slow. Callers that need a bounded wait should wrap the
// call with `withTimeout` themselves instead.
const cityClustersPromises = new Map();
const loadCityClusters = (cityCode)=>{
    if (!cityClustersPromises.has(cityCode)) cityClustersPromises.set(cityCode, (0, _fetchCacheDefault.default)(`/data/${cityCode}/clusters.min.json`, CACHE_TIME).catch(()=>({})));
    return cityClustersPromises.get(cityCode);
};
// The small nationwide leftover from the same Voronoi computation covering
// only genuinely cross-city same-place edges (e.g. a city bus stop right
// next to a `railways`/`greyhound` stop) — every other (same-city) cluster
// edge lives in that city's own clusters.min.json above instead of one
// ever-growing nationwide file (see globaltransfers.py).
let crossCityClustersPromise = null;
const loadCrossCityClusters = ()=>{
    if (!crossCityClustersPromise) crossCityClustersPromise = (0, _fetchCacheDefault.default)('/data/all/clusters-cross-city.min.json', 1440).catch(()=>({}));
    return crossCityClustersPromise;
};
// Resolves a location {lat,lon} to its nearby-stop Voronoi cluster (nearest
// stop + same-cell siblings) — the exact same candidate set the location
// popover shows. Shared by the popover and the location-to-X `between`
// search so both search over identical stops. Deliberately does NOT touch
// activeSelectionCities (all-mode's viewport-unload pin) — callers manage
// pinning themselves, since a between query needs to pin candidates from
// *two* independent resolutions without one clobbering the other.
const resolveLocationStops = (lat, lon)=>{
    if (IS_ALL_MODE) {
        const candidateCities = (0, _config.AVAILABLE_CITIES).filter((c)=>{
            var _CITY_CONFIGS_c_city, _CITY_CONFIGS_c;
            const b = (_CITY_CONFIGS_c = (0, _cityConfig.CITY_CONFIGS)[c]) === null || _CITY_CONFIGS_c === void 0 ? void 0 : (_CITY_CONFIGS_c_city = _CITY_CONFIGS_c.city) === null || _CITY_CONFIGS_c_city === void 0 ? void 0 : _CITY_CONFIGS_c_city.bounds;
            return b && lon >= b.lowerLong && lon <= b.upperLong && lat >= b.lowerLat && lat <= b.upperLat;
        });
        return Promise.all([
            withTimeout(Promise.all(candidateCities.map((c)=>loadCityData(c))).catch(()=>{}), LOCATION_FETCH_TIMEOUT_MS, null),
            withTimeout(loadCrossCityClusters().catch(()=>null), LOCATION_FETCH_TIMEOUT_MS, null)
        ]).then(([, crossCityClusters])=>{
            var _cityDataMap_get;
            const closest = computeAllModeClosestStops(lon, lat);
            if (!closest.length || closest[0].distance > MAX_RANGE_KM) return [];
            const nearest = closest[0];
            const results = [
                nearest
            ];
            // Same-city siblings come from that city's own already-loaded clusters
            // shard (raw ids, re-qualified here); the tiny nationwide cross-city
            // file covers the rare case of a different city's stop sharing the
            // same physical place (see globaltransfers.py).
            const ownClusters = ((_cityDataMap_get = cityDataMap.get(nearest.city)) === null || _cityDataMap_get === void 0 ? void 0 : _cityDataMap_get.clustersData) || {};
            const siblings = [
                ...(ownClusters[nearest.number] || []).map(([n, d])=>[
                        `${nearest.city}^${n}`,
                        d
                    ]),
                ...(crossCityClusters === null || crossCityClusters === void 0 ? void 0 : crossCityClusters[`${nearest.city}^${nearest.number}`]) || []
            ].sort((a, b)=>a[1] - b[1]);
            for (const [siblingGlobalId, distanceM] of siblings){
                var _cityDataMap_get_stopsData, _cityDataMap_get1;
                if (results.length >= NEARBY_STOPS_MAX) break;
                const caret = siblingGlobalId.indexOf('^');
                if (caret === -1) continue;
                const sCity = siblingGlobalId.slice(0, caret);
                const sNumber = siblingGlobalId.slice(caret + 1);
                const stopEntry = (_cityDataMap_get1 = cityDataMap.get(sCity)) === null || _cityDataMap_get1 === void 0 ? void 0 : (_cityDataMap_get_stopsData = _cityDataMap_get1.stopsData) === null || _cityDataMap_get_stopsData === void 0 ? void 0 : _cityDataMap_get_stopsData[sNumber];
                if (stopEntry) results.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, stopEntry), {
                    city: sCity,
                    number: sNumber,
                    distance: distanceM
                }));
            }
            return results;
        });
    }
    return withTimeout(loadCityClusters(city).then((clusters)=>(0, _workerClient.workerNearbyStops)(lon, lat, clusters)), LOCATION_FETCH_TIMEOUT_MS, {
        stops: []
    }).then(({ stops })=>stops).catch(()=>[]);
};
// Pre-built lookup maps for O(1) normalized key lookups
let normalizedServiceKeyMap = null;
let normalizedStopKeyMap = null;
/**
 * Build normalized lookup maps for fast O(1) lookups
 * Called once after data is loaded
 */ const buildNormalizedLookupMaps = ()=>{
    if (servicesData && !normalizedServiceKeyMap) {
        normalizedServiceKeyMap = new Map();
        Object.keys(servicesData).forEach((key)=>{
            normalizedServiceKeyMap.set((0, _normalizeNames.normalizeName)(key, city), key);
        });
    }
    if (stopsData && Object.keys(stopsData).length > 0 && !normalizedStopKeyMap) {
        normalizedStopKeyMap = new Map();
        Object.keys(stopsData).forEach((key)=>{
            normalizedStopKeyMap.set((0, _normalizeNames.normalizeName)(key, city), key);
        });
    }
};
/**
 * Find a service by key, using normalized name comparison if enabled for the city.
 * Uses pre-built lookup map for O(1) performance.
 * @param {string} key - The service key/number to find
 * @returns {string|null} The actual service key in servicesData, or null if not found
 */ const findServiceKey = (key)=>{
    if (!key || !servicesData) return null;
    // First try exact match
    if (servicesData[key]) return key;
    // Use pre-built map for O(1) lookup
    if (normalizedServiceKeyMap) return normalizedServiceKeyMap.get((0, _normalizeNames.normalizeName)(key, city)) || null;
    return null;
};
/**
 * Find a stop by key, using normalized name comparison if enabled for the city.
 * Uses pre-built lookup map for O(1) performance.
 * @param {string} key - The stop key/number to find
 * @returns {string|null} The actual stop key in stopsData, or null if not found
 */ const findStopKey = (key)=>{
    if (!key || !stopsData) return null;
    // First try exact match
    if (stopsData[key]) return key;
    // Use pre-built map for O(1) lookup
    if (normalizedStopKeyMap) return normalizedStopKeyMap.get((0, _normalizeNames.normalizeName)(key, city)) || null;
    return null;
};
/**
 * Simple debounce utility
 * @param {Function} fn - Function to debounce
 * @param {number} delay - Delay in milliseconds
 * @returns {Function} Debounced function
 */ const debounce = (fn, delay)=>{
    let timeoutId;
    return (...args)=>{
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>fn(...args), delay);
    };
};
/**
 * Simple throttle utility
 * @param {Function} fn - Function to throttle
 * @param {number} limit - Minimum time between calls in milliseconds
 * @returns {Function} Throttled function
 */ const throttle = (fn, limit)=>{
    let lastCall = 0;
    return (...args)=>{
        const now = performance.now();
        if (now - lastCall >= limit) {
            lastCall = now;
            fn(...args);
        }
    };
};
// Helper function to ensure consistent hash navigation with city prefix
const navigateTo = (path, currentRoute)=>{
    const prefix = path === '/' ? '' : currentRoute.cityPrefix;
    location.hash = `${prefix}${path}`;
};
const getViewportFromUrl = ()=>{
    try {
        const params = new URL(window.location.href).searchParams;
        const lat = parseFloat(params.get('lat'));
        const lon = parseFloat(params.get('lon'));
        const z = parseFloat(params.get('z'));
        if (!isNaN(lat) && !isNaN(lon) && !isNaN(z)) return {
            lat,
            lon,
            z
        };
    } catch (_) {}
    return null;
};
const saveViewportToUrl = (lat, lng, zoom)=>{
    try {
        const url = new URL(window.location.href);
        url.searchParams.set('lat', lat.toFixed(5));
        url.searchParams.set('lon', lng.toFixed(5));
        url.searchParams.set('z', zoom.toFixed(2));
        history.replaceState(null, '', url);
    } catch (_) {}
};
// ── All-mode helpers ──────────────────────────────────────────────────────────
const viewportOverlapsBounds = (vp, b)=>vp.getNorth() > b.lowerLat && vp.getSouth() < b.upperLat && vp.getEast() > b.lowerLong && vp.getWest() < b.upperLong;
const processStopsForCity = (rawStops)=>{
    const cityStopsData = {};
    const cityStopsDataArr = [];
    const stopsByParent = {};
    Object.keys(rawStops).forEach((number)=>{
        const [lng, lat, , , parentStopID = ''] = rawStops[number];
        if (parentStopID) {
            if (!stopsByParent[parentStopID]) stopsByParent[parentStopID] = [];
            stopsByParent[parentStopID].push({
                number,
                lng,
                lat
            });
        }
    });
    Object.keys(rawStops).forEach((number)=>{
        const [lng, lat, name, suffix = '', parentStopID = ''] = rawStops[number];
        let left = false;
        if (parentStopID && stopsByParent[parentStopID]) {
            const opp = stopsByParent[parentStopID].filter((s)=>s.number !== number)[0];
            if (opp) left = ruler.bearing([
                lng,
                lat
            ], [
                opp.lng,
                opp.lat
            ]) > 0;
        }
        cityStopsData[number] = {
            name,
            suffix,
            number,
            parentStopID: parentStopID || null,
            interchange: /\sint$/i.test(name) && !/^(bef|aft|opp|bet)\s/i.test(name),
            coordinates: [
                lng,
                lat
            ],
            services: [],
            routes: [],
            left
        };
        cityStopsDataArr.push(cityStopsData[number]);
    });
    cityStopsDataArr.sort((a, b)=>a.interchange ? 1 : b.interchange ? -1 : 0);
    return {
        cityStopsData,
        cityStopsDataArr
    };
};
// Fetches and merges a city's stops/services/routes JSON into `cityDataMap`
// only — no map sources/layers. This is all `runAllModeBetween`'s RAPTOR
// search needs (a route-major graph to search over), so between-queries don't
// have to pay for rendering every stop of every city touched during the
// search onto the map. `loadCity` (full load, below) reuses this and adds the
// map layers on top when a city needs to actually be browsable/visible.
const loadCityDataPromises = new Map(); // cityCode → Promise<void>, data-only fetch in flight
const loadCityData = (cityCode)=>{
    if (cityDataMap.has(cityCode)) return Promise.resolve();
    if (loadCityPromises.has(cityCode)) return loadCityPromises.get(cityCode);
    if (loadCityDataPromises.has(cityCode)) return loadCityDataPromises.get(cityCode);
    const promise = _fetchCityDataImpl(cityCode);
    loadCityDataPromises.set(cityCode, promise);
    promise.finally(()=>loadCityDataPromises.delete(cityCode));
    return promise;
};
const _fetchCityDataImpl = async (cityCode)=>{
    const dp = `/data/${cityCode}`;
    const [rawStops, citySvcsData, cityRoutesData, cityPoisData, cityClustersData] = await Promise.all([
        fetch(`${dp}/stops.min.json`).then((r)=>r.json()),
        fetch(`${dp}/services.min.json`).then((r)=>r.json()),
        fetch(`${dp}/routes.min.json`).then((r)=>r.json()),
        (0, _cityConfig.isAlphaEnabled)() ? (0, _parsePoisCsv.fetchPois)(cityCode) : Promise.resolve([]),
        loadCityClusters(cityCode)
    ]);
    const { cityStopsData, cityStopsDataArr } = processStopsForCity(rawStops);
    Object.keys(citySvcsData).forEach((svcNum)=>{
        const svc = citySvcsData[svcNum];
        Object.keys(svc).forEach((dest)=>{
            if (dest === 'name') return;
            svc[dest].forEach((route, vi)=>{
                route.forEach((stop, stopIdx)=>{
                    if (!cityStopsData[stop]) return;
                    if (!cityStopsData[stop].services.includes(svcNum)) cityStopsData[stop].services.push(svcNum);
                    const rk = `${svcNum}|${dest}|${vi}`;
                    if (!cityStopsData[stop].routes.includes(rk)) {
                        cityStopsData[stop].routes.push(rk);
                        if (!cityStopsData[stop].destinationGroups) cityStopsData[stop].destinationGroups = {};
                        if (!cityStopsData[stop].destinationGroups[svcNum]) cityStopsData[stop].destinationGroups[svcNum] = {};
                        if (!cityStopsData[stop].destinationGroups[svcNum][dest]) cityStopsData[stop].destinationGroups[svcNum][dest] = {
                            destination: dest,
                            routes: [],
                            stopCount: 0
                        };
                        const dg = cityStopsData[stop].destinationGroups[svcNum][dest];
                        dg.routes.push(route);
                        const remaining = route.length - stopIdx - 1;
                        if (remaining > dg.stopCount) dg.stopCount = remaining;
                    }
                });
            });
        });
    });
    cityDataMap.set(cityCode, {
        stopsData: cityStopsData,
        stopsDataArr: cityStopsDataArr,
        servicesData: citySvcsData,
        routesData: cityRoutesData,
        poisData: cityPoisData.map((poi, id)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, poi), {
                id
            })),
        clustersData: cityClustersData
    });
};
const loadCity = (cityCode)=>{
    if (loadedCities.has(cityCode)) return Promise.resolve();
    if (loadCityPromises.has(cityCode)) return loadCityPromises.get(cityCode);
    const promise = _loadCityImpl(cityCode);
    loadCityPromises.set(cityCode, promise);
    promise.finally(()=>loadCityPromises.delete(cityCode));
    return promise;
};
const _loadCityImpl = async (cityCode)=>{
    loadingCities.add(cityCode);
    try {
        // Reuse an in-flight/completed data-only fetch (e.g. from a between query)
        // instead of re-requesting the same JSON.
        if (!cityDataMap.has(cityCode)) await (loadCityDataPromises.get(cityCode) || _fetchCityDataImpl(cityCode));
        if (!map || map.getSource(`stops-${cityCode}`)) return;
        const { stopsDataArr: cityStopsDataArr, servicesData: citySvcsData, poisData: cityPoisData } = cityDataMap.get(cityCode) || {};
        if (!cityStopsDataArr) return; // data fetch failed
        const cityConfig = (0, _config.getConfigForCity)(cityCode);
        const disableStopID = (cityConfig === null || cityConfig === void 0 ? void 0 : cityConfig.disableStopID) || false;
        let stopTextPartialFormat, stopTextFullFormat;
        if (disableStopID) {
            stopTextPartialFormat = [
                'get',
                'name'
            ];
            stopTextFullFormat = [
                'format',
                [
                    'get',
                    'name'
                ],
                {},
                [
                    'case',
                    [
                        '!=',
                        [
                            'get',
                            'suffix'
                        ],
                        null
                    ],
                    [
                        'concat',
                        '\n',
                        [
                            'get',
                            'suffix'
                        ]
                    ],
                    ''
                ],
                {
                    'font-scale': 0.8,
                    'text-color': (0, _theme.C).text
                }
            ];
        } else {
            stopTextPartialFormat = [
                'get',
                'number'
            ];
            stopTextFullFormat = [
                'format',
                [
                    'get',
                    'number'
                ],
                {
                    'font-scale': 0.8
                },
                '\n',
                {},
                [
                    'get',
                    'name'
                ],
                {
                    'text-color': (0, _theme.C).text
                }
            ];
        }
        // Match single-city mode's stacking (stop/rail layers added with no
        // beforeId sit above the entire base style, including road labels) —
        // the only thing per-city layers must stay under is the shared
        // stops-highlight overlay, so selection/highlight markers stay visible
        // above every city's own stops. Relative order between cities is then
        // just load order, same as single-city has only one city to order.
        const insertBefore = map.getLayer('stops-highlight') ? 'stops-highlight' : undefined;
        // Rail layers anchor to stops-highlight-circle instead — a separate,
        // permanent (never unloaded) layer added just below stops-highlight —
        // so every city's rail lines/stations stack below every city's stops,
        // rather than interleaving with them by load order. Without this, one
        // city's rail station (e.g. a metro interchange) can render on top of
        // and visually cover another city's bus stop at the same physical hub.
        const railInsertBefore = map.getLayer('stops-highlight-circle') ? 'stops-highlight-circle' : insertBefore;
        map.addSource(`stops-${cityCode}`, {
            type: 'geojson',
            tolerance: 10,
            data: {
                type: 'FeatureCollection',
                features: (0, _mapOptimizations.createFeaturesOptimized)(cityStopsDataArr, (stop)=>({
                        type: 'Feature',
                        id: (0, _specialID.encode)(stop.number),
                        properties: {
                            number: stop.number,
                            name: stop.name,
                            interchange: stop.interchange,
                            left: stop.left,
                            suffix: stop.suffix,
                            city: cityCode
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: stop.coordinates
                        }
                    }))
            }
        });
        map.addSource(`stops-highlight-${cityCode}`, {
            type: 'geojson',
            tolerance: 10,
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            id: `stops-${cityCode}`,
            type: 'circle',
            source: `stops-${cityCode}`,
            paint: {
                'circle-radius': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    [
                        'case',
                        [
                            'boolean',
                            [
                                'feature-state',
                                'selected'
                            ],
                            false
                        ],
                        4,
                        1
                    ],
                    14,
                    4,
                    15,
                    [
                        'case',
                        [
                            'boolean',
                            [
                                'feature-state',
                                'selected'
                            ],
                            false
                        ],
                        12,
                        6
                    ]
                ],
                'circle-color': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    (0, _theme.C).stopCircleBg,
                    (0, _theme.C).stopRed
                ],
                'circle-stroke-color': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    (0, _theme.C).stopRed,
                    (0, _theme.C).stopCircleBg
                ],
                'circle-stroke-width': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    5,
                    1
                ],
                'circle-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    1,
                    13.9,
                    1,
                    14,
                    0.5
                ],
                'circle-stroke-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    [
                        'case',
                        [
                            'boolean',
                            [
                                'feature-state',
                                'selected'
                            ],
                            false
                        ],
                        1,
                        0
                    ],
                    13.5,
                    1,
                    14,
                    0.5
                ]
            }
        }, insertBefore);
        map.addLayer({
            id: `stops-icon-${cityCode}`,
            type: 'symbol',
            source: `stops-${cityCode}`,
            filter: [
                'any',
                [
                    '>=',
                    [
                        'zoom'
                    ],
                    14
                ],
                [
                    'get',
                    'interchange'
                ]
            ],
            layout: {
                'icon-image': 'stop',
                'icon-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    0.4,
                    15,
                    0.5,
                    16,
                    0.6
                ],
                'icon-padding': 0.5,
                'icon-allow-overlap': true,
                'text-optional': true,
                'text-field': [
                    'step',
                    [
                        'zoom'
                    ],
                    '',
                    15,
                    stopTextPartialFormat,
                    16,
                    stopTextFullFormat
                ],
                'text-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    12,
                    16,
                    14
                ],
                'text-justify': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    'right',
                    'left'
                ],
                'text-anchor': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    'right',
                    'left'
                ],
                'text-offset': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    [
                        'literal',
                        [
                            -1,
                            0
                        ]
                    ],
                    [
                        'literal',
                        [
                            1,
                            0
                        ]
                    ]
                ],
                'text-padding': 0.5,
                'text-font': [
                    'Noto Sans Regular'
                ],
                'text-max-width': 16,
                'text-line-height': 1.1
            },
            paint: {
                'icon-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    8,
                    [
                        'case',
                        [
                            'get',
                            'interchange'
                        ],
                        1,
                        0
                    ],
                    14,
                    1
                ],
                'text-color': (0, _theme.C).stopRed,
                'text-halo-width': 1,
                'text-halo-color': (0, _theme.C).textHalo
            }
        }, insertBefore);
        map.on('mouseenter', `stops-${cityCode}`, ()=>{
            map.getCanvas().style.cursor = 'pointer';
        });
        map.on('mouseleave', `stops-${cityCode}`, ()=>{
            map.getCanvas().style.cursor = '';
        });
        // Add to search index only if not already indexed (preindexAllCities may have run first)
        AllModeIndex.addCity(cityCode, {
            services: Object.keys(citySvcsData).map((num)=>({
                    number: num,
                    name: citySvcsData[num].name
                })),
            stops: cityStopsDataArr,
            pois: cityPoisData || []
        });
        // Try to load rail data — not all cities have it, so 404 is expected
        try {
            const railResp = await fetch(`/data/${cityCode}/rail.json`);
            if (railResp.ok && map && !map.getSource(`rail-${cityCode}`)) {
                const railData = await railResp.json();
                const railLineFilter = [
                    'all',
                    [
                        '==',
                        [
                            'geometry-type'
                        ],
                        'LineString'
                    ],
                    [
                        'has',
                        'stroke'
                    ]
                ];
                const railLineLayout = {
                    'line-join': 'round',
                    'line-cap': 'round'
                };
                const railInterchangeFilter = [
                    'all',
                    [
                        '==',
                        [
                            'geometry-type'
                        ],
                        'Point'
                    ],
                    [
                        '==',
                        [
                            'get',
                            'interchange'
                        ],
                        true
                    ]
                ];
                const railStationsFilter = [
                    'all',
                    [
                        '==',
                        [
                            'geometry-type'
                        ],
                        'Point'
                    ],
                    [
                        'has',
                        'name'
                    ],
                    [
                        '!=',
                        [
                            'get',
                            'interchange'
                        ],
                        true
                    ]
                ];
                map.addSource(`rail-${cityCode}`, {
                    type: 'geojson',
                    data: railData
                });
                map.addLayer({
                    id: `rail-path-case-${cityCode}`,
                    type: 'line',
                    source: `rail-${cityCode}`,
                    filter: railLineFilter,
                    minzoom: 8,
                    layout: railLineLayout,
                    paint: {
                        'line-color': [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'metro',
                            (0, _theme.C).stopCircleBg,
                            'monorail',
                            '#FFF',
                            [
                                'get',
                                'stroke'
                            ]
                        ],
                        'line-width': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            16,
                            [
                                'match',
                                [
                                    'get',
                                    'mode'
                                ],
                                'monorail',
                                0.85,
                                'rail',
                                5,
                                9
                            ],
                            22,
                            [
                                'match',
                                [
                                    'get',
                                    'mode'
                                ],
                                'monorail',
                                12,
                                'rail',
                                7,
                                12
                            ]
                        ],
                        'line-opacity': [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'monorail',
                            0.5,
                            'rail',
                            0.75,
                            0.5
                        ]
                    }
                }, railInsertBefore);
                map.addLayer({
                    id: `rail-path-${cityCode}`,
                    type: 'line',
                    source: `rail-${cityCode}`,
                    filter: railLineFilter,
                    minzoom: 8,
                    layout: railLineLayout,
                    paint: {
                        'line-color': [
                            'get',
                            'stroke'
                        ],
                        'line-width': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            12,
                            3,
                            16,
                            4,
                            22,
                            6
                        ],
                        'line-opacity': [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'monorail',
                            1,
                            'rail',
                            0.01,
                            (0, _theme.C).routeLineOpacity
                        ]
                    }
                }, railInsertBefore);
                map.addLayer({
                    id: `rail-path-dots-${cityCode}`,
                    type: 'line',
                    source: `rail-${cityCode}`,
                    filter: [
                        'all',
                        ...railLineFilter.slice(1),
                        [
                            '==',
                            [
                                'get',
                                'mode'
                            ],
                            'rail'
                        ]
                    ],
                    minzoom: 8,
                    layout: (0, _objectSpreadProps._)((0, _objectSpread._)({}, railLineLayout), {
                        'line-cap': 'butt'
                    }),
                    paint: {
                        'line-color': [
                            'get',
                            'stroke'
                        ],
                        'line-width': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            12,
                            2,
                            16,
                            3,
                            22,
                            4
                        ],
                        'line-opacity': 1,
                        'line-dasharray': [
                            3,
                            3
                        ]
                    }
                }, railInsertBefore);
                map.addLayer({
                    id: `rail-stations-${cityCode}`,
                    type: 'symbol',
                    source: `rail-${cityCode}`,
                    filter: railStationsFilter,
                    minzoom: 10,
                    layout: {
                        'icon-image': [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'metro',
                            'metro-station',
                            'monorail',
                            'monorail-station',
                            'rail-station'
                        ],
                        'icon-size': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            11,
                            0.3,
                            22,
                            0.5
                        ],
                        'icon-allow-overlap': false,
                        'text-field': [
                            'get',
                            'name'
                        ],
                        'text-font': [
                            'Noto Sans Bold'
                        ],
                        'text-size': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            11,
                            10,
                            22,
                            16
                        ],
                        'text-variable-anchor': [
                            'left',
                            'right',
                            'top'
                        ],
                        'text-radial-offset': 1.1,
                        'text-optional': true
                    },
                    paint: (0, _objectSpreadProps._)((0, _objectSpread._)({
                        'icon-color': (0, _theme.stationIconColor),
                        'icon-opacity': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            10,
                            0,
                            11,
                            1
                        ]
                    }, (0, _theme.isDark) && {
                        'icon-halo-color': '#000',
                        'icon-halo-width': 0.5,
                        'icon-halo-blur': 1
                    }), {
                        'text-color': (0, _theme.stationTextColor),
                        'text-opacity': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            10,
                            0,
                            11,
                            1
                        ],
                        'text-halo-color': (0, _theme.C).textHalo,
                        'text-halo-width': (0, _theme.C).stationHaloWidth
                    })
                }, railInsertBefore);
                map.addLayer({
                    id: `rail-stations-interchange-${cityCode}`,
                    type: 'symbol',
                    source: `rail-${cityCode}`,
                    filter: railInterchangeFilter,
                    minzoom: 9,
                    layout: {
                        'icon-image': [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'metro',
                            'metro-station',
                            'monorail',
                            'monorail-station',
                            'rail-station'
                        ],
                        'icon-size': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            10,
                            0.45,
                            22,
                            0.75
                        ],
                        'icon-allow-overlap': true,
                        'text-field': [
                            'get',
                            'name'
                        ],
                        'text-font': [
                            'Noto Sans Bold'
                        ],
                        'text-size': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            10,
                            10,
                            22,
                            16
                        ],
                        'text-variable-anchor': [
                            'left',
                            'right',
                            'top'
                        ],
                        'text-radial-offset': 1.1,
                        'text-optional': true
                    },
                    paint: (0, _objectSpreadProps._)((0, _objectSpread._)({
                        'icon-color': (0, _theme.C).text,
                        'icon-opacity': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            9,
                            0,
                            10,
                            1
                        ]
                    }, (0, _theme.isDark) && {
                        'icon-halo-color': '#000',
                        'icon-halo-width': 0.5,
                        'icon-halo-blur': 1
                    }), {
                        'text-color': (0, _theme.C).text,
                        'text-opacity': [
                            'interpolate',
                            [
                                'linear'
                            ],
                            [
                                'zoom'
                            ],
                            9,
                            0,
                            10,
                            1
                        ],
                        'text-halo-color': (0, _theme.C).textHalo,
                        'text-halo-width': (0, _theme.C).stationHaloWidth
                    })
                }, railInsertBefore);
            }
        } catch (_railErr) {
        // Rail data not available for this city
        }
        loadedCities.add(cityCode);
        allModeSearchListCache = null;
        onCityLoadedCallback === null || onCityLoadedCallback === void 0 ? void 0 : onCityLoadedCallback(cityCode);
    } catch (err) {} finally{
        loadingCities.delete(cityCode);
    }
};
const unloadCity = (cityCode)=>{
    if (!loadedCities.has(cityCode)) return;
    [
        `rail-stations-interchange-${cityCode}`,
        `rail-stations-${cityCode}`,
        `rail-path-dots-${cityCode}`,
        `rail-path-${cityCode}`,
        `rail-path-case-${cityCode}`,
        `stops-icon-${cityCode}`,
        `stops-${cityCode}`
    ].forEach((id)=>{
        if (map === null || map === void 0 ? void 0 : map.getLayer(id)) map.removeLayer(id);
    });
    [
        `rail-${cityCode}`,
        `stops-${cityCode}`,
        `stops-highlight-${cityCode}`
    ].forEach((id)=>{
        if (map === null || map === void 0 ? void 0 : map.getSource(id)) map.removeSource(id);
    });
    cityDataMap.delete(cityCode);
    loadedCities.delete(cityCode);
    allModeSearchListCache = null;
    onCityUnloadedCallback === null || onCityUnloadedCallback === void 0 ? void 0 : onCityUnloadedCallback(cityCode);
};
// Unload any currently-loaded city that isn't pinned (`activeSelectionCities`)
// and is outside the current viewport. `checkViewport` only re-evaluates this
// on the next pan/zoom, so a selection (service view, between query) that
// pinned cities outside the viewport would otherwise leave them loaded
// indefinitely once dismissed — call this right after clearing/updating
// `activeSelectionCities` to release them immediately.
const releaseUnpinnedCities = ()=>{
    if (!map) return;
    const vp = map.getBounds();
    const zoom = map.getZoom();
    [
        ...loadedCities
    ].forEach((cityCode)=>{
        var _CITY_CONFIGS_cityCode_city_bounds, _CITY_CONFIGS_cityCode_city, _CITY_CONFIGS_cityCode;
        if (activeSelectionCities.has(cityCode)) return;
        const minZoom = (_CITY_CONFIGS_cityCode = (0, _cityConfig.CITY_CONFIGS)[cityCode]) === null || _CITY_CONFIGS_cityCode === void 0 ? void 0 : (_CITY_CONFIGS_cityCode_city = _CITY_CONFIGS_cityCode.city) === null || _CITY_CONFIGS_cityCode_city === void 0 ? void 0 : (_CITY_CONFIGS_cityCode_city_bounds = _CITY_CONFIGS_cityCode_city.bounds) === null || _CITY_CONFIGS_cityCode_city_bounds === void 0 ? void 0 : _CITY_CONFIGS_cityCode_city_bounds.minZoom;
        const b = cityStopsBounds.get(cityCode);
        if (minZoom != null && b && viewportOverlapsBounds(vp, b) && zoom >= minZoom) return;
        unloadCity(cityCode);
    });
};
// Fetch lightweight name/number index for ALL cities upfront so search works globally.
// The full stop/service objects are NOT retained — just { number, name, city }.
const preindexAllCities = async ()=>{
    await Promise.all((0, _config.AVAILABLE_CITIES).map(async (cityCode)=>{
        if (AllModeIndex.hasCity(cityCode)) return; // already indexed
        try {
            const dp = `/data/${cityCode}`;
            const [rawStops, svcsData, cityPois] = await Promise.all([
                fetch(`${dp}/stops.min.json`).then((r)=>r.json()),
                fetch(`${dp}/services.min.json`).then((r)=>r.json()),
                (0, _cityConfig.isAlphaEnabled)() ? (0, _parsePoisCsv.fetchPois)(cityCode) : Promise.resolve([])
            ]);
            // Guard again — loadCity may have run concurrently
            if (AllModeIndex.hasCity(cityCode)) return;
            let minLng = Infinity, maxLng = -Infinity, minLat = Infinity, maxLat = -Infinity;
            const stops = Object.keys(rawStops).map((num)=>{
                const [lng, lat, name] = rawStops[num];
                if (lng < minLng) minLng = lng;
                if (lng > maxLng) maxLng = lng;
                if (lat < minLat) minLat = lat;
                if (lat > maxLat) maxLat = lat;
                return {
                    number: num,
                    name
                };
            });
            if (minLng !== Infinity && !cityStopsBounds.has(cityCode)) {
                // Buffer the data-derived extent by 4km, using a ruler built for this
                // city's actual latitude (longitude degrees shrink towards the poles)
                const cityRuler = new (0, _cheapRulerDefault.default)((minLat + maxLat) / 2);
                const [lowerLong, lowerLat, upperLong, upperLat] = cityRuler.bufferBBox([
                    minLng,
                    minLat,
                    maxLng,
                    maxLat
                ], 4 // km
                );
                cityStopsBounds.set(cityCode, {
                    lowerLat,
                    upperLat,
                    lowerLong,
                    upperLong
                });
            }
            AllModeIndex.addCity(cityCode, {
                services: Object.keys(svcsData).map((num)=>{
                    var _svcsData_num;
                    return {
                        number: num,
                        name: (_svcsData_num = svcsData[num]) === null || _svcsData_num === void 0 ? void 0 : _svcsData_num.name
                    };
                }),
                stops,
                pois: cityPois
            });
        } catch (e) {}
    }));
};
// Display name for a city code, used to label all-mode search results
const cityDisplayName = (cityCode)=>{
    var _CITY_CONFIGS_cityCode_city, _CITY_CONFIGS_cityCode;
    return ((_CITY_CONFIGS_cityCode = (0, _cityConfig.CITY_CONFIGS)[cityCode]) === null || _CITY_CONFIGS_cityCode === void 0 ? void 0 : (_CITY_CONFIGS_cityCode_city = _CITY_CONFIGS_cityCode.city) === null || _CITY_CONFIGS_cityCode_city === void 0 ? void 0 : _CITY_CONFIGS_cityCode_city.name) || cityCode;
};
// City ranking shared by every all-mode result list: loaded cities first, then
// by minZoom desc (higher = more specific/zoomed-in city ranks first)
const getMinZoom = (cityCode)=>{
    var _CITY_CONFIGS_cityCode_city_bounds, _CITY_CONFIGS_cityCode_city, _CITY_CONFIGS_cityCode;
    var _CITY_CONFIGS_cityCode_city_bounds_minZoom;
    return (_CITY_CONFIGS_cityCode_city_bounds_minZoom = (_CITY_CONFIGS_cityCode = (0, _cityConfig.CITY_CONFIGS)[cityCode]) === null || _CITY_CONFIGS_cityCode === void 0 ? void 0 : (_CITY_CONFIGS_cityCode_city = _CITY_CONFIGS_cityCode.city) === null || _CITY_CONFIGS_cityCode_city === void 0 ? void 0 : (_CITY_CONFIGS_cityCode_city_bounds = _CITY_CONFIGS_cityCode_city.bounds) === null || _CITY_CONFIGS_cityCode_city_bounds === void 0 ? void 0 : _CITY_CONFIGS_cityCode_city_bounds.minZoom) !== null && _CITY_CONFIGS_cityCode_city_bounds_minZoom !== void 0 ? _CITY_CONFIGS_cityCode_city_bounds_minZoom : 0;
};
const compareCityPriority = (a, b)=>{
    const aLoaded = loadedCities.has(a) ? 1 : 0;
    const bLoaded = loadedCities.has(b) ? 1 : 0;
    if (bLoaded !== aLoaded) return bLoaded - aLoaded;
    return getMinZoom(b) - getMinZoom(a);
};
// Groups a flat list of { city, ... } items into per-city buckets ordered by
// compareCityPriority, preserving each item's relative order within its city.
const groupByCity = (items)=>{
    const order = [];
    const buckets = new Map();
    for (const item of items){
        if (!buckets.has(item.city)) {
            buckets.set(item.city, []);
            order.push(item.city);
        }
        buckets.get(item.city).push(item);
    }
    order.sort(compareCityPriority);
    return order.map((cityCode)=>({
            city: cityCode,
            items: buckets.get(cityCode)
        }));
};
// Caps grouped results to a total item count, dropping whole groups once the limit is hit
const capGroups = (groups, limit)=>{
    const capped = [];
    let remaining = limit;
    for (const group of groups){
        if (remaining <= 0) break;
        const items = group.items.slice(0, remaining);
        capped.push({
            city: group.city,
            items
        });
        remaining -= items.length;
    }
    return capped;
};
// Sort services for all-mode search list: loaded cities first, then by minZoom desc (higher = more specific city)
const buildAllModeSearchList = ()=>allModeSearchListCache || (allModeSearchListCache = [
        ...allModeServicesIdx
    ].sort((a, b)=>compareCityPriority(a.city, b.city)));
const App = ()=>{
    var _route_value, _cityDataMap_get_stopsData, _cityDataMap_get, _getConfigForCity, _cityDataMap_get1, _cityDataMap_get_servicesData, _cityDataMap_get2, _route_value1;
    const { t, i18n } = (0, _reactI18Next.useTranslation)();
    const [route, setRoute] = (0, _hooks.useState)((0, _getRouteDefault.default)());
    const prevRoute = (0, _usePreviousDefault.default)(route);
    // Handle city selection and validation
    (0, _hooks.useEffect)(()=>{
        const { city } = route;
        // If invalid city code, redirect to default city
        if (!(0, _config.isCitySupported)(city)) {
            location.hash = `/${0, _config.DEFAULT_CITY}${route.page === 'home' ? '' : route.path}`;
            return;
        }
        // Update page title with city name
        const cityInfo = (0, _config.getCityInfo)();
        document.title = `${cityInfo.name} Transit Routes - ${t('app.name')}`;
    }, [
        route
    ]);
    const [routeLoading, setRouteLoading] = (0, _hooks.useState)(true);
    const [services, setServices] = (0, _hooks.useState)([]);
    const [stops, setStops] = (0, _hooks.useState)([]);
    const [locations, setLocations] = (0, _hooks.useState)([]); // alpha "locations" feature — local pois.csv matches
    const [liveLocations, setLiveLocations] = (0, _hooks.useState)([]); // alpha "locations" feature — live Nominatim matches
    const [locationSearchEnabled, setLocationSearchEnabled] = (0, _hooks.useState)(()=>localStorage.getItem('locationSearch') === 'true');
    const locationSearchEnabledRef = (0, _hooks.useRef)(locationSearchEnabled);
    (0, _hooks.useEffect)(()=>{
        locationSearchEnabledRef.current = locationSearchEnabled;
    }, [
        locationSearchEnabled
    ]);
    const [showLocationPopover, setShowLocationPopover] = (0, _hooks.useState)(false);
    const [locationPopoverData, setLocationPopoverData] = (0, _hooks.useState)(null);
    const [locationPopoverStops, setLocationPopoverStops] = (0, _hooks.useState)([]);
    const [locationPopoverLoading, setLocationPopoverLoading] = (0, _hooks.useState)(false);
    const [searching, setSearching] = (0, _hooks.useState)(false);
    const [expandSearch, setExpandSearch] = (0, _hooks.useState)(false);
    const expandedSearchOnce = (0, _hooks.useRef)(false);
    const [shrinkSearch, setShrinkSearch] = (0, _hooks.useState)(false);
    const [stopPopoverData, setStopPopoverData] = (0, _hooks.useState)(null);
    const [showStopPopover, setShowStopPopover] = (0, _hooks.useState)(false);
    const [showServicePopover, setShowServicePopover] = (0, _hooks.useState)(false);
    const [stopPopoverLoading, setStopPopoverLoading] = (0, _hooks.useState)(false);
    const [stopPopoverError, setStopPopoverError] = (0, _hooks.useState)(false);
    const [stopPopoverSource, setStopPopoverSource] = (0, _hooks.useState)(null);
    const [intersectStops, setIntersectStops] = (0, _hooks.useState)([]);
    const [allModePreindexed, setAllModePreindexed] = (0, _hooks.useState)(false);
    const [routeServices, setRouteServices] = (0, _hooks.useState)([]);
    const [routeVehicles, setRouteVehicles] = (0, _hooks.useState)([]);
    const [routeLiveStatus, setRouteLiveStatus] = (0, _hooks.useState)({
        loading: false,
        error: false,
        source: null
    });
    const [followedVehicleId, setFollowedVehicleId] = (0, _hooks.useState)(null);
    const [activeVehicles, setActiveVehicles] = (0, _hooks.useState)([]); // search: vehicles currently active in the source
    const [vehicleQuery, setVehicleQuery] = (0, _hooks.useState)('');
    const [vehiclePanel, setVehiclePanel] = (0, _hooks.useState)(null); // { id, info, notFound, estimated, svc }
    const vehicleSeq = (0, _hooks.useRef)(0);
    const vehiclePoll = (0, _hooks.useRef)(null);
    const vehicleRouteRef = (0, _hooks.useRef)(undefined); // last-drawn route (svc), so a poll only redraws on an actual change
    const stopPopoverCancelRef = (0, _hooks.useRef)(null);
    const [stopPopoverDestFilter, setStopPopoverDestFilter] = (0, _hooks.useState)(()=>{
        var _get;
        return (_get = new URLSearchParams(window.location.search).get('dest')) !== null && _get !== void 0 ? _get : '';
    });
    const [stopPopoverDestFilterExact, setStopPopoverDestFilterExact] = (0, _hooks.useState)(()=>new URLSearchParams(window.location.search).get('destExact') === '1');
    const handleStopLoadingChange = (0, _hooks.useCallback)((loading)=>{
        setStopPopoverLoading(loading);
        if (loading) setStopPopoverError(false);
    }, []);
    const handleStopDestFilterChange = (0, _hooks.useCallback)((value, exact = false)=>{
        setStopPopoverDestFilter(value);
        setStopPopoverDestFilterExact(exact);
    }, []);
    (0, _hooks.useEffect)(()=>{
        const url = new URL(window.location.href);
        if (stopPopoverDestFilter) {
            url.searchParams.set('dest', stopPopoverDestFilter);
            if (stopPopoverDestFilterExact) url.searchParams.set('destExact', '1');
            else url.searchParams.delete('destExact');
        } else {
            url.searchParams.delete('dest');
            url.searchParams.delete('destExact');
        }
        history.replaceState(null, '', url);
    }, [
        stopPopoverDestFilter,
        stopPopoverDestFilterExact
    ]);
    const [showBetweenPopover, setShowBetweenPopover] = (0, _hooks.useState)(false);
    // Lags one step behind showBetweenPopover: keeps the last non-null data around
    // while the popover slides shut, so its content doesn't vanish mid-transition
    // (mirrors stopPopoverData, which is likewise never nulled on close).
    const [betweenPopoverData, setBetweenPopoverData] = (0, _hooks.useState)(null);
    (0, _hooks.useEffect)(()=>{
        if (showBetweenPopover) setBetweenPopoverData(showBetweenPopover);
    }, [
        showBetweenPopover
    ]);
    const [betweenStartStop, setBetweenStartStop] = (0, _hooks.useState)(null);
    const [betweenEndStop, setBetweenEndStop] = (0, _hooks.useState)(null);
    // All-mode (cross-city) `between` result: { startId, endId, startStop, endStop, itineraries, loading, error }
    const [allModeBetween, setAllModeBetween] = (0, _hooks.useState)(null);
    // Same lag as betweenPopoverData, for the all-mode variant.
    const [allModeBetweenData, setAllModeBetweenData] = (0, _hooks.useState)(null);
    (0, _hooks.useEffect)(()=>{
        if (allModeBetween) setAllModeBetweenData(allModeBetween);
    }, [
        allModeBetween
    ]);
    const [directionsOrigin, setDirectionsOrigin] = (0, _hooks.useState)(null);
    const [editingBetweenStop, setEditingBetweenStop] = (0, _hooks.useState)(null);
    const [currentLocation, setCurrentLocation] = (0, _hooks.useState)(null);
    const [closestStops, setClosestStops] = (0, _hooks.useState)([]);
    const prevStopNumber = (0, _hooks.useRef)(null);
    const prevStopCity = (0, _hooks.useRef)(null); // tracks source city for feature state clearing in all-mode
    const currentLocationRef = (0, _hooks.useRef)(null); // kept in sync for use in non-reactive callbacks
    const closestStopsRef = (0, _hooks.useRef)([]);
    const servicesList = (0, _hooks.useRef)(null);
    const searchField = (0, _hooks.useRef)(null);
    const searchPopover = (0, _hooks.useRef)(null);
    const searchPane = (0, _hooks.useRef)(null); // CupertinoPane instance for search-popover, mobile only
    const stopPopover = (0, _hooks.useRef)(null);
    const stopPane = (0, _hooks.useRef)(null); // CupertinoPane instance for stop-popover, mobile only
    const locationPopover = (0, _hooks.useRef)(null);
    const locationPane = (0, _hooks.useRef)(null); // CupertinoPane instance for location-popover, mobile only
    const locationMarkerRef = (0, _hooks.useRef)(null); // alpha "locations" feature — maplibregl.Marker for the selected location
    const locationSearchSeq = (0, _hooks.useRef)(0);
    // All-mode's viewport-driven city loader (defined inside the map-load
    // effect, below) — stashed here so the location route handler and
    // hideLocationPopover can force a re-check without waiting for a real
    // moveend, which a static location viewport may never produce.
    const checkViewportRef = (0, _hooks.useRef)(null);
    const floatPill = (0, _hooks.useRef)(null);
    const betweenPopover = (0, _hooks.useRef)(null);
    const betweenPane = (0, _hooks.useRef)(null); // CupertinoPane instance for between-popover, mobile only
    // Cache key for the last-run between query — lets navigating list ↔ detail
    // (which only changes route.subpage) skip re-running the RAPTOR search /
    // worker-based route computation, since the query itself hasn't changed.
    const lastAllModeBetweenQuery = (0, _hooks.useRef)(null);
    const lastBetweenQuery = (0, _hooks.useRef)(null);
    const servicePopover = (0, _hooks.useRef)(null);
    const servicePane = (0, _hooks.useRef)(null); // CupertinoPane instance for service-popover, mobile only
    // showServicePopover for the [] -dep callbacks below, which would
    // otherwise close over its first-render value. Written during render, not
    // from an effect: _showStopPopover runs off a hashchange, before effects.
    const showServicePopoverRef = (0, _hooks.useRef)(false);
    showServicePopoverRef.current = showServicePopover;
    // Stop to scroll back to and flash in the route list, handed over by
    // hideStopPopover once the route sheet is on screen again.
    const revealStopInServiceList = (0, _hooks.useRef)(null);
    // Resolves when the stop sheet is up; the route sheet waits on it before
    // taking itself away from underneath.
    const stopPanePresented = (0, _hooks.useRef)(null);
    // Whether a stop took the route sheet's place last render, so the effect
    // can tell "reopening right after that stop closed" from any other reopen.
    const stopTookOverFromService = (0, _hooks.useRef)(false);
    const vehicleTracker = (0, _hooks.useRef)(null);
    const workerReadyRef = (0, _hooks.useRef)(null);
    const routeRenderSeq = (0, _hooks.useRef)(0);
    const geolocateBtn = (0, _hooks.useRef)(null);
    const geolocateControlRef = (0, _hooks.useRef)(null);
    const hasPannedToLocationOnLoad = (0, _hooks.useRef)(false);
    // (closest-stop calculation now runs in the data worker — see useEffect below)
    // Pan/zoom to location with geolocateSource flag
    const panToLocation = (0, _hooks.useCallback)((location1, geolocateControl)=>{
        if (!location1 || !map) return;
        const checkAndPan = ()=>{
            const marker = geolocateControl === null || geolocateControl === void 0 ? void 0 : geolocateControl._dot;
            if (!marker || !marker._addedToMap) {
                requestAnimationFrame(checkAndPan);
                return;
            }
            // On mobile, adjust latitude to account for UI elements
            const center = !BREAKPOINT() ? [
                location1[0],
                location1[1] - 0.004
            ] : location1;
            const eventData = {
                geolocateSource: true
            };
            map.flyTo({
                center,
                zoom: 15,
                duration: 2000
            }, eventData);
        };
        requestAnimationFrame(()=>{
            requestAnimationFrame(checkAndPan);
        });
    }, []);
    // Handle location update (from GeolocateControl)
    const handleLocationUpdate = (0, _hooks.useCallback)((location1, geolocateControl)=>{
        if (!location1) return;
        setCurrentLocation(location1);
        // Pan/zoom on initial page load only
        if (!hasPannedToLocationOnLoad.current) {
            hasPannedToLocationOnLoad.current = true;
            panToLocation(location1, geolocateControl);
        }
    }, [
        panToLocation
    ]);
    let previewRAF = (0, _hooks.useRef)(null).current;
    const largerScreen = window.matchMedia('(min-width: 1200px) and (min-height: 600px) and (orientation: landscape)').matches;
    const handleKeys = (e)=>{
        switch(e.key.toLowerCase()){
            case 'enter':
                {
                    var _servicesList_current;
                    const link = (_servicesList_current = servicesList.current) === null || _servicesList_current === void 0 ? void 0 : _servicesList_current.querySelector('li a[href^="#"]');
                    if (link) {
                        var _searchField_current;
                        (_searchField_current = searchField.current) === null || _searchField_current === void 0 ? void 0 : _searchField_current.blur();
                        link.click();
                    }
                    break;
                }
        }
    };
    // Vehicles are only offered for sources rendered on the map: the current
    // city, or in all-mode every city currently loaded.
    // Vehicle search results are an alpha feature; vehicle page links work regardless.
    const vehicleSearchPool = (0, _cityConfig.isAlphaEnabled)() ? activeVehicles : [];
    const loadActiveVehicles = ()=>{
        if (!(0, _cityConfig.isAlphaEnabled)()) return;
        const cities = IS_ALL_MODE ? [
            ...loadedCities
        ] : [
            route.city
        ];
        const lookups = cities.map((c)=>{
            var _getConfigForCity;
            return [
                c,
                (_getConfigForCity = (0, _config.getConfigForCity)(c)) === null || _getConfigForCity === void 0 ? void 0 : _getConfigForCity.vehicleLookup
            ];
        }).filter(([, lookup])=>lookup === null || lookup === void 0 ? void 0 : lookup.enabled);
        Promise.all(lookups.map(([c, lookup])=>(0, _vehicleLookup.fetchActiveVehicles)(lookup.apiPath).then((list)=>list.map((v)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, v), {
                        city: c
                    }))))).then((lists)=>setActiveVehicles(lists.flat()));
    };
    const handleSearchFocus = (e)=>{
        var _searchField_current;
        loadActiveVehicles();
        setExpandSearch(true);
        expandedSearchOnce.current = true;
        // $map.classList.add('fade-out');
        (0, _mobilePane.movePaneToBreak)(searchPane, 'top');
        pinScrollTop();
        if (IS_ALL_MODE && !((_searchField_current = searchField.current) === null || _searchField_current === void 0 ? void 0 : _searchField_current.value)) {
            // Immediately populate with sorted index (no debounce delay)
            const sorted = buildAllModeSearchList().slice(0, (0, _searchLimits.SEARCH_RESULT_LIMIT));
            setServices(sorted);
        }
    };
    // Debounced search — stored in a ref so the debounce timeoutId survives re-renders.
    // A monotonic sequence number guards against out-of-order responses from
    // back-to-back debounce firings.
    const searchSeq = (0, _hooks.useRef)(0);
    const setServicesRef = (0, _hooks.useRef)(null);
    const setStopsRef = (0, _hooks.useRef)(null);
    const setSearchingRef = (0, _hooks.useRef)(null);
    setServicesRef.current = setServices;
    setStopsRef.current = setStops;
    setSearchingRef.current = setSearching;
    const performSearchRef = (0, _hooks.useRef)(null);
    if (!performSearchRef.current) performSearchRef.current = debounce(async (value)=>{
        try {
            if (value) {
                const seq = searchSeq.current;
                const { services, stops, locations } = await (0, _workerClient.workerSearch)(value);
                if (seq !== searchSeq.current) return; // stale — a newer query is in flight
                setServicesRef.current(services);
                setStopsRef.current(stops);
                setLocations((0, _cityConfig.isAlphaEnabled)() && locationSearchEnabledRef.current ? locations : []);
                setSearchingRef.current(true);
                if (!IS_ALL_MODE && servicesList.current) {
                    // Scroll to top, with hack for momentum scrolling
                    // https://popmotion.io/blog/20170704-manually-set-scroll-while-ios-momentum-scroll-bounces/
                    servicesList.current.style['-webkit-overflow-scrolling'] = 'auto';
                    servicesList.current.scrollTop = 0;
                    servicesList.current.style['-webkit-overflow-scrolling'] = null;
                }
            } else {
                setServicesRef.current(IS_ALL_MODE ? buildAllModeSearchList().slice(0, (0, _searchLimits.SEARCH_RESULT_LIMIT)) : servicesDataArr);
                setStopsRef.current(currentLocationRef.current ? closestStopsRef.current : []);
                setLocations([]);
                setLiveLocations([]);
                setSearchingRef.current(false);
            }
        } catch (err) {}
    }, 150);
    const performSearch = performSearchRef.current;
    // Separate, longer debounce for live Nominatim lookups (alpha "locations"
    // feature) — a network round trip, kept independent of the instant local
    // Fuse search above so it never blocks/slows down services/stops results.
    const geocodeSeq = (0, _hooks.useRef)(0);
    const performGeocodeRef = (0, _hooks.useRef)(null);
    if (!performGeocodeRef.current) performGeocodeRef.current = debounce(async (value)=>{
        if (!(0, _cityConfig.isAlphaEnabled)() || !locationSearchEnabledRef.current || value.trim().length < 3) {
            setLiveLocations([]);
            return;
        }
        const seq = ++geocodeSeq.current;
        const results = await (0, _geocode.fetchGeocode)(value, [
            lowerLat,
            lowerLong,
            upperLat,
            upperLong
        ]);
        if (seq !== geocodeSeq.current) return; // stale
        setLiveLocations(results);
    }, 400);
    const performGeocode = performGeocodeRef.current;
    const handleSearch = (e)=>{
        const { value } = e && e.target || searchField;
        searchSeq.current++;
        setVehicleQuery(value || '');
        loadActiveVehicles();
        // Keep pending queries bounded while the worker catches up.
        if (value && !searching) {
            setSearching(true);
            setServices((current)=>current.slice(0, (0, _searchLimits.COLLAPSED_SEARCH_LIMIT)));
            setStops([]);
        }
        performSearch(value);
        performGeocode(value);
    };
    const handleSearchClose = ()=>{
        setExpandSearch(false);
        $map.classList.remove('fade-out');
        resetSearch();
        (0, _mobilePane.movePaneToBreak)(searchPane, 'middle');
    };
    const resetSearch = ()=>{
        var _searchField_current;
        searchSeq.current++;
        (_searchField_current = searchField.current) === null || _searchField_current === void 0 ? void 0 : _searchField_current.blur();
        searchField.current.value = '';
        setVehicleQuery('');
        setSearching(false);
        expandedSearchOnce.current = false;
        setServices(IS_ALL_MODE ? buildAllModeSearchList().slice(0, (0, _searchLimits.SEARCH_RESULT_LIMIT)) : servicesDataArr);
        // Show closest stops if location is available, otherwise empty
        setStops(currentLocation ? closestStops : []);
        setLocations([]);
        setLiveLocations([]);
    };
    const handleServicesScroll = ()=>{
        if (expandSearch || expandedSearchOnce.current) return;
        setExpandSearch(true);
        expandedSearchOnce.current = true;
    // $map.classList.add('fade-out');
    };
    // Update closest stops whenever location changes — runs in the data worker (city mode) or
    // main thread (all-mode, since cityDataMap is already loaded).
    (0, _hooks.useEffect)(()=>{
        closestStopsRef.current = closestStops;
    }, [
        closestStops
    ]);
    (0, _hooks.useEffect)(()=>{
        currentLocationRef.current = currentLocation;
        if (IS_ALL_MODE) {
            if (!currentLocation) {
                setClosestStops([]);
                return;
            }
            setClosestStops(computeAllModeClosestStops(...currentLocation));
            return;
        }
        if (!currentLocation || !(stopsDataArr === null || stopsDataArr === void 0 ? void 0 : stopsDataArr.length)) {
            setClosestStops([]);
            return;
        }
        let cancelled = false;
        const [lng, lat] = currentLocation;
        (0, _workerClient.workerClosestStops)(lng, lat).then(({ stops })=>{
            if (!cancelled) setClosestStops(stops);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        currentLocation
    ]);
    // `city` omitted → city-scoped stop from the single loaded city's own
    // `stops`/`stops-highlight` sources; `city` given → all-mode stop pulled
    // from that city's `stops-${city}` source (and `stopData` must be passed
    // in, since there's no single loaded-city `stopsData` to look it up in).
    // `fromRouteView`: the user was reading a route when this stop was opened
    // (a row in the route list, or a stop on the route line). renderRoute
    // passes it explicitly since it resets showServicePopover before the stop
    // case; the direct map-tap path omits it and the live flag is read.
    const _showStopPopover = (0, _hooks.useCallback)((number, { city, stopData: providedStopData, fromRouteView } = {})=>{
        const stopData = providedStopData || stopsData[number];
        if (!(stopData === null || stopData === void 0 ? void 0 : stopData.coordinates)) return;
        const { coordinates } = stopData;
        // Opening a stop out of a route is a move *within* a view the user is
        // reading, not an arrival at a new one: snapping to street-level zoom 17
        // throws the route away, and does it as a hard cut whenever the route
        // was framed below zoom 12 (where the flight is suppressed). Ease in
        // just far enough to read the stop, and always animate.
        const keepRouteContext = fromRouteView !== null && fromRouteView !== void 0 ? fromRouteView : showServicePopoverRef.current;
        const panToStop = (offset)=>{
            const zoom = map.getZoom();
            if (keepRouteContext) map.flyTo({
                center: coordinates,
                offset,
                zoom: Math.max(zoom, 15),
                duration: 600
            });
            else if (zoom < 17) map.flyTo({
                zoom: 17,
                center: coordinates,
                offset,
                animate: zoom >= 12
            });
            else map.easeTo({
                center: coordinates,
                offset
            });
        };
        const popoverHeight = paneOrOffsetHeight(stopPopover.current);
        panToStop(BREAKPOINT() ? [
            0,
            0
        ] : [
            0,
            -(popoverHeight || 0) / 2
        ]);
        // Clear previous selection (from whichever source it was selected on)
        if (prevStopNumber.current) {
            if (prevStopCity.current) {
                const prevSrc = `stops-${prevStopCity.current}`;
                if (map.getSource(prevSrc)) map.setFeatureState({
                    source: prevSrc,
                    id: (0, _specialID.encode)(prevStopNumber.current)
                }, {
                    selected: false
                });
            } else {
                map.setFeatureState({
                    source: 'stops',
                    id: (0, _specialID.encode)(prevStopNumber.current)
                }, {
                    selected: false
                });
                map.setFeatureState({
                    source: 'stops-highlight',
                    id: (0, _specialID.encode)(prevStopNumber.current)
                }, {
                    selected: false
                });
            }
        }
        if (city) {
            const src = `stops-${city}`;
            if (map.getSource(src)) map.setFeatureState({
                source: src,
                id: (0, _specialID.encode)(number)
            }, {
                selected: true
            });
            // Expose city data so BusServicesArrival can resolve destination stop names
            const cityEntry = cityDataMap.get(city);
            if (cityEntry) window._data = {
                stopsData: cityEntry.stopsData,
                stopsDataArr: cityEntry.stopsDataArr,
                servicesData: cityEntry.servicesData,
                routesData: cityEntry.routesData,
                servicesDataArr: []
            };
            setHead({
                title: [
                    'stop.title',
                    {
                        stopNumber: number,
                        stopName: stopData.name
                    }
                ],
                url: `/all/stops/${city}^${number}`
            });
        } else {
            map.setFeatureState({
                source: 'stops',
                id: (0, _specialID.encode)(number)
            }, {
                selected: true
            });
            map.setFeatureState({
                source: 'stops-highlight',
                id: (0, _specialID.encode)(number)
            }, {
                selected: true
            });
        }
        setShrinkSearch(true);
        prevStopNumber.current = number;
        prevStopCity.current = city || null;
        setShowStopPopover(true);
        setStopPopoverData(city ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, stopData), {
            city
        }) : stopData);
        requestAnimationFrame(()=>{
            var _stopPopover_current, _stopPopover_current1;
            // Pane-managed height is a fixed estimate (see above) rather than a
            // measured DOM value, so there's nothing to re-measure here — this
            // recompute only matters for the non-pane (DOM-driven height) path.
            if ((0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT)) return;
            if (popoverHeight === ((_stopPopover_current = stopPopover.current) === null || _stopPopover_current === void 0 ? void 0 : _stopPopover_current.offsetHeight)) return;
            panToStop(BREAKPOINT() ? [
                0,
                0
            ] : [
                0,
                -((_stopPopover_current1 = stopPopover.current) === null || _stopPopover_current1 === void 0 ? void 0 : _stopPopover_current1.offsetHeight) / 2
            ]);
        });
    }, []);
    // Returning from a stop lands where the user left off in the route list,
    // not at the top of it.
    const flashStopInServiceList = (number)=>{
        var _servicePopover_current;
        const row = (_servicePopover_current = servicePopover.current) === null || _servicePopover_current === void 0 ? void 0 : _servicePopover_current.querySelector(`a[data-stop="${number}"]`);
        if (!row) return;
        row.classList.add('flash');
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
        setTimeout(()=>row.classList.remove('flash'), 1000);
    };
    const hideStopPopover = (e)=>{
        const { page, subpage } = route;
        if (e && (page !== 'stop' || subpage === 'routes')) e.preventDefault();
        const number = (stopPopoverData === null || stopPopoverData === void 0 ? void 0 : stopPopoverData.number) || prevStopNumber.current;
        if (number) {
            var _stopPopover_current;
            const stopSource = IS_ALL_MODE && prevStopCity.current ? `stops-${prevStopCity.current}` : 'stops';
            if (map === null || map === void 0 ? void 0 : map.getSource(stopSource)) map.setFeatureState({
                source: stopSource,
                id: (0, _specialID.encode)(number)
            }, {
                selected: false
            });
            if (map === null || map === void 0 ? void 0 : map.getSource('stops-highlight')) map.setFeatureState({
                source: 'stops-highlight',
                id: (0, _specialID.encode)(number)
            }, {
                selected: false
            });
            if ((_stopPopover_current = stopPopover.current) === null || _stopPopover_current === void 0 ? void 0 : _stopPopover_current.classList.contains('expand')) {
                // As a mobile sheet the route popover is right now the display:none
                // leftover of its own teardown, so scrollIntoView would do nothing
                // and the row would come back at the top of a rebuilt list — hand it
                // to the service pane effect. Desktop keeps both mounted.
                if ((0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT)) revealStopInServiceList.current = number;
                else requestAnimationFrame(()=>flashStopInServiceList(number));
            }
        }
        setShowStopPopover(false);
        prevStopNumber.current = null;
        prevStopCity.current = null;
    };
    // Alpha "locations" feature — map pin for the selected location, created
    // lazily and reused, following GeolocateControl's DOM-marker pattern
    // (locations aren't part of the GeoJSON `stops` source, so they can't use
    // setFeatureState like stop selection does).
    const showLocationMarker = ({ lat, lon, color })=>{
        if (!locationMarkerRef.current) {
            const el = document.createElement('div');
            el.className = 'location-marker';
            el.innerHTML = '<div class="location-marker-pin"></div>';
            locationMarkerRef.current = new (0, _maplibreGlDefault.default).Marker({
                element: el,
                anchor: 'bottom'
            });
        }
        const pin = locationMarkerRef.current.getElement().querySelector('.location-marker-pin');
        if (pin) pin.style.color = color || '';
        locationMarkerRef.current.setLngLat([
            lon,
            lat
        ]).addTo(map);
    };
    const hideLocationMarker = ()=>{
        var _locationMarkerRef_current;
        (_locationMarkerRef_current = locationMarkerRef.current) === null || _locationMarkerRef_current === void 0 ? void 0 : _locationMarkerRef_current.remove();
    };
    const _showLocationPopover = (0, _hooks.useCallback)((locInfo)=>{
        const { lat, lon } = locInfo;
        const popoverHeight = paneOrOffsetHeight(locationPopover.current);
        const offset = BREAKPOINT() ? [
            0,
            0
        ] : [
            0,
            -(popoverHeight || 0) / 2
        ];
        const zoom = map.getZoom();
        if (zoom < 16) map.flyTo({
            zoom: 16,
            center: [
                lon,
                lat
            ],
            offset,
            animate: zoom >= 12
        });
        else map.easeTo({
            center: [
                lon,
                lat
            ],
            offset
        });
        showLocationMarker(locInfo);
        setShrinkSearch(true);
        setShowLocationPopover(true);
        setLocationPopoverData(locInfo);
        setLocationPopoverLoading(true);
        setLocationPopoverStops([]);
        const seq = ++locationSearchSeq.current;
        if (IS_ALL_MODE) {
            // Pin bounds-guessed candidate cities immediately so the viewport
            // engine's checkViewport (which unloads any city outside the current
            // view and not "pinned") can't rip the data back out from under
            // resolveLocationStops's loadCityData calls mid-flight.
            const candidateCities = (0, _config.AVAILABLE_CITIES).filter((c)=>{
                var _CITY_CONFIGS_c_city, _CITY_CONFIGS_c;
                const b = (_CITY_CONFIGS_c = (0, _cityConfig.CITY_CONFIGS)[c]) === null || _CITY_CONFIGS_c === void 0 ? void 0 : (_CITY_CONFIGS_c_city = _CITY_CONFIGS_c.city) === null || _CITY_CONFIGS_c_city === void 0 ? void 0 : _CITY_CONFIGS_c_city.bounds;
                return b && lon >= b.lowerLong && lon <= b.upperLong && lat >= b.lowerLat && lat <= b.upperLat;
            });
            activeSelectionCities.clear();
            candidateCities.forEach((c)=>activeSelectionCities.add(c));
        }
        resolveLocationStops(lat, lon).then((stops)=>{
            if (seq !== locationSearchSeq.current) return; // stale — a newer location is showing
            if (IS_ALL_MODE) {
                // Now that we know the real city/cities, pin exactly those (dropping
                // any other bounds-guessed candidates) so they stay loaded for as
                // long as this popover is showing them.
                activeSelectionCities.clear();
                stops.forEach((s)=>activeSelectionCities.add(s.city));
                releaseUnpinnedCities();
            }
            setLocationPopoverStops(stops);
            setLocationPopoverLoading(false);
        });
        // No cached/local-POI name was available — fall back to a reverse-geocode
        // lookup, filling in the popover title once it resolves.
        if (!locInfo.name) {
            const key = locationKey(lat, lon);
            withTimeout((0, _geocode.fetchReverseGeocode)(lat, lon), LOCATION_FETCH_TIMEOUT_MS, null).then((name)=>{
                if (seq !== locationSearchSeq.current) return; // stale — a newer location is showing
                const resolved = name || 'Selected Location';
                locationNameCache.set(key, {
                    name: resolved
                });
                setLocationPopoverData((prev)=>prev && prev.lat === lat && prev.lon === lon ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), {
                        name: resolved
                    }) : prev);
            });
        }
    }, []);
    const hideLocationPopover = ()=>{
        var // Belt-and-suspenders for the same race the location route handler
        // guards against above — if stops still hadn't loaded for this area by
        // the time the popover closes, re-check now rather than leaving the
        // user stuck until their next pan/zoom.
        _checkViewportRef_current;
        setShowLocationPopover(false);
        hideLocationMarker();
        (_checkViewportRef_current = checkViewportRef.current) === null || _checkViewportRef_current === void 0 ? void 0 : _checkViewportRef_current.call(checkViewportRef);
    };
    const navBackToStop = (e)=>{
        if ((prevRoute === null || prevRoute === void 0 ? void 0 : prevRoute.page) === 'stop') {
            e.preventDefault();
            history.back();
        }
    };
    const zoomToStop = (num)=>{
        var _cityDataMap_get_stopsData, _cityDataMap_get;
        const number = num || (stopPopoverData === null || stopPopoverData === void 0 ? void 0 : stopPopoverData.number);
        const stopEntry = IS_ALL_MODE ? ((_cityDataMap_get = cityDataMap.get(stopPopoverData === null || stopPopoverData === void 0 ? void 0 : stopPopoverData.city)) === null || _cityDataMap_get === void 0 ? void 0 : (_cityDataMap_get_stopsData = _cityDataMap_get.stopsData) === null || _cityDataMap_get_stopsData === void 0 ? void 0 : _cityDataMap_get_stopsData[number]) || stopsData[number] : stopsData[number];
        const { coordinates } = stopEntry || {};
        if (!coordinates) return;
        let offset = BREAKPOINT() ? [
            0,
            0
        ] : [
            0,
            -paneOrOffsetHeight(stopPopover.current) / 2
        ];
        if (showServicePopover) offset = BREAKPOINT() ? [
            -servicePopover.current.offsetWidth / 3,
            0
        ] : [
            0,
            -paneOrOffsetHeight(servicePopover.current) / 2
        ];
        const zoom = map.getZoom();
        if (zoom < 17) map.flyTo({
            zoom: 17,
            center: coordinates,
            offset
        });
        else map.easeTo({
            center: coordinates,
            offset
        });
    };
    const highlightRouteTag = (service)=>{
        var _floatPill_current;
        const $servicesList = (_floatPill_current = floatPill.current) === null || _floatPill_current === void 0 ? void 0 : _floatPill_current.querySelector('.services-list');
        if (!$servicesList) return;
        if (service) {
            const otherServices = $servicesList.querySelectorAll('.service-tag');
            otherServices.forEach((el)=>{
                el.classList.remove('highlight');
                if (el.dataset.service.trim() === service.trim()) el.style.opacity = '';
                else el.style.opacity = 0.3;
            });
        } else $servicesList.querySelectorAll('.service-tag').forEach((el)=>el.style.opacity = '');
    };
    const clickRoute = (e, service)=>{
        e.stopPropagation();
        e.preventDefault();
        if (IS_ALL_MODE) location.hash = e.currentTarget.getAttribute('href');
        else navigateTo(`/services/${encodeURIComponent(service)}`, route);
    };
    const highlightRoute = (e, service)=>{
        var _STORE_routesPathServices;
        if (e) e.target.classList.remove('highlight');
        const hoveredRouteID = (0, _specialID.encode)(service);
        map.setFeatureState({
            source: 'routes-path',
            id: hoveredRouteID
        }, {
            hover: true,
            fadein: false
        });
        (_STORE_routesPathServices = STORE.routesPathServices) === null || _STORE_routesPathServices === void 0 ? void 0 : _STORE_routesPathServices.forEach((service)=>{
            const id = (0, _specialID.encode)(service);
            if (hoveredRouteID === id) return;
            map.setFeatureState({
                source: 'routes-path',
                id
            }, {
                hover: false,
                fadein: true
            });
        });
    };
    const unhighlightRoute = (e)=>{
        var _e_target, _STORE_routesPathServices;
        if (e && ((_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.classList.contains('service-tag'))) e.target.classList.remove('highlight');
        (_STORE_routesPathServices = STORE.routesPathServices) === null || _STORE_routesPathServices === void 0 ? void 0 : _STORE_routesPathServices.forEach((service)=>{
            const id = (0, _specialID.encode)(service);
            map.setFeatureState({
                source: 'routes-path',
                id
            }, {
                fadein: false,
                hover: false
            });
        });
    };
    const _showBetweenPopover = (data)=>{
        var _data_results;
        setShrinkSearch(true);
        setShowBetweenPopover(data);
        // Only auto-select when there's a single candidate route — with
        // multiple candidates the list itself is the useful result and should
        // stay showing. Mirrors clicking the (only) result; safe since
        // navigating to its /<n> subpage no longer wipes showBetweenPopover,
        // see the isSameBetweenQuery guard in renderRoute().
        if (((_data_results = data.results) === null || _data_results === void 0 ? void 0 : _data_results.length) === 1) setTimeout(()=>{
            var _betweenPopover_current;
            const firstResult = (_betweenPopover_current = betweenPopover.current) === null || _betweenPopover_current === void 0 ? void 0 : _betweenPopover_current.querySelector('.between-item');
            firstResult === null || firstResult === void 0 ? void 0 : firstResult.click();
        }, 300);
    };
    const cannotPreviewRoute = ()=>{
        const { page, subpage, value } = route;
        return subpage === 'routes' || page === 'service' && value.split('~').length > 1;
    };
    const previewRoute = (service)=>{
        if (IS_ALL_MODE) return; // later implement preview route
        cancelAnimationFrame(previewRAF);
        if (cannotPreviewRoute()) return;
        previewRAF = requestAnimationFrame(()=>{
            const routes = routesData[service];
            const geometries = routes.map((route)=>decodePolyline(route));
            map.getSource('routes-path').setData({
                type: 'FeatureCollection',
                features: geometries.map((geometry)=>({
                        type: 'Feature',
                        id: (0, _specialID.encode)(service),
                        properties: {
                            service
                        },
                        geometry
                    }))
            });
        });
    };
    const unpreviewRoute = ()=>{
        cancelAnimationFrame(previewRAF);
        if (cannotPreviewRoute()) return;
        map.getSource('routes-path').setData({
            type: 'FeatureCollection',
            features: []
        });
    };
    const isValidCoords = (coords)=>Array.isArray(coords) && coords.length >= 2 && typeof coords[0] === 'number' && !isNaN(coords[0]) && typeof coords[1] === 'number' && !isNaN(coords[1]);
    // Draws an itinerary (legacy single-city or RAPTOR cross-city — both share
    // the {startId, legs} shape since dataWorker.js's handleBetweenRoutes was
    // normalized to match raptor.js's output) on the map: stop markers,
    // service-polyline segments per ride leg, and straight lines per walk leg.
    //
    // `resolveStop(id)` and `getServicePolylines(city, service)` are the two
    // things that differ by mode — legacy ids are bare stop numbers resolved
    // via the single loaded city's `stopsData`; RAPTOR ids are `city^number`
    // resolved via `cityDataMap`, and its polylines come from the matching
    // city's own `routesData`.
    //
    // `literalStartStop`/`literalEndStop` are legacy-only: the stop the user
    // actually picked, which can differ from `itinerary.startId`/the last
    // leg's `to` when a nearby-stop match was used — RAPTOR never needs this,
    // since its own search already bakes a real walk leg into `legs` for that
    // case. Passing them synthesizes the equivalent leading/trailing walk leg
    // here for rendering, exactly as RAPTOR itineraries already carry one.
    const renderBetweenItinerary = (itinerary, { e, resolveStop, getServicePolylines, literalStartStop, literalEndStop } = {})=>{
        var _itinerary_legs, _e_target;
        if (!(itinerary === null || itinerary === void 0 ? void 0 : (_itinerary_legs = itinerary.legs) === null || _itinerary_legs === void 0 ? void 0 : _itinerary_legs.length)) return;
        // Selection highlighting (skipped when called without a click event, e.g.
        // restoring a selection from a deep-linked result URL)
        const clickedItem = e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.closest('.between-item');
        if (clickedItem) {
            const container = clickedItem.closest('.between-block');
            if (container) container.querySelectorAll('.between-item').forEach((el)=>{
                el.classList.toggle('selected', el === clickedItem);
            });
        }
        const renderLegs = [
            ...itinerary.legs
        ];
        let renderStartId = itinerary.startId;
        if (literalStartStop && String(itinerary.startId) !== String(literalStartStop.number)) {
            renderLegs.unshift({
                kind: 'walk',
                to: itinerary.startId
            });
            renderStartId = literalStartStop.number;
        }
        const lastTo = itinerary.legs[itinerary.legs.length - 1].to;
        if (literalEndStop && String(lastTo) !== String(literalEndStop.number)) renderLegs.push({
            kind: 'walk',
            to: literalEndStop.number
        });
        // Build stops for map markers
        const highlightStops = [];
        const addHighlight = (id, type)=>{
            const stop = resolveStop(id);
            if ((stop === null || stop === void 0 ? void 0 : stop.coordinates) && isValidCoords(stop.coordinates)) highlightStops.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, stop), {
                number: id,
                _type: type
            }));
        };
        addHighlight(renderStartId, 'end');
        addHighlight(renderLegs[renderLegs.length - 1].to, 'end');
        // Every intermediate leg's destination is an interchange/waypoint, not
        // the origin or destination — a transfer leg's full candidate list (see
        // dataWorker.js) is shown in full rather than just the resolved one.
        renderLegs.slice(0, -1).forEach((leg)=>{
            var _leg_transferCandidates;
            if ((_leg_transferCandidates = leg.transferCandidates) === null || _leg_transferCandidates === void 0 ? void 0 : _leg_transferCandidates.length) leg.transferCandidates.forEach((number)=>addHighlight(number, 'intersect'));
            else addHighlight(leg.to, 'intersect');
        });
        // Update stops-highlight source
        const stopsHighlightSource = map.getSource('stops-highlight');
        if (stopsHighlightSource) stopsHighlightSource.setData({
            type: 'FeatureCollection',
            features: highlightStops.map((stop)=>({
                    type: 'Feature',
                    id: (0, _specialID.encode)(stop.number),
                    properties: {
                        name: stop.name,
                        number: stop.number,
                        type: stop._type,
                        left: stop.left
                    },
                    geometry: {
                        type: 'Point',
                        coordinates: stop.coordinates
                    }
                }))
        });
        requestAnimationFrame(()=>{
            var _betweenPopover_current, _betweenPopover_current1;
            const geometries = [];
            let fromId = renderStartId;
            renderLegs.forEach((leg)=>{
                const fromStop = resolveStop(fromId);
                const toStop = resolveStop(leg.to);
                fromId = leg.to;
                if (!(fromStop === null || fromStop === void 0 ? void 0 : fromStop.coordinates) || !(toStop === null || toStop === void 0 ? void 0 : toStop.coordinates)) return;
                if (leg.kind === 'walk') {
                    geometries.push({
                        kind: 'walk',
                        geometry: {
                            type: 'LineString',
                            coordinates: [
                                fromStop.coordinates,
                                toStop.coordinates
                            ]
                        }
                    });
                    return;
                }
                const servicePolylines = getServicePolylines(fromStop.city, leg.service);
                let cropped = null;
                if (servicePolylines === null || servicePolylines === void 0 ? void 0 : servicePolylines.length) try {
                    cropped = (0, _geometry.findBestRouteSegment)(servicePolylines, fromStop.coordinates, toStop.coordinates, (0, _polyline.toGeoJSON));
                } catch (err) {}
                geometries.push({
                    kind: 'ride',
                    geometry: cropped ? {
                        type: 'LineString',
                        coordinates: cropped
                    } : {
                        type: 'LineString',
                        coordinates: [
                            fromStop.coordinates,
                            toStop.coordinates
                        ]
                    }
                });
            });
            // Update routes-between source — the first/second *ride* segment gets
            // the start/end gradient color (see the 'routes-between' layer's
            // paint), regardless of where any walk segments fall in the sequence.
            const routesBetweenSource = map.getSource('routes-between');
            if (routesBetweenSource) {
                let rideIndex = 0;
                routesBetweenSource.setData({
                    type: 'FeatureCollection',
                    features: geometries.map(({ kind, geometry })=>{
                        const type = kind === 'walk' ? 'walk' : rideIndex++ === 0 ? 'start' : 'end';
                        return {
                            type: 'Feature',
                            properties: {
                                type
                            },
                            geometry
                        };
                    })
                });
            }
            // Fit map bounds
            const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
            let hasValidBounds = false;
            highlightStops.forEach((stop)=>{
                if (isValidCoords(stop.coordinates)) {
                    bounds.extend(stop.coordinates);
                    hasValidBounds = true;
                }
            });
            if (hasValidBounds) map.fitBounds(bounds, {
                padding: BREAKPOINT() ? {
                    top: 80,
                    right: (((_betweenPopover_current = betweenPopover.current) === null || _betweenPopover_current === void 0 ? void 0 : _betweenPopover_current.offsetWidth) || 0) + 80,
                    bottom: 80,
                    left: 80
                } : {
                    top: 80,
                    right: 80,
                    bottom: (((_betweenPopover_current1 = betweenPopover.current) === null || _betweenPopover_current1 === void 0 ? void 0 : _betweenPopover_current1.offsetHeight) || 0) + 80,
                    left: 80
                }
            });
        });
    };
    const legacyResolveStop = (id)=>{
        const s = stopsData === null || stopsData === void 0 ? void 0 : stopsData[id];
        return s ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, s), {
            city: undefined,
            number: id
        }) : null;
    };
    const legacyGetServicePolylines = (city, service)=>routesData === null || routesData === void 0 ? void 0 : routesData[service];
    const allModeResolveStop = (globalId)=>{
        var _cityDataMap_get_stopsData, _cityDataMap_get;
        const [city, number] = String(globalId).split('^');
        const stop = (_cityDataMap_get = cityDataMap.get(city)) === null || _cityDataMap_get === void 0 ? void 0 : (_cityDataMap_get_stopsData = _cityDataMap_get.stopsData) === null || _cityDataMap_get_stopsData === void 0 ? void 0 : _cityDataMap_get_stopsData[number];
        return stop ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, stop), {
            city,
            number
        }) : null;
    };
    const allModeGetServicePolylines = (city, service)=>{
        var _cityDataMap_get_routesData, _cityDataMap_get;
        return (_cityDataMap_get = cityDataMap.get(city)) === null || _cityDataMap_get === void 0 ? void 0 : (_cityDataMap_get_routesData = _cityDataMap_get.routesData) === null || _cityDataMap_get_routesData === void 0 ? void 0 : _cityDataMap_get_routesData[service];
    };
    // Nationwide precomputed indices for all-mode routing, fetched once and
    // cached: the inter-cluster walking-transfer graph (data/all/transfers.min.json)
    // and the per-stop trip-frequency index (data/all/frequency.min.json) the
    // RAPTOR search's cost function looks up synchronously (no network calls
    // inside the round loop — see raptor.js's header comment for why that
    // matters). The intra-cluster same-place stop groups come from each city's
    // own clusters.min.json (already fetched into cityDataMap by loadCityData)
    // plus the small loadCrossCityClusters() leftover, not a single nationwide
    // file — see globaltransfers.py.
    let globalTransfersPromise = null;
    const loadGlobalTransfers = ()=>{
        if (!globalTransfersPromise) globalTransfersPromise = (0, _fetchCacheDefault.default)('/data/all/transfers.min.json', 1440);
        return globalTransfersPromise;
    };
    let globalFrequencyPromise = null;
    const loadGlobalFrequency = ()=>{
        if (!globalFrequencyPromise) globalFrequencyPromise = (0, _fetchCacheDefault.default)('/data/all/frequency.min.json', 1440);
        return globalFrequencyPromise;
    };
    /**
   * All-mode `between`: runs unscoped (cross-city) RAPTOR over every city's
   * route graph. The search itself needs every city's stop/route data in
   * memory (it doesn't know upfront which cities a path will cross), so this
   * fetches data-only for every city via `loadCityData` — no map sources or
   * layers, just the routing graph. Only the cities actually touched by the
   * resulting itineraries (plus the two endpoint cities) get their stops/
   * routes fully loaded onto the map afterwards, and are pinned in
   * `activeSelectionCities` so panning the map while viewing the result can't
   * unload them. Additive to, and independent of, single-city `between`'s
   * worker-based search.
   */ // startToken/endToken are `between` endpoint tokens (see encodeBetweenToken/
    // decodeBetweenToken) — either "{city}^{number}" for a stop, or
    // "loc:{lat},{lon}" for a location, which resolves to its whole nearby-stop
    // cluster and searches from/to all of them at once (see computeRaptorRoute's
    // startIds/endIds).
    const runAllModeBetween = async (startToken, endToken)=>{
        const startEndpoint = decodeBetweenToken(startToken);
        const endEndpoint = decodeBetweenToken(endToken);
        // Computed synchronously (cache/POI lookup only, no network) so the
        // header never has to fall back to the raw "loc:{lat},{lon}" token
        // during the "Finding routes…" phase, before startStop/endStop resolve.
        const startLocation = (startEndpoint === null || startEndpoint === void 0 ? void 0 : startEndpoint.type) === 'location' ? {
            lat: startEndpoint.lat,
            lon: startEndpoint.lon,
            name: friendlyLocationName(startEndpoint.lat, startEndpoint.lon)
        } : null;
        const endLocation = (endEndpoint === null || endEndpoint === void 0 ? void 0 : endEndpoint.type) === 'location' ? {
            lat: endEndpoint.lat,
            lon: endEndpoint.lon,
            name: friendlyLocationName(endEndpoint.lat, endEndpoint.lon)
        } : null;
        activeSelectionCities.clear();
        if ((startEndpoint === null || startEndpoint === void 0 ? void 0 : startEndpoint.type) === 'stop') activeSelectionCities.add(startEndpoint.city);
        if ((endEndpoint === null || endEndpoint === void 0 ? void 0 : endEndpoint.type) === 'stop') activeSelectionCities.add(endEndpoint.city);
        setAllModeBetween({
            startId: startToken,
            endId: endToken,
            startStop: null,
            endStop: null,
            startLocation,
            endLocation,
            itineraries: [],
            loading: true,
            error: null
        });
        try {
            const [, transfers, crossCityClusters, frequencyIndex] = await Promise.all([
                Promise.all((0, _config.AVAILABLE_CITIES).map((c)=>loadCityData(c))),
                loadGlobalTransfers(),
                loadCrossCityClusters(),
                loadGlobalFrequency()
            ]);
            const resolveEndpoint = async (endpoint)=>{
                if (!endpoint) return null;
                if (endpoint.type === 'stop') {
                    var _cityDataMap_get_stopsData, _cityDataMap_get;
                    const stop = (_cityDataMap_get = cityDataMap.get(endpoint.city)) === null || _cityDataMap_get === void 0 ? void 0 : (_cityDataMap_get_stopsData = _cityDataMap_get.stopsData) === null || _cityDataMap_get_stopsData === void 0 ? void 0 : _cityDataMap_get_stopsData[endpoint.number];
                    return stop ? {
                        ids: [
                            `${endpoint.city}^${endpoint.number}`
                        ],
                        displayStop: (0, _objectSpreadProps._)((0, _objectSpread._)({}, stop), {
                            city: endpoint.city,
                            number: endpoint.number
                        })
                    } : null;
                }
                const stops = await resolveLocationStops(endpoint.lat, endpoint.lon);
                return stops.length ? {
                    ids: stops.map((s)=>`${s.city}^${s.number}`),
                    displayStop: stops[0]
                } : null;
            };
            const [startResolved, endResolved] = await Promise.all([
                resolveEndpoint(startEndpoint),
                resolveEndpoint(endEndpoint)
            ]);
            if (!startResolved || !endResolved) {
                setAllModeBetween((prev)=>prev && prev.startId === startToken && prev.endId === endToken ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), {
                        loading: false,
                        error: 'Stop not found.'
                    }) : prev);
                return;
            }
            // Build the index and run the search inside a worker — both are
            // synchronous, CPU-bound work over every currently-loaded city's stop/
            // route data and previously ran on the main thread for every search.
            await (0, _raptorWorkerClient.syncRaptorWorkerCities)(cityDataMap);
            const { itineraries, globalIndex } = await (0, _raptorWorkerClient.searchRaptorWorker)({
                cityCodes: [
                    ...cityDataMap.keys()
                ],
                transfers,
                crossCityClusters,
                frequencyIndex,
                startIds: startResolved.ids,
                endIds: endResolved.ids
            });
            if (itineraries.length) await (0, _raptor.refineWithSchedule)(itineraries, globalIndex);
            // Render/pin only the cities the result actually touches — everything
            // else stays data-only (fetched above for the search, but never added
            // to the map).
            const touchedCities = new Set([
                ...startResolved.ids,
                ...endResolved.ids
            ].map((id)=>id.split('^')[0]));
            itineraries.forEach((it)=>{
                it.legs.forEach((leg)=>touchedCities.add(leg.to.split('^')[0]));
            });
            touchedCities.forEach((c)=>activeSelectionCities.add(c));
            await Promise.all([
                ...touchedCities
            ].map((c)=>loadCity(c)));
            // Release cities pinned by a previous between query that this one
            // doesn't touch and that are outside the viewport.
            releaseUnpinnedCities();
            setAllModeBetween((prev)=>prev && prev.startId === startToken && prev.endId === endToken ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), {
                    startStop: startResolved.displayStop,
                    endStop: endResolved.displayStop,
                    itineraries,
                    loading: false,
                    error: itineraries.length ? null : 'No route found.'
                }) : prev);
        } catch (error) {
            setAllModeBetween((prev)=>prev && prev.startId === startToken && prev.endId === endToken ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), {
                    loading: false,
                    error: 'Something went wrong.'
                }) : prev);
        }
    };
    // Deep-linking a specific result (`.../between/<query>/<result-num>`) should
    // draw that itinerary on the map even if the user never clicked it — e.g. a
    // shared link, or the back/forward buttons restoring a selection.
    (0, _hooks.useEffect)(()=>{
        if (route.page !== 'between' || !route.subpage) return;
        const idx = parseInt(route.subpage, 10) - 1;
        if (!Number.isInteger(idx) || idx < 0) return;
        if (IS_ALL_MODE) {
            var _allModeBetween_itineraries;
            const itinerary = allModeBetween === null || allModeBetween === void 0 ? void 0 : (_allModeBetween_itineraries = allModeBetween.itineraries) === null || _allModeBetween_itineraries === void 0 ? void 0 : _allModeBetween_itineraries[idx];
            if (itinerary) renderBetweenItinerary(itinerary, {
                resolveStop: allModeResolveStop,
                getServicePolylines: allModeGetServicePolylines
            });
        } else if (showBetweenPopover) {
            const sorted = (0, _betweenRoutes.sortAndFilterResults)(showBetweenPopover.results || [], showBetweenPopover.arrivalData, showBetweenPopover.staticFrequency);
            const itinerary = sorted[idx];
            if (itinerary) renderBetweenItinerary(itinerary, {
                resolveStop: legacyResolveStop,
                getServicePolylines: legacyGetServicePolylines,
                literalStartStop: showBetweenPopover.startStop,
                literalEndStop: showBetweenPopover.endStop
            });
        }
    }, [
        route.page,
        route.subpage,
        allModeBetween,
        showBetweenPopover
    ]);
    const defaultURL = document.querySelector('meta[property="og:url"]').content;
    const defaultImg = document.querySelector('meta[property="og:image"]').content;
    const defaultHead = {
        title: [
            'app.title'
        ],
        url: defaultURL,
        desc: [
            'app.description'
        ],
        image: defaultImg
    };
    const [head, setHead] = (0, _hooks.useState)(defaultHead);
    (0, _hooks.useEffect)(()=>{
        let { title, url, desc, image } = head;
        document.title = document.querySelector('meta[property="og:title"]').content = Array.isArray(title) ? t(...title) : title;
        if (!/^https?/.test(url)) {
            const { city } = route;
            const cityPrefix = city ? `/${city}` : '';
            url = `https://transitrouter.vonter.in/#${cityPrefix}${url}`;
        }
        document.querySelector('meta[property="og:url"]').content = url;
        document.querySelector('meta[name="description"]').content = document.querySelector('meta[property="og:description"]').content = Array.isArray(desc) ? t(...desc) : desc;
        document.querySelector('meta[property="og:image"]').content = image;
    }, [
        head
    ]);
    const renderRoute = ()=>{
        var // Stop vehicle tracking when changing routes
        _vehicleTracker_current;
        const route = (0, _getRouteDefault.default)();
        const renderSeq = ++routeRenderSeq.current;
        const scheduleRouteFrame = (callback)=>requestAnimationFrame(()=>{
                if (renderSeq === routeRenderSeq.current) callback();
            });
        // Read before the resets below clear it: was a route on screen when this
        // navigation started? Tapping a row in a route list tears that view down,
        // but the stop it lands on is still one the user was reading the route
        // for — which is what the map pan needs to know (see _showStopPopover).
        const fromRouteView = showServicePopoverRef.current;
        // Vehicle page (from a vehicle search result): fetches the vehicle's info,
        // draws its route (if any) and position, and keeps both fresh. Reads the
        // module-level stopsData/servicesData/routesData, which in all-mode the
        // caller must have merged for `cityCode` first.
        const resetVehiclePage = ()=>{
            var _map_getSource;
            vehicleSeq.current++;
            setFollowedVehicleId(null);
            clearInterval(vehiclePoll.current);
            vehiclePoll.current = null;
            setVehiclePanel(null);
            (_map_getSource = map.getSource('vehicle-focus')) === null || _map_getSource === void 0 ? void 0 : _map_getSource.setData({
                type: 'FeatureCollection',
                features: []
            });
        };
        const startVehiclePage = (cityCode, vehicleId)=>{
            var _getConfigForCity_vehicleLookup, _getConfigForCity;
            const apiPath = (_getConfigForCity = (0, _config.getConfigForCity)(cityCode)) === null || _getConfigForCity === void 0 ? void 0 : (_getConfigForCity_vehicleLookup = _getConfigForCity.vehicleLookup) === null || _getConfigForCity_vehicleLookup === void 0 ? void 0 : _getConfigForCity_vehicleLookup.apiPath;
            if (!vehicleId || !apiPath) {
                navigateTo('/', route);
                return;
            }
            setExpandSearch(false);
            setShrinkSearch(true);
            resetSearch();
            setHead({
                title: [
                    'vehicle.title',
                    {
                        vehicleNumber: vehicleId
                    }
                ],
                url: IS_ALL_MODE ? `/all/vehicle/${cityCode}^${encodeURIComponent(vehicleId)}` : `/vehicle/${encodeURIComponent(vehicleId)}`
            });
            if (IS_ALL_MODE) {
                activeSelectionCities.clear();
                activeSelectionCities.add(cityCode);
                releaseUnpinnedCities();
                loadedCities.forEach((c)=>{
                    if (map.getLayer(`stops-${c}`)) map.setLayoutProperty(`stops-${c}`, 'visibility', 'none');
                    if (map.getLayer(`stops-icon-${c}`)) map.setLayoutProperty(`stops-icon-${c}`, 'visibility', 'none');
                });
            } else {
                map.setLayoutProperty('stops', 'visibility', 'none');
                if (map.getLayer('stops-icon')) map.setLayoutProperty('stops-icon', 'visibility', 'none');
            }
            const seq = ++vehicleSeq.current;
            let first = true;
            vehicleRouteRef.current = undefined;
            const coordsFor = (id)=>{
                var _stopsData_id;
                return ((_stopsData_id = stopsData[id]) === null || _stopsData_id === void 0 ? void 0 : _stopsData_id.coordinates) || null;
            };
            const load = async ()=>{
                var _map_getSource;
                const { info, notFound } = await (0, _vehicleLookup.fetchVehicleInfo)(apiPath, vehicleId);
                if (seq !== vehicleSeq.current) return;
                const isFirst = first;
                first = false;
                // A transient failure on a refresh keeps what's already shown.
                if (!info && !notFound && !isFirst) return;
                const svc = (info === null || info === void 0 ? void 0 : info.routeNo) ? findServiceKey(String(info.routeNo)) : null;
                const estimated = info && !info.location ? (0, _vehicleLookup.estimateLocationFromStops)(info.stops, coordsFor) : null;
                const position = (info === null || info === void 0 ? void 0 : info.location) || estimated;
                setVehiclePanel({
                    id: vehicleId,
                    info,
                    notFound,
                    estimated,
                    svc
                });
                setRouteServices(svc ? [
                    svc
                ] : []);
                setRouteLoading(false);
                // Opened only once there is content, so the mobile sheet is never
                // sized while empty.
                if (isFirst) setShowServicePopover(true);
                var _info_heading;
                (_map_getSource = map.getSource('vehicle-focus')) === null || _map_getSource === void 0 ? void 0 : _map_getSource.setData({
                    type: 'FeatureCollection',
                    features: position ? [
                        {
                            type: 'Feature',
                            properties: {
                                vehicleNumber: info.vehicleNumber,
                                heading: (_info_heading = info.heading) !== null && _info_heading !== void 0 ? _info_heading : null
                            },
                            geometry: {
                                type: 'Point',
                                coordinates: [
                                    position.lng,
                                    position.lat
                                ]
                            }
                        }
                    ] : []
                });
                // The vehicle can switch (or lose) its route between polls — redraw
                // the route layers and refit only when it actually changes, not on
                // every 30s refresh.
                const routeChanged = svc !== vehicleRouteRef.current;
                if (!isFirst && !routeChanged) return;
                vehicleRouteRef.current = svc;
                const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
                let hasBounds = false;
                if (position) {
                    bounds.extend([
                        position.lng,
                        position.lat
                    ]);
                    hasBounds = true;
                }
                if (!svc) {
                    var _map_getSource1, _map_getSource2;
                    (_map_getSource1 = map.getSource('stops-highlight')) === null || _map_getSource1 === void 0 ? void 0 : _map_getSource1.setData({
                        type: 'FeatureCollection',
                        features: []
                    });
                    (_map_getSource2 = map.getSource('routes')) === null || _map_getSource2 === void 0 ? void 0 : _map_getSource2.setData({
                        type: 'FeatureCollection',
                        features: []
                    });
                }
                if (svc) {
                    const routes = getServiceRoutes(servicesData[svc]);
                    const routeStops = [
                        ...new Set(routes.flat())
                    ].filter((stop)=>stopsData[stop]);
                    const endStops = new Set();
                    routes.forEach((r)=>{
                        if (r === null || r === void 0 ? void 0 : r.length) endStops.add(r[0]).add(r[r.length - 1]);
                    });
                    routeStops.forEach((stop)=>bounds.extend(stopsData[stop].coordinates));
                    hasBounds = hasBounds || routeStops.length > 0;
                    map.getSource('stops-highlight').setData({
                        type: 'FeatureCollection',
                        features: routeStops.map((stop)=>{
                            const { name, left, coordinates } = stopsData[stop];
                            return {
                                type: 'Feature',
                                id: (0, _specialID.encode)(stop),
                                properties: {
                                    name,
                                    number: stop,
                                    type: endStops.has(stop) ? 'end' : null,
                                    left
                                },
                                geometry: {
                                    type: 'Point',
                                    coordinates
                                }
                            };
                        })
                    });
                    scheduleRouteFrame(()=>{
                        map.getSource('routes').setData({
                            type: 'FeatureCollection',
                            features: (routesData[svc] || []).map((r)=>({
                                    type: 'Feature',
                                    properties: {},
                                    geometry: decodePolyline(r)
                                }))
                        });
                    });
                }
                if (hasBounds) scheduleRouteFrame(()=>{
                    var _servicePopover_current;
                    const mobileBottomPad = paneOrOffsetHeight(servicePopover.current) + 20;
                    map.fitBounds(bounds, {
                        maxZoom: 16,
                        padding: BREAKPOINT() ? {
                            top: 80,
                            right: (((_servicePopover_current = servicePopover.current) === null || _servicePopover_current === void 0 ? void 0 : _servicePopover_current.offsetWidth) || 320) + 80,
                            bottom: 80,
                            left: 80
                        } : {
                            top: 80,
                            right: 80,
                            bottom: mobileBottomPad,
                            left: 80
                        }
                    });
                });
            };
            load();
            vehiclePoll.current = setInterval(load, 30000);
        };
        // All-mode: viewport engine manages city data; handle stop selection via cityDataMap
        if (IS_ALL_MODE) {
            var _vehicleTracker_current1;
            $map.classList.remove('fade-out');
            setShowServicePopover(false);
            // Cleared unconditionally, same as showServicePopover above — the
            // 'service' branch below re-sets it immediately if that's where we
            // land. Left stale otherwise (e.g. after stop->service->back), it
            // keeps has-floating-footer applied and the service popover's own
            // content block eligible to render (it's gated on this length, not
            // showServicePopover, whenever showStopPopover+paneAppliesHere is
            // also true) even though no service is actually selected anymore.
            setRouteServices([]);
            setShowBetweenPopover(false);
            if (route.page !== 'between') setAllModeBetween(null);
            if (route.page !== 'location') {
                setShowLocationPopover(false);
                hideLocationMarker();
            }
            (_vehicleTracker_current1 = vehicleTracker.current) === null || _vehicleTracker_current1 === void 0 ? void 0 : _vehicleTracker_current1.stop();
            resetVehiclePage();
            setRouteLoading(false);
            // Clear previous stop selection on every navigation (unless staying on same stop)
            if (prevStopNumber.current && prevStopCity.current) {
                const isStayingOnStop = route.page === 'stop' && route.value === `${prevStopCity.current}^${prevStopNumber.current}`;
                if (!isStayingOnStop) {
                    const prevSrc = `stops-${prevStopCity.current}`;
                    if (map === null || map === void 0 ? void 0 : map.getSource(prevSrc)) map.setFeatureState({
                        source: prevSrc,
                        id: (0, _specialID.encode)(prevStopNumber.current)
                    }, {
                        selected: false
                    });
                    if (map === null || map === void 0 ? void 0 : map.getSource('stops-highlight')) map.setFeatureState({
                        source: 'stops-highlight',
                        id: (0, _specialID.encode)(prevStopNumber.current)
                    }, {
                        selected: false
                    });
                    prevStopNumber.current = null;
                    prevStopCity.current = null;
                    setShowStopPopover(false);
                }
            } else if (route.page !== 'stop') setShowStopPopover(false);
            if (route.page === 'vehicle' && route.value) {
                var _map_getSource, _map_getSource1, _map_getSource2, _map_getSource3;
                (_map_getSource = map.getSource('routes')) === null || _map_getSource === void 0 ? void 0 : _map_getSource.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                (_map_getSource1 = map.getSource('routes-path')) === null || _map_getSource1 === void 0 ? void 0 : _map_getSource1.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                (_map_getSource2 = map.getSource('routes-between')) === null || _map_getSource2 === void 0 ? void 0 : _map_getSource2.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                (_map_getSource3 = map.getSource('stops-highlight')) === null || _map_getSource3 === void 0 ? void 0 : _map_getSource3.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                const caret = route.value.indexOf('^');
                if (caret === -1) {
                    navigateTo('/', route);
                    return;
                }
                const vehicleCity = route.value.slice(0, caret);
                const vehicleId = route.value.slice(caret + 1);
                loadCity(vehicleCity).then(()=>{
                    if (renderSeq !== routeRenderSeq.current) return;
                    const entry = cityDataMap.get(vehicleCity);
                    if (!entry) return;
                    Object.keys(stopsData).forEach((k)=>delete stopsData[k]);
                    Object.keys(servicesData).forEach((k)=>delete servicesData[k]);
                    Object.keys(routesData).forEach((k)=>delete routesData[k]);
                    Object.assign(stopsData, entry.stopsData);
                    Object.assign(servicesData, entry.servicesData);
                    Object.assign(routesData, entry.routesData);
                    window._data = {
                        stopsData,
                        stopsDataArr: entry.stopsDataArr,
                        servicesData,
                        routesData,
                        servicesDataArr: []
                    };
                    startVehiclePage(vehicleCity, vehicleId);
                });
                return;
            }
            if (route.page === 'service' && route.value) {
                var // Leaving a between-detail view (e.g. via a leg's service-tag link)
                // must not leave its itinerary line/highlight drawn on the map -
                // the single-city path clears these unconditionally on every
                // navigation, but all-mode's per-page branches don't share that
                // reset, so this branch needs its own clear.
                _map_getSource4, _map_getSource5;
                (_map_getSource4 = map.getSource('routes-between')) === null || _map_getSource4 === void 0 ? void 0 : _map_getSource4.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                (_map_getSource5 = map.getSource('stops-highlight')) === null || _map_getSource5 === void 0 ? void 0 : _map_getSource5.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                // Parse all city^service segments from the value (supports multi-route via ~)
                const qualifiedParts = route.value.split('~').filter((p)=>p.includes('^'));
                if (qualifiedParts.length) {
                    // Group services by city: { cityCode → [svcNum, ...] }
                    const cityGroups = {};
                    qualifiedParts.forEach((qp)=>{
                        const c = qp.indexOf('^');
                        const city = qp.slice(0, c);
                        const num = qp.slice(c + 1);
                        if (!cityGroups[city]) cityGroups[city] = [];
                        cityGroups[city].push(num);
                    });
                    const renderAllModeServices = (cityEntries)=>{
                        var _map_getSource;
                        if (renderSeq !== routeRenderSeq.current) return;
                        // Merge data from all involved cities into module-level vars
                        Object.keys(stopsData).forEach((k)=>delete stopsData[k]);
                        Object.keys(servicesData).forEach((k)=>delete servicesData[k]);
                        Object.keys(routesData).forEach((k)=>delete routesData[k]);
                        const mergedStopsDataArr = [];
                        Object.values(cityEntries).forEach((entry)=>{
                            Object.assign(stopsData, entry.stopsData);
                            Object.assign(servicesData, entry.servicesData);
                            Object.assign(routesData, entry.routesData);
                            mergedStopsDataArr.push(...entry.stopsDataArr);
                        });
                        window._data = {
                            stopsData,
                            stopsDataArr: mergedStopsDataArr,
                            servicesData,
                            routesData,
                            servicesDataArr: []
                        };
                        // All service numbers (unqualified) across cities
                        const allSvcNums = Object.values(cityGroups).flat();
                        const primarySvcNum = allSvcNums[0];
                        activeSelectionCities.clear();
                        Object.keys(cityGroups).forEach((c)=>activeSelectionCities.add(c));
                        releaseUnpinnedCities();
                        setExpandSearch(false);
                        setShrinkSearch(true);
                        setRouteServices(allSvcNums);
                        setShowServicePopover(true);
                        // Compute intersecting stops for multi-service views
                        if (allSvcNums.length > 1) {
                            const routeStopsList = [];
                            allSvcNums.forEach((svcNum)=>{
                                const serviceData = servicesData[svcNum];
                                if (!serviceData) return;
                                Object.keys(serviceData).forEach((key)=>{
                                    if (key === 'name') return;
                                    const variants = serviceData[key];
                                    if (!Array.isArray(variants)) return;
                                    if (variants[0]) variants[0].forEach((s)=>routeStopsList.push(s));
                                    if (variants[1]) variants[1].forEach((s)=>routeStopsList.push(s));
                                });
                            });
                            setIntersectStops(uniqueAndIntersectingStops(routeStopsList).intersecting);
                        } else setIntersectStops([]);
                        // Page title
                        if (allSvcNums.length === 1) {
                            var _Object_values__servicesData_allSvcNums_, _Object_values__servicesData, _Object_values_;
                            const svcName = ((_Object_values_ = Object.values(cityEntries)[0]) === null || _Object_values_ === void 0 ? void 0 : (_Object_values__servicesData = _Object_values_.servicesData) === null || _Object_values__servicesData === void 0 ? void 0 : (_Object_values__servicesData_allSvcNums_ = _Object_values__servicesData[allSvcNums[0]]) === null || _Object_values__servicesData_allSvcNums_ === void 0 ? void 0 : _Object_values__servicesData_allSvcNums_.name) || '';
                            setHead({
                                title: [
                                    'service.title',
                                    {
                                        serviceNumber: allSvcNums[0],
                                        serviceName: svcName
                                    }
                                ],
                                url: `/all/services/${route.value}`
                            });
                        } else {
                            const serviceNumbersNames = allSvcNums.join(', ');
                            setHead({
                                title: [
                                    'service.titleMultiple',
                                    {
                                        serviceNumbersNames
                                    }
                                ],
                                url: `/all/services/${route.value}`
                            });
                        }
                        // Hide all city stop layers so only route stops (stops-highlight) are visible
                        loadedCities.forEach((c)=>{
                            if (map.getLayer(`stops-${c}`)) map.setLayoutProperty(`stops-${c}`, 'visibility', 'none');
                            if (map.getLayer(`stops-icon-${c}`)) map.setLayoutProperty(`stops-icon-${c}`, 'visibility', 'none');
                        });
                        // Draw all route lines
                        scheduleRouteFrame(()=>{
                            var _map_getSource;
                            const allGeometries = [];
                            allSvcNums.forEach((svcNum)=>{
                                const routes = routesData[svcNum];
                                if (routes) allGeometries.push(...routes.map((r)=>decodePolyline(r)));
                            });
                            (_map_getSource = map.getSource('routes')) === null || _map_getSource === void 0 ? void 0 : _map_getSource.setData({
                                type: 'FeatureCollection',
                                features: allGeometries.map((geometry)=>({
                                        type: 'Feature',
                                        properties: {},
                                        geometry
                                    }))
                            });
                        });
                        // Collect stops for all services
                        const allRouteStops = new Set();
                        const endStops = new Set();
                        allSvcNums.forEach((svcNum)=>{
                            const serviceData = servicesData[svcNum];
                            if (!serviceData) return;
                            Object.keys(serviceData).forEach((key)=>{
                                if (key === 'name') return;
                                const variants = serviceData[key];
                                if (!Array.isArray(variants)) return;
                                if (variants[0]) {
                                    variants[0].forEach((s)=>allRouteStops.add(s));
                                    endStops.add(variants[0][0]);
                                    endStops.add(variants[0][variants[0].length - 1]);
                                }
                                if (variants[1]) variants[1].forEach((s)=>allRouteStops.add(s));
                            });
                        });
                        (_map_getSource = map.getSource('stops-highlight')) === null || _map_getSource === void 0 ? void 0 : _map_getSource.setData({
                            type: 'FeatureCollection',
                            features: [
                                ...allRouteStops
                            ].filter((s)=>stopsData[s]).map((s)=>({
                                    type: 'Feature',
                                    id: (0, _specialID.encode)(s),
                                    properties: {
                                        name: stopsData[s].name,
                                        number: s,
                                        type: endStops.has(s) ? 'end' : null,
                                        left: stopsData[s].left
                                    },
                                    geometry: {
                                        type: 'Point',
                                        coordinates: stopsData[s].coordinates
                                    }
                                }))
                        });
                        // Fit map to combined bounds
                        const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
                        [
                            ...allRouteStops
                        ].forEach((s)=>{
                            if (stopsData[s]) bounds.extend(stopsData[s].coordinates);
                        });
                        if (!bounds.isEmpty()) scheduleRouteFrame(()=>{
                            var _servicePopover_current;
                            map.fitBounds(bounds, {
                                padding: BREAKPOINT() ? {
                                    top: 80,
                                    right: (((_servicePopover_current = servicePopover.current) === null || _servicePopover_current === void 0 ? void 0 : _servicePopover_current.offsetWidth) || 320) + 80,
                                    bottom: 80,
                                    left: 80
                                } : {
                                    top: 80,
                                    right: 80,
                                    bottom: (paneOrOffsetHeight(servicePopover.current) || 200) + 20,
                                    left: 80
                                }
                            });
                        });
                    };
                    const uniqueCities = Object.keys(cityGroups);
                    Promise.all(uniqueCities.map((c)=>loadCity(c))).then(()=>{
                        if (renderSeq !== routeRenderSeq.current) return;
                        const cityEntries = {};
                        uniqueCities.forEach((c)=>{
                            const entry = cityDataMap.get(c);
                            if (entry) cityEntries[c] = entry;
                        });
                        if (Object.keys(cityEntries).length) renderAllModeServices(cityEntries);
                    });
                }
                return;
            } else if (route.page === 'stop' && route.value) {
                var _map_getSource6, _map_getSource7;
                // Restore city stop layers and clear service route in case we came from a service view
                loadedCities.forEach((c)=>{
                    if (map.getLayer(`stops-${c}`)) map.setLayoutProperty(`stops-${c}`, 'visibility', 'visible');
                    if (map.getLayer(`stops-icon-${c}`)) map.setLayoutProperty(`stops-icon-${c}`, 'visibility', 'visible');
                });
                (_map_getSource6 = map.getSource('routes')) === null || _map_getSource6 === void 0 ? void 0 : _map_getSource6.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                (_map_getSource7 = map.getSource('stops-highlight')) === null || _map_getSource7 === void 0 ? void 0 : _map_getSource7.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                const caret = route.value.indexOf('^');
                const [stopCity, stopNum] = caret !== -1 ? [
                    route.value.slice(0, caret),
                    route.value.slice(caret + 1)
                ] : [
                    null,
                    null
                ];
                if (stopCity && stopNum) {
                    var _cityData_stopsData;
                    const cityData = cityDataMap.get(stopCity);
                    if (cityData === null || cityData === void 0 ? void 0 : (_cityData_stopsData = cityData.stopsData) === null || _cityData_stopsData === void 0 ? void 0 : _cityData_stopsData[stopNum]) _showStopPopover(stopNum, {
                        city: stopCity,
                        stopData: cityData.stopsData[stopNum],
                        fromRouteView
                    });
                    else // City not loaded yet — load it, then show popover
                    loadCity(stopCity).then(()=>{
                        var _loaded_stopsData;
                        if (renderSeq !== routeRenderSeq.current) return;
                        const loaded = cityDataMap.get(stopCity);
                        if (loaded === null || loaded === void 0 ? void 0 : (_loaded_stopsData = loaded.stopsData) === null || _loaded_stopsData === void 0 ? void 0 : _loaded_stopsData[stopNum]) _showStopPopover(stopNum, {
                            city: stopCity,
                            stopData: loaded.stopsData[stopNum],
                            fromRouteView
                        });
                    });
                } else setShowStopPopover(false);
            } else if (route.page === 'between' && route.value) {
                var _map_getSource8;
                (_map_getSource8 = map.getSource('routes')) === null || _map_getSource8 === void 0 ? void 0 : _map_getSource8.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                const parsedEndpoints = parseBetweenValue(route.value);
                if (!parsedEndpoints) navigateTo('/', route);
                else {
                    const [startEndpoint, endEndpoint] = parsedEndpoints;
                    const startToken = encodeBetweenToken(startEndpoint);
                    const endToken = encodeBetweenToken(endEndpoint);
                    setHead({
                        title: `Directions - ${t('app.name')}`,
                        url: `/all/between/${route.value}`
                    });
                    setExpandSearch(false);
                    setShrinkSearch(true);
                    // Hide every loaded city's own stops layer only once a specific
                    // itinerary is selected (route.subpage present) — the result list
                    // view keeps stops visible, matching single-city between's behavior.
                    loadedCities.forEach((c)=>{
                        const visibility = route.subpage ? 'none' : 'visible';
                        if (map.getLayer(`stops-${c}`)) map.setLayoutProperty(`stops-${c}`, 'visibility', visibility);
                        if (map.getLayer(`stops-icon-${c}`)) map.setLayoutProperty(`stops-icon-${c}`, 'visibility', visibility);
                    });
                    // Navigating back to the result list (subpage dropped, e.g. closing
                    // the detail view) leaves no itinerary selected — clear the
                    // previously drawn detail line/highlight so it doesn't linger.
                    if (!route.subpage) {
                        var _map_getSource9, _map_getSource10;
                        (_map_getSource9 = map.getSource('stops-highlight')) === null || _map_getSource9 === void 0 ? void 0 : _map_getSource9.setData({
                            type: 'FeatureCollection',
                            features: []
                        });
                        (_map_getSource10 = map.getSource('routes-between')) === null || _map_getSource10 === void 0 ? void 0 : _map_getSource10.setData({
                            type: 'FeatureCollection',
                            features: []
                        });
                    }
                    const queryKey = `${startToken}|${endToken}`;
                    if (lastAllModeBetweenQuery.current !== queryKey) {
                        lastAllModeBetweenQuery.current = queryKey;
                        runAllModeBetween(startToken, endToken);
                    }
                }
            } else if (route.page === 'location' && route.value) {
                var _checkViewportRef_current;
                if (!(0, _cityConfig.isAlphaEnabled)()) {
                    navigateTo('/', route);
                    return;
                }
                const [rawLat, rawLon] = route.value.split(',');
                const lat = parseFloat(rawLat);
                const lon = parseFloat(rawLon);
                if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
                    navigateTo('/', route);
                    return;
                }
                setExpandSearch(false);
                setShrinkSearch(true);
                const key = locationKey(lat, lon);
                const cached = locationNameCache.get(key) || findMatchingPoi(lat, lon);
                const locInfo = {
                    lat,
                    lon,
                    name: (cached === null || cached === void 0 ? void 0 : cached.name) || null,
                    type: (cached === null || cached === void 0 ? void 0 : cached.type) || null,
                    color: (cached === null || cached === void 0 ? void 0 : cached.color) || null
                };
                if (cached && !locationNameCache.has(key)) locationNameCache.set(key, cached);
                setHead({
                    title: `${locInfo.name || 'Location'} - ${t('app.name')}`,
                    url: `/all/locations/${route.value}`
                });
                // Restore any city stop layers a previous service view hid (mirrors
                // the 'stop' branch above), and force the viewport-driven city
                // loader to re-evaluate around this location right away — a
                // location page can center the map without the user ever panning
                // again afterward, and that loader otherwise only runs on
                // moveend/zoomend, so a city whose bounds weren't loaded yet at
                // that exact moment would never get picked up.
                loadedCities.forEach((c)=>{
                    if (map.getLayer(`stops-${c}`)) map.setLayoutProperty(`stops-${c}`, 'visibility', 'visible');
                    if (map.getLayer(`stops-icon-${c}`)) map.setLayoutProperty(`stops-icon-${c}`, 'visibility', 'visible');
                });
                _showLocationPopover(locInfo);
                (_checkViewportRef_current = checkViewportRef.current) === null || _checkViewportRef_current === void 0 ? void 0 : _checkViewportRef_current.call(checkViewportRef);
            } else {
                var // Clear route/stop highlight sources when returning home
                _map_getSource11, _map_getSource12, _map_getSource13, _map_getSource14;
                activeSelectionCities.clear();
                releaseUnpinnedCities();
                setShowStopPopover(false);
                setHead(defaultHead);
                (_map_getSource11 = map.getSource('routes')) === null || _map_getSource11 === void 0 ? void 0 : _map_getSource11.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                (_map_getSource12 = map.getSource('routes-path')) === null || _map_getSource12 === void 0 ? void 0 : _map_getSource12.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                (_map_getSource13 = map.getSource('routes-between')) === null || _map_getSource13 === void 0 ? void 0 : _map_getSource13.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                (_map_getSource14 = map.getSource('stops-highlight')) === null || _map_getSource14 === void 0 ? void 0 : _map_getSource14.setData({
                    type: 'FeatureCollection',
                    features: []
                });
                // Restore city stop layers in case we came from a service view
                loadedCities.forEach((c)=>{
                    if (map.getLayer(`stops-${c}`)) map.setLayoutProperty(`stops-${c}`, 'visibility', 'visible');
                    if (map.getLayer(`stops-icon-${c}`)) map.setLayoutProperty(`stops-icon-${c}`, 'visibility', 'visible');
                });
            }
            return;
        }
        // Navigating between subpages of the *same* between query (e.g. picking
        // a result, or closing the detail view back to the list) only changes
        // route.subpage — it must not wipe the popover/map state the 'between'
        // case below relies on still being there, since its own dedup guard
        // (lastBetweenQuery) skips re-fetching/re-populating in that case.
        const isSameBetweenQuery = route.page === 'between' && lastBetweenQuery.current === `${route.city}|${route.value}`;
        // Reset everything
        $map.classList.remove('fade-out');
        setShowStopPopover(false);
        setShowServicePopover(false);
        // Cleared unconditionally, same as showServicePopover above — see the
        // matching comment in the IS_ALL_MODE branch for why leaving this
        // stale matters even once showServicePopover is correctly false.
        setRouteServices([]);
        if (!isSameBetweenQuery) setShowBetweenPopover(false);
        if (route.page !== 'location') {
            setShowLocationPopover(false);
            hideLocationMarker();
        }
        if (map.getLayer('dim-overlay')) map.setPaintProperty('dim-overlay', 'fill-opacity', 0);
        (_vehicleTracker_current = vehicleTracker.current) === null || _vehicleTracker_current === void 0 ? void 0 : _vehicleTracker_current.stop();
        resetVehiclePage();
        // Clear map sources - only clear sources that have data to avoid unnecessary re-renders
        (0, _mapOptimizations.batchClearSources)(map, [
            ...isSameBetweenQuery ? [] : [
                'stops-highlight',
                'routes-between'
            ],
            'routes',
            'routes-path',
            'buses-service'
        ]);
        if (prevStopNumber.current) hideStopPopover();
        switch(route.page){
            case 'service':
                {
                    const servicesValue = route.value;
                    const services = servicesValue.split('~').map((s)=>findServiceKey(s)).filter(Boolean);
                    if (!services.length) return; // No value or none of the service codes are valid
                    services.forEach((service)=>(0, _metricsPage.routeMetrics)(route.city, service, 'main'));
                    // Reset
                    setExpandSearch(false);
                    setShrinkSearch(true);
                    resetSearch();
                    // Hide all stops
                    map.setLayoutProperty('stops', 'visibility', 'none');
                    if (map.getLayer('stops-icon')) map.setLayoutProperty('stops-icon', 'visibility', 'none');
                    setRouteServices(services);
                    if (services.length === 1) {
                        const service = services[0];
                        const serviceData = servicesData[service];
                        const { name } = serviceData;
                        const routes = getServiceRoutes(serviceData);
                        setHead({
                            title: [
                                'service.title',
                                {
                                    serviceNumber: service,
                                    serviceName: name
                                }
                            ],
                            url: `${route.cityPrefix}/services/${encodeURIComponent(service)}`
                        });
                        setShowServicePopover(true);
                        // Show stops of the selected service
                        if (routes.length > 0 && routes[0] && routes[0].length > 0) {
                            const endStops = new Set([
                                routes[0][0],
                                routes[0][routes[0].length - 1]
                            ]);
                            if (routes[1] && routes[1].length > 0) endStops.add(routes[1][0]).add(routes[1][routes[1].length - 1]);
                            let routeStops = [
                                ...new Set([
                                    ...routes[0],
                                    ...routes[1] || []
                                ])
                            ]; // Merge and unique
                            // Fit map to route bounds
                            const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
                            routeStops.forEach((stop)=>{
                                const { coordinates } = stopsData[stop];
                                bounds.extend(coordinates);
                            });
                            scheduleRouteFrame(()=>{
                                const mobileBottomPad = paneOrOffsetHeight(servicePopover.current) + 20;
                                map.fitBounds(bounds, {
                                    padding: BREAKPOINT() ? {
                                        top: 80,
                                        right: servicePopover.current.offsetWidth + 80,
                                        bottom: 80,
                                        left: 80
                                    } : {
                                        top: 80,
                                        right: 80,
                                        bottom: mobileBottomPad,
                                        left: 80
                                    }
                                });
                            });
                            map.getSource('stops-highlight').setData({
                                type: 'FeatureCollection',
                                features: routeStops.map((stop, i)=>{
                                    const { name, left } = stopsData[stop];
                                    return {
                                        type: 'Feature',
                                        id: (0, _specialID.encode)(stop),
                                        properties: {
                                            name,
                                            number: stop,
                                            type: endStops.has(stop) ? 'end' : null,
                                            left
                                        },
                                        geometry: {
                                            type: 'Point',
                                            coordinates: stopsData[stop].coordinates
                                        }
                                    };
                                })
                            });
                            // Show routes
                            scheduleRouteFrame(()=>{
                                const routes = routesData[service];
                                const geometries = routes.map((route)=>decodePolyline(route));
                                map.getSource('routes').setData({
                                    type: 'FeatureCollection',
                                    features: geometries.map((geometry)=>({
                                            type: 'Feature',
                                            properties: {},
                                            geometry
                                        }))
                                });
                            });
                        }
                    } else {
                        const serviceNumbersNames = services.map((s)=>{
                            const { name } = servicesData[s];
                            return `${s}: ${name}`;
                        }).join(', ');
                        setHead({
                            title: [
                                'service.titleMultiple',
                                {
                                    serviceNumbersNames
                                }
                            ],
                            url: `${route.cityPrefix}/services/${services.map((s)=>encodeURIComponent(s)).join('~')}`
                        });
                        let routeStops = [];
                        let endStops = [];
                        let serviceGeometries = [];
                        services.forEach((service)=>{
                            const serviceData = servicesData[service];
                            const routes = getServiceRoutes(serviceData);
                            if (routes.length > 0) {
                                endStops.push(routes[0][0], routes[0][routes[0].length - 1]);
                                if (routes[1]) endStops.push(routes[1][0], routes[1][routes[1].length - 1]);
                                const allRoutes = [
                                    ...new Set([
                                        ...routes[0],
                                        ...routes[1] || []
                                    ])
                                ];
                                routeStops = routeStops.concat(allRoutes);
                            }
                            const routeGeometries = routesData[service];
                            if (routeGeometries) serviceGeometries = serviceGeometries.concat(routeGeometries.map((r)=>({
                                    service,
                                    geometry: decodePolyline(r)
                                })));
                        });
                        // Merge and unique stops
                        const { unique: dedupedRouteStops, intersecting: intersectStops } = uniqueAndIntersectingStops(routeStops);
                        routeStops = dedupedRouteStops;
                        setIntersectStops(intersectStops);
                        const endStopSet = new Set(endStops);
                        const intersectStopSet = new Set(intersectStops);
                        // Fit map to route bounds
                        const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
                        routeStops.forEach((stop)=>{
                            const { coordinates } = stopsData[stop];
                            bounds.extend(coordinates);
                        });
                        scheduleRouteFrame(()=>{
                            map.fitBounds(bounds, {
                                padding: largerScreen ? {
                                    top: floatPill.current.offsetHeight / 2,
                                    right: 80,
                                    bottom: 80,
                                    left: floatPill.current.offsetHeight / 2
                                } : BREAKPOINT() ? {
                                    top: 80,
                                    right: Math.max(floatPill.current.offsetWidth / 2, 80),
                                    bottom: 80 + floatPill.current.offsetHeight / 2,
                                    left: Math.max(floatPill.current.offsetWidth / 2, 80)
                                } : {
                                    top: 80,
                                    right: 80,
                                    bottom: 80 + floatPill.current.offsetHeight,
                                    // height of search bar + float pill
                                    left: 80
                                }
                            });
                        });
                        map.getSource('stops-highlight').setData({
                            type: 'FeatureCollection',
                            features: routeStops.map((stop, i)=>{
                                const { name, left } = stopsData[stop];
                                return {
                                    type: 'Feature',
                                    id: (0, _specialID.encode)(stop),
                                    properties: {
                                        name,
                                        number: stop,
                                        type: endStopSet.has(stop) ? 'end' : intersectStopSet.has(stop) ? 'intersect' : null,
                                        left
                                    },
                                    geometry: {
                                        type: 'Point',
                                        coordinates: stopsData[stop].coordinates
                                    }
                                };
                            })
                        });
                        // Show routes
                        scheduleRouteFrame(()=>{
                            map.getSource('routes-path').setData({
                                type: 'FeatureCollection',
                                features: serviceGeometries.map((sg)=>({
                                        type: 'Feature',
                                        id: (0, _specialID.encode)(sg.service),
                                        properties: {
                                            service: sg.service
                                        },
                                        geometry: sg.geometry
                                    }))
                            });
                            STORE.routesPathServices = serviceGeometries.map((sg)=>sg.service);
                        });
                    }
                    break;
                }
            case 'stop':
                {
                    const stop = findStopKey(route.value);
                    if (!stop) return;
                    (0, _metricsPage.stopMetrics)(route.city, stop, 'main');
                    // Reset
                    setExpandSearch(false);
                    setShrinkSearch(true);
                    resetSearch();
                    const { routes, name, coordinates } = stopsData[stop];
                    if (route.subpage === 'routes') {
                        setHead({
                            title: [
                                'stop.titleRoutes',
                                {
                                    stopNumber: stop,
                                    stopName: name
                                }
                            ],
                            url: `/stops/${stop}/routes`
                        });
                        // Hide all stops
                        map.setLayoutProperty('stops', 'visibility', 'none');
                        if (map.getLayer('stops-icon')) map.setLayoutProperty('stops-icon', 'visibility', 'none');
                        map.getSource('stops-highlight').setData({
                            type: 'FeatureCollection',
                            features: [
                                {
                                    type: 'Feature',
                                    id: (0, _specialID.encode)(stop),
                                    properties: {
                                        name,
                                        number: stop,
                                        type: 'end',
                                        left: stopsData[stop].left
                                    },
                                    geometry: {
                                        type: 'Point',
                                        coordinates
                                    }
                                }
                            ]
                        });
                        // Show all routes (cropped from current stop)
                        // Find the polyline that passes through the current stop for each service
                        const STOP_PROXIMITY_THRESHOLD = 0.0045; // ~500m, same as arrival.js
                        scheduleRouteFrame(()=>{
                            const stopCoords = coordinates; // Current stop coordinates [lng, lat]
                            // Group routes by service to find the best polyline per service
                            const serviceRouteKeys = {};
                            routes.forEach((route)=>{
                                const service = route.split('|')[0];
                                if (!serviceRouteKeys[service]) serviceRouteKeys[service] = [];
                                serviceRouteKeys[service].push(route);
                            });
                            const serviceGeometries = Object.entries(serviceRouteKeys).map(([service, routeKeys])=>{
                                const serviceRoutes = routesData[service];
                                if (!Array.isArray(serviceRoutes) || serviceRoutes.length === 0) return null;
                                // Find the polyline that passes closest to the current stop
                                let bestPolyline = null;
                                let bestClosest = null;
                                for(let i = 0; i < serviceRoutes.length; i++)try {
                                    var _geometry_coordinates;
                                    const geometry = decodePolyline(serviceRoutes[i]);
                                    if (geometry.type !== 'LineString' || !((_geometry_coordinates = geometry.coordinates) === null || _geometry_coordinates === void 0 ? void 0 : _geometry_coordinates.length)) continue;
                                    const closest = (0, _geometry.findClosestPointOnPolyline)(stopCoords, geometry.coordinates);
                                    // Only consider polylines that pass near the stop
                                    if (closest.distance < STOP_PROXIMITY_THRESHOLD) {
                                        if (!bestClosest || closest.distance < bestClosest.distance) {
                                            bestClosest = closest;
                                            bestPolyline = geometry;
                                        }
                                    }
                                } catch (e) {
                                // Skip invalid polyline
                                }
                                if (!bestPolyline || !bestClosest) return null;
                                // Crop polyline from the current stop
                                if (bestClosest.point && bestClosest.segmentIndex >= 0) {
                                    const croppedCoords = (0, _geometry.cropPolylineFromPoint)(bestPolyline.coordinates, bestClosest.point, bestClosest.segmentIndex);
                                    if (croppedCoords.length >= 2) return {
                                        service,
                                        geometry: {
                                            type: 'LineString',
                                            coordinates: croppedCoords
                                        }
                                    };
                                }
                                return {
                                    service,
                                    geometry: bestPolyline
                                };
                            }).filter(Boolean);
                            map.getSource('routes-path').setData({
                                type: 'FeatureCollection',
                                features: serviceGeometries.map((sg, i)=>({
                                        type: 'Feature',
                                        id: (0, _specialID.encode)(sg.service),
                                        properties: {
                                            service: sg.service
                                        },
                                        geometry: sg.geometry
                                    }))
                            });
                            STORE.routesPathServices = serviceGeometries.map((sg)=>sg.service);
                            // Fit map to rendered route bounds
                            const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
                            serviceGeometries.forEach((sg)=>{
                                sg.geometry.coordinates.forEach((coord)=>{
                                    bounds.extend(coord);
                                });
                            });
                            if (!bounds.isEmpty()) map.fitBounds(bounds, {
                                padding: largerScreen ? {
                                    top: floatPill.current.offsetHeight / 2,
                                    right: 80,
                                    bottom: 80,
                                    left: floatPill.current.offsetHeight / 2
                                } : BREAKPOINT() ? {
                                    top: 80,
                                    right: Math.max(floatPill.current.offsetWidth / 2, 80),
                                    bottom: 80 + floatPill.current.offsetHeight / 2,
                                    left: Math.max(floatPill.current.offsetWidth / 2, 80)
                                } : {
                                    top: 80,
                                    right: 80,
                                    bottom: 80 + floatPill.current.offsetHeight,
                                    // height of search bar + float pill
                                    left: 80
                                }
                            });
                        });
                    } else {
                        setHead({
                            title: [
                                'stop.title',
                                {
                                    stopNumber: stop,
                                    stopName: name
                                }
                            ],
                            url: `/stops/${stop}`
                        });
                        map.setLayoutProperty('stops', 'visibility', 'visible');
                        if (map.getLayer('stops-icon')) map.setLayoutProperty('stops-icon', 'visibility', 'visible');
                        _showStopPopover(stop, {
                            fromRouteView
                        });
                    }
                    break;
                }
            case 'between':
                {
                    if (!(0, _cityConfig.isAlphaEnabled)()) {
                        navigateTo('/', route);
                        return;
                    }
                    const parsedEndpoints = parseBetweenValue(route.value);
                    if (!parsedEndpoints) {
                        alert('Invalid directions link.');
                        return;
                    }
                    const [startEndpoint, endEndpoint] = parsedEndpoints;
                    setHead({
                        title: `Directions - ${t('app.name')}`,
                        url: `/between/${route.value}`
                    });
                    // Reset
                    setExpandSearch(false);
                    setShrinkSearch(true);
                    // Hide stops only once a specific itinerary is selected (route.subpage
                    // present) — the result list view keeps stops visible. Dim basemap
                    // either way.
                    {
                        const visibility = route.subpage ? 'none' : 'visible';
                        map.setLayoutProperty('stops', 'visibility', visibility);
                        if (map.getLayer('stops-icon')) map.setLayoutProperty('stops-icon', 'visibility', visibility);
                    }
                    if (map.getLayer('dim-overlay')) map.setPaintProperty('dim-overlay', 'fill-opacity', (0, _theme.isDark) ? 0.5 : 0.4);
                    // Navigating back to the result list (subpage dropped, e.g. closing the
                    // detail view) leaves no itinerary selected — clear the previously
                    // drawn detail line/highlight so it doesn't linger on the map.
                    if (!route.subpage) {
                        var _map_getSource15, _map_getSource16;
                        (_map_getSource15 = map.getSource('stops-highlight')) === null || _map_getSource15 === void 0 ? void 0 : _map_getSource15.setData({
                            type: 'FeatureCollection',
                            features: []
                        });
                        (_map_getSource16 = map.getSource('routes-between')) === null || _map_getSource16 === void 0 ? void 0 : _map_getSource16.setData({
                            type: 'FeatureCollection',
                            features: []
                        });
                    }
                    // Fetch arrivals for start stop and filter routes — skipped if this is
                    // the same query as last time (e.g. navigating list ↔ result detail,
                    // which only changes route.subpage) so the worker/live-arrival fetch
                    // doesn't rerun on every such navigation.
                    const betweenQueryKey = `${city}|${route.value}`;
                    if (lastBetweenQuery.current === betweenQueryKey) break;
                    lastBetweenQuery.current = betweenQueryKey;
                    (async ()=>{
                        var _cityConfig_liveArrivals, _cityConfig_liveArrivals1;
                        // Resolve each endpoint to a concrete stop number, plus (for a
                        // location endpoint) its full nearby-stop candidate cluster —
                        // same cluster the location popover itself would show.
                        const resolveEndpoint = async (endpoint)=>{
                            if (endpoint.type === 'stop') {
                                const number = findStopKey(endpoint.number);
                                return number ? {
                                    number,
                                    candidateNumbers: null,
                                    location: null
                                } : null;
                            }
                            const stops = await resolveLocationStops(endpoint.lat, endpoint.lon);
                            return stops.length ? {
                                number: stops[0].number,
                                candidateNumbers: stops.map((s)=>s.number),
                                location: {
                                    lat: endpoint.lat,
                                    lon: endpoint.lon,
                                    name: friendlyLocationName(endpoint.lat, endpoint.lon)
                                }
                            } : null;
                        };
                        const [startResolved, endResolved] = await Promise.all([
                            resolveEndpoint(startEndpoint),
                            resolveEndpoint(endEndpoint)
                        ]);
                        if (betweenQueryKey !== lastBetweenQuery.current) return; // a newer query has started
                        if (!startResolved || !endResolved) {
                            alert('One of the stops/locations could not be found nearby.');
                            return;
                        }
                        const startStopNumber = startResolved.number;
                        const endStopNumber = endResolved.number;
                        const cityConfig = (0, _config.getConfigForCity)(city);
                        const ONE_HOUR_MS = 3600000;
                        let availableServices = new Set();
                        let arrivalData = null; // Store full arrival data for scoring
                        const staticFrequency = {}; // service_no → daily trip_count from schedule
                        // Helper function to extract services from arrivals data
                        const extractServicesFromArrivals = (services)=>{
                            if (!services || !Array.isArray(services)) return new Set();
                            const serviceSet = new Set();
                            services.forEach((service)=>{
                                // Check all available arrivals (next, next2, next3, or arrivals array)
                                const arrivals = service.arrivals || [
                                    service.next,
                                    service.next2,
                                    service.next3,
                                    service.next4,
                                    service.next5
                                ].filter(Boolean);
                                // Check if any arrival is within the next hour
                                const hasArrivalInNextHour = arrivals.some((arrival)=>arrival && typeof arrival.duration_ms === 'number' && arrival.duration_ms >= 0 && arrival.duration_ms <= ONE_HOUR_MS);
                                if (hasArrivalInNextHour) serviceSet.add(String(service.no));
                            });
                            return serviceSet;
                        };
                        // Helper to convert schedule to arrival format
                        const convertScheduleToArrival = (scheduleData)=>{
                            if (!(scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.services)) return [];
                            const now = new Date();
                            const currentMinutes = now.getHours() * 60 + now.getMinutes();
                            const ONE_HOUR_MS = 3600000;
                            const allUpcomingTrips = [];
                            scheduleData.services.forEach((service)=>{
                                const { no, origin, destination, trips } = service;
                                if (!trips || !Array.isArray(trips)) return;
                                trips.forEach((timeStr)=>{
                                    const colonIdx = timeStr.indexOf(':');
                                    if (colonIdx === -1) return;
                                    const hours = parseInt(timeStr.substring(0, colonIdx), 10);
                                    const minutes = parseInt(timeStr.substring(colonIdx + 1), 10);
                                    const tripMinutes = hours * 60 + minutes;
                                    const duration_ms = (tripMinutes - currentMinutes) * 60000;
                                    if (duration_ms >= 0 && duration_ms <= ONE_HOUR_MS) allUpcomingTrips.push({
                                        no,
                                        origin,
                                        destination,
                                        duration_ms,
                                        type: 'SD',
                                        load: 'SEA',
                                        feature: 'WAB',
                                        visit_number: 1,
                                        origin_code: origin,
                                        destination_code: destination
                                    });
                                });
                            });
                            // Sort by arrival time and group by service
                            allUpcomingTrips.sort((a, b)=>a.duration_ms - b.duration_ms);
                            const serviceMap = new Map();
                            allUpcomingTrips.forEach((trip)=>{
                                const key = `${trip.no}-${trip.destination}`;
                                if (!serviceMap.has(key)) serviceMap.set(key, {
                                    no: trip.no,
                                    destination: trip.destination,
                                    frequency: 0,
                                    trips: []
                                });
                                const service = serviceMap.get(key);
                                service.trips.push(trip);
                                service.frequency++;
                            });
                            // Convert to arrival format (next through next5)
                            return Array.from(serviceMap.values()).map((service)=>{
                                const result = {
                                    no: service.no,
                                    destination: service.destination,
                                    frequency: service.frequency
                                };
                                if (service.trips.length > 0) result.next = service.trips[0];
                                if (service.trips.length > 1) result.next2 = service.trips[1];
                                if (service.trips.length > 2) result.next3 = service.trips[2];
                                if (service.trips.length > 3) result.next4 = service.trips[3];
                                if (service.trips.length > 4) result.next5 = service.trips[4];
                                return result;
                            });
                        };
                        // Try to fetch live arrivals
                        let liveApiFailed = false;
                        if (cityConfig === null || cityConfig === void 0 ? void 0 : (_cityConfig_liveArrivals = cityConfig.liveArrivals) === null || _cityConfig_liveArrivals === void 0 ? void 0 : _cityConfig_liveArrivals.enabled) try {
                            const apiUrl = (0, _cityConfig.getApiUrl)(cityConfig.liveArrivals.apiPath);
                            if (apiUrl) {
                                const response = await fetch(`${apiUrl}?stationid=${startStopNumber}`);
                                if (response.ok) {
                                    var _data_services;
                                    const data = await response.json();
                                    if ((data === null || data === void 0 ? void 0 : (_data_services = data.services) === null || _data_services === void 0 ? void 0 : _data_services.length) > 0) {
                                        const filtered = data.services.map((0, _fetchArrivals.filterStaleArrivalsFromService)).filter((s)=>s.next || s.arrivals && s.arrivals.length > 0);
                                        arrivalData = filtered.length > 0 ? filtered : data.services;
                                        availableServices = extractServicesFromArrivals(arrivalData);
                                    }
                                } else // API returned error status - this is a failure case
                                liveApiFailed = true;
                            } else // API disabled (e.g. developer mode) - fall back to schedule
                            liveApiFailed = true;
                        } catch (error) {
                            // API request failed - this is a failure case
                            liveApiFailed = true;
                        }
                        // Fallback to schedule only when live API could not be reached
                        // (network error, HTTP error, or city has no live arrivals configured).
                        // A successful but empty live response is valid — don't override it.
                        if (liveApiFailed || !(cityConfig === null || cityConfig === void 0 ? void 0 : (_cityConfig_liveArrivals1 = cityConfig.liveArrivals) === null || _cityConfig_liveArrivals1 === void 0 ? void 0 : _cityConfig_liveArrivals1.enabled)) try {
                            const scheduleData = await (0, _fetchCacheDefault.default)(`https://data.transitrouter.vonter.in/${city}/schedule/${startStopNumber}.json`, 60);
                            if (scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.services) {
                                const now = new Date();
                                const currentMinutes = now.getHours() * 60 + now.getMinutes();
                                scheduleData.services.forEach((service)=>{
                                    const { no, trips, trip_count } = service;
                                    if (trip_count > 0) staticFrequency[String(no)] = (staticFrequency[String(no)] || 0) + trip_count;
                                    if (!trips || !Array.isArray(trips)) return;
                                    const hasTripInNextHour = trips.some((timeStr)=>{
                                        const colonIdx = timeStr.indexOf(':');
                                        if (colonIdx === -1) return false;
                                        const hours = parseInt(timeStr.substring(0, colonIdx), 10);
                                        const minutes = parseInt(timeStr.substring(colonIdx + 1), 10);
                                        const tripMinutes = hours * 60 + minutes;
                                        const duration_ms = (tripMinutes - currentMinutes) * 60000;
                                        return duration_ms >= 0 && duration_ms <= ONE_HOUR_MS;
                                    });
                                    if (hasTripInNextHour) availableServices.add(String(no));
                                });
                                arrivalData = convertScheduleToArrival(scheduleData);
                            }
                        } catch (error) {}
                        // Route-finding (proximity expansion + intersection) runs in the worker.
                        // A location endpoint's own candidate cluster replaces the worker's
                        // usual single-stop proximity expansion for that side (see
                        // handleBetweenRoutes) — the plain stop number is omitted so the
                        // worker doesn't also treat it as "the" literal picked stop for
                        // the live-arrival service filter.
                        const { routes: allRoutes, nearestStartStop, nearestEndStop } = await (0, _workerClient.workerBetweenRoutes)(startResolved.candidateNumbers ? undefined : startStopNumber, endResolved.candidateNumbers ? undefined : endStopNumber, Array.from(availableServices), {
                            startCandidateNumbers: startResolved.candidateNumbers || undefined,
                            endCandidateNumbers: endResolved.candidateNumbers || undefined
                        });
                        const startStop = stopsData[startStopNumber];
                        const endStop = stopsData[endStopNumber];
                        _showBetweenPopover({
                            startStop,
                            endStop,
                            startLocation: startResolved.location,
                            endLocation: endResolved.location,
                            nearestStartStop,
                            nearestEndStop,
                            startWalkMins: nearestStartStop ? (0, _getWalkingMinutesDefault.default)(ruler.distance(startStop.coordinates, nearestStartStop.coordinates) * 1000) : 0,
                            endWalkMins: nearestEndStop ? (0, _getWalkingMinutesDefault.default)(ruler.distance(endStop.coordinates, nearestEndStop.coordinates) * 1000) : 0,
                            arrivalData,
                            // Pass arrival data for scoring
                            staticFrequency,
                            // Daily trip counts from schedule
                            liveApiFailed,
                            // Track if live API fetch failed
                            results: allRoutes // Single unified array
                        });
                    })();
                    break;
                }
            case 'location':
                {
                    if (!(0, _cityConfig.isAlphaEnabled)()) {
                        navigateTo('/', route);
                        return;
                    }
                    const raw = route.value || '';
                    const [rawLat, rawLon] = raw.split(',');
                    const lat = parseFloat(rawLat);
                    const lon = parseFloat(rawLon);
                    if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
                        navigateTo('/', route);
                        return;
                    }
                    setExpandSearch(false);
                    setShrinkSearch(true);
                    // Name resolution is never part of the URL — resolve in priority order:
                    // a just-clicked search result's cached name, a nearby known POI, or
                    // (async, once the popover is already open) a reverse-geocode lookup.
                    const key = locationKey(lat, lon);
                    const cached = locationNameCache.get(key) || findMatchingPoi(lat, lon);
                    const locInfo = {
                        lat,
                        lon,
                        name: (cached === null || cached === void 0 ? void 0 : cached.name) || null,
                        type: (cached === null || cached === void 0 ? void 0 : cached.type) || null,
                        color: (cached === null || cached === void 0 ? void 0 : cached.color) || null
                    };
                    if (cached && !locationNameCache.has(key)) locationNameCache.set(key, cached);
                    setHead({
                        title: `${locInfo.name || 'Location'} - ${t('app.name')}`,
                        url: `/locations/${raw}`
                    });
                    // Unlike 'stop'/'between'/default, this case never turned the stops
                    // layer back on — arriving here straight from a service view (which
                    // hides it) or a direct link (whatever the style's initial layout
                    // visibility is) left it off with nothing to turn it back on.
                    map.setLayoutProperty('stops', 'visibility', 'visible');
                    if (map.getLayer('stops-icon')) map.setLayoutProperty('stops-icon', 'visibility', 'visible');
                    _showLocationPopover(locInfo);
                    break;
                }
            case 'vehicle':
                startVehiclePage(route.city, route.value);
                break;
            default:
                setHead(defaultHead);
                // Show all stops
                map.setLayoutProperty('stops', 'visibility', 'visible');
                map.setLayoutProperty('stops-icon', 'visibility', 'visible');
        }
        setRouteLoading(false);
    };
    const setStartStop = (number)=>{
        if (betweenEndStop && betweenEndStop != number) navigateTo(`/between/${number}-${betweenEndStop}`, route);
        else {
            setBetweenStartStop(number);
            setBetweenEndStop(null);
        }
    };
    const setEndStop = (number)=>{
        if (betweenStartStop && betweenStartStop != number) location.hash = `${route.cityPrefix}/between/${betweenStartStop}-${number}`;
        else {
            setBetweenStartStop(null);
            setBetweenEndStop(number);
        }
    };
    const resetStartEndStops = ()=>{
        setBetweenStartStop(null);
        setBetweenEndStop(null);
    };
    const [mapLoaded, setMapLoaded] = (0, _hooks.useState)(false);
    let workerReady = Promise.resolve();
    const onLoad = async ()=>{
        // Split across two listeners because they're not interchangeable: a
        // plain `location.hash =` assignment reliably fires hashchange but
        // popstate's firing for it is implementation-defined, while a real
        // back/forward through a history entry whose *other* URL components
        // (query string — see saveViewportToUrl in all-mode) also differ from
        // the current entry fires only popstate — per spec, hashchange fires
        // only when a traversal changes the fragment alone. Relying on either
        // one exclusively silently drops the other's navigations.
        //
        // Most real navigations fire *both* events (confirmed by logging real
        // traversals), so dedupe on the fragment itself rather than letting
        // renderRoute() run twice back-to-back — its resets mutate refs
        // (prevStopNumber.current etc.) that a second, redundant pass would
        // then read back already-cleared, which is its own source of
        // stale/incorrect renders independent of the missing-event bug above.
        let lastHandledHash = location.hash;
        const handleRouteChange = ()=>{
            if (location.hash === lastHandledHash) return;
            lastHandledHash = location.hash;
            setRoute((0, _getRouteDefault.default)());
            renderRoute();
        };
        window.onhashchange = handleRouteChange;
        window.addEventListener('popstate', handleRouteChange);
        if (!IS_ALL_MODE) {
            const fetchStopsP = (0, _fetchCacheDefault.default)(stopsJSONPath, CACHE_TIME);
            const fetchServicesP = (0, _fetchCacheDefault.default)(servicesJSONPath, CACHE_TIME);
            const fetchRoutesP = (0, _fetchCacheDefault.default)(routesJSONPath, CACHE_TIME);
            const fetchPoisP = (0, _cityConfig.isAlphaEnabled)() ? (0, _parsePoisCsv.fetchPois)(city) : Promise.resolve([]);
            // Init data
            const stops = await fetchStopsP;
            // First pass: collect all stops with their parentStopID
            const stopsByParent = {};
            Object.keys(stops).forEach((number)=>{
                const stop = stops[number];
                const [lng, lat, name, suffix = '', parentStopID = ''] = stop;
                if (parentStopID) {
                    if (!stopsByParent[parentStopID]) stopsByParent[parentStopID] = [];
                    stopsByParent[parentStopID].push({
                        number,
                        lng,
                        lat
                    });
                }
            });
            // Second pass: process stops and calculate left based on parentStopID
            Object.keys(stops).forEach((number)=>{
                const stop = stops[number];
                const [lng, lat, name, suffix = '', parentStopID = ''] = stop;
                let left = false;
                // Calculate left based on parentStopID (opposite stops)
                if (parentStopID && stopsByParent[parentStopID]) {
                    const oppositeStops = stopsByParent[parentStopID].filter((s)=>s.number !== number);
                    if (oppositeStops.length > 0) {
                        // Use the first opposite stop to calculate bearing
                        const oppositeStop = oppositeStops[0];
                        const bearing = ruler.bearing([
                            lng,
                            lat
                        ], [
                            oppositeStop.lng,
                            oppositeStop.lat
                        ]);
                        left = bearing > 0;
                    }
                }
                stopsData[number] = {
                    name,
                    suffix,
                    number,
                    parentStopID: parentStopID || null,
                    interchange: /\sint$/i.test(name) && !/^(bef|aft|opp|bet)\s/i.test(name),
                    coordinates: [
                        lng,
                        lat
                    ],
                    services: [],
                    routes: [],
                    left
                };
                stopsDataArr.push(stopsData[number]);
            });
            stopsDataArr.sort((a, b)=>a.interchange ? 1 : b.interchange ? -1 : 0);
            servicesData = await fetchServicesP;
            Object.keys(servicesData).forEach((number)=>{
                const routes = servicesData[number];
                servicesDataArr.push({
                    number,
                    name: routes.name
                });
                // routes is now an object with destinations as keys, values are arrays of route variations
                Object.keys(routes).forEach((destination)=>{
                    if (destination === 'name') return;
                    const routeVariations = routes[destination];
                    // Process each route variation for this destination
                    routeVariations.forEach((route, variantIdx)=>{
                        route.forEach((stop, stopIdx)=>{
                            if (stopsData[stop]) {
                                // Add service to services array if not already present
                                if (!stopsData[stop].services.includes(number)) stopsData[stop].services.push(number);
                                // Store destination-grouped data for this stop
                                if (!stopsData[stop].destinationGroups) stopsData[stop].destinationGroups = {};
                                if (!stopsData[stop].destinationGroups[number]) stopsData[stop].destinationGroups[number] = {};
                                if (!stopsData[stop].destinationGroups[number][destination]) stopsData[stop].destinationGroups[number][destination] = {
                                    destination: destination,
                                    routes: [],
                                    stopCount: 0 // Count stops from this stop to destination
                                };
                                // Calculate remaining stops to destination for this route
                                const remainingStops = route.length - stopIdx - 1;
                                // Store route info with variant index
                                const routeKey = number + '|' + destination + '|' + variantIdx;
                                if (!stopsData[stop].routes.includes(routeKey)) {
                                    stopsData[stop].routes.push(routeKey);
                                    stopsData[stop].destinationGroups[number][destination].routes.push(route);
                                    // Track the maximum stop count (in case of multiple route variations)
                                    if (remainingStops > stopsData[stop].destinationGroups[number][destination].stopCount) stopsData[stop].destinationGroups[number][destination].stopCount = remainingStops;
                                }
                            }
                        });
                    });
                });
            });
            servicesDataArr.sort((a, b)=>(0, _bus.sortServices)(a.number, b.number));
            routesData = await fetchRoutesP;
            const rawPois = await fetchPoisP;
            poisData = rawPois.map((poi, id)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, poi), {
                    id
                }));
            // Build normalized lookup maps for O(1) key lookups
            buildNormalizedLookupMaps();
            // Transfer data to the worker: it builds Fuse indices and handles all
            // future search, closest-stop, and between-routes requests off-thread.
            workerReady = (0, _workerClient.initDataWorker)({
                stopsArr: stopsDataArr.map((s)=>({
                        number: s.number,
                        name: s.name,
                        suffix: s.suffix,
                        coordinates: s.coordinates,
                        routes: s.routes
                    })),
                servicesArr: servicesDataArr.map((s)=>({
                        number: s.number,
                        name: s.name
                    })),
                servicesData,
                poisArr: poisData
            });
            setServices(servicesDataArr);
            // Recalculate closest stops if location is already available
            if (currentLocation && stopsDataArr.length > 0) {
                const [lng, lat] = currentLocation;
                (0, _workerClient.workerClosestStops)(lng, lat).then(({ stops })=>setClosestStops(stops));
            }
            window._data = {
                servicesData,
                stopsData,
                stopsDataArr,
                routesData,
                servicesDataArr
            };
        } // end if (!IS_ALL_MODE)
        map = window._map = new (0, _maplibreGlDefault.default).Map({
            container: 'map',
            style: (0, _theme.mapStyle),
            renderWorldCopies: false,
            boxZoom: false,
            minZoom: 4,
            logoPosition: 'bottom-left',
            attributionControl: false,
            pitchWithRotate: false,
            dragRotate: supportsTouch,
            touchPitch: false,
            bounds: [
                lowerLong,
                lowerLat,
                upperLong,
                upperLat
            ],
            fitBoundsOptions: {
                padding: BREAKPOINT() ? 120 : {
                    top: 40,
                    bottom: window.innerHeight / 2,
                    left: 40,
                    right: 40
                }
            },
            // Performance optimizations
            maxTileCacheSize: 100,
            // Limit tile cache for memory savings (default is unlimited)
            fadeDuration: supportsTouch ? 0 : 300,
            // Disable fade animations on touch devices for smoother UX
            collectResourceTiming: false,
            // Disable resource timing collection for better performance
            trackResize: true,
            // Keep resize tracking but it's optimized internally
            refreshExpiredTiles: false,
            // Don't auto-refresh expired tiles during session
            crossSourceCollisions: false // Disable cross-source collision detection for faster rendering
        });
        if (!supportsTouch) map.touchZoomRotate.disableRotation();
        // Controls
        map.addControl(new (0, _maplibreGlDefault.default).AttributionControl({
            compact: true
        }), 'bottom-right');
        // GeolocateControl - map button on desktop only, search bar button on mobile
        const geolocateControl = new (0, _geolocateControlDefault.default)({
            offset: ()=>{
                if (BREAKPOINT()) return [
                    0,
                    0
                ];
                const popover = [
                    stopPopover,
                    servicePopover,
                    betweenPopover
                ].map((p)=>p.current).find((p)=>p === null || p === void 0 ? void 0 : p.classList.contains('expand'));
                return popover ? [
                    0,
                    -popover.offsetHeight / 2
                ] : [
                    0,
                    0
                ];
            },
            showMapControl: BREAKPOINT(),
            onClick: (location1)=>handleLocationUpdate(location1, geolocateControl)
        });
        map.addControl(geolocateControl, 'top-left');
        geolocateControlRef.current = geolocateControl;
        if (geolocateBtn.current) geolocateControl.registerExternalButton(geolocateBtn.current);
        map.addControl(new (0, _maplibreGlDefault.default).NavigationControl({
            showCompass: true,
            showZoom: false
        }), 'bottom-left');
        const compassButton = document.querySelector('.maplibregl-ctrl-compass');
        map.on('rotateend', ()=>{
            const bearing = map.getBearing();
            compassButton.classList.toggle('show', bearing !== 0);
        });
        let initialMoveStart = false;
        const initialHideSearch = (e)=>{
            // Don't collapse search bar if movement is from geolocation
            if (e && e.geolocateSource) return;
            if (initialMoveStart) return;
            initialMoveStart = true;
            $logo.classList.add('fadeout');
            setShrinkSearch(true);
        };
        map.once('dragstart', initialHideSearch);
        map.once('zoomstart', initialHideSearch);
        await new Promise((resolve)=>{
            map.once('styledata', ()=>resolve());
        });
        const loadPng = (name, path)=>map.loadImage(path).then((img)=>map.addImage(name, img.data));
        const loadSvg = (name, path, size, opts = {})=>new Promise((resolve, reject)=>{
                const dpr = window.devicePixelRatio || 1;
                const img = new Image();
                img.onload = ()=>{
                    map.addImage(name, img, (0, _objectSpread._)({
                        pixelRatio: size / img.naturalWidth * dpr
                    }, opts));
                    resolve();
                };
                img.onerror = reject;
                img.width = img.height = size * dpr;
                img.src = path;
            });
        await Promise.all([
            loadPng('stop', (0, _stopPngDefault.default)),
            loadPng('stop-end', (0, _stopEndPngDefault.default)),
            loadPng('stop-active', (0, _stopActivePngDefault.default)),
            loadSvg('metro-station', (0, _metroStationSdfSvgDefault.default), 60, {
                sdf: true
            }),
            loadSvg('rail-station', (0, _railStationSvgDefault.default), 60, {
                sdf: true
            }),
            loadSvg('monorail-station', (0, _monorailStationSvgDefault.default), 60, {
                sdf: true
            })
        ]).catch((e)=>{});
        // Add rail source (not used in all-mode — no single rail.json path)
        if (!IS_ALL_MODE) map.addSource('rail', {
            type: 'geojson',
            data: railJSONPath
        });
        setMapLoaded(true);
    };
    (0, _hooks.useEffect)(()=>{
        onLoad();
    }, []);
    // stop/service/location/between popovers: mobile presentation is owned by their
    // CupertinoPane instances (see mobilePane.js). Each pane is torn down and
    // rebuilt from scratch every time one of these effects runs with its
    // popover shown — see syncMobilePane's comment for why. The dependency
    // arrays deliberately include each popover's *content* identity (not
    // just its show-state boolean): switching directly from one stop/service
    // to another can leave the boolean unchanged across the switch (React
    // only observes its final value for a render, so a reset-then-reopen
    // within the same update never visibly passes through false), and
    // without the content key here that switch wouldn't rebuild the pane at
    // all.
    // paneAppliesHere(supportsTouch, BREAKPOINT) is read at the top of every
    // pane effect below, but a window resize alone doesn't cause Preact to
    // re-render — so crossing the mobile/desktop width threshold (640px)
    // without some *other* unrelated state change happening to fire a
    // render left a pane built for one layout stuck on screen under the
    // other's CSS (wrong side of the screen, wrong width) until something
    // else eventually re-rendered the component. Bumping this on a
    // (debounced) resize forces those effects to re-check and correctly
    // build/tear down as the breakpoint is crossed.
    //
    // Only on an actual crossing: each of those effects rebuilds its pane from
    // scratch, moving the popover's DOM out of the document and back. Bumping on
    // *any* resize let a mere height change destroy every open sheet — the
    // keyboard opening blurred the input it had just opened for, closing it,
    // which resized again; the collapsing URL bar did the same on scroll.
    const [viewportTick, setViewportTick] = (0, _hooks.useState)(0);
    (0, _hooks.useEffect)(()=>{
        let lastApplies = (0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT);
        const handler = (0, _mapOptimizations.rafThrottle)(()=>{
            const applies = (0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT);
            if (applies === lastApplies) return;
            lastApplies = applies;
            setViewportTick((t)=>t + 1);
        });
        window.addEventListener('resize', handler);
        return ()=>{
            handler.cancel();
            window.removeEventListener('resize', handler);
        };
    }, []);
    // Whether each popover's pane is currently resting at its "bottom" peek
    // break (handle+header only — see computeBreaks in mobilePane.js). Drives
    // hiding the floating footer, which lives outside the pane's own clipped
    // content and so isn't hidden automatically the way the scrollable body
    // is. Reset to false on every fresh open below (buildPane always starts
    // at 'middle').
    const [stopPaneAtBottom, setStopPaneAtBottom] = (0, _hooks.useState)(false);
    const [servicePaneAtBottom, setServicePaneAtBottom] = (0, _hooks.useState)(false);
    const [locationPaneAtBottom, setLocationPaneAtBottom] = (0, _hooks.useState)(false);
    const [betweenPaneAtBottom, setBetweenPaneAtBottom] = (0, _hooks.useState)(false);
    const stopPopoverKey = stopPopoverData ? `${stopPopoverData.city || ''}^${stopPopoverData.number}` : null;
    (0, _hooks.useEffect)(()=>{
        if (!(0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT)) {
            // A resize just crossed from mobile into desktop width — tear the pane
            // down and release the element, so neither the stale cupertino wrapper
            // nor its leftover inline styles fight the desktop CSS layout.
            (0, _mobilePane.syncMobilePane)(stopPane, stopPopover.current, false, {
                release: true
            });
            setStopPaneAtBottom(false);
            return;
        }
        setStopPaneAtBottom(false);
        // The stop sheet is the one that moves in both directions of the
        // stop↔route handoff, so it always animates and always stacks above. The
        // service effect reads this promise to know when the route sheet can go.
        stopPanePresented.current = (0, _mobilePane.syncMobilePane)(stopPane, stopPopover.current, showStopPopover, {
            // Navigate away (not just flip the boolean) — same reasoning as the
            // service pane's own onDismiss below: a drag-dismiss doesn't go
            // through renderRoute otherwise, so none of its resets run. This app
            // has no defined page-stack, so dismissing always closes out to home
            // rather than trying to reconstruct "whatever was there before" —
            // that also fully closes a service popover left open underneath
            // (renderRoute's reset resets showServicePopover too), rather than
            // leaving it revealed the way flipping only showStopPopover would.
            onDismiss: ()=>navigateTo('/', route),
            paneOptions: {
                zIndex: PANE_Z.stop,
                onBreakChange: (b)=>setStopPaneAtBottom(b === 'bottom')
            }
        });
        if (showStopPopover) {
            const cleanupContent = (0, _mobilePane.watchMobilePaneContent)(stopPane, stopPopover.current);
            const cleanupResize = (0, _mobilePane.watchMobilePaneResize)(stopPane, stopPopover.current);
            return ()=>{
                cleanupContent();
                cleanupResize();
            };
        }
    }, [
        showStopPopover,
        stopPopoverKey,
        viewportTick
    ]);
    const servicePopoverKey = (routeServices === null || routeServices === void 0 ? void 0 : routeServices.join(',')) || null;
    (0, _hooks.useEffect)(()=>{
        if (!(0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT)) {
            (0, _mobilePane.syncMobilePane)(servicePane, servicePopover.current, false, {
                release: true
            });
            setServicePaneAtBottom(false);
            return;
        }
        // stop-popover can open on top of an already-open service-popover (e.g.
        // tapping a stop highlighted on the currently-viewed service's route —
        // see the `feature.source == 'stops'` check a few hundred lines down).
        // Only one sheet is ever shown at a time: service is torn down while
        // stop is on top, and rebuilt here once showStopPopover goes false
        // (while showServicePopover is still true) — which is what makes
        // dismissing stop "go back" to service.
        const shouldShow = showServicePopover && !showStopPopover;
        // A stop takes this sheet's place two ways: tapped on the route line
        // (showServicePopover stays true, stop stacks on top) or tapped in the
        // route list (navigates, tearing the route view down). Either way the
        // stop sheet is the one that moves, so this one holds still until the
        // stop is fully up — two sheets crossing reads as a flicker. Coming back
        // it reappears in place underneath while the stop slides off.
        // `servicePane.current` keeps this to sheets that were really on screen:
        // opening a stop from the map with no route hits the same state.
        const handedToStop = !shouldShow && showStopPopover && !!servicePane.current;
        const revealedFromStop = shouldShow && stopTookOverFromService.current;
        stopTookOverFromService.current = handedToStop;
        setServicePaneAtBottom(false);
        const presented = (0, _mobilePane.syncMobilePane)(servicePane, servicePopover.current, shouldShow, {
            // Navigate away (not just flip the boolean) so the map's own service
            // view — hidden stops layer, highlighted route, routes-path/
            // buses-service sources — gets torn down the same way it would from
            // any other route change. Directly setting the state here skipped
            // all of that, since a drag-dismiss doesn't go through renderRoute.
            onDismiss: ()=>navigateTo('/', route),
            animate: !handedToStop && !revealedFromStop,
            waitFor: handedToStop ? stopPanePresented.current : null,
            paneOptions: {
                zIndex: PANE_Z.base,
                onBreakChange: (b)=>setServicePaneAtBottom(b === 'bottom')
            }
        });
        // Flash the row that was tapped, once the list is on screen to scroll.
        // Any other outcome drops the pending stop rather than letting it fire
        // on some later, unrelated route.
        const pendingReveal = revealStopInServiceList.current;
        if (!handedToStop) revealStopInServiceList.current = null;
        if (revealedFromStop && pendingReveal) presented.then(()=>flashStopInServiceList(pendingReveal));
        if (shouldShow) {
            const cleanupContent = (0, _mobilePane.watchMobilePaneContent)(servicePane, servicePopover.current);
            const cleanupResize = (0, _mobilePane.watchMobilePaneResize)(servicePane, servicePopover.current);
            return ()=>{
                cleanupContent();
                cleanupResize();
            };
        }
    }, [
        showServicePopover,
        showStopPopover,
        servicePopoverKey,
        viewportTick
    ]);
    // `.mobile-floating-footer` is fixed, outside the pane's DOM, so the
    // scroll region has to reserve room for it or the last rows stay behind
    // it. Its height isn't constant — it grows by env(safe-area-inset-bottom)
    // on notched devices and varies with which buttons render — so publish the
    // measured value for app.css rather than hard-coding a reserve.
    (0, _hooks.useEffect)(()=>{
        const footer = document.querySelector('.mobile-floating-footer.show');
        if (!footer) return;
        const apply = ()=>{
            const height = footer.offsetHeight;
            if (height) document.documentElement.style.setProperty('--mobile-footer-height', `${height}px`);
        };
        apply();
        if (!window.ResizeObserver) return;
        const observer = new ResizeObserver(apply);
        observer.observe(footer);
        return ()=>observer.disconnect();
    }, [
        showStopPopover,
        stopPaneAtBottom,
        showServicePopover,
        servicePaneAtBottom,
        stopPopoverKey,
        servicePopoverKey,
        viewportTick
    ]);
    const locationPopoverKey = locationPopoverData ? `${locationPopoverData.lat},${locationPopoverData.lon}` : null;
    (0, _hooks.useEffect)(()=>{
        if (!(0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT)) {
            (0, _mobilePane.syncMobilePane)(locationPane, locationPopover.current, false, {
                release: true
            });
            setLocationPaneAtBottom(false);
            return;
        }
        setLocationPaneAtBottom(false);
        (0, _mobilePane.syncMobilePane)(locationPane, locationPopover.current, showLocationPopover, {
            onDismiss: ()=>hideLocationPopover(),
            paneOptions: {
                zIndex: PANE_Z.base,
                onBreakChange: (b)=>setLocationPaneAtBottom(b === 'bottom')
            }
        });
        if (showLocationPopover) {
            const cleanupContent = (0, _mobilePane.watchMobilePaneContent)(locationPane, locationPopover.current);
            const cleanupResize = (0, _mobilePane.watchMobilePaneResize)(locationPane, locationPopover.current);
            return ()=>{
                cleanupContent();
                cleanupResize();
            };
        }
    }, [
        showLocationPopover,
        locationPopoverKey,
        viewportTick
    ]);
    const betweenShown = IS_ALL_MODE ? !!allModeBetween : showBetweenPopover;
    const betweenPopoverKey = `${route.value || ''}|${route.subpage || ''}`;
    (0, _hooks.useEffect)(()=>{
        if (!(0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT)) {
            (0, _mobilePane.syncMobilePane)(betweenPane, betweenPopover.current, false, {
                release: true
            });
            setBetweenPaneAtBottom(false);
            return;
        }
        setBetweenPaneAtBottom(false);
        (0, _mobilePane.syncMobilePane)(betweenPane, betweenPopover.current, betweenShown, {
            // The popover's own close (×) is an <a href="#.../"> — navigating
            // away is what actually hides it; setAllModeBetween(null)/
            // resetStartEndStops() are only supplementary cleanup it does
            // alongside that navigation, not the dismiss mechanism itself.
            onDismiss: ()=>{
                if (route.subpage) // Dismissing a specific itinerary detail (route.subpage set —
                // e.g. /between/<query>/1) should land back on the results list
                // for the same query, same as the detail view's own in-page
                // back link (betweenListHref) — not skip past it to home.
                // route.cityPrefix is already `/all` in all-mode, so this
                // produces the right URL either way without an IS_ALL_MODE branch.
                navigateTo(`/between/${route.value}`, route);
                else {
                    navigateTo('/', route);
                    if (IS_ALL_MODE) setAllModeBetween(null);
                    else resetStartEndStops();
                }
            },
            paneOptions: {
                zIndex: PANE_Z.base,
                onBreakChange: (b)=>setBetweenPaneAtBottom(b === 'bottom')
            }
        });
        if (betweenShown) {
            const cleanupContent = (0, _mobilePane.watchMobilePaneContent)(betweenPane, betweenPopover.current);
            const cleanupResize = (0, _mobilePane.watchMobilePaneResize)(betweenPane, betweenPopover.current);
            return ()=>{
                cleanupContent();
                cleanupResize();
            };
        }
    }, [
        betweenShown,
        betweenPopoverKey,
        viewportTick
    ]);
    // Shared "is anything else up" signal — used below to show/hide search,
    // and by the map-tap handler further down to decide dismiss vs. collapse.
    // Deliberately not shrinkSearch: that's set on every popover open but
    // only ever reset back to false from a couple of directions-specific
    // spots, not on a plain "close and return home" — it can stay stuck
    // true long after every popover is actually gone.
    const anyPopoverOpen = showStopPopover || betweenShown || showServicePopover || showLocationPopover;
    // search-popover: unlike the other four, it isn't a distinct "session"
    // with its own content identity — it's the app's default/home surface,
    // present whenever nothing else is and torn down the instant something
    // else takes over. No content-key dependency needed here for the same
    // reason. It also has no .popover-handle and no drag-to-dismiss — its
    // break is driven entirely by handleSearchFocus/handleSearchClose, the
    // keyboard-height effect, and the map-tap handler below, all via
    // movePaneToBreak().
    (0, _hooks.useEffect)(()=>{
        if (!(0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT)) {
            (0, _mobilePane.syncMobilePane)(searchPane, searchPopover.current, false, {
                release: true
            });
            return;
        }
        (0, _mobilePane.syncMobilePane)(searchPane, searchPopover.current, !anyPopoverOpen, {
            paneOptions: {
                zIndex: PANE_Z.search,
                dragHandleSelector: null,
                computeBreaksFn: (0, _mobilePane.computeSearchBreaks),
                bottomClose: false,
                fastSwipeClose: false
            }
        });
        if (!anyPopoverOpen) return (0, _mobilePane.watchMobilePaneResize)(searchPane, searchPopover.current);
    }, [
        anyPopoverOpen,
        viewportTick
    ]);
    (0, _hooks.useEffect)(()=>{
        const vv = window.visualViewport;
        if (!vv) return;
        let lastKh = -1;
        const update = ()=>{
            const kh = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
            // Only write when it actually changes so iOS toolbar-collapse scrolls
            // don't churn the custom property and trigger transform repaints.
            if (kh === lastKh) return;
            const wasOpen = lastKh > 0;
            lastKh = kh;
            document.documentElement.style.setProperty('--keyboard-height', `${kh}px`);
            // The on-screen keyboard just went away (mobile "back" while it's up
            // does this before it ever touches history/hash) — search should
            // settle back to its default half-screen resting position rather
            // than staying expanded to fit a keyboard that's no longer there.
            if (wasOpen && kh === 0) (0, _mobilePane.movePaneToBreak)(searchPane, 'middle');
        };
        vv.addEventListener('resize', update);
        return ()=>{
            vv.removeEventListener('resize', update);
        };
    }, []);
    (0, _hooks.useEffect)(()=>{
        if (!mapLoaded) return;
        const mapCanvas = map.getCanvas();
        map.addSource('stops', {
            type: 'geojson',
            tolerance: 10,
            data: {
                type: 'FeatureCollection',
                features: (0, _mapOptimizations.createFeaturesOptimized)(stopsDataArr, (stop)=>({
                        type: 'Feature',
                        id: (0, _specialID.encode)(stop.number),
                        properties: {
                            number: stop.number,
                            name: stop.name,
                            interchange: stop.interchange,
                            left: stop.left,
                            suffix: stop.suffix
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: stop.coordinates
                        }
                    }))
            }
        });
        // Check if stop IDs should be disabled for this city
        const cityConfig = (0, _config.getConfigForCity)(route.city);
        const disableStopID = (cityConfig === null || cityConfig === void 0 ? void 0 : cityConfig.disableStopID) || false;
        let stopTextPartialFormat, stopTextFullFormat;
        if (disableStopID) {
            stopTextPartialFormat = [
                'get',
                'name'
            ];
            stopTextFullFormat = [
                'format',
                [
                    'get',
                    'name'
                ],
                {},
                [
                    'case',
                    [
                        '!=',
                        [
                            'get',
                            'suffix'
                        ],
                        null
                    ],
                    [
                        'concat',
                        '\n',
                        [
                            'get',
                            'suffix'
                        ]
                    ],
                    ''
                ],
                {
                    'font-scale': 0.8,
                    'text-color': (0, _theme.C).text
                }
            ];
        } else {
            stopTextPartialFormat = [
                'get',
                'number'
            ];
            stopTextFullFormat = [
                'format',
                [
                    'get',
                    'number'
                ],
                {
                    'font-scale': 0.8
                },
                '\n',
                {},
                [
                    'get',
                    'name'
                ],
                {
                    'text-color': (0, _theme.C).text
                }
            ];
        }
        const stopText = {
            layout: {
                'text-optional': true,
                'text-field': [
                    'step',
                    [
                        'zoom'
                    ],
                    '',
                    15,
                    stopTextPartialFormat,
                    16,
                    stopTextFullFormat
                ],
                'text-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    12,
                    16,
                    14
                ],
                'text-justify': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    'right',
                    'left'
                ],
                'text-anchor': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    'right',
                    'left'
                ],
                'text-offset': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    [
                        'literal',
                        [
                            -1,
                            0
                        ]
                    ],
                    [
                        'literal',
                        [
                            1,
                            0
                        ]
                    ]
                ],
                // 'text-justify': 'auto',
                // 'text-variable-anchor': ['left', 'right'],
                // 'text-radial-offset': 1,
                'text-padding': 0.5,
                // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
                'text-font': [
                    'Noto Sans Regular'
                ],
                'text-max-width': 16,
                'text-line-height': 1.1
            },
            paint: {
                'text-color': (0, _theme.C).stopRed,
                'text-halo-width': 1,
                'text-halo-color': (0, _theme.C).textHalo
            }
        };
        map.addLayer({
            id: 'stops',
            type: 'circle',
            source: 'stops',
            layout: {
                visibility: 'none'
            },
            paint: {
                'circle-radius': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    [
                        'case',
                        [
                            'boolean',
                            [
                                'feature-state',
                                'selected'
                            ],
                            false
                        ],
                        4,
                        1
                    ],
                    14,
                    4,
                    15,
                    [
                        'case',
                        [
                            'boolean',
                            [
                                'feature-state',
                                'selected'
                            ],
                            false
                        ],
                        12,
                        6
                    ]
                ],
                'circle-color': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    (0, _theme.C).stopCircleBg,
                    (0, _theme.C).stopRed
                ],
                'circle-stroke-color': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    (0, _theme.C).stopRed,
                    (0, _theme.C).stopCircleBg
                ],
                'circle-stroke-width': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    5,
                    1
                ],
                'circle-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    1,
                    13.9,
                    1,
                    14,
                    0.5
                ],
                'circle-stroke-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    [
                        'case',
                        [
                            'boolean',
                            [
                                'feature-state',
                                'selected'
                            ],
                            false
                        ],
                        1,
                        0
                    ],
                    13.5,
                    1,
                    14,
                    0.5
                ]
            }
        });
        map.addLayer({
            id: 'stops-icon',
            type: 'symbol',
            source: 'stops',
            filter: [
                'any',
                [
                    '>=',
                    [
                        'zoom'
                    ],
                    14
                ],
                [
                    'get',
                    'interchange'
                ]
            ],
            layout: (0, _objectSpread._)({
                visibility: 'none',
                // 'symbol-z-order': 'source',
                'icon-image': 'stop',
                'icon-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    0.4,
                    15,
                    0.5,
                    16,
                    0.6
                ],
                // 'icon-size': ['interpolate', ['linear'], ['zoom'], 14, 0.4, 16, 0.6],
                'icon-padding': 0.5,
                'icon-allow-overlap': true
            }, stopText.layout),
            paint: (0, _objectSpread._)({
                'icon-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    8,
                    [
                        'case',
                        [
                            'get',
                            'interchange'
                        ],
                        1,
                        0
                    ],
                    14,
                    1
                ]
            }, stopText.paint)
        });
        // Rail layer specs
        const railLineFilter = [
            'all',
            [
                '==',
                [
                    'geometry-type'
                ],
                'LineString'
            ],
            [
                'has',
                'stroke'
            ]
        ];
        const railLineLayout = {
            'line-join': 'round',
            'line-cap': 'round'
        };
        const railInterchangeFilter = [
            'all',
            [
                '==',
                [
                    'geometry-type'
                ],
                'Point'
            ],
            [
                '==',
                [
                    'get',
                    'interchange'
                ],
                true
            ]
        ];
        const railStationsFilter = [
            'all',
            [
                '==',
                [
                    'geometry-type'
                ],
                'Point'
            ],
            [
                'has',
                'name'
            ],
            [
                '!=',
                [
                    'get',
                    'interchange'
                ],
                true
            ]
        ];
        const railInterchangeLayout = {
            'icon-image': [
                'match',
                [
                    'get',
                    'mode'
                ],
                'metro',
                'metro-station',
                'monorail',
                'monorail-station',
                'rail-station'
            ],
            'icon-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                10,
                0.45,
                22,
                0.75
            ],
            'icon-allow-overlap': true,
            'text-field': [
                'get',
                'name'
            ],
            'text-font': [
                'Noto Sans Bold'
            ],
            'text-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                10,
                10,
                22,
                16
            ],
            'text-variable-anchor': [
                'left',
                'right',
                'top'
            ],
            'text-radial-offset': 1.1,
            'text-optional': true
        };
        const railInterchangePaint = (0, _objectSpreadProps._)((0, _objectSpread._)({
            'icon-color': (0, _theme.C).text,
            'icon-opacity': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                9,
                0,
                10,
                1
            ]
        }, (0, _theme.isDark) && {
            'icon-halo-color': '#000',
            'icon-halo-width': 0.5,
            'icon-halo-blur': 1
        }), {
            'text-color': (0, _theme.C).text,
            'text-opacity': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                9,
                0,
                10,
                1
            ],
            'text-halo-color': (0, _theme.C).textHalo,
            'text-halo-width': (0, _theme.C).stationHaloWidth
        });
        const railStationsLayout = {
            'icon-image': [
                'match',
                [
                    'get',
                    'mode'
                ],
                'metro',
                'metro-station',
                'monorail',
                'monorail-station',
                'rail-station'
            ],
            'icon-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                11,
                0.3,
                22,
                0.5
            ],
            'icon-allow-overlap': false,
            'text-field': [
                'get',
                'name'
            ],
            'text-font': [
                'Noto Sans Bold'
            ],
            'text-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                11,
                10,
                22,
                16
            ],
            'text-variable-anchor': [
                'left',
                'right',
                'top'
            ],
            'text-radial-offset': 1.1,
            'text-optional': true
        };
        const railStationsPaint = (0, _objectSpreadProps._)((0, _objectSpread._)({
            'icon-color': (0, _theme.stationIconColor),
            'icon-opacity': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                10,
                0,
                11,
                1
            ]
        }, (0, _theme.isDark) && {
            'icon-halo-color': '#000',
            'icon-halo-width': 0.5,
            'icon-halo-blur': 1
        }), {
            'text-color': (0, _theme.stationTextColor),
            'text-opacity': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                10,
                0,
                11,
                1
            ],
            'text-halo-color': (0, _theme.C).textHalo,
            'text-halo-width': (0, _theme.C).stationHaloWidth
        });
        // Rail layers — single-city mode only (all-mode loads rail per city in loadCity)
        // Everything here — line paths and station icons alike — stays below the
        // 'stops' layer, so a rail/metro station never visually covers a bus stop
        // marker at the same physical hub.
        if (!IS_ALL_MODE) {
            map.addLayer({
                id: 'rail-path',
                type: 'line',
                source: 'rail',
                filter: railLineFilter,
                minzoom: 8,
                layout: railLineLayout,
                paint: {
                    'line-color': [
                        'get',
                        'stroke'
                    ],
                    'line-width': [
                        'interpolate',
                        [
                            'linear'
                        ],
                        [
                            'zoom'
                        ],
                        12,
                        3,
                        16,
                        4,
                        22,
                        6
                    ],
                    // Fade metro lines down as the map zooms past the subway-entrance
                    // threshold (z15) so other features become easier to read
                    'line-opacity': [
                        'interpolate',
                        [
                            'linear'
                        ],
                        [
                            'zoom'
                        ],
                        15,
                        [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'monorail',
                            1,
                            'rail',
                            0.01,
                            (0, _theme.C).routeLineOpacity
                        ],
                        18,
                        [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'monorail',
                            1,
                            'rail',
                            0.01,
                            (0, _theme.C).routeLineOpacity * 0.45
                        ]
                    ]
                }
            }, 'stops');
            map.addLayer({
                id: 'rail-path-dots',
                type: 'line',
                source: 'rail',
                filter: [
                    'all',
                    ...railLineFilter.slice(1),
                    [
                        '==',
                        [
                            'get',
                            'mode'
                        ],
                        'rail'
                    ]
                ],
                minzoom: 8,
                layout: (0, _objectSpreadProps._)((0, _objectSpread._)({}, railLineLayout), {
                    'line-cap': 'butt'
                }),
                paint: {
                    'line-color': [
                        'get',
                        'stroke'
                    ],
                    'line-width': [
                        'interpolate',
                        [
                            'linear'
                        ],
                        [
                            'zoom'
                        ],
                        12,
                        2,
                        16,
                        3,
                        22,
                        4
                    ],
                    'line-opacity': 1,
                    'line-dasharray': [
                        3,
                        3
                    ]
                }
            }, 'stops');
            map.addLayer({
                id: 'rail-path-case',
                type: 'line',
                source: 'rail',
                filter: railLineFilter,
                minzoom: 8,
                layout: railLineLayout,
                paint: {
                    'line-color': [
                        'match',
                        [
                            'get',
                            'mode'
                        ],
                        'metro',
                        (0, _theme.C).stopCircleBg,
                        'monorail',
                        '#FFF',
                        [
                            'get',
                            'stroke'
                        ]
                    ],
                    'line-width': [
                        'interpolate',
                        [
                            'linear'
                        ],
                        [
                            'zoom'
                        ],
                        16,
                        [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'monorail',
                            0.85,
                            'rail',
                            5,
                            9
                        ],
                        22,
                        [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'monorail',
                            12,
                            'rail',
                            7,
                            12
                        ]
                    ],
                    'line-opacity': [
                        'interpolate',
                        [
                            'linear'
                        ],
                        [
                            'zoom'
                        ],
                        15,
                        [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'monorail',
                            0.5,
                            'rail',
                            0.75,
                            0.5
                        ],
                        18,
                        [
                            'match',
                            [
                                'get',
                                'mode'
                            ],
                            'monorail',
                            0.5,
                            'rail',
                            0.75,
                            0.15
                        ]
                    ]
                }
            }, 'rail-path');
            map.addLayer({
                id: 'rail-stations',
                type: 'symbol',
                source: 'rail',
                filter: railStationsFilter,
                minzoom: 10,
                layout: railStationsLayout,
                paint: railStationsPaint
            }, 'stops');
            map.addLayer({
                id: 'rail-stations-interchange',
                type: 'symbol',
                source: 'rail',
                filter: railInterchangeFilter,
                minzoom: 9,
                layout: railInterchangeLayout,
                paint: railInterchangePaint
            }, 'stops');
        } // end if (!IS_ALL_MODE) for rail layers
        // Create stops-highlight source and layers BEFORE setting up event handlers
        // that query this layer to avoid "layer does not exist" errors
        map.addSource('stops-highlight', {
            type: 'geojson',
            tolerance: 10,
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            id: 'stops-highlight-circle',
            type: 'circle',
            source: 'stops-highlight',
            minzoom: 4,
            maxzoom: 14,
            filter: [
                'all',
                [
                    '!=',
                    [
                        'get',
                        'type'
                    ],
                    'end'
                ],
                [
                    '!=',
                    [
                        'get',
                        'type'
                    ],
                    'intersect'
                ]
            ],
            paint: {
                'circle-radius': [
                    'step',
                    [
                        'zoom'
                    ],
                    2,
                    12,
                    3
                ],
                'circle-color': (0, _theme.C).stopCircleBg,
                'circle-stroke-color': (0, _theme.C).stopRed,
                'circle-stroke-width': [
                    'step',
                    [
                        'zoom'
                    ],
                    1.5,
                    12,
                    2
                ]
            }
        });
        map.addLayer({
            id: 'stops-highlight',
            type: 'symbol',
            source: 'stops-highlight',
            filter: [
                'any',
                [
                    '>=',
                    [
                        'zoom'
                    ],
                    14
                ],
                [
                    '==',
                    [
                        'get',
                        'type'
                    ],
                    'end'
                ],
                [
                    '==',
                    [
                        'get',
                        'type'
                    ],
                    'intersect'
                ]
            ],
            layout: {
                // Simplified with 'match' expression for better performance
                'icon-image': [
                    'match',
                    [
                        'get',
                        'type'
                    ],
                    'end',
                    'stop-end',
                    'intersect',
                    'stop-active',
                    'stop' // default
                ],
                'icon-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    0.3,
                    10,
                    [
                        'match',
                        [
                            'get',
                            'type'
                        ],
                        'end',
                        0.3,
                        'intersect',
                        0.6,
                        0.45 // default
                    ],
                    15,
                    [
                        'match',
                        [
                            'get',
                            'type'
                        ],
                        'end',
                        0.45,
                        'intersect',
                        0.9,
                        0.6 // default
                    ]
                ],
                // Simplified: both 'end' and 'intersect' use 'bottom', others use 'center'
                'icon-anchor': [
                    'match',
                    [
                        'get',
                        'type'
                    ],
                    [
                        'end',
                        'intersect'
                    ],
                    'bottom',
                    'center' // default
                ],
                'icon-padding': 0.5,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
                'text-optional': true,
                'text-field': [
                    'step',
                    [
                        'zoom'
                    ],
                    [
                        'case',
                        [
                            'any',
                            [
                                '==',
                                [
                                    'get',
                                    'type'
                                ],
                                'end'
                            ],
                            [
                                '==',
                                [
                                    'get',
                                    'type'
                                ],
                                'intersect'
                            ]
                        ],
                        stopTextFullFormat,
                        ''
                    ],
                    14,
                    [
                        'case',
                        [
                            'any',
                            [
                                '==',
                                [
                                    'get',
                                    'type'
                                ],
                                'end'
                            ],
                            [
                                '==',
                                [
                                    'get',
                                    'type'
                                ],
                                'intersect'
                            ]
                        ],
                        stopTextFullFormat,
                        stopTextPartialFormat
                    ],
                    16,
                    stopTextFullFormat
                ],
                'text-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    [
                        'case',
                        [
                            'any',
                            [
                                '==',
                                [
                                    'get',
                                    'type'
                                ],
                                'end'
                            ],
                            [
                                '==',
                                [
                                    'get',
                                    'type'
                                ],
                                'intersect'
                            ]
                        ],
                        14,
                        11
                    ],
                    16,
                    14
                ],
                'text-justify': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    'right',
                    'left'
                ],
                'text-anchor': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    'right',
                    'left'
                ],
                'text-offset': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    [
                        'literal',
                        [
                            -0.8,
                            0
                        ]
                    ],
                    [
                        'literal',
                        [
                            0.8,
                            0
                        ]
                    ]
                ],
                'text-padding': 0.5,
                'text-font': [
                    'Noto Sans Regular'
                ],
                'text-max-width': 16,
                'text-line-height': 1.1
            },
            paint: (0, _objectSpreadProps._)((0, _objectSpread._)({}, stopText.paint), {
                'text-halo-width': [
                    'case',
                    [
                        'any',
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'end'
                        ],
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'intersect'
                        ]
                    ],
                    2,
                    1
                ]
            })
        });
        // Add stops-highlight-selected layer, checking if stops-highlight exists first
        const stopsHighlightLayer = map.getLayer('stops-highlight');
        const beforeLayerForSelected = stopsHighlightLayer ? 'stops-highlight' : 'stops';
        map.addLayer({
            id: 'stops-highlight-selected',
            type: 'circle',
            source: 'stops-highlight',
            filter: [
                'any',
                [
                    '>',
                    [
                        'zoom'
                    ],
                    10
                ],
                [
                    '==',
                    [
                        'get',
                        'type'
                    ],
                    'end'
                ]
            ],
            paint: {
                'circle-radius': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    4,
                    15,
                    // Simplified: both 'end' and 'intersect' get 4, default 12
                    [
                        'match',
                        [
                            'get',
                            'type'
                        ],
                        [
                            'end',
                            'intersect'
                        ],
                        4,
                        12 // default
                    ]
                ],
                'circle-color': '#fff',
                'circle-stroke-color': '#f01b48',
                'circle-stroke-width': 5,
                'circle-opacity': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    0.5,
                    0
                ],
                'circle-stroke-opacity': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    0.5,
                    0
                ]
            }
        }, beforeLayerForSelected);
        // Cursor and dismiss handlers are lightweight — attach immediately
        map.on('mouseenter', 'stops', ()=>{
            mapCanvas.style.cursor = 'pointer';
        });
        map.on('mouseleave', 'stops', ()=>{
            mapCanvas.style.cursor = '';
            hideStopTooltip();
        });
        map.on('mouseout', hideStopTooltip);
        map.on('movestart', hideStopTooltip);
        map.on('mouseenter', 'stops-highlight', ()=>{
            mapCanvas.style.cursor = 'pointer';
        });
        map.on('mouseleave', 'stops-highlight', ()=>{
            mapCanvas.style.cursor = '';
        });
        // Defer the queryRenderedFeatures hover handler until idle (guaranteed within 2s)
        if (supportsHover) requestIdleCallback(()=>{
            let lastFeature = null;
            // RAF-throttled mousemove handler for smooth 60fps updates
            const handleMouseMove = (0, _mapOptimizations.rafThrottle)((e)=>{
                if (map.isMoving() || map.getZoom() >= 16) {
                    if (lastFeature) {
                        lastFeature = null;
                        hideStopTooltip();
                    }
                    return;
                }
                const { point } = e;
                // Build layers array, only including layers that exist
                let queryLayers;
                if (IS_ALL_MODE) {
                    queryLayers = [];
                    loadedCities.forEach((c)=>{
                        if (map.getLayer(`stops-${c}`)) queryLayers.push(`stops-${c}`);
                    });
                    if (map.getLayer('stops-highlight')) queryLayers.push('stops-highlight');
                } else {
                    queryLayers = [
                        'stops'
                    ].filter((l)=>map.getLayer(l));
                    if (map.getLayer('stops-highlight')) queryLayers.push('stops-highlight');
                }
                const features = map.queryRenderedFeatures(point, {
                    layers: queryLayers,
                    validate: false
                });
                if (features.length) {
                    if (lastFeature && features[0].id === lastFeature.id) return;
                    lastFeature = features[0];
                    const stopID = (0, _specialID.decode)(features[0].id);
                    let data;
                    if (IS_ALL_MODE) {
                        var _features__properties, _features__source, _cityDataMap_get_stopsData, _cityDataMap_get;
                        const featureCity = ((_features__properties = features[0].properties) === null || _features__properties === void 0 ? void 0 : _features__properties.city) || ((_features__source = features[0].source) === null || _features__source === void 0 ? void 0 : _features__source.replace(/^stops-/, ''));
                        data = featureCity ? (_cityDataMap_get = cityDataMap.get(featureCity)) === null || _cityDataMap_get === void 0 ? void 0 : (_cityDataMap_get_stopsData = _cityDataMap_get.stopsData) === null || _cityDataMap_get_stopsData === void 0 ? void 0 : _cityDataMap_get_stopsData[stopID] : null;
                    } else data = stopsData[stopID];
                    showStopTooltip((0, _objectSpread._)({}, data, point));
                } else if (lastFeature) {
                    lastFeature = null;
                    hideStopTooltip();
                }
            });
            map.on('mousemove', handleMouseMove);
        }, {
            timeout: 2000
        });
        // Transit service routes
        map.addSource('routes', {
            type: 'geojson',
            tolerance: 1,
            buffer: 0,
            lineMetrics: true,
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            id: 'routes',
            type: 'line',
            source: 'routes',
            layout: {
                'line-cap': 'round'
            },
            paint: {
                'line-color': (0, _theme.C).routeLine,
                'line-gradient': (0, _theme.routeLineGradient),
                'line-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0.9,
                    16,
                    0.4
                ],
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    2,
                    16,
                    5,
                    22,
                    10
                ],
                'line-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    16,
                    -3,
                    22,
                    -8
                ]
            }
        }, 'stops');
        map.addLayer({
            id: 'routes-bg',
            type: 'line',
            source: 'routes',
            maxzoom: 20,
            // Stop rendering when nearly transparent (opacity approaches 0)
            layout: {
                'line-cap': 'round'
            },
            paint: {
                'line-color': (0, _theme.C).routeCasing,
                'line-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    1,
                    22,
                    0
                ],
                'line-width': 6,
                'line-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    16,
                    -3,
                    22,
                    -8
                ]
            }
        }, 'routes');
        map.addLayer({
            id: 'route-arrows',
            type: 'symbol',
            source: 'routes',
            minzoom: 10,
            // Only show arrows when zoomed in enough to see direction
            maxzoom: 18,
            // Hide at very high zooms where direction is obvious from line
            layout: {
                'symbol-placement': 'line',
                'symbol-spacing': 100,
                'text-field': "\u2192",
                'text-size': 16,
                // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
                'text-font': [
                    'Noto Sans Regular'
                ],
                'text-allow-overlap': true,
                'text-ignore-placement': true,
                'text-keep-upright': false,
                'text-anchor': 'bottom',
                'text-padding': 0,
                'text-line-height': 1,
                'text-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    [
                        'literal',
                        [
                            0,
                            0
                        ]
                    ],
                    22,
                    [
                        'literal',
                        [
                            0,
                            -2
                        ]
                    ]
                ]
            },
            paint: {
                'text-color': (0, _theme.C).metroPurple,
                'text-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    0,
                    11,
                    0.9,
                    16,
                    0.9,
                    18,
                    0
                ],
                'text-halo-color': (0, _theme.C).textHalo,
                'text-halo-width': 2
            }
        }, 'stops');
        // Transit service routes (passing, overlapping)
        map.addSource('routes-path', {
            type: 'geojson',
            tolerance: 1,
            buffer: 0,
            lineMetrics: true,
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            id: 'routes-path',
            type: 'line',
            source: 'routes-path',
            layout: {
                'line-cap': 'round'
            },
            paint: {
                'line-color': (0, _theme.C).routeLine,
                'line-gradient': (0, _theme.routeLineGradient),
                'line-opacity': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'hover'
                        ],
                        false
                    ],
                    1,
                    [
                        'boolean',
                        [
                            'feature-state',
                            'fadein'
                        ],
                        false
                    ],
                    0.07,
                    0.5 // default
                ],
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    2,
                    16,
                    5,
                    22,
                    10
                ]
            }
        }, 'stops');
        map.addLayer({
            id: 'routes-path-bg',
            type: 'line',
            source: 'routes-path',
            layout: {
                'line-cap': 'round'
            },
            maxzoom: 20,
            paint: {
                'line-color': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'fadein'
                        ],
                        false
                    ],
                    'transparent',
                    (0, _theme.C).routeCasing
                ],
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    6,
                    16,
                    10,
                    22,
                    16
                ]
            }
        }, 'routes-path');
        map.addLayer({
            id: 'route-path-labels',
            type: 'symbol',
            source: 'routes-path',
            layout: {
                'symbol-placement': 'line',
                'symbol-spacing': 300,
                // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
                'text-font': [
                    'Noto Sans Regular'
                ],
                'text-field': '{service}',
                'text-size': 14,
                'text-rotation-alignment': 'viewport',
                'text-padding': 0,
                'text-line-height': 1
            },
            paint: {
                'text-color': (0, _theme.C).serviceGreen,
                'text-halo-color': (0, _theme.C).serviceGreenHalo,
                'text-halo-width': 2,
                'text-opacity': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'fadein'
                        ],
                        false
                    ],
                    0.1,
                    1
                ]
            }
        });
        map.addLayer({
            id: 'route-path-arrows',
            type: 'symbol',
            source: 'routes-path',
            minzoom: 10,
            // Only show arrows when zoomed in enough
            maxzoom: 18,
            // Hide at very high zooms
            layout: {
                'symbol-placement': 'line',
                'symbol-spacing': 200,
                'text-field': "\u2192",
                'text-size': 16,
                // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
                'text-font': [
                    'Noto Sans Regular'
                ],
                // 'text-allow-overlap': true,
                // 'text-ignore-placement': true,
                'text-keep-upright': false,
                'text-anchor': 'bottom',
                'text-padding': 0,
                'text-line-height': 1,
                'text-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    [
                        'literal',
                        [
                            0,
                            0
                        ]
                    ],
                    22,
                    [
                        'literal',
                        [
                            0,
                            -2
                        ]
                    ]
                ]
            },
            paint: {
                'text-color': (0, _theme.C).metroPurple,
                'text-halo-color': (0, _theme.C).textHalo,
                'text-halo-width': 2,
                'text-opacity': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'fadein'
                        ],
                        false
                    ],
                    0.1,
                    1
                ]
            }
        }, 'stops');
        requestIdleCallback(()=>{
            let hoveredRouteID;
            map.on('mouseenter', 'routes-path', ()=>{
                mapCanvas.style.cursor = 'pointer';
            });
            map.on('click', 'routes-path', (e)=>{
                if (e.features.length) {
                    const { id } = e.features[0];
                    navigateTo(`/services/${encodeURIComponent((0, _specialID.decode)(id))}`, route);
                }
            });
            // RAF-throttled mousemove for smooth route highlighting
            const handleRoutesPathMouseMove = (0, _mapOptimizations.rafThrottle)((e)=>{
                if (e.features.length) {
                    var _STORE_routesPathServices;
                    const currentHoveredRouteID = e.features[0].id;
                    if (hoveredRouteID && hoveredRouteID === currentHoveredRouteID) return;
                    hoveredRouteID = currentHoveredRouteID;
                    // Build batch updates for all routes
                    const updates = [];
                    updates.push({
                        id: hoveredRouteID,
                        state: {
                            hover: true,
                            fadein: false
                        }
                    });
                    (_STORE_routesPathServices = STORE.routesPathServices) === null || _STORE_routesPathServices === void 0 ? void 0 : _STORE_routesPathServices.forEach((service)=>{
                        const id = (0, _specialID.encode)(service);
                        if (hoveredRouteID !== id) updates.push({
                            id,
                            state: {
                                hover: false,
                                fadein: true
                            }
                        });
                    });
                    // Apply all feature state updates efficiently
                    (0, _mapOptimizations.replaceFeatureStates)(map, 'routes-path', updates);
                    highlightRouteTag((0, _specialID.decode)(hoveredRouteID));
                }
            });
            map.on('mousemove', 'routes-path', handleRoutesPathMouseMove);
            map.on('mouseleave', 'routes-path', ()=>{
                mapCanvas.style.cursor = '';
                if (hoveredRouteID) {
                    // Clear all feature states at once instead of iterating
                    map.removeFeatureState({
                        source: 'routes-path'
                    });
                    hoveredRouteID = null;
                    highlightRouteTag();
                }
            });
        });
        // Service live buses
        map.addSource('buses-service', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.loadImage((0, _busTinyMapPngDefault.default)).then((img)=>{
            map.addImage('bus-tiny', img.data);
        }).catch((e)=>{});
        map.addLayer({
            id: 'buses-service',
            type: 'symbol',
            source: 'buses-service',
            minzoom: 4,
            layout: {
                'icon-image': 'bus-tiny',
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
                'icon-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    0.5,
                    14,
                    0.6,
                    15,
                    0.7,
                    16,
                    0.8
                ],
                'text-field': [
                    'get',
                    'vehicleNumber'
                ],
                'text-optional': true,
                'text-size': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    12,
                    14,
                    14,
                    16,
                    16
                ],
                'text-font': [
                    'Noto Sans Regular'
                ],
                'text-variable-anchor': [
                    'left',
                    'right',
                    'bottom',
                    'top'
                ],
                'text-justify': 'auto',
                'text-offset': [
                    0.5,
                    1
                ],
                'text-padding': 4
            },
            paint: {
                'text-color': (0, _theme.C).text,
                'text-halo-color': (0, _theme.C).textHalo,
                'text-halo-width': 2
            }
        });
        // Vehicle selected from search (position may be estimated from stop times)
        map.addSource('vehicle-focus', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            id: 'vehicle-focus',
            type: 'symbol',
            source: 'vehicle-focus',
            layout: {
                'icon-image': 'bus-tiny',
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
                'icon-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    0.5,
                    14,
                    0.6,
                    15,
                    0.7,
                    16,
                    0.8
                ],
                'text-field': [
                    'get',
                    'vehicleNumber'
                ],
                'text-optional': true,
                'text-size': 14,
                'text-font': [
                    'Noto Sans Regular'
                ],
                'text-variable-anchor': [
                    'left',
                    'right',
                    'bottom',
                    'top'
                ],
                'text-justify': 'auto',
                'text-offset': [
                    0.5,
                    1
                ],
                'text-padding': 4
            },
            paint: {
                'text-color': (0, _theme.C).text,
                'text-halo-color': (0, _theme.C).textHalo,
                'text-halo-width': 2
            }
        });
        // Dim overlay — sits below between-route layers to fade the basemap
        map.addSource('dim-overlay', {
            type: 'geojson',
            data: {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: [
                        [
                            [
                                -180,
                                -90
                            ],
                            [
                                180,
                                -90
                            ],
                            [
                                180,
                                90
                            ],
                            [
                                -180,
                                90
                            ],
                            [
                                -180,
                                -90
                            ]
                        ]
                    ]
                }
            }
        });
        map.addLayer({
            id: 'dim-overlay',
            type: 'fill',
            source: 'dim-overlay',
            paint: {
                'fill-color': (0, _theme.isDark) ? '#000' : '#fff',
                'fill-opacity': 0,
                'fill-opacity-transition': {
                    duration: 300
                }
            }
        }, 'stops');
        // Between routes
        map.addSource('routes-between', {
            type: 'geojson',
            tolerance: 1,
            buffer: 0,
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            id: 'routes-between',
            type: 'line',
            source: 'routes-between',
            filter: [
                '!=',
                [
                    'get',
                    'type'
                ],
                'walk'
            ],
            layout: {
                'line-cap': 'round'
            },
            paint: {
                'line-color': [
                    'match',
                    [
                        'get',
                        'type'
                    ],
                    'start',
                    (0, _theme.C).routeLine,
                    'end',
                    (0, _theme.C).routeLineMid,
                    (0, _theme.C).routeLine
                ],
                'line-opacity': 0.7,
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    2,
                    16,
                    5,
                    22,
                    10
                ],
                'line-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    16,
                    -3,
                    22,
                    -8
                ]
            }
        }, 'stops');
        // Add routes-between-walk layer, checking if stops-highlight exists first
        const beforeLayer = map.getLayer('stops-highlight') ? 'stops-highlight' : 'stops';
        map.addLayer({
            id: 'routes-between-walk',
            type: 'line',
            source: 'routes-between',
            filter: [
                '==',
                [
                    'get',
                    'type'
                ],
                'walk'
            ],
            paint: {
                'line-color': (0, _theme.C).linkBlue,
                'line-dasharray': [
                    2,
                    2
                ],
                'line-opacity': 0.7,
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    2,
                    16,
                    5,
                    22,
                    10
                ]
            }
        }, beforeLayer);
        map.addLayer({
            id: 'routes-between-bg',
            type: 'line',
            source: 'routes-between',
            layout: {
                'line-cap': 'round'
            },
            maxzoom: 14,
            paint: {
                'line-color': (0, _theme.C).routeCasing,
                'line-width': 6
            }
        }, 'routes-between');
        map.addLayer({
            id: 'route-between-arrows',
            type: 'symbol',
            source: 'routes-between',
            minzoom: 10,
            // Only show arrows when zoomed in enough
            maxzoom: 18,
            // Hide at very high zooms
            layout: {
                'symbol-placement': 'line',
                'symbol-spacing': 100,
                'text-field': "\u2192",
                'text-size': 16,
                'text-allow-overlap': true,
                'text-ignore-placement': true,
                'text-keep-upright': false,
                'text-anchor': 'bottom',
                'text-padding': 0,
                'text-line-height': 1,
                'text-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    [
                        'literal',
                        [
                            0,
                            0
                        ]
                    ],
                    22,
                    [
                        'literal',
                        [
                            0,
                            -2
                        ]
                    ]
                ]
            },
            paint: {
                'text-color': (0, _theme.C).metroPurple,
                'text-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    0,
                    11,
                    0.8,
                    16,
                    0.8,
                    18,
                    0
                ],
                'text-halo-color': (0, _theme.C).textHalo,
                'text-halo-width': 2
            }
        });
        renderRoute();
        // Re-run search if the user typed something while the worker was initialising
        workerReady.then(()=>{
            var _searchField_current;
            if ((_searchField_current = searchField.current) === null || _searchField_current === void 0 ? void 0 : _searchField_current.value) handleSearch();
        });
        // In all-mode, attach viewport engine to load/unload cities as user pans
        if (IS_ALL_MODE) {
            const checkViewport = throttle(()=>{
                if (!map) return;
                const vp = map.getBounds();
                const zoom = map.getZoom();
                // Persist viewport so returning to /#/all restores position
                try {
                    const c = map.getCenter();
                    localStorage.setItem('allModeViewport', JSON.stringify({
                        lng: c.lng,
                        lat: c.lat,
                        zoom
                    }));
                    saveViewportToUrl(c.lat, c.lng, map.getZoom());
                } catch (_) {}
                (0, _config.AVAILABLE_CITIES).forEach((cityCode)=>{
                    var _CITY_CONFIGS_cityCode_city_bounds, _CITY_CONFIGS_cityCode_city, _CITY_CONFIGS_cityCode;
                    const minZoom = (_CITY_CONFIGS_cityCode = (0, _cityConfig.CITY_CONFIGS)[cityCode]) === null || _CITY_CONFIGS_cityCode === void 0 ? void 0 : (_CITY_CONFIGS_cityCode_city = _CITY_CONFIGS_cityCode.city) === null || _CITY_CONFIGS_cityCode_city === void 0 ? void 0 : (_CITY_CONFIGS_cityCode_city_bounds = _CITY_CONFIGS_cityCode_city.bounds) === null || _CITY_CONFIGS_cityCode_city_bounds === void 0 ? void 0 : _CITY_CONFIGS_cityCode_city_bounds.minZoom;
                    // Data-derived (stops.min.json extent + 4km buffer) bounds — not yet
                    // available if this city's preindex fetch hasn't resolved
                    const b = cityStopsBounds.get(cityCode);
                    if (minZoom == null || !b) return;
                    if (viewportOverlapsBounds(vp, b) && zoom >= minZoom) loadCity(cityCode);
                    else if (!activeSelectionCities.has(cityCode)) unloadCity(cityCode);
                });
            }, 200);
            checkViewportRef.current = checkViewport;
            map.on('moveend', checkViewport);
            map.on('zoomend', checkViewport);
            // Restore initial position: URL params → localStorage → geolocation
            const urlViewport = getViewportFromUrl();
            if (urlViewport) map.jumpTo({
                center: [
                    urlViewport.lon,
                    urlViewport.lat
                ],
                zoom: urlViewport.z
            });
            else {
                const savedViewport = (()=>{
                    try {
                        return JSON.parse(localStorage.getItem('allModeViewport'));
                    } catch (_) {
                        return null;
                    }
                })();
                if ((savedViewport === null || savedViewport === void 0 ? void 0 : savedViewport.lng) != null) map.jumpTo({
                    center: [
                        savedViewport.lng,
                        savedViewport.lat
                    ],
                    zoom: savedViewport.zoom
                });
                else if (navigator.geolocation) navigator.geolocation.getCurrentPosition(({ coords })=>{
                    map.flyTo({
                        center: [
                            coords.longitude,
                            coords.latitude
                        ],
                        zoom: 11,
                        animate: true
                    });
                }, ()=>{}, // denied — stay on default India view
                {
                    timeout: 5000
                });
            }
            // Run once after the viewport is settled (not before) so it evaluates the
            // restored position rather than the pre-jump default — `checkViewport` is
            // leading-edge throttled, so calling it before jumpTo would have this call
            // win the throttle window and silently swallow jumpTo's own moveend firing.
            checkViewport();
            // Pre-index all cities for global search (lightweight — name+number only)
            // Called immediately (no debounce) so search updates as soon as a city loads or unloads.
            const refreshSearch = ()=>{
                var _searchField_current;
                const currentValue = ((_searchField_current = searchField.current) === null || _searchField_current === void 0 ? void 0 : _searchField_current.value) || '';
                if (currentValue) {
                    const q = (0, _search.stripRouteHyphens)(currentValue.toLowerCase());
                    const matched = allModeServicesIdx.filter((s)=>(0, _search.stripRouteHyphens)(s.number.toLowerCase()).includes(q) || (0, _search.stripRouteHyphens)(s.name.toLowerCase()).includes(q)).sort((a, b)=>compareCityPriority(a.city, b.city)).slice(0, (0, _searchLimits.SEARCH_RESULT_LIMIT));
                    setServices(matched);
                } else setServices(buildAllModeSearchList().slice(0, (0, _searchLimits.SEARCH_RESULT_LIMIT)));
            };
            onCityLoadedCallback = (cityCode)=>{
                refreshSearch();
                if (currentLocationRef.current) setClosestStops(computeAllModeClosestStops(...currentLocationRef.current));
                // Keep newly loaded city stops hidden while a service is being shown
                if ((0, _getRouteDefault.default)().page === 'service') {
                    if (map === null || map === void 0 ? void 0 : map.getLayer(`stops-${cityCode}`)) map.setLayoutProperty(`stops-${cityCode}`, 'visibility', 'none');
                    if (map === null || map === void 0 ? void 0 : map.getLayer(`stops-icon-${cityCode}`)) map.setLayoutProperty(`stops-icon-${cityCode}`, 'visibility', 'none');
                }
            };
            onCityUnloadedCallback = refreshSearch;
            preindexAllCities().then(()=>{
                setAllModePreindexed(true);
                (0, _workerClient.initDataWorker)({
                    stopsArr: allModeStopsIdx,
                    servicesArr: allModeServicesIdx,
                    servicesData: {},
                    poisArr: allModePoisIdx
                });
                refreshSearch();
                // Bounds for cities whose preindex fetch was still in flight during the
                // last checkViewport() call are only available now — re-evaluate so
                // that a static viewport (no further pan/zoom) still loads them
                checkViewport();
            });
        }
    // All-mode only: persist/restore viewport via URL so a shared link keeps its
    // map position across cities. City-scoped mode never writes lat/lon/z to
    // the URL — the hash route alone determines its viewport.
    // GeolocateControl automatically acquires location on page load if permission is 'granted'
    // The handleLocationUpdate callback will be triggered when location is acquired and marker is rendered
    }, [
        mapLoaded
    ]);
    // destEndpoint: {type:'stop', number, city} | {type:'location', lat, lon} —
    // completes whichever picking mode is active (editing one side of an
    // existing query, or picking a fresh destination for directionsOrigin)
    // by building a `between` URL with the new ~-joined, location-aware token
    // format (see encodeBetweenToken). Returns false if neither picking mode
    // is active, so callers can fall through to their normal click behavior.
    const finishDirectionsPick = (destEndpoint)=>{
        if (editingBetweenStop) {
            const { role, fixedStop } = editingBetweenStop;
            setEditingBetweenStop(null);
            const destToken = encodeBetweenToken(destEndpoint);
            if (fixedStop != destToken) {
                const start = role === 'origin' ? destToken : fixedStop;
                const end = role === 'origin' ? fixedStop : destToken;
                location.hash = `${route.cityPrefix}/between/${start}~${end}`;
            }
            return true;
        }
        if (!directionsOrigin) return false;
        const originToken = encodeBetweenToken(directionsOrigin);
        setDirectionsOrigin(null);
        const destToken = encodeBetweenToken(destEndpoint);
        if (originToken !== destToken) {
            const prefix = IS_ALL_MODE ? '/all' : route.cityPrefix;
            location.hash = `${prefix}/between/${originToken}~${destToken}`;
        }
        return true;
    };
    const selectDirectionsDestination = (stopNumber, destCity)=>finishDirectionsPick({
            type: 'stop',
            number: stopNumber,
            city: destCity
        });
    // Alpha "location-to-location directions" feature — completes a directions
    // pick with a location endpoint (map click or a location search result
    // clicked while origin-picking/edit-picking is active).
    const selectLocationDirectionsDestination = (lat, lon)=>finishDirectionsPick({
            type: 'location',
            lat,
            lon
        });
    // Starts picking a destination FROM a location (mirrors the stop
    // popover's "Directions" button, which sets directionsOrigin to a plain
    // stop object — encodeBetweenToken treats anything without
    // type:'location' as a stop, so that path is untouched).
    const startDirectionsFromLocation = (locInfo)=>{
        setDirectionsOrigin({
            type: 'location',
            lat: locInfo.lat,
            lon: locInfo.lon,
            name: locInfo.name
        });
        hideLocationPopover();
        setShrinkSearch(false);
    };
    (0, _hooks.useEffect)(()=>{
        if (!mapLoaded) return;
        const handleMapClick = (e)=>{
            if (e.originalEvent.altKey) {
                const layers = map.queryRenderedFeatures(e.point, {
                    validate: false
                });
            }
            const { point } = e;
            // Build layers array, only including layers that exist
            const queryLayers = [
                'stops',
                'stops-icon'
            ].filter((layerId)=>map.getLayer(layerId));
            // Only add stops-highlight if it exists
            if (map.getLayer('stops-highlight')) queryLayers.push('stops-highlight');
            // In all-mode, also query city-scoped stop layers
            if (IS_ALL_MODE) loadedCities.forEach((cityCode)=>{
                if (map.getLayer(`stops-${cityCode}`)) queryLayers.push(`stops-${cityCode}`);
                if (map.getLayer(`stops-icon-${cityCode}`)) queryLayers.push(`stops-icon-${cityCode}`);
            });
            const features = map.queryRenderedFeatures(point, {
                layers: queryLayers,
                validate: false
            });
            if (features.length) {
                const zoom = map.getZoom();
                const feature = features[0];
                const center = feature.geometry.coordinates;
                if (zoom < 12) {
                    // Slowly zoom in first
                    map.flyTo({
                        zoom: zoom + 2,
                        center
                    });
                    setShrinkSearch(true);
                } else if (selectDirectionsDestination(feature.properties.number, feature.properties.city)) ;
                else if (IS_ALL_MODE && feature.properties.city) location.hash = `#/all/stops/${feature.properties.city}^${feature.properties.number}`;
                else if (feature.source == 'stops') navigateTo(`/stops/${feature.properties.number}`, route);
                else _showStopPopover(feature.properties.number);
            } else {
                var // A bare map tap collapses search out of the way (no-ops if search
                // isn't currently the thing presented, e.g. another popover is up).
                // Blur first so the on-screen keyboard doesn't stay open over a
                // sheet that's no longer expanded to make room for it.
                _searchField_current;
                const hadDirectionsContext = directionsOrigin !== null || editingBetweenStop !== null;
                // Mid-pick, a bare map click completes the pick with that point as a
                // location endpoint, rather than cancelling — this is what makes
                // stop→location and location→location directions reachable from the
                // map, not just via search results.
                if (hadDirectionsContext && (0, _cityConfig.isAlphaEnabled)() && locationSearchEnabledRef.current) {
                    const { lng, lat } = e.lngLat;
                    selectLocationDirectionsDestination(lat, lng);
                    return;
                }
                if (directionsOrigin !== null) setDirectionsOrigin(null);
                if (editingBetweenStop !== null) setEditingBetweenStop(null);
                (_searchField_current = searchField.current) === null || _searchField_current === void 0 ? void 0 : _searchField_current.blur();
                (0, _mobilePane.movePaneToBreak)(searchPane, 'bottom');
                // A bare map tap while any popover (stop/service/between/location)
                // is open collapses it first — same "peek" break a drag-to-bottom
                // would rest at (handle+header only) — and only actually dismisses
                // it on a *second* tap once it's already resting there. On desktop
                // (no pane involved) there's no peek state to collapse to, so a tap
                // there still dismisses immediately, same as before.
                if (anyPopoverOpen) {
                    if ((0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT)) {
                        var _activePane_isPanePresented;
                        const activePaneRef = showLocationPopover ? locationPane : betweenShown ? betweenPane : showServicePopover ? servicePane : stopPane;
                        const activePane = activePaneRef.current;
                        const atBottom = (activePane === null || activePane === void 0 ? void 0 : (_activePane_isPanePresented = activePane.isPanePresented) === null || _activePane_isPanePresented === void 0 ? void 0 : _activePane_isPanePresented.call(activePane)) && activePane.currentBreak() === 'bottom';
                        if (!atBottom) {
                            (0, _mobilePane.movePaneToBreak)(activePaneRef, 'bottom');
                            return;
                        }
                    }
                    if (showLocationPopover) hideLocationPopover();
                    else if (showServicePopover || showBetweenPopover) navigateTo('/', route);
                    else {
                        const { page, subpage } = route;
                        if (page === 'stop' && subpage !== 'routes') navigateTo('/', route);
                        else hideStopPopover();
                    }
                    return;
                }
                // Alpha "locations" feature: clicking bare map (no stop hit, not mid
                // directions-picking, nothing else open) opens the location popover
                // for that point.
                if ((0, _cityConfig.isAlphaEnabled)() && locationSearchEnabledRef.current) {
                    const { lng, lat } = e.lngLat;
                    location.hash = `${route.cityPrefix}/locations/${lat.toFixed(6)},${lng.toFixed(6)}`;
                }
            }
        };
        map.on('click', handleMapClick);
        return ()=>map.off('click', handleMapClick);
    }, [
        mapLoaded,
        route.page,
        route.subpage,
        _showStopPopover,
        hideStopPopover,
        hideLocationPopover,
        directionsOrigin,
        editingBetweenStop,
        showStopPopover,
        showBetweenPopover,
        showServicePopover,
        showLocationPopover
    ]);
    const popoverIsUp = (0, _hooks.useMemo)(()=>(!!showStopPopover || !!showBetweenPopover || !!showServicePopover) && !largerScreen, [
        showStopPopover,
        showBetweenPopover,
        showServicePopover,
        largerScreen
    ]);
    // Global shortcuts
    (0, _hooks.useEffect)(()=>{
        const handler = (e)=>{
            const isFormField = e.target && e.target.tagName && /input|textarea|button|select/i.test(e.target.tagName);
            const keydown = e.key.toLowerCase();
            switch(keydown){
                case '/':
                    if (isFormField) return;
                    if (popoverIsUp) return;
                    e.preventDefault();
                    searchField.current.focus();
                    break;
                case 'escape':
                    if (expandSearch) handleSearchClose();
                    else if (showStopPopover) hideStopPopover();
                    else if (showBetweenPopover) navigateTo('/', route);
                    else if (showServicePopover) navigateTo('/', route);
                    break;
                default:
                    if (e.shiftKey && e.altKey) document.body.classList.add('alt-mode');
            }
        };
        const keyupHandler = ()=>{
            document.body.classList.remove('alt-mode');
        };
        document.addEventListener('keydown', handler);
        document.addEventListener('keyup', keyupHandler);
        return ()=>{
            document.removeEventListener('keydown', handler);
            document.removeEventListener('keyup', keyupHandler);
        };
    }, [
        expandSearch,
        showStopPopover,
        showBetweenPopover,
        showServicePopover,
        popoverIsUp
    ]);
    // Initialize vehicle tracker when map loads (or when effective city changes in all-mode)
    const trackerCity = IS_ALL_MODE ? ((_route_value = route.value) === null || _route_value === void 0 ? void 0 : _route_value.split('^')[0]) || null : route.city;
    (0, _hooks.useEffect)(()=>{
        if (!mapLoaded || !map) return;
        const cityConfig = (0, _config.getConfigForCity)(trackerCity);
        vehicleTracker.current = (0, _fetchVehicles.createVehicleTracker)({
            cityConfig,
            map,
            setRafInterval: (0, _rafInterval.setRafInterval),
            clearRafInterval: (0, _rafInterval.clearRafInterval)
        });
        // Subscribe to vehicle updates
        const unsubscribe = vehicleTracker.current.subscribe((vehicles)=>{
            setRouteVehicles(vehicles);
        });
        const unsubscribeStatus = vehicleTracker.current.subscribeLiveStatus(setRouteLiveStatus);
        // Cleanup on unmount
        return ()=>{
            var _vehicleTracker_current;
            unsubscribe();
            unsubscribeStatus();
            (_vehicleTracker_current = vehicleTracker.current) === null || _vehicleTracker_current === void 0 ? void 0 : _vehicleTracker_current.stop();
        };
    }, [
        mapLoaded,
        trackerCity
    ]);
    // Track vehicles for a selected single-service route.
    (0, _hooks.useEffect)(()=>{
        if (!vehicleTracker.current || !mapLoaded || !servicesData) return;
        const currentRoute = (0, _getRouteDefault.default)();
        // Check if we're on a service page with a single service
        if (currentRoute.page === 'service' && currentRoute.value) {
            const parts = currentRoute.value.split('~');
            // In all-mode, only track for single-city single-service views
            if (IS_ALL_MODE) {
                if (parts.length === 1 && parts[0].includes('^')) {
                    const svcNum = parts[0].slice(parts[0].indexOf('^') + 1);
                    if (servicesData[svcNum]) vehicleTracker.current.start(svcNum);
                }
            } else {
                const services = parts.map((s)=>findServiceKey(s)).filter(Boolean);
                if (services.length === 1) vehicleTracker.current.start(services[0]);
            }
        }
    }, [
        mapLoaded,
        routeServices
    ]);
    // Follow selected vehicle on the map. On the vehicle page the only
    // vehicle is the one being viewed (its position may be estimated).
    const followableVehicles = (0, _hooks.useMemo)(()=>route.page === 'vehicle' && (vehiclePanel === null || vehiclePanel === void 0 ? void 0 : vehiclePanel.info) ? [
            {
                vehicleId: vehiclePanel.info.vehicleId,
                location: vehiclePanel.info.location || vehiclePanel.estimated
            }
        ] : routeVehicles, [
        route.page,
        vehiclePanel,
        routeVehicles
    ]);
    (0, _hooks.useEffect)(()=>{
        if (!mapLoaded || !followedVehicleId || !followableVehicles.length) return;
        const vehicle = followableVehicles.find((v)=>v.vehicleId === followedVehicleId);
        if (!vehicle || !vehicle.location) return;
        const { lat, lng } = vehicle.location;
        if (typeof lat !== 'number' || typeof lng !== 'number') return;
        // Zoom to and follow the vehicle
        map.easeTo({
            center: [
                lng,
                lat
            ],
            zoom: Math.max(map.getZoom(), 16),
            duration: 800
        });
    }, [
        followedVehicleId,
        followableVehicles,
        mapLoaded
    ]);
    const showServicesFloatPill = route.page === 'service' && servicesData && routeServices.length > 1;
    // In all-mode, the float pill stop data comes from cityDataMap, not stopsData
    const pillCaret = IS_ALL_MODE && route.page === 'stop' && route.subpage === 'routes' ? (route.value || '').indexOf('^') : -1;
    const pillStopCity = pillCaret !== -1 ? route.value.slice(0, pillCaret) : null;
    const pillStopNum = pillCaret !== -1 ? route.value.slice(pillCaret + 1) : null;
    var _cityDataMap_get_stopsData_pillStopNum;
    const pillStopData = pillStopCity ? (_cityDataMap_get_stopsData_pillStopNum = (_cityDataMap_get = cityDataMap.get(pillStopCity)) === null || _cityDataMap_get === void 0 ? void 0 : (_cityDataMap_get_stopsData = _cityDataMap_get.stopsData) === null || _cityDataMap_get_stopsData === void 0 ? void 0 : _cityDataMap_get_stopsData[pillStopNum]) !== null && _cityDataMap_get_stopsData_pillStopNum !== void 0 ? _cityDataMap_get_stopsData_pillStopNum : null : null;
    const showPassingRoutesFloatPill = route.page === 'stop' && route.subpage === 'routes' && (IS_ALL_MODE ? !!pillStopData : stopsData && findStopKey(route.value));
    // `#/all/between/<query>/<result-num>` (1-based) or `${cityPrefix}/between/<query>/<result-num>` —
    // selects a single itinerary/result to show as a vertical detail card instead of the list.
    const betweenSelectedIdx = (()=>{
        if (route.page !== 'between' || !route.subpage) return null;
        const idx = parseInt(route.subpage, 10) - 1;
        return Number.isInteger(idx) && idx >= 0 ? idx : null;
    })();
    const betweenListUrl = IS_ALL_MODE ? `/all/between/${route.value}` : `${route.cityPrefix}/between/${route.value}`;
    const betweenListHref = `#${betweenListUrl}`;
    // Derived per-stop view for the multi-service popover's intersecting-stops list —
    // memoized so the O(cities) city lookup and O(services) filter+sort per stop only
    // rerun when the underlying data actually changes, not on every popover re-render.
    const intersectingStopsView = (0, _hooks.useMemo)(()=>intersectStops.map((s)=>{
            const stop = stopsData[s];
            const stopCity = IS_ALL_MODE ? [
                ...activeSelectionCities
            ].find((c)=>{
                var _cityDataMap_get_stopsData, _cityDataMap_get;
                return (_cityDataMap_get = cityDataMap.get(c)) === null || _cityDataMap_get === void 0 ? void 0 : (_cityDataMap_get_stopsData = _cityDataMap_get.stopsData) === null || _cityDataMap_get_stopsData === void 0 ? void 0 : _cityDataMap_get_stopsData[s];
            }) : null;
            const servicesLabel = routeServices.length > 2 ? stop.services.filter((svc)=>routeServices.includes(svc)).sort((0, _bus.sortServices)).join(' ') : null;
            return {
                id: s,
                stop,
                stopCity,
                servicesLabel
            };
        }), [
        intersectStops,
        stopsData,
        routeServices
    ]);
    // Extracted so the same buttons can render in both places: nested inside
    // the popover (desktop's floating card, where it's naturally sized to
    // fit) and in a separate always-on-screen floating bar for mobile — see
    // the .mobile-floating-footer siblings right after the stop/service
    // divs below. cupertino-pane keeps a popover as one continuous box sized
    // to its tallest enabled break and only reveals part of it via
    // transform; a footer in normal flow at the bottom of that box is only
    // ever visible once dragged almost to the top, not at the default
    // resting position. Only `stopPopoverData &&`-gated call sites should
    // invoke this.
    const renderStopFooter = ()=>(0, _preact.h)("div", {
            class: "popover-footer"
        }, (0, _preact.h)("div", {
            class: "popover-buttons footer-actions"
        }, (0, _preact.h)("a", {
            href: `/arrival/${stopPopoverDestFilter ? `?dest=${encodeURIComponent(stopPopoverDestFilter)}${stopPopoverDestFilterExact ? '&destExact=1' : ''}` : ''}#/${stopPopoverData.city || route.city}/${stopPopoverData.number}`,
            class: "popover-button primary footer-arrivals"
        }, (0, _preact.h)("svg", {
            viewBox: "0 0 24 24",
            width: "15",
            height: "15",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
        }, (0, _preact.h)("circle", {
            cx: "12",
            cy: "12",
            r: "10"
        }), (0, _preact.h)("polyline", {
            points: "12 6 12 12 16 14"
        })), t('glossary.busArrivals')), (0, _cityConfig.isAlphaEnabled)() && (0, _preact.h)("a", {
            href: `/beta/timetable/#/${stopPopoverData.city || route.city}/${stopPopoverData.number}`,
            class: "popover-button footer-secondary",
            target: "_blank",
            title: "Timetable"
        }, TIMETABLE_SVG), stopPopoverData.services.length > 1 && (0, _preact.h)("a", {
            href: IS_ALL_MODE && stopPopoverData.city ? `#/all/stops/${stopPopoverData.city}^${stopPopoverData.number}/routes` : `#${route.cityPrefix}/stops/${stopPopoverData.number}/routes`,
            class: "popover-button footer-secondary",
            title: t('glossary.passingRoutes')
        }, (0, _preact.h)("img", {
            src: (0, _passingRoutesBlueSvgDefault.default),
            width: "16",
            height: "16",
            alt: ""
        })), (0, _cityConfig.isAlphaEnabled)() && (0, _preact.h)("a", {
            href: `/diagram/#/${stopPopoverData.city || route.city}/${stopPopoverData.number}`,
            class: "popover-button footer-secondary",
            target: "_blank",
            title: "Diagram"
        }, (0, _preact.h)("svg", {
            viewBox: "0 0 24 24",
            width: "15",
            height: "15",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
        }, (0, _preact.h)("polygon", {
            points: "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
        }), (0, _preact.h)("line", {
            x1: "8",
            y1: "2",
            x2: "8",
            y2: "18"
        }), (0, _preact.h)("line", {
            x1: "16",
            y1: "6",
            x2: "16",
            y2: "22"
        })))));
    // Same reasoning as renderStopFooter above. Only rendered for the
    // single-service alpha view (matches the original inline condition).
    const renderServiceFooter = ()=>{
        var _route_value, _route_value1;
        return (0, _cityConfig.isAlphaEnabled)() && (0, _preact.h)("div", {
            class: "popover-footer"
        }, (0, _preact.h)("div", {
            class: "popover-buttons footer-actions"
        }, (0, _preact.h)("a", {
            href: `/beta/timetable/#/${IS_ALL_MODE ? (_route_value = route.value) === null || _route_value === void 0 ? void 0 : _route_value.split('^')[0] : route.city}/route/${encodeURIComponent(routeServices[0])}`,
            class: "popover-button footer-arrivals",
            target: "_blank",
            title: "Timetable"
        }, TIMETABLE_SVG, "Timetable"), (0, _preact.h)("a", {
            href: `/beta/visualization/?city=${IS_ALL_MODE ? (_route_value1 = route.value) === null || _route_value1 === void 0 ? void 0 : _route_value1.split('^')[0] : route.city}#services/${routeServices[0]}`,
            class: "popover-button footer-arrivals",
            target: "_blank",
            title: "3D Visualization"
        }, (0, _preact.h)("svg", {
            viewBox: "0 0 24 24",
            width: "15",
            height: "15",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
        }, (0, _preact.h)("path", {
            d: "M12 2L2 7l10 5 10-5-10-5z"
        }), (0, _preact.h)("path", {
            d: "M2 17l10 5 10-5"
        }), (0, _preact.h)("path", {
            d: "M2 12l10 5 10-5"
        })), "3D Visualize")));
    };
    return (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("div", {
        id: "search-popover",
        ref: searchPopover,
        class: `popover ${expandSearch ? 'expand' : ''} ${shrinkSearch ? 'shrink' : ''} ${routeLoading ? 'loading' : ''} ${!anyPopoverOpen && (0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT) ? 'pane-managed' : ''}`
    }, (0, _preact.h)("div", {
        id: "popover-float",
        hidden: !(showServicesFloatPill || showPassingRoutesFloatPill)
    }, (0, _preact.h)("div", {
        class: "float-pill",
        ref: floatPill
    }, (0, _preact.h)("a", {
        href: `#${route.cityPrefix}/`,
        class: "popover-close"
    }, "\xD7"), showServicesFloatPill && (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("div", {
        class: "service-flex"
    }, (0, _preact.h)("h1", null, t('multiRoute.showingServices', {
        count: routeServices.length
    }))), (0, _preact.h)("div", {
        class: "services-list"
    }, (0, _preact.h)("div", null, (()=>{
        // In all-mode, route.value contains city-qualified IDs like 'blr^12F~chennai^104P'
        // Build a map from service number → qualified segment for URL construction
        const qualifiedParts = IS_ALL_MODE ? (route.value || '').split('~').filter((p)=>p.includes('^')) : [];
        const svcToQualified = Object.fromEntries(qualifiedParts.map((p)=>[
                p.slice(p.indexOf('^') + 1),
                p
            ]));
        return routeServices.sort((0, _bus.sortServices)).map((service)=>{
            const svcHref = IS_ALL_MODE && svcToQualified[service] ? `#/all/services/${svcToQualified[service]}` : `#${route.cityPrefix}/services/${encodeURIComponent(service)}`;
            return (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("a", {
                href: svcHref,
                onClick: (e)=>clickRoute(e, service),
                onMouseEnter: (e)=>highlightRoute(e, service),
                onMouseLeave: unhighlightRoute,
                class: "service-tag",
                "data-service": service
            }, service, (0, _preact.h)("span", {
                class: "close",
                title: "Remove this service",
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    if (IS_ALL_MODE) {
                        const remaining = qualifiedParts.filter((p)=>p.slice(p.indexOf('^') + 1) !== service);
                        location.hash = remaining.length ? `/all/services/${remaining.join('~')}` : '/all/';
                    } else {
                        const newRouteServices = routeServices.filter((s)=>s !== service);
                        location.hash = `${route.cityPrefix}/services/${newRouteServices.map((s)=>encodeURIComponent(s)).join('~')}`;
                    }
                    unhighlightRoute();
                }
            }, "\xD7")));
        });
    })(), (0, _preact.h)("button", {
        type: "button",
        class: "plus",
        onClick: ()=>{
            setExpandSearch(true);
            expandedSearchOnce.current = true;
        },
        title: t('multiRoute.addRoute')
    })), !!intersectStops.length && (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("h2", null, t('multiRoute.intersectingStops', {
        count: intersectStops.length
    })), (0, _preact.h)("ul", {
        class: "simple-stops-list"
    }, intersectingStopsView.map(({ id, stop, stopCity, servicesLabel })=>(0, _preact.h)("li", {
            key: stop.number
        }, (0, _preact.h)("a", {
            href: IS_ALL_MODE && stopCity ? `#/all/stops/${stopCity}^${stop.number}` : `#${route.cityPrefix}/stops/${stop.number}`,
            onClick: (e)=>{
                e.preventDefault();
                zoomToStop(id);
            }
        }, (0, _preact.h)("b", {
            class: "stop-tag"
        }, stop.number), ' ', (0, _preact.h)("span", {
            class: "stop-name"
        }, stop.name), ' ', servicesLabel && (0, _preact.h)("span", {
            class: "services-meta-list"
        }, servicesLabel)))))))), showPassingRoutesFloatPill && (()=>{
        const activeStop = IS_ALL_MODE ? pillStopData : stopsData[findStopKey(route.value)];
        const activeStopKey = IS_ALL_MODE ? pillStopNum : route.value;
        const pillCity = IS_ALL_MODE ? pillStopCity : null;
        const cityConfig = (0, _config.getConfigForCity)(IS_ALL_MODE ? pillStopCity : route.city);
        const disableStopID = (cityConfig === null || cityConfig === void 0 ? void 0 : cityConfig.disableStopID) || false;
        const makeMultiRouteHref = (services)=>{
            const sorted = [
                ...services
            ].sort((0, _bus.sortServices));
            return IS_ALL_MODE && pillCity ? `#/all/services/${sorted.map((s)=>`${pillCity}^${encodeURIComponent(s)}`).join('~')}` : `#${route.cityPrefix}/services/${sorted.map((s)=>encodeURIComponent(s)).join('~')}`;
        };
        const makeServiceHref = (service)=>IS_ALL_MODE && pillCity ? `#/all/services/${pillCity}^${encodeURIComponent(service)}` : `#${route.cityPrefix}/services/${encodeURIComponent(service)}`;
        return (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("div", {
            class: "service-flex"
        }, disableStopID ? (0, _preact.h)("div", null, (0, _preact.h)("h1", null, (0, _preact.h)("span", {
            class: "stop-name-with-suffix"
        }, (0, _preact.h)("span", {
            class: "stop-name"
        }, activeStop.name), activeStop.suffix && (0, _preact.h)("span", {
            class: "stop-suffix"
        }, activeStop.suffix)))) : (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("span", {
            class: "stop-tag"
        }, activeStopKey), (0, _preact.h)("div", null, (0, _preact.h)("h1", null, activeStop.name)))), (0, _preact.h)("div", {
            class: "services-list",
            onClick: unhighlightRoute
        }, (0, _preact.h)("h2", null, t('passingRoutes.passingRoutes', {
            count: activeStop.services.length
        }), ' ', "\xB7", ' ', (0, _preact.h)("a", {
            href: makeMultiRouteHref(activeStop.services)
        }, t('glossary.multiRouteMode'), " \u2295")), [
            ...activeStop.services
        ].sort((0, _bus.sortServices)).map((service)=>(0, _preact.h)("a", {
                href: makeServiceHref(service),
                onClick: IS_ALL_MODE ? undefined : (e)=>clickRoute(e, service),
                onMouseEnter: IS_ALL_MODE ? undefined : (e)=>highlightRoute(e, service),
                onMouseLeave: IS_ALL_MODE ? undefined : unhighlightRoute,
                class: "service-tag",
                "data-service": service
            }, service))));
    })())), (0, _preact.h)("div", {
        class: "popover-inner"
    }, (0, _preact.h)("div", {
        class: "popover-search"
    }, (0, _preact.h)("div", {
        class: "search-input-wrapper"
    }, (0, _preact.h)("input", {
        type: "search",
        placeholder: t('search.placeholder'),
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        spellcheck: "false",
        ref: searchField,
        onfocus: handleSearchFocus,
        oninput: handleSearch,
        onkeydown: handleKeys,
        disabled: !IS_ALL_MODE && !searching && !services.length
    }), (0, _preact.h)("button", {
        type: "button",
        class: "cancel-btn",
        onclick: handleSearchClose,
        title: t('common.cancel'),
        dangerouslySetInnerHTML: {
            __html: (0, _closeControl.CLOSE_SVG)
        }
    })), (0, _preact.h)("button", {
        type: "button",
        class: "geolocate-btn",
        title: t('search.geolocate'),
        ref: geolocateBtn,
        onClick: ()=>{
            var _geolocateControlRef_current;
            return (_geolocateControlRef_current = geolocateControlRef.current) === null || _geolocateControlRef_current === void 0 ? void 0 : _geolocateControlRef_current.trigger();
        },
        dangerouslySetInnerHTML: {
            __html: (0, _geolocateControl.GEOLOCATE_SVG)
        }
    })), (0, _cityConfig.isAlphaEnabled)() && (0, _preact.h)("div", {
        class: "location-search-row"
    }, (0, _preact.h)("span", {
        class: "location-search-row-label"
    }, "Search locations"), (0, _preact.h)("div", {
        class: `dev-toggle-track${locationSearchEnabled ? ' active' : ''}`,
        role: "switch",
        "aria-checked": locationSearchEnabled,
        "aria-label": "Search locations",
        tabIndex: 0,
        onClick: ()=>{
            var _searchField_current;
            const next = !locationSearchEnabled;
            localStorage.setItem('locationSearch', String(next));
            setLocationSearchEnabled(next);
            if (!next) {
                setLocations([]);
                setLiveLocations([]);
            } else if ((_searchField_current = searchField.current) === null || _searchField_current === void 0 ? void 0 : _searchField_current.value) {
                performSearch(searchField.current.value);
                performGeocode(searchField.current.value);
            }
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.currentTarget.click();
            }
        }
    }, (0, _preact.h)("span", {
        class: "dev-toggle-thumb"
    }))), (!anyPopoverOpen || expandSearch || !(0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT)) && (0, _preact.h)("ul", {
        class: `popover-list ${IS_ALL_MODE ? allModePreindexed ? '' : 'loading' : services.length || searching || closestStops.length && !searching ? '' : 'loading'} ${searching ? 'searching' : ''}`,
        ref: servicesList,
        onScroll: handleServicesScroll,
        "overflow-y": "true"
    }, !searching && closestStops.length > 0 && (IS_ALL_MODE ? groupByCity(closestStops) : [
        {
            city: null,
            items: closestStops
        }
    ]).map((group)=>{
        var _group_city;
        return (0, _preact.h)((0, _preact.Fragment), {
            key: (_group_city = group.city) !== null && _group_city !== void 0 ? _group_city : 'closest'
        }, group.city && (0, _preact.h)("li", {
            class: "popover-city-header"
        }, (0, _preact.h)("strong", null, cityDisplayName(group.city))), group.items.map((s)=>(0, _preact.h)("li", {
                key: IS_ALL_MODE ? `${s.city}^${s.number}` : s.number
            }, (0, _preact.h)("a", {
                href: IS_ALL_MODE && s.city ? `#/all/stops/${s.city}^${s.number}` : `#${route.cityPrefix}/stops/${s.number}`
            }, (0, _preact.h)("b", {
                class: "stop-tag"
            }, s.number), (0, _preact.h)("span", {
                class: "stop-name-with-suffix"
            }, (0, _preact.h)("span", {
                class: "stop-name"
            }, s.name), s.suffix && (0, _preact.h)("span", {
                class: "stop-suffix"
            }, s.suffix))))));
    }), searching && (locations.length > 0 || liveLocations.length > 0) && (0, _preact.h)((0, _preact.Fragment), null, locations.map((loc)=>(0, _preact.h)("li", {
            key: `poi-${loc.id}`
        }, (0, _preact.h)("a", {
            href: `#${route.cityPrefix}/locations/${loc.lat},${loc.lon}`,
            onClick: (e)=>{
                locationNameCache.set(locationKey(loc.lat, loc.lon), {
                    name: loc.name,
                    type: loc.type,
                    color: loc.color
                });
                if (directionsOrigin || editingBetweenStop) {
                    e.preventDefault();
                    selectLocationDirectionsDestination(loc.lat, loc.lon);
                }
            }
        }, (0, _preact.h)("b", {
            class: "location-tag"
        }, "\u25CF"), (0, _preact.h)("span", {
            class: "location-name"
        }, loc.name)))), liveLocations.map((loc)=>(0, _preact.h)("li", {
            key: `live-${loc.placeId}`
        }, (0, _preact.h)("a", {
            href: `#${route.cityPrefix}/locations/${loc.lat},${loc.lon}`,
            onClick: (e)=>{
                locationNameCache.set(locationKey(loc.lat, loc.lon), {
                    name: loc.name
                });
                if (directionsOrigin || editingBetweenStop) {
                    e.preventDefault();
                    selectLocationDirectionsDestination(loc.lat, loc.lon);
                }
            }
        }, (0, _preact.h)("b", {
            class: "location-tag"
        }, "\u25CF"), (0, _preact.h)("span", {
            class: "location-name"
        }, loc.name))))), services.length ? capGroups(IS_ALL_MODE ? groupByCity(services) : [
        {
            city: null,
            items: services
        }
    ], expandSearch ? (0, _searchLimits.SEARCH_RESULT_LIMIT) : (0, _searchLimits.COLLAPSED_SEARCH_LIMIT)).map((group)=>{
        var _group_city;
        return (0, _preact.h)((0, _preact.Fragment), {
            key: (_group_city = group.city) !== null && _group_city !== void 0 ? _group_city : 'services'
        }, group.city && (0, _preact.h)("li", {
            class: "popover-city-header"
        }, (0, _preact.h)("strong", null, cityDisplayName(group.city))), group.items.map((s)=>{
            const isServicePage = route.page === 'service';
            // In all-mode route.value uses 'city^num' segments; plain num otherwise
            const qualifiedId = IS_ALL_MODE && s.city ? `${s.city}^${s.number}` : s.number;
            const checked = route.value && route.value.split('~').includes(IS_ALL_MODE ? qualifiedId : s.number);
            return (0, _preact.h)("li", {
                key: qualifiedId
            }, (0, _preact.h)("a", {
                href: IS_ALL_MODE && s.city ? `#/all/services/${s.city}^${encodeURIComponent(s.number)}` : `#${route.cityPrefix}/services/${encodeURIComponent(s.number)}`,
                class: checked ? 'current' : '',
                onMouseEnter: ()=>previewRoute(s.number),
                onMouseLeave: unpreviewRoute
            }, (0, _preact.h)("b", {
                class: "service-tag"
            }, s.number), " ", s.name), (0, _preact.h)("label", {
                hidden: !isServicePage
            }, (0, _preact.h)("input", {
                type: "checkbox",
                checked: checked,
                onChange: (e)=>{
                    const { checked } = e.target;
                    let newServices = [];
                    if (checked) newServices = route.value.split('~').concat(qualifiedId);
                    else newServices = route.value.split('~').filter((service)=>service !== qualifiedId);
                    newServices.sort((0, _bus.sortServices));
                    setTimeout(()=>{
                        if (newServices.length) navigateTo(`/services/${newServices.map((s)=>encodeURIComponent(s)).join('~')}`, route);
                        else if (IS_ALL_MODE) location.hash = '/all/';
                        else navigateTo('/', route);
                    }, 250);
                }
            })));
        }));
    }) : !searching && (!IS_ALL_MODE || !allModePreindexed) && !closestStops.length && [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ].map((s, i)=>(0, _preact.h)("li", {
            key: s
        }, (0, _preact.h)("a", {
            href: `#${route.cityPrefix}/`
        }, (0, _preact.h)("b", {
            class: "service-tag"
        }, "\xA0\xA0\xA0"), (0, _preact.h)("span", {
            class: "placeholder"
        }, "\u2588\u2588\u2588\u2588\u2588", i % 3 == 0 ? "\u2588\u2588\u2588" : '', " \u2588\u2588\u2588", i % 2 == 0 ? "\u2588\u2588\u2588\u2588" : '')))), capGroups(groupByCity((0, _vehicleLookup.filterVehicles)(vehicleSearchPool, vehicleQuery, (0, _searchLimits.SEARCH_RESULT_LIMIT))), expandSearch ? (0, _searchLimits.SEARCH_RESULT_LIMIT) : (0, _searchLimits.COLLAPSED_SEARCH_LIMIT)).map((group)=>(0, _preact.h)((0, _preact.Fragment), {
            key: `vehicles-${group.city}`
        }, IS_ALL_MODE && (0, _preact.h)("li", {
            class: "popover-city-header"
        }, (0, _preact.h)("strong", null, cityDisplayName(group.city))), group.items.map((v)=>{
            const id = IS_ALL_MODE ? `${v.city}^${encodeURIComponent(v.vehicleId)}` : encodeURIComponent(v.vehicleId);
            return (0, _preact.h)("li", {
                key: `vehicle-${v.city}-${v.vehicleId}`
            }, (0, _preact.h)("a", {
                href: `#${route.cityPrefix}/vehicle/${id}`
            }, (0, _preact.h)((0, _vehicleChipDefault.default), {
                number: v.vehicleNumber,
                size: "md"
            })));
        }))), searching && !!stops.length && (IS_ALL_MODE ? groupByCity(stops) : [
        {
            city: null,
            items: stops
        }
    ]).map((group)=>{
        var _group_city;
        return (0, _preact.h)((0, _preact.Fragment), {
            key: (_group_city = group.city) !== null && _group_city !== void 0 ? _group_city : 'stops'
        }, group.city && (0, _preact.h)("li", {
            class: "popover-city-header"
        }, (0, _preact.h)("strong", null, cityDisplayName(group.city))), group.items.map((s)=>(0, _preact.h)("li", {
                key: IS_ALL_MODE && s.city ? `${s.city}^${s.number}` : s.number
            }, (0, _preact.h)("a", {
                href: IS_ALL_MODE && s.city ? `#/all/stops/${s.city}^${s.number}` : `#${route.cityPrefix}/stops/${s.number}`,
                onClick: (e)=>{
                    if (directionsOrigin || editingBetweenStop) {
                        e.preventDefault();
                        selectDirectionsDestination(s.number, s.city);
                    }
                }
            }, (0, _preact.h)("b", {
                class: "stop-tag"
            }, s.number), (0, _preact.h)("span", {
                class: "stop-name-with-suffix"
            }, (0, _preact.h)("span", {
                class: "stop-name"
            }, s.name), s.suffix && (0, _preact.h)("span", {
                class: "stop-suffix"
            }, s.suffix))))));
    }), searching && !stops.length && !services.length && !(0, _vehicleLookup.filterVehicles)(vehicleSearchPool, vehicleQuery, 1).length && (0, _preact.h)("li", {
        class: "nada"
    }, "No results.")))), (0, _preact.h)("div", {
        id: "stop-popover",
        ref: stopPopover,
        class: `popover ${showStopPopover ? 'expand' : ''} ${showStopPopover && (0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT) ? 'pane-managed' : ''}`
    }, (0, _preact.h)("div", {
        class: "popover-handle"
    }, (0, _preact.h)("span", null)), stopPopoverData && (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("a", {
        href: `#${route.cityPrefix}/`,
        onClick: hideStopPopover,
        class: "popover-close"
    }, "\xD7"), (0, _preact.h)("header", null, (0, _preact.h)("div", {
        class: "stop-header-row"
    }, (0, _preact.h)("h1", {
        onClick: ()=>zoomToStop(stopPopoverData.number)
    }, !((_getConfigForCity = (0, _config.getConfigForCity)(stopPopoverData.city || city)) === null || _getConfigForCity === void 0 ? void 0 : _getConfigForCity.disableStopID) && (0, _preact.h)("b", {
        class: "stop-tag"
    }, stopPopoverData.number), (0, _preact.h)("span", {
        class: "stop-name-with-suffix"
    }, (0, _preact.h)("span", {
        class: "stop-name"
    }, stopPopoverData.name), stopPopoverData.suffix && (0, _preact.h)("span", {
        class: "stop-suffix"
    }, stopPopoverData.suffix))), (0, _preact.h)((0, _liveDataIndicatorJsxDefault.default), {
        loading: stopPopoverLoading,
        error: stopPopoverError,
        source: stopPopoverSource
    }), (0, _cityConfig.isAlphaEnabled)() && (0, _preact.h)("button", {
        class: "directions-btn",
        title: "Directions",
        onClick: (e)=>{
            e.stopPropagation();
            setDirectionsOrigin(stopPopoverData);
            hideStopPopover();
            setShrinkSearch(false);
        }
    }, DIRECTIONS_SVG))), stopPopoverData.services.length > 0 && (0, _preact.h)("div", {
        class: "dest-filter-wrapper"
    }, (0, _preact.h)("div", {
        class: "dest-filter-row"
    }, (0, _preact.h)("svg", {
        class: "dest-filter-icon",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        width: "16",
        height: "16",
        "aria-hidden": "true"
    }, (0, _preact.h)("path", {
        "fill-rule": "evenodd",
        d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
        "clip-rule": "evenodd"
    })), (0, _preact.h)("div", {
        class: "dest-filter-input-wrapper"
    }, (0, _preact.h)("input", {
        type: "search",
        class: "dest-filter",
        placeholder: "Search for stop\u2026",
        value: stopPopoverDestFilter,
        onInput: (e)=>{
            setStopPopoverDestFilter(e.target.value);
            setStopPopoverDestFilterExact(false);
        }
    }), stopPopoverDestFilter && (0, _preact.h)("button", {
        class: "dest-filter-clear",
        onClick: ()=>{
            setStopPopoverDestFilter('');
            setStopPopoverDestFilterExact(false);
        },
        "aria-label": "Clear search"
    }, (0, _preact.h)("svg", {
        viewBox: "0 0 20 20",
        fill: "currentColor",
        width: "16",
        height: "16"
    }, (0, _preact.h)("path", {
        "fill-rule": "evenodd",
        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
        "clip-rule": "evenodd"
    })))))), (0, _preact.h)((0, _scrollableContainerDefault.default), {
        class: "popover-scroll",
        "overflow-y": "true"
    }, (0, _preact.h)((0, _busServicesArrivalDefault.default), {
        active: showStopPopover,
        map: map,
        showBusesOnMap: route.page !== 'service',
        id: stopPopoverData.number,
        services: stopPopoverData.services,
        stopData: stopPopoverData,
        cityCode: stopPopoverData.city || undefined,
        stopsData: IS_ALL_MODE && stopPopoverData.city ? (_cityDataMap_get1 = cityDataMap.get(stopPopoverData.city)) === null || _cityDataMap_get1 === void 0 ? void 0 : _cityDataMap_get1.stopsData : undefined,
        onLoadingChange: handleStopLoadingChange,
        onErrorChange: setStopPopoverError,
        onSourceChange: setStopPopoverSource,
        cancelRef: stopPopoverCancelRef,
        destFilter: stopPopoverDestFilter,
        destFilterExact: stopPopoverDestFilterExact,
        onDestFilterChange: handleStopDestFilterChange
    })), renderStopFooter())), stopPopoverData && (0, _preact.h)("div", {
        class: `mobile-floating-footer ${showStopPopover && !stopPaneAtBottom ? 'show' : ''}`
    }, renderStopFooter()), (0, _cityConfig.isAlphaEnabled)() && (0, _preact.h)("div", {
        ref: locationPopover,
        id: "location-popover",
        class: `popover ${showLocationPopover ? 'expand' : ''} ${showLocationPopover && (0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT) ? 'pane-managed' : ''}`
    }, (0, _preact.h)("div", {
        class: "popover-handle"
    }, (0, _preact.h)("span", null)), (0, _preact.h)("a", {
        href: `#${route.cityPrefix}/`,
        onClick: hideLocationPopover,
        class: "popover-close"
    }, "\xD7"), locationPopoverData && (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("header", null, (0, _preact.h)("h1", null, (0, _preact.h)("b", {
        class: "location-tag"
    }, "\u25CF"), locationPopoverData.name || "Locating\u2026", (0, _cityConfig.isAlphaEnabled)() && (0, _preact.h)("button", {
        class: "directions-btn",
        title: "Directions",
        onClick: (e)=>{
            e.stopPropagation();
            startDirectionsFromLocation(locationPopoverData);
        }
    }, DIRECTIONS_SVG))), (0, _preact.h)("div", {
        class: "popover-scroll",
        "overflow-y": "true"
    }, locationPopoverLoading && (0, _preact.h)("p", {
        class: "placeholder"
    }, "Finding nearby stops\u2026"), !locationPopoverLoading && !locationPopoverStops.length && (0, _preact.h)("p", {
        class: "nada"
    }, "No nearby stops found."), locationPopoverStops.map((stop)=>(0, _preact.h)("div", {
            class: "location-nearby-stop",
            key: IS_ALL_MODE ? `${stop.city}^${stop.number}` : stop.number
        }, (0, _preact.h)("h3", {
            onClick: ()=>{
                hideLocationPopover();
                if (IS_ALL_MODE && stop.city) location.hash = `#/all/stops/${stop.city}^${stop.number}`;
                else _showStopPopover(stop.number);
            }
        }, (0, _preact.h)("b", {
            class: "stop-tag"
        }, stop.number), " ", stop.name), (0, _preact.h)("div", {
            class: "location-service-list"
        }, (stop.services || []).map((svc)=>(0, _preact.h)("a", {
                key: svc,
                href: IS_ALL_MODE && stop.city ? `#/all/services/${stop.city}^${encodeURIComponent(svc)}` : `#${route.cityPrefix}/services/${encodeURIComponent(svc)}`,
                class: "service-tag"
            }, svc)))))))), (0, _preact.h)("div", {
        ref: servicePopover,
        id: "service-popover",
        class: `popover ${showServicePopover ? 'expand' : ''} ${showServicePopover && !showStopPopover && (0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT) ? 'pane-managed' : ''} ${(0, _cityConfig.isAlphaEnabled)() && routeServices.length > 0 ? 'has-floating-footer' : ''}`,
        key: ``
    }, (0, _preact.h)("div", {
        class: "popover-handle"
    }, (0, _preact.h)("span", null)), (0, _preact.h)("a", {
        href: `#${route.cityPrefix}/`,
        onClick: navBackToStop,
        class: "popover-close"
    }, "\xD7"), showServicePopover && vehiclePanel && !routeServices.length && (0, _preact.h)((0, _vehiclePanelDefault.default), {
        panel: vehiclePanel,
        withHeader: true
    }), (showServicePopover || showStopPopover && (0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT)) && routeServices.length > 0 && (IS_ALL_MODE ? (_cityDataMap_get2 = cityDataMap.get((_route_value1 = route.value) === null || _route_value1 === void 0 ? void 0 : _route_value1.split('^')[0])) === null || _cityDataMap_get2 === void 0 ? void 0 : (_cityDataMap_get_servicesData = _cityDataMap_get2.servicesData) === null || _cityDataMap_get_servicesData === void 0 ? void 0 : _cityDataMap_get_servicesData[routeServices[0]] : servicesData[routeServices[0]]) && (()=>{
        var _cityDataMap_get_servicesData, _cityDataMap_get, _route_value, _cityDataMap_get1, _route_value1, _cityDataMap_get2, _route_value2, _route_value3;
        // Service numbers aren't unique across cities — in all-mode, look
        // this up in the current city's own servicesData (like stopsData
        // below already does) rather than the module-level `servicesData`,
        // which merges every city touched this session and can silently
        // collide when two cities reuse the same service number.
        const serviceData = IS_ALL_MODE ? (_cityDataMap_get = cityDataMap.get((_route_value = route.value) === null || _route_value === void 0 ? void 0 : _route_value.split('^')[0])) === null || _cityDataMap_get === void 0 ? void 0 : (_cityDataMap_get_servicesData = _cityDataMap_get.servicesData) === null || _cityDataMap_get_servicesData === void 0 ? void 0 : _cityDataMap_get_servicesData[routeServices[0]] : servicesData[routeServices[0]];
        const routes = getServiceRoutes(serviceData);
        // Vehicle page: the vehicle leads the header (route second), and
        // its stop times / position ride on the route's own stop list.
        const onVehiclePage = route.page === 'vehicle' && !!vehiclePanel;
        var _cityDataMap_get_stopsData;
        const vehicleStopsData = IS_ALL_MODE ? (_cityDataMap_get_stopsData = (_cityDataMap_get1 = cityDataMap.get((_route_value1 = route.value) === null || _route_value1 === void 0 ? void 0 : _route_value1.split('^')[0])) === null || _cityDataMap_get1 === void 0 ? void 0 : _cityDataMap_get1.stopsData) !== null && _cityDataMap_get_stopsData !== void 0 ? _cityDataMap_get_stopsData : stopsData : stopsData;
        const vehicleView = onVehiclePage ? (0, _vehiclePanel.buildRouteVehicleView)(t, vehiclePanel.info, (id)=>!!vehicleStopsData[id]) : null;
        var _cityDataMap_get_stopsData1;
        return (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("header", null, onVehiclePage && vehiclePanel.info ? (0, _preact.h)("div", {
            class: "service-header-row"
        }, (0, _preact.h)("h1", {
            class: "vehicle-header"
        }, (0, _preact.h)((0, _vehicleChipDefault.default), {
            number: vehiclePanel.info.vehicleNumber,
            size: "lg"
        }), (0, _preact.h)("b", {
            class: "service-tag"
        }, routeServices[0])), (0, _preact.h)((0, _liveDataIndicatorJsxDefault.default), {
            source: vehiclePanel.info.source
        })) : (0, _preact.h)("div", {
            class: "service-header-row"
        }, (0, _preact.h)("h1", null, (0, _preact.h)("b", {
            class: "service-tag"
        }, routeServices[0]), serviceData.name), (0, _cityConfig.isDevMode)() && (0, _preact.h)((0, _liveDataIndicatorJsxDefault.default), {
            loading: routeLiveStatus.loading,
            error: routeLiveStatus.error,
            source: routeLiveStatus.source,
            errorTitle: "Live vehicle positions unavailable for this route."
        }))), (0, _preact.h)((0, _scrollableContainerDefault.default), {
            class: "popover-scroll",
            "overflow-y": "true",
            scrollToTopKey: `sttk-${routeServices[0]}`
        }, onVehiclePage && (0, _preact.h)((0, _vehiclePanelDefault.default), {
            panel: vehiclePanel
        }), (0, _preact.h)("h2", null, t('glossary.nRoutes', {
            count: routes.length
        }), ' ', "\u2219", ' ', routes.map((route)=>t('glossary.nStops', {
                count: route.length
            })).join(" \u2219 "), "\xA0\xA0", (0, _preact.h)("button", {
            type: "button",
            class: "plus",
            onClick: ()=>{
                setExpandSearch(true);
                expandedSearchOnce.current = true;
            },
            title: t('multiRoute.addRoute')
        })), (0, _preact.h)((0, _stopsListJsxDefault.default), {
            routes: routes,
            stopsData: IS_ALL_MODE ? (_cityDataMap_get_stopsData1 = (_cityDataMap_get2 = cityDataMap.get((_route_value2 = route.value) === null || _route_value2 === void 0 ? void 0 : _route_value2.split('^')[0])) === null || _cityDataMap_get2 === void 0 ? void 0 : _cityDataMap_get2.stopsData) !== null && _cityDataMap_get_stopsData1 !== void 0 ? _cityDataMap_get_stopsData1 : stopsData : stopsData,
            cityCode: IS_ALL_MODE ? (_route_value3 = route.value) === null || _route_value3 === void 0 ? void 0 : _route_value3.split('^')[0] : undefined,
            vehicles: vehicleView ? vehicleView.vehicles : routeVehicles,
            stopTimeLabels: vehicleView === null || vehicleView === void 0 ? void 0 : vehicleView.stopTimeLabels,
            onVehicleClick: setFollowedVehicleId
        })), renderServiceFooter());
    })()), (0, _cityConfig.isAlphaEnabled)() && routeServices.length > 0 && (0, _preact.h)("div", {
        class: `mobile-floating-footer ${showServicePopover && !showStopPopover && !servicePaneAtBottom ? 'show' : ''}`
    }, renderServiceFooter()), (0, _preact.h)("div", {
        id: "between-popover",
        ref: betweenPopover,
        class: `popover ${(IS_ALL_MODE ? allModeBetween : showBetweenPopover) ? 'expand' : ''} ${betweenShown && (0, _mobilePane.paneAppliesHere)(supportsTouch, BREAKPOINT) ? 'pane-managed' : ''}`
    }, (0, _preact.h)("div", {
        class: "popover-handle"
    }, (0, _preact.h)("span", null)), (()=>{
        // Both modes lag one render behind their "live" open state (see
        // betweenPopoverData/allModeBetweenData's own effects) so content
        // doesn't vanish mid-close-transition \u2014 same shape either way:
        // {startStop, endStop, startLocation, endLocation, ...mode-specific}.
        const data = IS_ALL_MODE ? allModeBetweenData : betweenPopoverData;
        if (!data) return null;
        const { startStop, endStop, startLocation, endLocation } = data;
        // route.cityPrefix is already `/all` whenever IS_ALL_MODE is true
        // (the city segment of the URL literally is "all"), so most
        // hash-building below doesn't need to branch on mode at all.
        const tokenFor = (stop, loc)=>{
            if (loc) return encodeBetweenToken({
                type: 'location',
                lat: loc.lat,
                lon: loc.lon
            });
            return IS_ALL_MODE ? `${stop.city}^${stop.number}` : stop.number;
        };
        const editStop = (role)=>{
            const fixedIsOrigin = role !== 'origin';
            const fixedStop = fixedIsOrigin ? startStop : endStop;
            const fixedLocation = fixedIsOrigin ? startLocation : endLocation;
            setEditingBetweenStop({
                role,
                fixedStop: tokenFor(fixedStop, fixedLocation),
                label: (fixedLocation === null || fixedLocation === void 0 ? void 0 : fixedLocation.name) || fixedStop.name || fixedStop.number
            });
            setShrinkSearch(false);
            navigateTo('/', route);
        };
        const startLabel = (startLocation === null || startLocation === void 0 ? void 0 : startLocation.name) || (startStop === null || startStop === void 0 ? void 0 : startStop.name) || 'Selected Location';
        const endLabel = (endLocation === null || endLocation === void 0 ? void 0 : endLocation.name) || (endStop === null || endStop === void 0 ? void 0 : endStop.name) || 'Selected Location';
        const canSwap = !IS_ALL_MODE || !data.loading && startStop && endStop;
        return [
            (0, _preact.h)("a", {
                href: betweenSelectedIdx != null ? betweenListHref : `#${route.cityPrefix}/`,
                onClick: ()=>{
                    if (betweenSelectedIdx != null) return;
                    if (IS_ALL_MODE) setAllModeBetween(null);
                    else resetStartEndStops();
                },
                class: "popover-close"
            }, "\xD7"),
            (0, _preact.h)("header", null, (0, _preact.h)("div", {
                class: "between-header-row"
            }, (0, _preact.h)("div", {
                class: "between-header-stops"
            }, (0, _preact.h)("button", {
                class: "between-stop-edit",
                title: "Change origin",
                onClick: ()=>editStop('origin')
            }, startLabel), (0, _preact.h)("span", {
                class: "between-stop-arrow"
            }, '\u2192'), (0, _preact.h)("button", {
                class: "between-stop-edit",
                title: "Change destination",
                onClick: ()=>editStop('destination')
            }, endLabel)), canSwap && (0, _preact.h)("button", {
                class: "between-swap-btn",
                title: "Swap origin and destination",
                onClick: ()=>{
                    location.hash = `${route.cityPrefix}/between/${tokenFor(endStop, endLocation)}~${tokenFor(startStop, startLocation)}`;
                }
            }, (0, _preact.h)("svg", {
                viewBox: "0 0 24 24",
                width: "16",
                height: "16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true"
            }, (0, _preact.h)("polyline", {
                points: "17 1 21 5 17 9"
            }), (0, _preact.h)("path", {
                d: "M3 11V9a4 4 0 0 1 4-4h14"
            }), (0, _preact.h)("polyline", {
                points: "7 23 3 19 7 15"
            }), (0, _preact.h)("path", {
                d: "M21 13v2a4 4 0 0 1-4 4H3"
            }))))),
            (0, _preact.h)("div", {
                class: "popover-scroll",
                "overflow-y": "true"
            }, IS_ALL_MODE && data.loading && (0, _preact.h)("div", {
                class: "between-block between-nada"
            }, "Finding routes\u2026"), IS_ALL_MODE && !data.loading && data.error && (0, _preact.h)("div", {
                class: "between-block between-nada"
            }, data.error), (!IS_ALL_MODE || !data.loading && !data.error) && (0, _preact.h)((0, _betweenRoutesDefault.default), {
                results: IS_ALL_MODE ? undefined : data.results || [],
                itineraries: IS_ALL_MODE ? data.itineraries : undefined,
                stopsData: IS_ALL_MODE ? undefined : stopsData,
                cityDataMap: IS_ALL_MODE ? cityDataMap : undefined,
                arrivalData: data.arrivalData,
                staticFrequency: data.staticFrequency,
                startStop: startStop,
                endStop: endStop,
                startLocation: startLocation,
                endLocation: endLocation,
                selectedIndex: betweenSelectedIdx,
                getServiceHref: IS_ALL_MODE ? (service, city)=>`#/all/services/${city}^${encodeURIComponent(service)}` : (service)=>`#${route.cityPrefix}/services/${encodeURIComponent(service)}`,
                onClickRoute: (e, itinerary, i)=>{
                    renderBetweenItinerary(itinerary, IS_ALL_MODE ? {
                        e,
                        resolveStop: allModeResolveStop,
                        getServicePolylines: allModeGetServicePolylines
                    } : {
                        e,
                        resolveStop: legacyResolveStop,
                        getServicePolylines: legacyGetServicePolylines,
                        literalStartStop: startStop,
                        literalEndStop: endStop
                    });
                    location.hash = `${betweenListUrl}/${i + 1}`;
                }
            }))
        ];
    })()), (directionsOrigin || editingBetweenStop) && (()=>{
        const isEditingOrigin = (editingBetweenStop === null || editingBetweenStop === void 0 ? void 0 : editingBetweenStop.role) === 'origin';
        const label = (editingBetweenStop === null || editingBetweenStop === void 0 ? void 0 : editingBetweenStop.label) || (directionsOrigin === null || directionsOrigin === void 0 ? void 0 : directionsOrigin.name) || (directionsOrigin === null || directionsOrigin === void 0 ? void 0 : directionsOrigin.number) || 'Selected Location';
        return (0, _preact.h)("div", {
            class: "directions-banner"
        }, (0, _preact.h)("div", {
            class: "directions-banner-inner"
        }, DIRECTIONS_SVG, (0, _preact.h)("span", null, isEditingOrigin ? (0, _preact.h)((0, _preact.Fragment), null, 'Select origin \u2192 ', (0, _preact.h)("b", null, label)) : (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("b", null, label), ' \u2192 Select destination')), currentLocation && (0, _preact.h)("button", {
            class: "directions-banner-mylocation",
            title: "Use my location",
            onClick: ()=>{
                const [lng, lat] = currentLocation;
                finishDirectionsPick({
                    type: 'location',
                    lat,
                    lon: lng
                });
            },
            dangerouslySetInnerHTML: {
                __html: (0, _geolocateControl.GEOLOCATE_SVG)
            }
        }), (0, _preact.h)("button", {
            class: "directions-banner-close",
            onClick: ()=>{
                setDirectionsOrigin(null);
                setEditingBetweenStop(null);
            },
            "aria-label": "Cancel"
        }, (0, _preact.h)("svg", {
            viewBox: "0 0 20 20",
            fill: "currentColor",
            width: "14",
            height: "14"
        }, (0, _preact.h)("path", {
            "fill-rule": "evenodd",
            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
            "clip-rule": "evenodd"
        })))));
    })());
};
(0, _preact.render)((0, _preact.h)(App, null), document.getElementById('app'));
if ('serviceWorker' in navigator && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') window.addEventListener('load', ()=>{
    navigator.serviceWorker.register(require("96a5551e0cc15851"));
});
else if ('serviceWorker' in navigator) navigator.serviceWorker.getRegistrations().then((registrations)=>{
    registrations.forEach((registration)=>registration.unregister());
});
if (window.navigator.standalone) {
    document.body.classList.add('standalone');
    // Refresh map size when dismissing software keyboard
    // https://stackoverflow.com/a/19464029/20838
    document.addEventListener('focusout', ()=>{
        if (_map) _map.resize();
    });
    // Enable CSS active states
    document.addEventListener('touchstart', ()=>{}, false);
}
const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') !== -1;
if (isSafari && !window.navigator.standalone) setTimeout(function() {
    const ratio = window.devicePixelRatio;
    const canvas = document.createElement('canvas');
    const w = canvas.width = window.screen.width * ratio;
    const h = canvas.height = window.screen.height * ratio;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#F9F5ED';
    ctx.fillRect(0, 0, w, h);
    const icon = new Image();
    icon.onload = ()=>{
        const aspectRatio = icon.width / icon.height;
        icon.width = w / 2;
        icon.height = w / 2 / aspectRatio;
        ctx.drawImage(icon, (w - icon.width) / 2, (h - icon.height) / 2, icon.width, icon.height);
        document.head.insertAdjacentHTML('beforeend', `<link rel="apple-touch-startup-image" href="${canvas.toDataURL()}">`);
    };
    icon.src = (0, _iconSvgDefault.default);
}, 5000);

},{"@swc/helpers/_/_object_spread":"2eaR5","@swc/helpers/_/_object_spread_props":"kR5CL","./i18n":"h6hrD","./utils/theme":"64PZj","./config":"ffd5s","./city-config":"7oMBO","./utils/normalizeNames":"d3SoU","./utils/search":"lmHpZ","./utils/geometry":"6yMmk","preact":"ej31g","preact/hooks":"gK13j","maplibre-gl":"gacdv","@mapbox/polyline":"3x2L0","cheap-ruler":"9WlFg","react-i18next":"d3rqO","./utils/workerClient":"6woga","./utils/parsePoisCsv":"dr0iO","./utils/geocode":"dVZ38","./utils/specialID":"lXpo4","./utils/raptor":"hJk4z","./utils/raptorWorkerClient":"ieW1k","./utils/bus":"4E495","./utils/fetchCache":"kNdlE","./utils/getRoute":"kYEZr","./utils/fetchArrivals":"awwGd","./utils/getWalkingMinutes":"tXXxs","./utils/usePrevious":"ixjNm","./utils/fetchVehicles":"4Ko6F","./utils/vehicleLookup":"5D3hz","./components/VehicleChip":"8XQvj","./components/VehiclePanel":"dKVNc","./utils/rafInterval":"aSR6k","./utils/metricsPage":"ioORP","./utils/mobilePane":"4cC7h","./utils/mapOptimizations":"kixUx","./utils/boundedNearest":"buDVS","./utils/searchLimits":"gdEzT","./components/BusServicesArrival":"8ZuIH","./components/CloseControl":"fe4TF","./components/GeolocateControl":"kT5y8","./components/BetweenRoutes":"6sgRh","./components/ScrollableContainer":"M6shC","./components/StopsList.jsx":"cMevO","./components/LiveDataIndicator.jsx":"4b2KT","./images/stop.png":"25zZC","./images/stop-end.png":"cM1DV","./images/stop-active.png":"8K34h","./images/passing-routes-blue.svg":"i17Kp","../icons/icon.svg":"fObxN","./images/bus-tiny-map.png":"faAC3","./images/metro-station-sdf.svg":"4RZ4f","./images/rail-station.svg":"dtx4r","./images/monorail-station.svg":"lFVpO","96a5551e0cc15851":"5me7G","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"lmHpZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stripRouteHyphens", ()=>stripRouteHyphens);
const stripRouteHyphens = (value)=>String(value !== null && value !== void 0 ? value : '').replace(/-/g, '');

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"9WlFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A collection of very fast approximations to common geodesic measurements. Useful for performance-sensitive code that measures things on a city scale.
 */ parcelHelpers.export(exports, "default", ()=>CheapRuler);
const factors = {
    kilometers: 1,
    miles: 1000 / 1609.344,
    nauticalmiles: 1000 / 1852,
    meters: 1000,
    metres: 1000,
    yards: 1000 / 0.9144,
    feet: 1000 / 0.3048,
    inches: 1000 / 0.0254
};
// Values that define WGS84 ellipsoid model of the Earth
const RE = 6378.137; // equatorial radius
const FE = 1 / 298.257223563; // flattening
const E2 = FE * (2 - FE);
const RAD = Math.PI / 180;
class CheapRuler {
    /**
     * Creates a ruler object from tile coordinates (y and z).
     *
     * @param {number} y
     * @param {number} z
     * @param {keyof typeof factors} [units='kilometers']
     * @returns {CheapRuler}
     * @example
     * const ruler = cheapRuler.fromTile(1567, 12);
     * //=ruler
     */ static fromTile(y, z, units) {
        const n = Math.PI * (1 - 2 * (y + 0.5) / Math.pow(2, z));
        const lat = Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))) / RAD;
        return new CheapRuler(lat, units);
    }
    /**
     * Multipliers for converting between units.
     *
     * @example
     * // convert 50 meters to yards
     * 50 * CheapRuler.units.yards / CheapRuler.units.meters;
     */ static get units() {
        return factors;
    }
    /**
     * Given two points of the form [longitude, latitude], returns the distance.
     *
     * @param {[number, number]} a point [longitude, latitude]
     * @param {[number, number]} b point [longitude, latitude]
     * @returns {number} distance
     * @example
     * const distance = ruler.distance([30.5, 50.5], [30.51, 50.49]);
     * //=distance
     */ distance(a, b) {
        const dx = wrap(a[0] - b[0]) * this.kx;
        const dy = (a[1] - b[1]) * this.ky;
        return Math.sqrt(dx * dx + dy * dy);
    }
    /**
     * Returns the bearing between two points in angles.
     *
     * @param {[number, number]} a point [longitude, latitude]
     * @param {[number, number]} b point [longitude, latitude]
     * @returns {number} bearing
     * @example
     * const bearing = ruler.bearing([30.5, 50.5], [30.51, 50.49]);
     * //=bearing
     */ bearing(a, b) {
        const dx = wrap(b[0] - a[0]) * this.kx;
        const dy = (b[1] - a[1]) * this.ky;
        return Math.atan2(dx, dy) / RAD;
    }
    /**
     * Returns a new point given distance and bearing from the starting point.
     *
     * @param {[number, number]} p point [longitude, latitude]
     * @param {number} dist distance
     * @param {number} bearing
     * @returns {[number, number]} point [longitude, latitude]
     * @example
     * const point = ruler.destination([30.5, 50.5], 0.1, 90);
     * //=point
     */ destination(p, dist, bearing) {
        const a = bearing * RAD;
        return this.offset(p, Math.sin(a) * dist, Math.cos(a) * dist);
    }
    /**
     * Returns a new point given easting and northing offsets (in ruler units) from the starting point.
     *
     * @param {[number, number]} p point [longitude, latitude]
     * @param {number} dx easting
     * @param {number} dy northing
     * @returns {[number, number]} point [longitude, latitude]
     * @example
     * const point = ruler.offset([30.5, 50.5], 10, 10);
     * //=point
     */ offset(p, dx, dy) {
        return [
            p[0] + dx / this.kx,
            p[1] + dy / this.ky
        ];
    }
    /**
     * Given a line (an array of points), returns the total line distance.
     *
     * @param {[number, number][]} points [longitude, latitude]
     * @returns {number} total line distance
     * @example
     * const length = ruler.lineDistance([
     *     [-67.031, 50.458], [-67.031, 50.534],
     *     [-66.929, 50.534], [-66.929, 50.458]
     * ]);
     * //=length
     */ lineDistance(points) {
        let total = 0;
        for(let i = 0; i < points.length - 1; i++)total += this.distance(points[i], points[i + 1]);
        return total;
    }
    /**
     * Given a polygon (an array of rings, where each ring is an array of points), returns the area.
     *
     * @param {[number, number][][]} polygon
     * @returns {number} area value in the specified units (square kilometers by default)
     * @example
     * const area = ruler.area([[
     *     [-67.031, 50.458], [-67.031, 50.534], [-66.929, 50.534],
     *     [-66.929, 50.458], [-67.031, 50.458]
     * ]]);
     * //=area
     */ area(polygon) {
        let sum = 0;
        for(let i = 0; i < polygon.length; i++){
            const ring = polygon[i];
            for(let j = 0, len = ring.length, k = len - 1; j < len; k = j++)sum += wrap(ring[j][0] - ring[k][0]) * (ring[j][1] + ring[k][1]) * (i ? -1 : 1);
        }
        return Math.abs(sum) / 2 * this.kx * this.ky;
    }
    /**
     * Returns the point at a specified distance along the line.
     *
     * @param {[number, number][]} line
     * @param {number} dist distance
     * @returns {[number, number]} point [longitude, latitude]
     * @example
     * const point = ruler.along(line, 2.5);
     * //=point
     */ along(line, dist) {
        let sum = 0;
        if (dist <= 0) return line[0];
        for(let i = 0; i < line.length - 1; i++){
            const p0 = line[i];
            const p1 = line[i + 1];
            const d = this.distance(p0, p1);
            sum += d;
            if (sum > dist) return interpolate(p0, p1, (dist - (sum - d)) / d);
        }
        return line[line.length - 1];
    }
    /**
     * Returns the distance from a point `p` to a line segment `a` to `b`.
     *
     * @pointToSegmentDistance
     * @param {[number, number]} p point [longitude, latitude]
     * @param {[number, number]} a segment point 1 [longitude, latitude]
     * @param {[number, number]} b segment point 2 [longitude, latitude]
     * @returns {number} distance
     * @example
     * const distance = ruler.pointToSegmentDistance([-67.04, 50.5], [-67.05, 50.57], [-67.03, 50.54]);
     * //=distance
     */ pointToSegmentDistance(p, a, b) {
        let [x, y] = a;
        let dx = wrap(b[0] - x) * this.kx;
        let dy = (b[1] - y) * this.ky;
        if (dx !== 0 || dy !== 0) {
            const t = (wrap(p[0] - x) * this.kx * dx + (p[1] - y) * this.ky * dy) / (dx * dx + dy * dy);
            if (t > 1) {
                x = b[0];
                y = b[1];
            } else if (t > 0) {
                x += dx / this.kx * t;
                y += dy / this.ky * t;
            }
        }
        dx = wrap(p[0] - x) * this.kx;
        dy = (p[1] - y) * this.ky;
        return Math.sqrt(dx * dx + dy * dy);
    }
    /**
     * Returns an object of the form {point, index, t}, where point is closest point on the line
     * from the given point, index is the start index of the segment with the closest point,
     * and t is a parameter from 0 to 1 that indicates where the closest point is on that segment.
     *
     * @param {[number, number][]} line
     * @param {[number, number]} p point [longitude, latitude]
     * @returns {{point: [number, number], index: number, t: number}} {point, index, t}
     * @example
     * const point = ruler.pointOnLine(line, [-67.04, 50.5]).point;
     * //=point
     */ pointOnLine(line, p) {
        let minDist = Infinity;
        let minX = line[0][0];
        let minY = line[0][1];
        let minI = 0;
        let minT = 0;
        for(let i = 0; i < line.length - 1; i++){
            let x = line[i][0];
            let y = line[i][1];
            let dx = wrap(line[i + 1][0] - x) * this.kx;
            let dy = (line[i + 1][1] - y) * this.ky;
            let t = 0;
            if (dx !== 0 || dy !== 0) {
                t = (wrap(p[0] - x) * this.kx * dx + (p[1] - y) * this.ky * dy) / (dx * dx + dy * dy);
                if (t > 1) {
                    x = line[i + 1][0];
                    y = line[i + 1][1];
                } else if (t > 0) {
                    x += dx / this.kx * t;
                    y += dy / this.ky * t;
                }
            }
            dx = wrap(p[0] - x) * this.kx;
            dy = (p[1] - y) * this.ky;
            const sqDist = dx * dx + dy * dy;
            if (sqDist < minDist) {
                minDist = sqDist;
                minX = x;
                minY = y;
                minI = i;
                minT = t;
            }
        }
        return {
            point: [
                minX,
                minY
            ],
            index: minI,
            t: Math.max(0, Math.min(1, minT))
        };
    }
    /**
     * Returns a part of the given line between the start and the stop points (or their closest points on the line).
     *
     * @param {[number, number]} start point [longitude, latitude]
     * @param {[number, number]} stop point [longitude, latitude]
     * @param {[number, number][]} line
     * @returns {[number, number][]} line part of a line
     * @example
     * const line2 = ruler.lineSlice([-67.04, 50.5], [-67.05, 50.56], line1);
     * //=line2
     */ lineSlice(start, stop, line) {
        let p1 = this.pointOnLine(line, start);
        let p2 = this.pointOnLine(line, stop);
        if (p1.index > p2.index || p1.index === p2.index && p1.t > p2.t) {
            const tmp = p1;
            p1 = p2;
            p2 = tmp;
        }
        const slice = [
            p1.point
        ];
        const l = p1.index + 1;
        const r = p2.index;
        if (!equals(line[l], slice[0]) && l <= r) slice.push(line[l]);
        for(let i = l + 1; i <= r; i++)slice.push(line[i]);
        if (!equals(line[r], p2.point)) slice.push(p2.point);
        return slice;
    }
    /**
     * Returns a part of the given line between the start and the stop points indicated by distance along the line.
     *
     * @param {number} start start distance
     * @param {number} stop stop distance
     * @param {[number, number][]} line
     * @returns {[number, number][]} part of a line
     * @example
     * const line2 = ruler.lineSliceAlong(10, 20, line1);
     * //=line2
     */ lineSliceAlong(start, stop, line) {
        let sum = 0;
        const slice = [];
        for(let i = 0; i < line.length - 1; i++){
            const p0 = line[i];
            const p1 = line[i + 1];
            const d = this.distance(p0, p1);
            sum += d;
            if (sum > start && slice.length === 0) slice.push(interpolate(p0, p1, (start - (sum - d)) / d));
            if (sum >= stop) {
                slice.push(interpolate(p0, p1, (stop - (sum - d)) / d));
                return slice;
            }
            if (sum > start) slice.push(p1);
        }
        return slice;
    }
    /**
     * Given a point, returns a bounding box object ([w, s, e, n]) created from the given point buffered by a given distance.
     *
     * @param {[number, number]} p point [longitude, latitude]
     * @param {number} buffer
     * @returns {[number, number, number, number]} bbox ([w, s, e, n])
     * @example
     * const bbox = ruler.bufferPoint([30.5, 50.5], 0.01);
     * //=bbox
     */ bufferPoint(p, buffer) {
        const v = buffer / this.ky;
        const h = buffer / this.kx;
        return [
            p[0] - h,
            p[1] - v,
            p[0] + h,
            p[1] + v
        ];
    }
    /**
     * Given a bounding box, returns the box buffered by a given distance.
     *
     * @param {[number, number, number, number]} bbox ([w, s, e, n])
     * @param {number} buffer
     * @returns {[number, number, number, number]} bbox ([w, s, e, n])
     * @example
     * const bbox = ruler.bufferBBox([30.5, 50.5, 31, 51], 0.2);
     * //=bbox
     */ bufferBBox(bbox, buffer) {
        const v = buffer / this.ky;
        const h = buffer / this.kx;
        return [
            bbox[0] - h,
            bbox[1] - v,
            bbox[2] + h,
            bbox[3] + v
        ];
    }
    /**
     * Returns true if the given point is inside in the given bounding box, otherwise false.
     *
     * @param {[number, number]} p point [longitude, latitude]
     * @param {[number, number, number, number]} bbox ([w, s, e, n])
     * @returns {boolean}
     * @example
     * const inside = ruler.insideBBox([30.5, 50.5], [30, 50, 31, 51]);
     * //=inside
     */ insideBBox(p, bbox) {
        return wrap(p[0] - bbox[0]) >= 0 && wrap(p[0] - bbox[2]) <= 0 && p[1] >= bbox[1] && p[1] <= bbox[3];
    }
    /**
     * Creates a ruler instance for very fast approximations to common geodesic measurements around a certain latitude.
     *
     * @param {number} lat latitude
     * @param {keyof typeof factors} [units='kilometers']
     * @example
     * const ruler = cheapRuler(35.05, 'miles');
     * //=ruler
     */ constructor(lat, units){
        if (lat === undefined) throw new Error('No latitude given.');
        if (units && !factors[units]) throw new Error(`Unknown unit ${units}. Use one of: ${Object.keys(factors).join(', ')}`);
        // Curvature formulas from https://en.wikipedia.org/wiki/Earth_radius#Meridional
        const m = RAD * RE * (units ? factors[units] : 1);
        const coslat = Math.cos(lat * RAD);
        const w2 = 1 / (1 - E2 * (1 - coslat * coslat));
        const w = Math.sqrt(w2);
        // multipliers for converting longitude and latitude degrees into distance
        this.kx = m * w * coslat; // based on normal radius of curvature
        this.ky = m * w * w2 * (1 - E2); // based on meridonal radius of curvature
    }
}
/**
 * @param {[number, number]} a
 * @param {[number, number]} b
 */ function equals(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
/**
 * @param {[number, number]} a
 * @param {[number, number]} b
 * @param {number} t
 * @returns {[number, number]}
 */ function interpolate(a, b, t) {
    const dx = wrap(b[0] - a[0]);
    const dy = b[1] - a[1];
    return [
        a[0] + dx * t,
        a[1] + dy * t
    ];
}
/**
 * normalize a degree value into [-180..180] range
 * @param {number} deg
 */ function wrap(deg) {
    while(deg < -180)deg += 360;
    while(deg > 180)deg -= 360;
    return deg;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"6woga":[function(require,module,exports,__globalThis) {
/**
 * Promise-based client for dataWorker.js.
 *
 * The worker is created lazily on first use and reused for the lifetime of the
 * page. Each call gets a unique id so concurrent requests resolve independently.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Send processed stop/service arrays + raw services JSON to the worker so it
 * can build Fuse indices and answer routing queries.
 *
 * @param {Object} opts
 * @param {Array}  opts.stopsArr      - [{number,name,suffix,coordinates,routes}]
 * @param {Array}  opts.servicesArr   - [{number,name}]
 * @param {Object} opts.servicesData  - Raw services JSON from services.min.json
 * @param {Array}  [opts.poisArr]     - [{id,name,type,lat,lon,color}]
 * @returns {Promise<{ok:true}>}
 */ parcelHelpers.export(exports, "initDataWorker", ()=>initDataWorker);
/**
 * Fuzzy-search services, stops, and (alpha) locations.
 * @param {string} query
 * @returns {Promise<{services:Array, stops:Array, locations:Array}>}
 */ parcelHelpers.export(exports, "workerSearch", ()=>workerSearch);
/**
 * Find the 25 closest stops to a coordinate.
 * @param {number} lng
 * @param {number} lat
 * @returns {Promise<{stops:Array}>}
 */ parcelHelpers.export(exports, "workerClosestStops", ()=>workerClosestStops);
/**
 * Find the nearest stop to a location plus every other stop sharing its
 * Voronoi cell (same physical place, from the city's clusters.min.json).
 * @param {number} lng
 * @param {number} lat
 * @param {Object} [clusters] - { [stopId]: [[siblingStopId, distanceM], ...] }
 * @returns {Promise<{stops:Array}>}
 */ parcelHelpers.export(exports, "workerNearbyStops", ()=>workerNearbyStops);
/**
 * Find routes between two stops (proximity expansion + route intersection).
 * Either side can instead be a location: pass its resolved cluster of nearby
 * stop numbers as `startCandidateNumbers`/`endCandidateNumbers` (first entry
 * treated as primary) to search from/to that whole set instead of a single
 * stop's own proximity expansion.
 * @param {string} [startStopNumber]
 * @param {string} [endStopNumber]
 * @param {string[]} availableServices  - Empty array means no live-API filter
 * @param {Object} [opts]
 * @param {string[]} [opts.startCandidateNumbers]
 * @param {string[]} [opts.endCandidateNumbers]
 * @returns {Promise<{routes:Array, nearestStartStop:Object, nearestEndStop:Object}>}
 */ parcelHelpers.export(exports, "workerBetweenRoutes", ()=>workerBetweenRoutes);
let _worker = null;
const _pending = new Map(); // id → { resolve, reject }
let _idCounter = 0;
function getWorker() {
    if (!_worker) {
        _worker = new Worker(require("391ef06e62261bb3"));
        _worker.onmessage = ({ data: { id, result, error } })=>{
            const task = _pending.get(id);
            if (!task) return;
            _pending.delete(id);
            error ? task.reject(new Error(error)) : task.resolve(result);
        };
        _worker.onerror = (e)=>void 0;
    }
    return _worker;
}
function postTask(type, payload) {
    return new Promise((resolve, reject)=>{
        const id = ++_idCounter;
        _pending.set(id, {
            resolve,
            reject
        });
        getWorker().postMessage({
            id,
            type,
            payload
        });
    });
}
function initDataWorker({ stopsArr, servicesArr, servicesData, poisArr }) {
    return postTask('INIT', {
        stopsArr,
        servicesArr,
        servicesData,
        poisArr
    });
}
function workerSearch(query) {
    return postTask('SEARCH', {
        query
    });
}
function workerClosestStops(lng, lat) {
    return postTask('CLOSEST_STOPS', {
        lng,
        lat
    });
}
function workerNearbyStops(lng, lat, clusters) {
    return postTask('NEARBY_STOPS', {
        lng,
        lat,
        clusters
    });
}
function workerBetweenRoutes(startStopNumber, endStopNumber, availableServices, { startCandidateNumbers, endCandidateNumbers } = {}) {
    return postTask('BETWEEN_ROUTES', {
        startStopNumber,
        endStopNumber,
        startCandidateNumbers,
        endCandidateNumbers,
        availableServices
    });
}

},{"391ef06e62261bb3":"ccok1","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"ccok1":[function(require,module,exports,__globalThis) {
let workerURL = require("f983f5d629f5332e");
let url = new URL(module.bundle.resolve("ktRd5"));
module.exports = workerURL(url.toString(), url.origin, true);

},{"f983f5d629f5332e":"hMMeG"}],"hMMeG":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};

},{}],"dr0iO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsePoisCsv", ()=>parsePoisCsv);
parcelHelpers.export(exports, "fetchPois", ()=>fetchPois);
function parsePoisCsv(text) {
    const lines = text.trim().split('\n');
    if (lines.length < 2) return [];
    return lines.slice(1).map((line)=>{
        const fields = [];
        let current = '';
        let inQuotes = false;
        for (const ch of line){
            if (ch === '"') inQuotes = !inQuotes;
            else if (ch === ',' && !inQuotes) {
                fields.push(current);
                current = '';
            } else current += ch;
        }
        fields.push(current);
        return {
            name: fields[0],
            type: fields[1],
            lat: parseFloat(fields[2]),
            lon: parseFloat(fields[3]),
            color: (fields[4] || '').trim()
        };
    });
}
function fetchPois(city) {
    return fetch(`/data/${city}/pois.csv`).then((r)=>r.ok ? r.text() : '').then((text)=>text ? parsePoisCsv(text) : []).catch(()=>[]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"dVZ38":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Free-text place search via the /api/map/geocode proxy (alpha "locations"
 * feature). Returns [] on any failure so callers can treat it the same as
 * "no live results" without extra error handling.
 *
 * @param {string} query
 * @param {[number,number,number,number]} bbox - [south, west, north, east]
 * @returns {Promise<Array<{name,lat,lon,placeId}>>}
 */ parcelHelpers.export(exports, "fetchGeocode", ()=>fetchGeocode);
/**
 * Reverse-geocode a coordinate to a place name via the /api/map/geocode
 * proxy (alpha "locations" feature). Returns null on any failure so callers
 * can fall back to a coordinate-based label.
 *
 * @param {number} lat
 * @param {number} lon
 * @returns {Promise<string|null>}
 */ parcelHelpers.export(exports, "fetchReverseGeocode", ()=>fetchReverseGeocode);
var _fetchCache = require("./fetchCache");
var _fetchCacheDefault = parcelHelpers.interopDefault(_fetchCache);
const CACHE_TIME = 10; // minutes — geocode results for a query+bbox are stable short-term
function fetchGeocode(query, bbox) {
    const params = new URLSearchParams({
        q: query
    });
    if (bbox) params.set('bbox', bbox.join(','));
    const url = `/api/map/geocode?${params.toString()}`;
    return (0, _fetchCacheDefault.default)(url, CACHE_TIME).then((r)=>r.results || []).catch(()=>[]);
}
function fetchReverseGeocode(lat, lon) {
    const url = `/api/map/geocode?lat=${lat}&lon=${lon}`;
    return (0, _fetchCacheDefault.default)(url, 1440).then((r)=>r.name || null).catch(()=>null);
}

},{"./fetchCache":"kNdlE","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"hJk4z":[function(require,module,exports,__globalThis) {
/**
 * Unscoped (cross-city) RAPTOR route search for all-mode `between`.
 *
 * Pure functions only — no module-level state, no DOM/Worker dependency —
 * so this can run inline on the main thread against `cityDataMap` once every
 * city is loaded (all-mode's "load all cities unconditionally" scope
 * decision), unlike single-city `dataWorker.js`'s single-transfer search
 * which stays as-is.
 *
 * Global ids are city-qualified everywhere, since raw stop/service numbers
 * are not unique across cities (see missing-features.md #20):
 *   globalStopId  = "{city}^{stopNumber}"
 *   globalRouteKey = "{city}^{service}|{destination}|{variantIdx}"
 *
 * Phase 1 scope: schedule/frequency-based cost function only,
 * no live-arrival fan-out during the search.
 *
 * Cost-function note: the search loop uses ONLY the precomputed nationwide
 * frequency index (data/all/frequency.min.json) — a synchronous, in-memory
 * lookup. An earlier version fetched each stop's real per-day schedule.json
 * mid-search; at country-wide scale (all cities loaded) the reachable set
 * balloons past round 1 via hub stops (one stop can sit on hundreds of
 * routes), which turned into hundreds of thousands of concurrent schedule
 * fetches — not viable regardless of batching. Real schedules are instead
 * fetched only for the final itinerary's boarding stops, via
 * `refineWithSchedule`, after the search has already picked a route.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merge every loaded city's stopsData/servicesData/clustersData (from
 * `cityDataMap`) into one city-qualified route-major index RAPTOR can search
 * over. `clusters` (same-place stop groups) is assembled from each city's own
 * clustersData plus the small nationwide `crossCityClusters` leftover (see
 * globaltransfers.py) instead of one ever-growing nationwide clusters file.
 *
 * @param {Map<string,{stopsData:Object, servicesData:Object, clustersData:Object}>} cityDataMap
 * @param {Object.<string, Array<[string, number]>>} [crossCityClusters] - global clusters-cross-city.min.json
 */ parcelHelpers.export(exports, "buildGlobalRouteIndex", ()=>buildGlobalRouteIndex);
/**
 * Round-based multi-transfer RAPTOR over a global (cross-city) route index.
 * Fully synchronous — the frequency-based cost function is an in-memory
 * lookup, so no round involves network I/O.
 *
 * @param {Object} opts
 * @param {ReturnType<typeof buildGlobalRouteIndex>} opts.globalIndex
 * @param {Object.<string, Array<[string, number]>>} opts.transfers - global transfers.min.json
 * @param {Object.<string, Object.<string, number>>} opts.frequencyIndex - global frequency.min.json
 * @param {string} [opts.startId] - global stop id (single-origin search)
 * @param {string} [opts.endId] - global stop id (single-destination search)
 * @param {string[]} [opts.startIds] - global stop ids to search from simultaneously
 *   (e.g. a location's nearby-stop cluster) - takes precedence over `startId` if given
 * @param {string[]} [opts.endIds] - global stop ids that all count as "arrived" -
 *   takes precedence over `endId` if given
 * @param {Date} [opts.departureTime]
 * @param {number} [opts.maxRounds]
 * @returns {{itineraries: Array<{startId, endId, legs}>}}
 */ parcelHelpers.export(exports, "computeRaptorRoute", ()=>computeRaptorRoute);
/**
 * Best-effort display enrichment: fetches the real per-day schedule for each
 * itinerary's ride-leg boarding stops (a handful per itinerary, not every
 * stop touched during the search) and attaches a `realBoardTime` ("HH:MM")
 * to legs where a matching scheduled departure is found.
 *
 * Also attaches `leg.alternates` - up to MAX_LEG_ALTERNATES upcoming
 * departures (any service covering the same board->alight segment, excluding
 * the one actually chosen for this leg) around this leg's actual boarding
 * time, for a "Alternatively, take X at HH:MM" hint in the UI. Reuses the
 * same already-fetched schedule.json response as the realBoardTime
 * refinement above - no extra network calls.
 *
 * Mutates `itineraries` in place - including re-sorting it by real final
 * arrival time. `computeRaptorRoute`'s own ordering (fastest by its
 * frequency-based cost estimate) is only a rough proxy, and can be badly
 * wrong for low-frequency services - once real schedules are known here, an
 * itinerary that looked fastest during the search can turn out to need an
 * overnight wait, while a different top-K alternative (same earlier legs,
 * different final service) gets there hours sooner. Since this is the only
 * place real times are known, this is also the only place that can correct
 * the ranking.
 *
 * @param {Array<{legs: Array}>} itineraries
 * @param {ReturnType<typeof buildGlobalRouteIndex>} globalIndex
 * @param {(city:string, stopNumber:string) => Promise<Object>} [fetchSchedule]
 */ parcelHelpers.export(exports, "refineWithSchedule", ()=>refineWithSchedule);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _fetchCache = require("./fetchCache");
var _fetchCacheDefault = parcelHelpers.interopDefault(_fetchCache);
const WALK_SPEED_MPS = 1.1; // ~4 km/h
// schedule.json has no trip_id stitched across a trip's stops
// — there's no way to know a
// specific trip's real arrival time at downstream stops, so travel time
// between consecutive stops on a route is approximated from stop-to-stop
// straight-line distance at an assumed average transit speed.
const AVG_TRANSIT_SPEED_MPS = 5.6; // ~20 km/h
const MINUTES_PER_DAY = 1440;
const DEFAULT_MAX_ROUNDS = 4;
// How many distinct stop-sequence "patterns" (see patternKeyFor below) each
// stop keeps track of during the search. >1 is what lets a genuinely
// different route through the network (e.g. transferring at a different
// railway station) survive alongside the fastest option instead of being
// silently discarded the moment something a few minutes faster is found.
// Kept fairly generous (rather than the bare minimum of 2) because patterns
// are deduped strictly by route identity - two near-identical express/local
// variants of the same corridor count as separate patterns and can otherwise
// crowd out a genuinely different route (e.g. a different transfer hub)
// before it gets a chance to be considered.
const TOP_K_PATTERNS = 4;
const SCHEDULE_BASE_URL = 'https://data.transitrouter.vonter.in';
const SCHEDULE_CACHE_MINUTES = 60;
const EARTH_RADIUS_M = 6371000;
function haversineMeters([lng1, lat1], [lng2, lat2]) {
    const toRad = (d)=>d * Math.PI / 180;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
    return 2 * EARTH_RADIUS_M * Math.asin(Math.sqrt(a));
}
function parseGlobalRouteKey(globalRouteKey) {
    const caretIdx = globalRouteKey.indexOf('^');
    if (caretIdx === -1) return null;
    const city = globalRouteKey.slice(0, caretIdx);
    const rest = globalRouteKey.slice(caretIdx + 1);
    const first = rest.indexOf('|');
    const second = rest.indexOf('|', first + 1);
    if (first === -1 || second === -1) return null;
    return {
        city,
        service: rest.slice(0, first),
        destination: rest.slice(first + 1, second),
        variantIdx: rest.slice(second + 1)
    };
}
// Rebuilding this from scratch is O(total stops/routes across every loaded
// city) — expensive, and was previously redone on *every* between search
// even when the set of loaded cities hadn't changed since the last one.
// Cached here, keyed on a sorted signature of cityDataMap's current city
// set, so it's only rebuilt when that set actually changes.
let cachedIndex = null;
let cachedSignature = null;
function buildGlobalRouteIndex(cityDataMap, crossCityClusters = {}) {
    const signature = [
        ...cityDataMap.keys()
    ].sort().join(',');
    if (cachedIndex && cachedSignature === signature) return cachedIndex;
    const stopRoutes = new Map(); // globalStopId -> globalRouteKey[]
    const routeStopSequence = new Map(); // globalRouteKey -> globalStopId[]
    // globalRouteKey -> Map(globalStopId -> index within that route's sequence)
    // — precomputed once here so the round loop's boarding-index lookup is an
    // O(1) Map.get instead of an O(route length) seq.indexOf per marked stop.
    const routeStopIndex = new Map();
    const stopMeta = new Map(); // globalStopId -> {city, number, coordinates, name}
    const clusters = {}; // globalStopId -> [[globalNeighborId, distanceM], ...]
    for (const [city, cityData] of cityDataMap){
        const { stopsData, servicesData, clustersData } = cityData;
        if (clustersData) for(const number in clustersData){
            const globalStopId = `${city}^${number}`;
            const sameCity = clustersData[number].map(([n, d])=>[
                    `${city}^${n}`,
                    d
                ]);
            const cross = crossCityClusters[globalStopId] || [];
            if (sameCity.length || cross.length) clusters[globalStopId] = [
                ...sameCity,
                ...cross
            ];
        }
        for(const number in stopsData){
            const stop = stopsData[number];
            const globalStopId = `${city}^${number}`;
            stopMeta.set(globalStopId, {
                city,
                number,
                coordinates: stop.coordinates,
                name: stop.name
            });
            stopRoutes.set(globalStopId, (stop.routes || []).map((routeKey)=>`${city}^${routeKey}`));
        }
        for(const service in servicesData){
            const serviceEntry = servicesData[service];
            for(const destination in serviceEntry){
                if (destination === 'name') continue;
                const variants = serviceEntry[destination];
                variants.forEach((stopSeq, variantIdx)=>{
                    const globalRouteKey = `${city}^${service}|${destination}|${variantIdx}`;
                    const globalStopSeq = stopSeq.map((n)=>`${city}^${n}`);
                    routeStopSequence.set(globalRouteKey, globalStopSeq);
                    const stopIndex = new Map();
                    globalStopSeq.forEach((stopId, i)=>{
                        // A route can legitimately revisit the same stop id (a loop
                        // service); keep the *first* occurrence, matching indexOf's
                        // behavior exactly so this is a drop-in replacement.
                        if (!stopIndex.has(stopId)) stopIndex.set(stopId, i);
                    });
                    routeStopIndex.set(globalRouteKey, stopIndex);
                });
            }
        }
    }
    cachedIndex = {
        stopRoutes,
        routeStopSequence,
        routeStopIndex,
        stopMeta,
        clusters
    };
    cachedSignature = signature;
    return cachedIndex;
}
function parseTripMinutes(timeStr) {
    const colonIdx = timeStr.indexOf(':');
    if (colonIdx === -1) return null;
    const hours = parseInt(timeStr.slice(0, colonIdx), 10);
    const minutes = parseInt(timeStr.slice(colonIdx + 1), 10);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    return hours * 60 + minutes;
}
// schedule.json's "HH:MM" trip strings are local wall-clock times, but
// boardTime/alightTime are absolute epoch-minute timestamps — the same
// representation `formatEpochMinutes` in BetweenRoutes.js reads via
// `new Date(mins * 60000).getHours()/.getMinutes()` (local getters). Taking
// `epochMinutes % 1440` instead assumes the local UTC offset is a whole
// multiple of a day, which is false almost everywhere (e.g. IST is UTC+5:30)
// — that mismatch is what made refineWithSchedule match against the wrong
// time-of-day and produce nonsensical (earlier/unrelated) departure times.
function localMinuteOfDay(epochMinutes) {
    const d = new Date(epochMinutes * 60000);
    return d.getHours() * 60 + d.getMinutes();
}
/**
 * Earliest boarding time (absolute minutes) catchable at a stop for a given
 * service, at or after `afterMinutes` — a pure, synchronous expected-wait
 * estimate from the precomputed nationwide frequency index (no network
 * calls). Mirrors the existing client-side `staticFrequency` heuristic.
 *
 * @param {Object.<string, Object.<string, number>>} frequencyIndex - data/all/frequency.min.json
 * @returns {number|null} null if this stop/service has no frequency data
 */ function estimateBoardingTime(stopId, service, afterMinutes, frequencyIndex) {
    var _frequencyIndex_stopId;
    const dailyTripCount = (_frequencyIndex_stopId = frequencyIndex[stopId]) === null || _frequencyIndex_stopId === void 0 ? void 0 : _frequencyIndex_stopId[service];
    if (!dailyTripCount) return null;
    return afterMinutes + MINUTES_PER_DAY / dailyTripCount / 2;
}
function cumulativeDistances(stopSeq, stopMeta) {
    const cum = [
        0
    ];
    for(let i = 1; i < stopSeq.length; i++){
        const a = stopMeta.get(stopSeq[i - 1]);
        const b = stopMeta.get(stopSeq[i]);
        const d = a && b ? haversineMeters(a.coordinates, b.coordinates) : 0;
        cum.push(cum[i - 1] + d);
    }
    return cum;
}
// Extends a label's pattern identity by the leg just taken. Deliberately
// keyed on the *route* (which, via its variantIdx, already captures the full
// stop-by-stop sequence a given trip follows - see buildGlobalRouteIndex)
// rather than just the resulting stop id, so two express/local variants of
// the same service that happen to share the same board/alight stops still
// count as genuinely different patterns, not duplicates of each other.
// Walk legs deliberately do NOT extend the pattern - walking to a different
// nearby stop before/after riding the exact same service (e.g. boarding at
// whichever of two close-together platforms, or alighting one stop earlier
// and walking the rest of the way) isn't a meaningfully different journey,
// just a trivial last-mile variation. Only riding a genuinely different
// service (a different routeKey, which - via variantIdx - already captures
// express/local variants distinctly) advances the pattern.
function patternKeyFor(parentPatternKey, edge) {
    if (edge.kind !== 'ride') return parentPatternKey;
    return `${parentPatternKey}>R:${edge.route}`;
}
// Walks a label's direct parent-label chain (no map lookups needed - each
// label already holds a live reference to the label it was built from) into
// the same {startId, endId, legs} shape the rest of the codebase expects.
function reconstructFromLabel(label) {
    const hops = [];
    let cur = label;
    while(cur.parent){
        hops.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, cur.edge), {
            to: cur.stopId
        }));
        cur = cur.parent;
    }
    hops.reverse();
    return {
        startId: cur.stopId,
        endId: label.stopId,
        legs: hops
    };
}
// Inserts/updates a candidate label at a stop, deduped by patternKey (same
// pattern reached twice - keep whichever arrives earlier) and capped to the
// TOP_K_PATTERNS best-arriving *distinct* patterns. Returns whether the
// candidate actually made it into the kept set, so callers know whether to
// mark this stop for further exploration this round.
function upsertLabel(map, stopId, candidate) {
    const existing = map.get(stopId) || [];
    const dupIdx = existing.findIndex((l)=>l.patternKey === candidate.patternKey);
    if (dupIdx !== -1 && candidate.arrival >= existing[dupIdx].arrival) return false;
    let next = dupIdx !== -1 ? existing.map((l, i)=>i === dupIdx ? candidate : l) : [
        ...existing,
        candidate
    ];
    next.sort((a, b)=>a.arrival - b.arrival);
    if (next.length > TOP_K_PATTERNS) next = next.slice(0, TOP_K_PATTERNS);
    map.set(stopId, next);
    return next.includes(candidate);
}
function computeRaptorRoute({ globalIndex, transfers, clusters = {}, frequencyIndex, startId, endId, startIds, endIds, departureTime = new Date(), maxRounds = DEFAULT_MAX_ROUNDS }) {
    const { stopRoutes, routeStopSequence, routeStopIndex, stopMeta } = globalIndex;
    const origins = ((startIds === null || startIds === void 0 ? void 0 : startIds.length) ? startIds : [
        startId
    ]).filter((id)=>stopMeta.has(id));
    const destinations = new Set(((endIds === null || endIds === void 0 ? void 0 : endIds.length) ? endIds : [
        endId
    ]).filter((id)=>stopMeta.has(id)));
    if (!origins.length || !destinations.size) return {
        itineraries: []
    };
    const routeDistanceCache = new Map(); // globalRouteKey -> cumulative distance array
    const startMinutes = Math.floor(departureTime.getTime() / 60000);
    // Each stop maps to up to TOP_K_PATTERNS labels - {stopId, arrival,
    // patternKey, edge, parent}, where `parent` is a direct reference to the
    // label it was extended from (or null at the start), so reconstruction
    // never needs a separate lookup map and is immune to a label being pruned
    // from some *other* stop's top-K list later on. Seeding every origin at
    // time 0 (rather than searching each separately and merging) lets RAPTOR's
    // own round structure naturally find the fastest one — a location with
    // several nearby stops is just a search with several starting points.
    let prevLabels = new Map(origins.map((id)=>[
            id,
            [
                {
                    stopId: id,
                    arrival: startMinutes,
                    patternKey: id,
                    edge: null,
                    parent: null
                }
            ]
        ]));
    let markedStops = new Set(origins);
    let fewestTransfersItinerary = null;
    for(let round = 1; round <= maxRounds && markedStops.size; round++){
        const thisRoundLabels = new Map(prevLabels);
        const newlyMarked = new Set();
        // Labels newly added/improved by *this round's ride scan* specifically -
        // as opposed to `thisRoundLabels.get(stopId)`, which also contains any
        // older labels already sitting at that stop (e.g. a walk-derived label
        // from a previous round). Footpath relaxation below must only extend
        // these, or an already-walked-to stop that later happens to *also* pick
        // up an unrelated new ride this round would get its old, already-used
        // walk label walked *again* - silently chaining redundant walk hops
        // onto what should be a single transfer.
        const newRideLabels = []; // {stopId, label}
        // Gather the earliest marked boarding index per candidate route.
        const routesToScan = new Map(); // globalRouteKey -> boardIdx
        for (const stopId of markedStops)for (const routeKey of stopRoutes.get(stopId) || []){
            var _routeStopIndex_get;
            const idx = (_routeStopIndex_get = routeStopIndex.get(routeKey)) === null || _routeStopIndex_get === void 0 ? void 0 : _routeStopIndex_get.get(stopId);
            if (idx === undefined) continue;
            if (!routesToScan.has(routeKey) || idx < routesToScan.get(routeKey)) routesToScan.set(routeKey, idx);
        }
        for (const [routeKey, boardIdx] of routesToScan){
            const seq = routeStopSequence.get(routeKey);
            const parsed = parseGlobalRouteKey(routeKey);
            if (!parsed) continue;
            if (!routeDistanceCache.has(routeKey)) routeDistanceCache.set(routeKey, cumulativeDistances(seq, stopMeta));
            const cumDist = routeDistanceCache.get(routeKey);
            const arrivalIfRiding = (b, i)=>b.time + Math.round((cumDist[i] - cumDist[b.boardIdx]) / AVG_TRANSIT_SPEED_MPS / 60);
            // Up to TOP_K_PATTERNS concurrently-ridden boarding states for this
            // route scan - one per distinct incoming pattern, instead of RAPTOR's
            // usual single `boarded` state, so a genuinely different way of
            // reaching this route can ride alongside the fastest one rather than
            // being overwritten by it.
            let boarded = []; // {stopId, boardIdx, time, patternKey, parentLabel}
            for(let i = boardIdx; i < seq.length; i++){
                const stopId = seq[i];
                for (const prevLabel of prevLabels.get(stopId) || []){
                    const newBoardTime = estimateBoardingTime(stopId, parsed.service, prevLabel.arrival, frequencyIndex);
                    if (newBoardTime === null) continue;
                    const candidate = {
                        stopId,
                        boardIdx: i,
                        time: newBoardTime,
                        patternKey: prevLabel.patternKey,
                        parentLabel: prevLabel
                    };
                    const dupIdx = boarded.findIndex((b)=>b.patternKey === candidate.patternKey);
                    if (dupIdx !== -1) {
                        if (candidate.time < boarded[dupIdx].time) boarded[dupIdx] = candidate;
                    } else boarded.push(candidate);
                }
                // Bound this scan's cost: keep only the best-projected-arrival
                // TOP_K_PATTERNS boarding states from here on.
                if (boarded.length > TOP_K_PATTERNS) {
                    boarded.sort((a, b)=>arrivalIfRiding(a, i) - arrivalIfRiding(b, i));
                    boarded = boarded.slice(0, TOP_K_PATTERNS);
                }
                for (const b of boarded){
                    if (i <= b.boardIdx) continue;
                    const arrival = arrivalIfRiding(b, i);
                    const edge = {
                        fromStop: b.stopId,
                        kind: 'ride',
                        route: routeKey,
                        service: parsed.service,
                        // Same service number can run multiple directions through a stop
                        // (e.g. a route's outbound/inbound branches) with entirely
                        // different trip times — schedule.json disambiguates per-stop
                        // entries by final destination, so this has to travel with the
                        // leg for refineWithSchedule to match the correct direction's
                        // trips instead of merging both directions' times together.
                        destination: parsed.destination,
                        boardTime: b.time,
                        alightTime: arrival
                    };
                    const label = {
                        stopId,
                        arrival,
                        patternKey: patternKeyFor(b.patternKey, edge),
                        edge,
                        parent: b.parentLabel
                    };
                    if (upsertLabel(thisRoundLabels, stopId, label)) {
                        newlyMarked.add(stopId);
                        newRideLabels.push({
                            stopId,
                            label
                        });
                    }
                }
            }
        }
        // Footpath transfer relaxation - strictly from labels this round's ride
        // scan just added, never from a stop's pre-existing (e.g. walk-derived)
        // labels (see newRideLabels above). Two distinct edge sets, both from the
        // same Voronoi computation (see transfers.py): `clusters` are same-place
        // stops (different stop ids at the same physical station/junction) and
        // `transfers` are genuine walks to a different, nearby place. Both cost
        // real (if often small) walking time, so they're relaxed identically.
        for (const { stopId, label } of newRideLabels){
            const footpaths = [
                ...clusters[stopId] || [],
                ...transfers[stopId] || []
            ];
            for (const [neighborId, distM] of footpaths){
                const walkMinutes = Math.ceil(distM / WALK_SPEED_MPS / 60);
                const edge = {
                    fromStop: stopId,
                    kind: 'walk',
                    distanceMeters: distM,
                    alightTime: label.arrival + walkMinutes
                };
                const walkLabel = {
                    stopId: neighborId,
                    arrival: label.arrival + walkMinutes,
                    patternKey: patternKeyFor(label.patternKey, edge),
                    edge,
                    parent: label
                };
                if (upsertLabel(thisRoundLabels, neighborId, walkLabel)) newlyMarked.add(neighborId);
            }
        }
        if (!fewestTransfersItinerary) {
            let best = null;
            for (const destId of destinations){
                const endLabels = thisRoundLabels.get(destId);
                if (!(endLabels === null || endLabels === void 0 ? void 0 : endLabels.length)) continue;
                const candidate = endLabels.reduce((a, b)=>a.arrival <= b.arrival ? a : b);
                if (!best || candidate.arrival < best.arrival) best = candidate;
            }
            if (best) fewestTransfersItinerary = reconstructFromLabel(best);
        }
        prevLabels = thisRoundLabels;
        markedStops = newlyMarked;
    }
    // Every destination candidate's labels pooled together — a location with
    // several nearby stops is "arrived" once any one of them is reached.
    const endLabels = [];
    for (const destId of destinations){
        const labels = prevLabels.get(destId);
        if (labels === null || labels === void 0 ? void 0 : labels.length) endLabels.push(...labels);
    }
    if (!endLabels.length) return {
        itineraries: []
    };
    // Every distinct pattern the search kept for the destination, best arrival
    // first - this is what surfaces a genuinely different route (e.g. via a
    // different railway station) instead of just the single fastest option.
    const itineraries = endLabels.slice().sort((a, b)=>a.arrival - b.arrival).map(reconstructFromLabel);
    // Also keep the fewest-transfers itinerary, if it isn't already equivalent
    // (by leg count) to one of the patterns already surfaced above.
    if (fewestTransfersItinerary && !itineraries.some((it)=>it.legs.length === fewestTransfersItinerary.legs.length)) itineraries.push(fewestTransfersItinerary);
    return {
        itineraries
    };
}
function defaultFetchSchedule(city, stopNumber) {
    return (0, _fetchCacheDefault.default)(`${SCHEDULE_BASE_URL}/${city}/schedule/${stopNumber}.json`, SCHEDULE_CACHE_MINUTES);
}
// How many "Alternatively, take X at HH:MM" suggestions to show per leg.
const MAX_LEG_ALTERNATES = 3;
/**
 * Every distinct (service, destination) pair whose route covers the exact
 * same board->alight segment as `leg` (fromStop before `leg.to`, in the same
 * route's stop sequence) - including the leg's own service. Pure lookup
 * against the same in-memory route index the search already built; no
 * network I/O. This is deliberately just the same-stop case (not stops
 * within walking distance of fromStop/leg.to) - a cheap, exact notion of
 * "another way to cover this specific part of the journey".
 */ function findLegAlternateRoutes(leg, globalIndex) {
    const { stopRoutes, routeStopIndex } = globalIndex;
    const seen = new Set();
    const candidates = [];
    for (const routeKey of stopRoutes.get(leg.fromStop) || []){
        const stopIndex = routeStopIndex.get(routeKey);
        if (!stopIndex) continue;
        const boardIdx = stopIndex.get(leg.fromStop);
        const alightIdx = stopIndex.get(leg.to);
        if (boardIdx === undefined || alightIdx === undefined || alightIdx <= boardIdx) continue;
        const parsed = parseGlobalRouteKey(routeKey);
        if (!parsed) continue;
        const key = `${parsed.service}|${parsed.destination}`;
        if (seen.has(key)) continue;
        seen.add(key);
        candidates.push({
            service: parsed.service,
            destination: parsed.destination
        });
    }
    return candidates;
}
async function refineWithSchedule(itineraries, globalIndex, fetchSchedule = defaultFetchSchedule) {
    const scheduleCache = new Map(); // "city^number" -> Promise<scheduleJson|null>
    const getSchedule = (city, number)=>{
        const key = `${city}^${number}`;
        if (!scheduleCache.has(key)) scheduleCache.set(key, fetchSchedule(city, number).catch(()=>null));
        return scheduleCache.get(key);
    };
    const rideLegs = itineraries.flatMap((it)=>it.legs.filter((l)=>l.kind === 'ride'));
    await Promise.all(rideLegs.map((leg)=>{
        const [city, number] = leg.fromStop.split('^');
        return getSchedule(city, number);
    }));
    // Real per-day trip-time list (sorted minute-of-day) for one ride leg,
    // matched by both service number and destination — the same service
    // number can run opposite directions through a stop (see leg.destination
    // in computeRaptorRoute above), each with its own unrelated set of trip
    // times, so matching on number alone can hand back a time for the wrong
    // direction entirely. Returns null if no real schedule match exists, in
    // which case the leg keeps RAPTOR's own frequency-based estimate.
    const resolveTripMinutes = async (leg)=>{
        const [city, number] = leg.fromStop.split('^');
        const scheduleData = await getSchedule(city, number);
        let entries = ((scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.services) || []).filter((s)=>String(s.no) === String(leg.service) && String(s.destination) === String(leg.destination));
        // Fall back to number-only matching for legs from before `destination`
        // was captured (or routes whose schedule entry omits it) rather than
        // silently dropping the refinement.
        if (!entries.length && leg.destination == null) entries = ((scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.services) || []).filter((s)=>String(s.no) === String(leg.service));
        if (!entries.length) return null;
        const tripMinutes = entries.flatMap((s)=>s.trips || []).map(parseTripMinutes).filter((m)=>m !== null).sort((a, b)=>a - b);
        return tripMinutes.length ? tripMinutes : null;
    };
    function localMidnightEpochMinutes(epochMinutes) {
        const d = new Date(epochMinutes * 60000);
        return Math.floor(new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime() / 60000);
    }
    // Latest valid occurrence of one of `tripMinutes` (a real per-day trip-time
    // list) that still lands in [floorAbsolute, deadlineAbsolute] - i.e. the
    // latest trip on this route that both (a) isn't earlier than the earliest
    // this leg could ever board (`floorAbsolute`, so this pass only ever delays,
    // never advances a leg), and (b) still boards in time to make the fixed
    // downstream connection. Returns null if no trip fits that window.
    function latestTripInWindow(tripMinutes, floorAbsolute, deadlineAbsolute) {
        if (deadlineAbsolute < floorAbsolute) return null;
        const dayStart = localMidnightEpochMinutes(deadlineAbsolute);
        let best = null;
        for(let dayOffset = 0; dayOffset >= -1; dayOffset--)for (const m of tripMinutes){
            const t = dayStart + dayOffset * MINUTES_PER_DAY + m;
            if (t >= floorAbsolute && t <= deadlineAbsolute && (best === null || t > best)) best = t;
        }
        return best;
    }
    for (const itinerary of itineraries){
        const legs = itinerary.legs;
        const rideIdxs = legs.reduce((acc, l, i)=>l.kind === 'ride' ? [
                ...acc,
                i
            ] : acc, []);
        if (!rideIdxs.length) continue;
        // RAPTOR's estimated ride/walk durations - fixed regardless of which real
        // trip ends up chosen for a leg (only *when* it boards changes, not how
        // long it takes), so snapshot them before anything gets mutated.
        // `waitEstimate` is RAPTOR's own estimated wait before boarding (relative
        // to the *previous* leg's original arrival) - the fallback for legs with
        // no real schedule match, so it isn't collapsed to zero wait below.
        const rideDuration = new Map(); // legIdx -> minutes
        const walkDuration = new Map(); // legIdx -> minutes
        const waitEstimate = new Map(); // legIdx (ride) -> minutes
        legs.forEach((leg, i)=>{
            if (leg.kind === 'ride') {
                rideDuration.set(i, leg.alightTime - leg.boardTime);
                waitEstimate.set(i, i > 0 ? leg.boardTime - legs[i - 1].alightTime : 0);
            } else walkDuration.set(i, Math.ceil(leg.distanceMeters / WALK_SPEED_MPS / 60));
        });
        const tripMinutesByIdx = new Map();
        for (const i of rideIdxs)tripMinutesByIdx.set(i, await resolveTripMinutes(legs[i]));
        // Forward pass: greedily board the earliest catchable real trip at every
        // leg. This is the earliest possible arrival for this fixed sequence of
        // routes (provably optimal - boarding any later trip on an earlier leg
        // can only push every downstream boarding later-or-equal, never earlier),
        // so it's the anchor for "keep the end time the same" below.
        const out = legs.map((leg)=>(0, _objectSpread._)({}, leg));
        let arrival = null; // epoch minutes at the current stop
        out.forEach((leg, i)=>{
            if (leg.kind === 'walk') {
                if (arrival != null) leg.alightTime = arrival + walkDuration.get(i);
                arrival = leg.alightTime;
                return;
            }
            const priorArrival = arrival != null ? arrival : leg.boardTime;
            const tripMinutes = tripMinutesByIdx.get(i);
            let board = priorArrival + waitEstimate.get(i);
            if (tripMinutes) {
                const dayMinute = localMinuteOfDay(priorArrival);
                var _tripMinutes_find;
                const next = (_tripMinutes_find = tripMinutes.find((m)=>m >= dayMinute)) !== null && _tripMinutes_find !== void 0 ? _tripMinutes_find : tripMinutes[0];
                let delta = next - dayMinute;
                if (delta < 0) delta += MINUTES_PER_DAY;
                board = priorArrival + delta;
                const boardDayMinute = localMinuteOfDay(board);
                const h = String(Math.floor(boardDayMinute / 60)).padStart(2, '0');
                const m = String(boardDayMinute % 60).padStart(2, '0');
                leg.realBoardTime = `${h}:${m}`;
            }
            leg.boardTime = board;
            leg.alightTime = board + rideDuration.get(i);
            arrival = leg.alightTime;
        });
        // Backward pass: compute, for every ride leg but the last, the latest
        // board time it could theoretically take (`latestAllowed`) and still
        // make the *last* leg's (forward, earliest-possible) board time - the
        // fixed deadline the itinerary's actual end time isn't allowed to move
        // past. This walks backward assuming every later leg also takes its own
        // latest option, so it's optimistic - it doesn't yet know whether an
        // earlier leg can actually *reach* this leg in time for that.
        const lastRideIdx = rideIdxs[rideIdxs.length - 1];
        const latestAllowed = new Map(); // legIdx -> epoch minutes
        let deadline = out[lastRideIdx].boardTime;
        for(let k = rideIdxs.length - 2; k >= 0; k--){
            const idx = rideIdxs[k];
            const nextIdx = rideIdxs[k + 1];
            const tripMinutes = tripMinutesByIdx.get(idx);
            // How much of `deadline` this leg actually gets to use, after
            // subtracting any walk-transfer time between it and the next ride leg,
            // and its own ride duration (this is the latest *board* time, not arrival).
            let requiredArrivalBy = deadline;
            for(let j = idx + 1; j < nextIdx; j++)if (out[j].kind === 'walk') requiredArrivalBy -= walkDuration.get(j);
            requiredArrivalBy -= rideDuration.get(idx);
            const floor = out[idx].boardTime; // never move earlier than the forward pass
            const latest = tripMinutes ? latestTripInWindow(tripMinutes, floor, requiredArrivalBy) : null;
            const cap = latest !== null ? latest : floor;
            latestAllowed.set(idx, cap);
            deadline = cap;
        }
        // Forward confirmation pass: re-walk the chain using *actual* running
        // arrival times (so it's always feasible, unlike the optimistic backward
        // pass above) and, at each leg but the last, prefer the latest real trip
        // that both (a) is catchable given the real arrival here and (b) still
        // fits under that leg's `latestAllowed` cap - relocating waiting toward
        // the origin instead of a later transfer stop. Falls back to the normal
        // earliest-catchable trip wherever the cap turns out infeasible once
        // actual (rather than optimistic) arrival times are known, so this can
        // only ever degrade gracefully to the plain forward pass, never break it.
        arrival = null;
        out.forEach((leg, i)=>{
            if (leg.kind === 'walk') {
                if (arrival != null) leg.alightTime = arrival + walkDuration.get(i);
                arrival = leg.alightTime;
                return;
            }
            const priorArrival = arrival != null ? arrival : leg.boardTime;
            const tripMinutes = tripMinutesByIdx.get(i);
            let board = leg.boardTime; // last leg (or no schedule match): keep as-is
            if (tripMinutes && i !== lastRideIdx) {
                const cap = latestAllowed.get(i);
                const preferred = latestTripInWindow(tripMinutes, priorArrival, cap);
                if (preferred !== null) board = preferred;
                else {
                    const dayMinute = localMinuteOfDay(priorArrival);
                    var _tripMinutes_find;
                    const next = (_tripMinutes_find = tripMinutes.find((m)=>m >= dayMinute)) !== null && _tripMinutes_find !== void 0 ? _tripMinutes_find : tripMinutes[0];
                    let delta = next - dayMinute;
                    if (delta < 0) delta += MINUTES_PER_DAY;
                    board = priorArrival + delta;
                }
            } else if (i === lastRideIdx) board = Math.max(priorArrival, leg.boardTime);
            if (tripMinutes) {
                const dayMinute = localMinuteOfDay(board);
                const h = String(Math.floor(dayMinute / 60)).padStart(2, '0');
                const m = String(dayMinute % 60).padStart(2, '0');
                leg.realBoardTime = `${h}:${m}`;
            }
            leg.boardTime = board;
            leg.alightTime = board + rideDuration.get(i);
            arrival = leg.alightTime;
        });
        // "Alternatively, take X at HH:MM" - up to MAX_LEG_ALTERNATES upcoming
        // departures (any service covering this exact board->alight segment,
        // excluding the one actually chosen - it's already shown as the main
        // leg) around each ride leg's real boarding time. Purely additive
        // display info - never changes boardTime/alightTime/realBoardTime above.
        if (globalIndex) for (const leg of out){
            if (leg.kind !== 'ride') continue;
            const candidates = findLegAlternateRoutes(leg, globalIndex);
            if (!candidates.length) continue;
            const [city, number] = leg.fromStop.split('^');
            const scheduleData = await getSchedule(city, number);
            const combined = [];
            for (const cand of candidates){
                const entries = ((scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.services) || []).filter((s)=>String(s.no) === String(cand.service) && String(s.destination) === String(cand.destination));
                for (const m of entries.flatMap((s)=>s.trips || []).map(parseTripMinutes).filter((m)=>m !== null))combined.push({
                    service: cand.service,
                    minute: m
                });
            }
            if (!combined.length) continue;
            combined.sort((a, b)=>a.minute - b.minute);
            // Drop the exact (service, minute) that was actually chosen for this
            // leg - it's already shown as the main departure, repeating it here
            // would be redundant. Only the *other* real departures (same service
            // at a different time, or a different service entirely) are useful
            // as alternatives.
            const dayMinute = localMinuteOfDay(leg.boardTime);
            const chosenIdx = combined.findIndex((c)=>c.service === leg.service && c.minute === dayMinute);
            if (chosenIdx !== -1) combined.splice(chosenIdx, 1);
            if (!combined.length) continue;
            // Rotate the remaining list so it starts at/after this leg's actual
            // boarding time - i.e. "what else was/is around now", not literally
            // the start of the day.
            const startIdx = combined.findIndex((c)=>c.minute >= dayMinute);
            const ordered = startIdx === -1 ? combined : [
                ...combined.slice(startIdx),
                ...combined.slice(0, startIdx)
            ];
            leg.alternates = ordered.slice(0, MAX_LEG_ALTERNATES).map((c)=>({
                    service: c.service,
                    time: `${String(Math.floor(c.minute / 60)).padStart(2, '0')}:${String(c.minute % 60).padStart(2, '0')}`
                }));
        }
        itinerary.legs = out;
    }
    // Re-rank by *real* arrival time now that every itinerary has been refined
    // against actual schedules. computeRaptorRoute's own ordering comes from
    // the search's frequency-based cost estimate, which is a poor proxy for
    // low-frequency (e.g. once-a-day) services - it can rank an itinerary that
    // turns out to require an overnight wait ahead of one that, once real
    // timetables are applied, gets there hours sooner using the exact same
    // earlier legs. Sorting here (rather than during the search) is what
    // actually fixes selection, since only refineWithSchedule knows real times.
    itineraries.sort((a, b)=>{
        var _a_legs_, _b_legs_;
        var _a_legs__alightTime;
        const endA = (_a_legs__alightTime = (_a_legs_ = a.legs[a.legs.length - 1]) === null || _a_legs_ === void 0 ? void 0 : _a_legs_.alightTime) !== null && _a_legs__alightTime !== void 0 ? _a_legs__alightTime : Infinity;
        var _b_legs__alightTime;
        const endB = (_b_legs__alightTime = (_b_legs_ = b.legs[b.legs.length - 1]) === null || _b_legs_ === void 0 ? void 0 : _b_legs_.alightTime) !== null && _b_legs__alightTime !== void 0 ? _b_legs__alightTime : Infinity;
        return endA - endB;
    });
}

},{"@swc/helpers/_/_object_spread":"2eaR5","@swc/helpers/_/_object_spread_props":"kR5CL","./fetchCache":"kNdlE","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"ieW1k":[function(require,module,exports,__globalThis) {
/**
 * Promise-based client for raptorWorker.js — mirrors workerClient.js's
 * pattern for the single-city data worker.
 *
 * The worker is created lazily on first use and reused for the lifetime of
 * the page. Each call gets a unique id so concurrent requests resolve
 * independently.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Push any not-yet-synced city's routing data into the worker's own cache.
 * @param {Map<string,{stopsData:Object, servicesData:Object, clustersData:Object}>} cityDataMap
 */ parcelHelpers.export(exports, "syncRaptorWorkerCities", ()=>syncRaptorWorkerCities);
/**
 * Build the global route index (over the given, already-synced city codes)
 * and run the RAPTOR search, entirely inside the worker. `crossCityClusters`
 * is the small nationwide leftover of genuinely cross-city same-place edges
 * (see globaltransfers.py) — each city's own same-place edges instead come
 * from its already-synced `clustersData`.
 * @returns {Promise<{itineraries: Array, globalIndex: Object}>}
 */ parcelHelpers.export(exports, "searchRaptorWorker", ()=>searchRaptorWorker);
let _worker = null;
const _pending = new Map(); // id → { resolve, reject }
let _idCounter = 0;
// City codes already pushed into the worker's own cache — a city's
// stopsData/servicesData never change after it first loads, so this avoids
// re-cloning them across the postMessage boundary on every search.
const syncedCities = new Set();
function getWorker() {
    if (!_worker) {
        _worker = new Worker(require("15b975acb50443bc"));
        _worker.onmessage = ({ data: { id, result, error } })=>{
            const task = _pending.get(id);
            if (!task) return;
            _pending.delete(id);
            error ? task.reject(new Error(error)) : task.resolve(result);
        };
        _worker.onerror = (e)=>void 0;
    }
    return _worker;
}
function postTask(type, payload) {
    return new Promise((resolve, reject)=>{
        const id = ++_idCounter;
        _pending.set(id, {
            resolve,
            reject
        });
        getWorker().postMessage({
            id,
            type,
            payload
        });
    });
}
function syncRaptorWorkerCities(cityDataMap) {
    const cities = [];
    for (const [code, data] of cityDataMap){
        if (syncedCities.has(code)) continue;
        cities.push({
            code,
            stopsData: data.stopsData,
            servicesData: data.servicesData,
            clustersData: data.clustersData
        });
        syncedCities.add(code);
    }
    if (!cities.length) return Promise.resolve({
        ok: true
    });
    return postTask('SYNC_CITIES', {
        cities
    });
}
function searchRaptorWorker({ cityCodes, transfers, crossCityClusters, frequencyIndex, startIds, endIds }) {
    return postTask('SEARCH', {
        cityCodes,
        transfers,
        crossCityClusters,
        frequencyIndex,
        startIds,
        endIds
    });
}

},{"15b975acb50443bc":"03IZM","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"03IZM":[function(require,module,exports,__globalThis) {
let workerURL = require("2a911d1e8abfaaf0");
let url = new URL(module.bundle.resolve("fKZxD"));
module.exports = workerURL(url.toString(), url.origin, true);

},{"2a911d1e8abfaaf0":"hMMeG"}],"4E495":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeDisplay", ()=>timeDisplay);
parcelHelpers.export(exports, "sortServices", ()=>sortServices);
parcelHelpers.export(exports, "sortServicesPinned", ()=>sortServicesPinned);
const timeDisplay = (ms)=>{
    if (ms === null) return;
    const mins = Math.floor(ms / 1000 / 60);
    return mins <= 0 ? 'Arr' : `${mins}m`;
};
const sortServices = (a, b)=>{
    const a0 = a.toString()[0];
    const b0 = b.toString()[0];
    if (isNaN(a0) && !isNaN(b0)) return 1;
    if (!isNaN(a0) && isNaN(b0)) return -1;
    const result = a0 - b0;
    if (result !== 0) return result;
    return parseInt(a, 10) - parseInt(b, 10);
};
const sortServicesPinned = (pinnedServices)=>(a, b)=>{
        const pinA = pinnedServices.includes(a.no);
        const pinB = pinnedServices.includes(b.no);
        if (pinA && !pinB) return -1;
        else if (pinB && !pinA) return 1;
        else return sortServices(a.no, b.no);
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"tXXxs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWalkingMinutes);
function getWalkingMinutes(distance) {
    // meters
    const walkingSpeed = 1.4; // meter/second
    return Math.ceil(distance / walkingSpeed / 60);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"ixjNm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePrevious);
var _hooks = require("preact/hooks");
function usePrevious(value) {
    const ref = (0, _hooks.useRef)();
    (0, _hooks.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

},{"preact/hooks":"gK13j","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"4Ko6F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return true if a vehicle has lastRefreshMs and it is older than LIVE_DATA_MAX_AGE_MS (15 min).
 * @param {Object} vehicle - Vehicle object (may have lastRefreshMs)
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isVehicleStale", ()=>isVehicleStale);
/**
 * Fetch live vehicles data from the vehicles API
 * Accepts either route name (routetext) or route ID
 * @param {string} apiPath - The API path from city config
 * @param {string|number} routeIdentifier - The route name (e.g., "KIA-14") or route ID
 * @param {number} serviceTypeId - The service type ID (default: 0 for all types)
 * @returns {Promise} Promise resolving to vehicle data with a vehicles array
 *   and a `source` naming what the endpoint derived positions from
 *   ('api' or 'gtfs-rt'), or null when no live source backs the route
 */ parcelHelpers.export(exports, "fetchVehicles", ()=>fetchVehicles);
/**
 * Reconstruct vehicle location from GeoJSON feature
 * Location is stored in GeoJSON coordinates to reduce redundancy
 * @param {Object} geoJSON - GeoJSON FeatureCollection
 * @param {string} vehicleId - Vehicle ID to look up
 * @returns {Object|null} Location object with lat and lng, or null if not found
 */ parcelHelpers.export(exports, "getVehicleLocationFromGeoJSON", ()=>getVehicleLocationFromGeoJSON);
/**
 * Enrich vehicles array with location data from GeoJSON
 * Useful when location is needed but was removed to reduce redundancy
 * @param {Array} vehicles - Array of vehicle objects (without location)
 * @param {Object} geoJSON - GeoJSON FeatureCollection with vehicle locations
 * @returns {Array} Vehicles array with location added
 */ parcelHelpers.export(exports, "enrichVehiclesWithLocation", ()=>enrichVehiclesWithLocation);
/**
 * Convert vehicles to GeoJSON features for map display
 * Only includes minimal properties needed for map rendering
 * Full vehicle data is available in the vehicles array, linked by vehicleId
 * @param {Array} vehicles - Array of vehicle objects with location
 * @returns {Object} GeoJSON FeatureCollection
 */ parcelHelpers.export(exports, "vehiclesToGeoJSON", ()=>vehiclesToGeoJSON);
/**
 * Create a vehicle tracker instance for managing live vehicles
 * Supports tracking multiple services simultaneously
 * @param {Object} config - Configuration object
 * @param {Object} config.cityConfig - City configuration with API paths
 * @param {Object} config.map - Maplibre GL map instance
 * @param {Function} config.setRafInterval - RAF interval setter function
 * @param {Function} config.clearRafInterval - RAF interval clearer function
 * @returns {Object} Vehicle tracker instance
 */ parcelHelpers.export(exports, "createVehicleTracker", ()=>createVehicleTracker);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _cityConfigJs = require("../city-config.js");
var _fetchArrivalsJs = require("./fetchArrivals.js");
const recentRequests = new Map();
const REQUEST_DEDUPE_MS = 2000;
const IDLE_STATUS = {
    loading: false,
    error: false,
    source: null
};
function isVehicleStale(vehicle) {
    if (!vehicle || vehicle.lastRefreshMs == null) return false;
    return Date.now() - Number(vehicle.lastRefreshMs) > (0, _fetchArrivalsJs.LIVE_DATA_MAX_AGE_MS);
}
function fetchVehicles(apiPath, routeIdentifier, serviceTypeId = 0) {
    if (!apiPath || !routeIdentifier || (0, _cityConfigJs.isApiDisabled)()) return Promise.resolve(null);
    // Determine if routeIdentifier is a number (route ID) or string (route name)
    const isRouteId = typeof routeIdentifier === 'number';
    const paramName = isRouteId ? 'routeid' : 'routetext';
    const paramValue = encodeURIComponent(routeIdentifier);
    const url = `${(0, _cityConfigJs.getApiUrl)(apiPath)}?${paramName}=${paramValue}&servicetypeid=${serviceTypeId}`;
    const cached = recentRequests.get(url);
    if (cached && (cached.settledAt === null || Date.now() - cached.settledAt < REQUEST_DEDUPE_MS)) return cached.promise;
    const promise = (async ()=>{
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Failed to fetch vehicles: ${response.status}`);
            return await response.json();
        } catch (error) {
            return null;
        }
    })();
    const entry = {
        promise,
        settledAt: null
    };
    recentRequests.set(url, entry);
    promise.finally(()=>{
        entry.settledAt = Date.now();
        setTimeout(()=>{
            if (recentRequests.get(url) === entry) recentRequests.delete(url);
        }, REQUEST_DEDUPE_MS);
    });
    return promise;
}
function getVehicleLocationFromGeoJSON(geoJSON, vehicleId) {
    if (!geoJSON || !geoJSON.features || !vehicleId) return null;
    const feature = geoJSON.features.find((f)=>{
        var _f_properties;
        return f.id === vehicleId || ((_f_properties = f.properties) === null || _f_properties === void 0 ? void 0 : _f_properties.vehicleId) === vehicleId;
    });
    if (!feature || !feature.geometry || !feature.geometry.coordinates) return null;
    // GeoJSON coordinates are [longitude, latitude]
    const [lng, lat] = feature.geometry.coordinates;
    return {
        lat,
        lng
    };
}
function enrichVehiclesWithLocation(vehicles, geoJSON) {
    if (!vehicles || !geoJSON) return vehicles || [];
    return vehicles.map((vehicle)=>{
        const location = getVehicleLocationFromGeoJSON(geoJSON, vehicle.vehicleId);
        return location ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, vehicle), {
            location
        }) : vehicle;
    });
}
function vehiclesToGeoJSON(vehicles) {
    if (!vehicles || vehicles.length === 0) return {
        type: 'FeatureCollection',
        features: []
    };
    const features = vehicles.filter((vehicle)=>{
        // Exclude vehicles with lastRefreshMs older than 15 minutes
        if (isVehicleStale(vehicle)) return false;
        // Only include vehicles with valid location data
        if (!vehicle.location || typeof vehicle.location.lat !== 'number' || typeof vehicle.location.lng !== 'number') return false;
        // Filter out invalid coordinates (0,0 or null island)
        if (vehicle.location.lat === 0 && vehicle.location.lng === 0) return false;
        return true;
    }).map((vehicle, index)=>({
            type: 'Feature',
            id: vehicle.vehicleId || `vehicle-${index}`,
            properties: {
                vehicleId: vehicle.vehicleId,
                vehicleNumber: vehicle.vehicleNumber,
                // Needed for text label on map
                heading: vehicle.heading // Needed for icon rotation
            },
            geometry: {
                type: 'Point',
                coordinates: [
                    vehicle.location.lng,
                    vehicle.location.lat
                ]
            }
        }));
    return {
        type: 'FeatureCollection',
        features
    };
}
function createVehicleTracker({ cityConfig, map, setRafInterval, clearRafInterval }) {
    let intervalId = null;
    const trackedServices = new Set(); // Track multiple services
    const currentVehicles = new Map(); // Map service number to vehicles array
    const routeIdCache = new Map(); // Cache route IDs: service number -> route ID
    const subscribers = new Set(); // Subscribers for vehicle updates
    const statusSubscribers = new Set(); // Subscribers for live data status
    let liveStatus = IDLE_STATUS;
    let activeServicesKey = '';
    let generation = 0;
    let startPromise = null;
    let hasRenderedVehicles = false;
    function setLiveStatus(next) {
        if (liveStatus.loading === next.loading && liveStatus.error === next.error && liveStatus.source === next.source) return;
        liveStatus = next;
        statusSubscribers.forEach((callback)=>callback(liveStatus));
    }
    /**
   * Update vehicles for all tracked services
   */ async function updatePositions(expectedGeneration = generation) {
        const vehicleTracking = cityConfig === null || cityConfig === void 0 ? void 0 : cityConfig.liveVehicles;
        // Early return if vehicle tracking is disabled or no services are tracked
        if (!(vehicleTracking === null || vehicleTracking === void 0 ? void 0 : vehicleTracking.enabled) || trackedServices.size === 0) return;
        try {
            var _results_find_response, _results_find;
            // Fetch vehicles for all tracked services in parallel
            const fetchPromises = Array.from(trackedServices).map(async (serviceNumber)=>{
                try {
                    // Check cache for route ID first
                    const cachedRouteId = routeIdCache.get(serviceNumber);
                    const routeIdentifier = cachedRouteId || serviceNumber;
                    const response = await fetchVehicles(vehicleTracking.apiPath, routeIdentifier);
                    // Cache the route ID from the response if available
                    if (response && response.routeId) routeIdCache.set(serviceNumber, response.routeId);
                    return {
                        serviceNumber,
                        response
                    };
                } catch (error) {
                    return {
                        serviceNumber,
                        response: null
                    };
                }
            });
            const results = await Promise.all(fetchPromises);
            if (expectedGeneration !== generation) return;
            var _results_find_response_source;
            // Status requires an actual vehicle, not just a responding endpoint —
            // a working feed that currently has nothing to show still reads as
            // "no live data" to the rider, same as the feed being down.
            const liveSource = (_results_find_response_source = (_results_find = results.find(({ response })=>{
                var _response_vehicles;
                return (response === null || response === void 0 ? void 0 : response.source) && ((_response_vehicles = response.vehicles) === null || _response_vehicles === void 0 ? void 0 : _response_vehicles.length);
            })) === null || _results_find === void 0 ? void 0 : (_results_find_response = _results_find.response) === null || _results_find_response === void 0 ? void 0 : _results_find_response.source) !== null && _results_find_response_source !== void 0 ? _results_find_response_source : null;
            setLiveStatus({
                loading: false,
                error: !liveSource,
                source: liveSource
            });
            // Combine all vehicles from all services
            const allVehicles = [];
            results.forEach(({ serviceNumber, response })=>{
                if (!(response === null || response === void 0 ? void 0 : response.vehicles)) return;
                const freshVehicles = response.vehicles.filter((vehicle)=>!isVehicleStale(vehicle));
                currentVehicles.set(serviceNumber, freshVehicles);
                allVehicles.push(...freshVehicles);
            });
            // Generate GeoJSON from vehicles on the client side
            const combinedGeoJSON = vehiclesToGeoJSON(allVehicles);
            // Update map if source exists
            const source = map === null || map === void 0 ? void 0 : map.getSource('buses-service');
            const hasVehicles = combinedGeoJSON.features.length > 0;
            if (source && (hasVehicles || hasRenderedVehicles)) source.setData(combinedGeoJSON);
            hasRenderedVehicles = hasVehicles;
            // Notify subscribers
            subscribers.forEach((callback)=>{
                callback(allVehicles);
            });
        } catch (error) {
            setLiveStatus({
                loading: false,
                error: true,
                source: null
            });
            subscribers.forEach((callback)=>callback([]));
        }
    }
    /**
   * Start tracking vehicles for multiple services
   * @param {Array<string>} serviceNumbers - Array of service numbers to track
   * @returns {Promise<boolean>} True if tracking started successfully
   */ function startServices(serviceNumbers) {
        if (!serviceNumbers || serviceNumbers.length === 0) {
            stop();
            return Promise.resolve(false);
        }
        const vehicleTracking = cityConfig === null || cityConfig === void 0 ? void 0 : cityConfig.liveVehicles;
        if (!(vehicleTracking === null || vehicleTracking === void 0 ? void 0 : vehicleTracking.enabled)) return Promise.resolve(false);
        const normalizedServices = [
            ...new Set(serviceNumbers.map(String))
        ];
        const servicesKey = normalizedServices.join('|');
        if (servicesKey === activeServicesKey) {
            if (startPromise) return startPromise;
            if (intervalId) return Promise.resolve(true);
        }
        const currentGeneration = ++generation;
        activeServicesKey = servicesKey;
        setLiveStatus({
            loading: true,
            error: false,
            source: null
        });
        startPromise = (async ()=>{
            // Stop existing tracking
            if (intervalId) {
                clearRafInterval(intervalId);
                intervalId = null;
            }
            // Clear existing tracked services
            trackedServices.clear();
            currentVehicles.clear();
            // Add services to tracking
            normalizedServices.forEach((serviceNumber)=>{
                trackedServices.add(serviceNumber);
            });
            if (trackedServices.size === 0) {
                stop();
                return false;
            }
            // Fetch vehicles immediately for all services
            await updatePositions(currentGeneration);
            if (currentGeneration !== generation) return false;
            // Only set up periodic updates if we have tracked services
            if (trackedServices.size > 0) intervalId = setRafInterval(()=>{
                updatePositions(currentGeneration);
            }, 60000);
            return true;
        })().catch((error)=>{
            return false;
        }).finally(()=>{
            if (currentGeneration === generation) startPromise = null;
        });
        return startPromise;
    }
    /**
   * Start tracking vehicles for a single service (backward compatibility)
   * @param {string} serviceNumber - The service number to track
   * @returns {Promise<boolean>} True if tracking started successfully
   */ async function start(serviceNumber) {
        return startServices([
            serviceNumber
        ]);
    }
    /**
   * Stop tracking vehicles and clear map
   */ function stop() {
        generation++;
        activeServicesKey = '';
        startPromise = null;
        setLiveStatus(IDLE_STATUS);
        if (intervalId) {
            clearRafInterval(intervalId);
            intervalId = null;
        }
        const hadVehicles = getVehicles().length > 0;
        trackedServices.clear();
        currentVehicles.clear();
        // Clear vehicles from map
        const source = map === null || map === void 0 ? void 0 : map.getSource('buses-service');
        if (source && hasRenderedVehicles) source.setData({
            type: 'FeatureCollection',
            features: []
        });
        hasRenderedVehicles = false;
        if (hadVehicles) subscribers.forEach((callback)=>callback([]));
    }
    /**
   * Get current tracking status
   * @returns {Object} Current tracking status
   */ function getStatus() {
        return {
            isTracking: intervalId !== null,
            serviceNumbers: Array.from(trackedServices)
        };
    }
    /**
   * Get current vehicles (all tracked services combined)
   * @returns {Array} Current vehicles array
   */ function getVehicles() {
        const allVehicles = [];
        currentVehicles.forEach((vehicles)=>{
            allVehicles.push(...vehicles);
        });
        return allVehicles;
    }
    /**
   * Subscribe to vehicle updates
   * @param {Function} callback - Callback function to receive vehicle updates
   * @returns {Function} Unsubscribe function
   */ function subscribe(callback) {
        subscribers.add(callback);
        // Immediately call with current vehicles
        const current = getVehicles();
        if (current.length > 0) callback(current);
        return ()=>subscribers.delete(callback);
    }
    /**
   * Subscribe to live data status updates ({ loading, error, source })
   * @param {Function} callback - Callback function to receive status updates
   * @returns {Function} Unsubscribe function
   */ function subscribeLiveStatus(callback) {
        statusSubscribers.add(callback);
        callback(liveStatus);
        return ()=>statusSubscribers.delete(callback);
    }
    return {
        start,
        startServices,
        // New method for multiple services
        stop,
        getStatus,
        getVehicles,
        subscribe,
        subscribeLiveStatus
    };
}

},{"@swc/helpers/_/_object_spread":"2eaR5","@swc/helpers/_/_object_spread_props":"kR5CL","../city-config.js":"7oMBO","./fetchArrivals.js":"awwGd","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"5D3hz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Fetch every vehicle currently active in the source, as
 * [{ vehicleId, vehicleNumber }]. Cached briefly so focusing/typing in the
 * search box doesn't refetch on every keystroke.
 */ parcelHelpers.export(exports, "fetchActiveVehicles", ()=>fetchActiveVehicles);
/** Vehicles whose number/id contains the query (ignoring case and punctuation). */ parcelHelpers.export(exports, "filterVehicles", ()=>filterVehicles);
/**
 * Fetch one vehicle's info. Resolves to null when the vehicle is not in the
 * source (404) or the request fails; `notFound` distinguishes the former.
 */ parcelHelpers.export(exports, "fetchVehicleInfo", ()=>fetchVehicleInfo);
/**
 * Estimated position of a vehicle from its per-stop arrival times alone
 * (used when the source gives no position): interpolates between the last
 * stop it should have reached and the next one. `coordsFor(stopId)` returns
 * [lng, lat] or null. Returns { lat, lng } or null.
 */ parcelHelpers.export(exports, "estimateLocationFromStops", ()=>estimateLocationFromStops);
parcelHelpers.export(exports, "isVehicleInfoStale", ()=>isVehicleInfoStale);
var _cityConfigJs = require("../city-config.js");
var _fetchArrivalsJs = require("./fetchArrivals.js");
const ACTIVE_CACHE_MS = 30000;
const activeCache = new Map(); // apiPath -> { at, promise }
const normalize = (value)=>String(value !== null && value !== void 0 ? value : '').toLowerCase().replace(/[^a-z0-9]/g, '');
function fetchActiveVehicles(apiPath) {
    if (!apiPath || (0, _cityConfigJs.isApiDisabled)()) return Promise.resolve([]);
    const cached = activeCache.get(apiPath);
    if (cached && Date.now() - cached.at < ACTIVE_CACHE_MS) return cached.promise;
    const promise = fetch((0, _cityConfigJs.getApiUrl)(apiPath)).then((res)=>{
        if (!res.ok) throw new Error(`Failed to fetch active vehicles: ${res.status}`);
        return res.json();
    }).then((data)=>(data === null || data === void 0 ? void 0 : data.vehicles) || []).catch((error)=>{
        activeCache.delete(apiPath);
        return [];
    });
    activeCache.set(apiPath, {
        at: Date.now(),
        promise
    });
    return promise;
}
function filterVehicles(vehicles, query, limit) {
    const q = normalize(query);
    if (!q) return [];
    const out = [];
    for (const v of vehicles)if (normalize(v.vehicleNumber).includes(q) || normalize(v.vehicleId).includes(q)) {
        out.push(v);
        if (out.length >= limit) break;
    }
    return out;
}
async function fetchVehicleInfo(apiPath, vehicleId) {
    if (!apiPath || !vehicleId || (0, _cityConfigJs.isApiDisabled)()) return {
        info: null,
        notFound: false
    };
    try {
        const res = await fetch(`${(0, _cityConfigJs.getApiUrl)(apiPath)}?vehicleid=${encodeURIComponent(vehicleId)}`);
        if (res.status === 404) return {
            info: null,
            notFound: true
        };
        if (!res.ok) throw new Error(`Failed to fetch vehicle: ${res.status}`);
        return {
            info: await res.json(),
            notFound: false
        };
    } catch (error) {
        return {
            info: null,
            notFound: false
        };
    }
}
function estimateLocationFromStops(stops, coordsFor, nowMs = Date.now()) {
    const timed = (stops || []).filter((s)=>s.arrivalTime != null && coordsFor(s.stopId)).sort((a, b)=>a.arrivalTime - b.arrivalTime);
    if (!timed.length) return null;
    const nowSec = nowMs / 1000;
    const nextIdx = timed.findIndex((s)=>s.arrivalTime >= nowSec);
    if (nextIdx === -1) {
        const [lng, lat] = coordsFor(timed[timed.length - 1].stopId);
        return {
            lat,
            lng
        };
    }
    if (nextIdx === 0) {
        const [lng, lat] = coordsFor(timed[0].stopId);
        return {
            lat,
            lng
        };
    }
    const prev = timed[nextIdx - 1];
    const next = timed[nextIdx];
    const span = next.arrivalTime - prev.arrivalTime;
    const f = span > 0 ? Math.min(1, Math.max(0, (nowSec - prev.arrivalTime) / span)) : 1;
    const [pLng, pLat] = coordsFor(prev.stopId);
    const [nLng, nLat] = coordsFor(next.stopId);
    return {
        lat: pLat + (nLat - pLat) * f,
        lng: pLng + (nLng - pLng) * f
    };
}
const isVehicleInfoStale = (info)=>(info === null || info === void 0 ? void 0 : info.lastRefreshMs) != null && Date.now() - Number(info.lastRefreshMs) > (0, _fetchArrivalsJs.LIVE_DATA_MAX_AGE_MS);

},{"../city-config.js":"7oMBO","./fetchArrivals.js":"awwGd","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"8XQvj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOAD_LABEL_KEYS", ()=>LOAD_LABEL_KEYS);
parcelHelpers.export(exports, "default", ()=>VehicleChip);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _preact = require("preact");
var _reactI18Next = require("react-i18next");
var _busTinyPng = require("../images/bus-tiny.png");
var _busTinyPngDefault = parcelHelpers.interopDefault(_busTinyPng);
const LOAD_LABEL_KEYS = {
    SEA: 'glossary.seatsAvailable',
    SDA: 'glossary.standingAvailable',
    LSD: 'glossary.limitedStanding'
};
function VehicleChip(_param) {
    var { number, size = 'sm', load } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "number",
        "size",
        "load"
    ]);
    const { t } = (0, _reactI18Next.useTranslation)();
    const loadKey = LOAD_LABEL_KEYS[load];
    return (0, _preact.h)("span", (0, _extendsDefault.default)({
        class: `vehicle-inline vehicle-inline--${size}`
    }, rest), (0, _preact.h)("img", {
        src: (0, _busTinyPngDefault.default),
        width: "14",
        height: "14",
        alt: "Bus"
    }), (0, _preact.h)("span", {
        class: "vehicle-inline-number"
    }, number), loadKey && (0, _preact.h)("span", {
        class: `vehicle-load vehicle-load-${load.toLowerCase()}`,
        title: t(loadKey),
        role: "img",
        "aria-label": t(loadKey)
    }));
}

},{"@swc/helpers/_/_object_without_properties":"87mRe","@babel/runtime/helpers/esm/extends":"aqsOV","preact":"ej31g","react-i18next":"d3rqO","../images/bus-tiny.png":"40M3r","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"40M3r":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("lkrLs");

},{}],"dKVNc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * "10:42 ∙ 5 min" (upcoming), "10:42 ∙ Now" (within NOW_WINDOW_SEC either
 * way), or "10:42 ∙ 22 min ago" beyond that (the source's stop-time data is
 * stale — this feed doesn't always extend a trip's remaining stops as it
 * advances, so "no data past this point" and "running late" can't be told
 * apart here, but the actual elapsed time is still shown either way).
 * Computed from `stop.arrivalTime` directly rather than the response's own
 * `duration_ms`, which is clamped to 0 for a past time and so can't tell
 * "just now" from "long ago".
 */ parcelHelpers.export(exports, "formatStopTimeLabel", ()=>formatStopTimeLabel);
/**
 * What the route popover needs to show a vehicle on its stop list: the
 * vehicle in the shape StopsList already places (after the stop it last
 * passed, else before the next), plus a time label per stop. Both are empty
 * unless the source gave trip updates that match stops of this route/city.
 *
 * Every known stop gets a label (not just ones near "now") — the feed only
 * ever reports a handful of stops per trip, and one this stale, per
 * formatStopTimeLabel, is still worth showing rather than going blank.
 */ parcelHelpers.export(exports, "buildRouteVehicleView", ()=>buildRouteVehicleView);
parcelHelpers.export(exports, "default", ()=>VehiclePanel);
var _preact = require("preact");
var _reactI18Next = require("react-i18next");
var _vehicleChip = require("./VehicleChip");
var _vehicleChipDefault = parcelHelpers.interopDefault(_vehicleChip);
var _liveDataIndicator = require("./LiveDataIndicator");
var _liveDataIndicatorDefault = parcelHelpers.interopDefault(_liveDataIndicator);
const formatTime = (unixSec)=>new Date(unixSec * 1000).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
// How long a stop's time still reads as "Now", either side of it — beyond
// this it always shows the real elapsed time ("N min ago"/"N min"), never
// hidden and never silently rounded to "Now" for longer than this.
const NOW_WINDOW_SEC = 120;
function formatStopTimeLabel(t, stop, nowMs = Date.now()) {
    if (stop.arrivalTime == null) return formatTime(stop.arrivalTime);
    const elapsedSec = nowMs / 1000 - stop.arrivalTime;
    let eta;
    if (elapsedSec > NOW_WINDOW_SEC) eta = t('vehicle.minutesAgo', {
        count: Math.round(elapsedSec / 60)
    });
    else if (elapsedSec >= -NOW_WINDOW_SEC) eta = t('vehicle.now');
    else eta = t('vehicle.minutes', {
        count: Math.round(-elapsedSec / 60)
    });
    return `${formatTime(stop.arrivalTime)} \u{2219} ${eta}`;
}
function buildRouteVehicleView(t, info, isKnownStop, nowMs = Date.now()) {
    const nowSec = nowMs / 1000;
    const stops = ((info === null || info === void 0 ? void 0 : info.stops) || []).filter((s)=>s.arrivalTime != null && isKnownStop(s.stopId)).sort((a, b)=>a.arrivalTime - b.arrivalTime);
    if (!stops.length) return {
        vehicles: [],
        stopTimeLabels: {}
    };
    const stopTimeLabels = {};
    let last = null;
    let next = null;
    for (const s of stops){
        stopTimeLabels[s.stopId] = formatStopTimeLabel(t, s, nowMs);
        if (s.arrivalTime <= nowSec) last = s;
        else if (!next) next = s;
    }
    var _last_stopId, _next_stopId;
    return {
        vehicles: [
            {
                vehicleId: info.vehicleId,
                vehicleNumber: info.vehicleNumber,
                serviceType: null,
                load: info.load,
                stops: {
                    lastLocationId: (_last_stopId = last === null || last === void 0 ? void 0 : last.stopId) !== null && _last_stopId !== void 0 ? _last_stopId : null,
                    currentLocationId: null,
                    nextLocationId: (_next_stopId = next === null || next === void 0 ? void 0 : next.stopId) !== null && _next_stopId !== void 0 ? _next_stopId : null
                }
            }
        ],
        stopTimeLabels
    };
}
function VehiclePanel({ panel, withHeader }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { info, notFound, estimated } = panel;
    if (!info) return (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("header", null, (0, _preact.h)("h1", null, (0, _preact.h)((0, _vehicleChipDefault.default), {
        number: panel.id,
        size: "lg"
    }))), (0, _preact.h)("div", {
        class: "popover-scroll"
    }, (0, _preact.h)("p", {
        class: "vehicle-error",
        role: "alert"
    }, notFound ? t('vehicle.notActive') : t('vehicle.loadFailed'))));
    const loadKey = (0, _vehicleChip.LOAD_LABEL_KEYS)[info.load];
    const notes = (0, _preact.h)((0, _preact.Fragment), null, loadKey && (0, _preact.h)("p", {
        class: "vehicle-occupancy"
    }, t(loadKey)), !info.location && estimated && (0, _preact.h)("p", {
        class: "vehicle-estimated"
    }, t('vehicle.estimatedPosition')));
    if (!withHeader) return (0, _preact.h)("div", {
        class: "vehicle-panel"
    }, notes);
    return (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("header", null, (0, _preact.h)("div", {
        class: "service-header-row"
    }, (0, _preact.h)("h1", null, (0, _preact.h)((0, _vehicleChipDefault.default), {
        number: info.vehicleNumber,
        size: "lg"
    })), (0, _preact.h)((0, _liveDataIndicatorDefault.default), {
        source: info.source
    }))), (0, _preact.h)("div", {
        class: "popover-scroll vehicle-panel"
    }, notes));
}

},{"preact":"ej31g","react-i18next":"d3rqO","./VehicleChip":"8XQvj","./LiveDataIndicator":"4b2KT","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"aSR6k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setRafInterval", ()=>setRafInterval);
parcelHelpers.export(exports, "clearRafInterval", ()=>clearRafInterval);
const setRafInterval = (fn, delay)=>{
    const id = {};
    function tick() {
        fn();
        id.timeout = setTimeout(()=>{
            id.raf = requestAnimationFrame(tick);
        }, delay);
    }
    tick();
    return id;
};
const clearRafInterval = (id)=>{
    if (!id) return;
    const { timeout, raf } = id;
    clearTimeout(timeout);
    cancelAnimationFrame(raf);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"4cC7h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paneAppliesHere", ()=>paneAppliesHere);
// Search's breaks are fixed proportions of the viewport, not measured from
// content — its list length varies with every keystroke, and unlike
// stop/service/between/location it's never auto-sized: callers drive its
// break explicitly (focus → top, keyboard dismiss → middle, map tap →
// bottom — see app.js), so there's nothing to measure against in the first
// place. "bottom" here is a resting/collapsed state, not a dismiss
// threshold (see bottomClose:false in its pane options below) — search is
// meant to always stay at least partly visible (the input bar itself)
// whenever no other popover has taken it over, so its "bottom" is a small
// peek, not fully off-screen the way stop/service/between/location's is.
parcelHelpers.export(exports, "computeSearchBreaks", ()=>computeSearchBreaks);
// --- syncMobilePane -----------------------------------------------------
//
// A CupertinoPane instance only ever does its real setup once: measuring
// content, wiring up the scrollable region, and building its breakpoints
// all happen inside present(), but only the *first* time a given instance
// is presented — every call after that takes a fast path that just moves
// to a breakpoint using whatever was computed way back then. Earlier
// versions of this module tried to keep one long-lived pane instance per
// popover and patch its internals back into sync on every reopen and every
// content change (setBreakpoints, setOverflowHeight, moveToBreak,
// ResizeObserver...). That produced a long tail of bugs — stale sizing
// carried over from a previous stop, headers cut off, scrolling that
// stopped working, sheets resting at the wrong breakpoint — because each
// patch covered one symptom without the reused instance ever being
// *actually* fresh the way a first-ever present() is.
//
// So: don't reuse. Every time a popover should be showing, tear down
// whatever pane instance is there (if any) and build a brand new one. This
// is a little more work per open, but it's the one code path that has
// always behaved correctly, and it means there is exactly one place
// (buildPane, above) that determines a pane's initial state — nothing
// downstream can leave it half-updated.
//
// `paneRef` is a plain `useRef(null)` — the ref's `.current` holds the live
// CupertinoPane instance (or null when not shown).
//
// `release` means "pane mode no longer applies" (crossed into desktop width)
// rather than "this popover is closed" — the element goes back under plain CSS
// instead of staying hidden by cupertino's leftovers.
//
// `animate` / `waitFor` hand one sheet over to another (see app.js). Two
// sheets animating at once, one down and one up, reads as a flicker; what
// works is one moving while the other holds still. `animate: false` opts
// this pane out of moving; `waitFor` holds its work back until the promise
// resolves, so the incoming sheet is fully up before this one is taken away.
//
// Returns a promise resolving once this call has settled — that's what the
// paired caller passes as its `waitFor`.
parcelHelpers.export(exports, "syncMobilePane", ()=>syncMobilePane);
// Content can still change *within* a single open — most notably
// BusServicesArrival's live arrivals loading in async, well after this
// pane's initial breaks were computed from whatever had rendered by
// present()-time. Watches for actual DOM mutations (not size — once
// setOverflowHeight() force-sets the scroll region's height, its *size*
// stops changing even though its *content* still is, so a ResizeObserver
// would go silent after the first firing) and rebuilds breakpoints in
// place, without tearing down the pane (no need to — same content
// identity, just more/less of it).
//
// Call this once per popover, e.g. in the same effect that calls
// syncMobilePane, and use the returned cleanup on unmount/dep-change.
parcelHelpers.export(exports, "watchMobilePaneContent", ()=>watchMobilePaneContent);
// A window resize/orientation change leaves a presented pane's breakpoints
// exactly as they were computed at build time — cupertino's own internal
// resize handler re-applies those same locked pixel heights rather than
// recomputing them (see ResizeEvents.onWindowResize/buildBreakpoints in the
// library), so a break like "middle: 50vh" silently goes stale the moment
// the viewport's actual height changes. Recompute for real and reapply.
//
// Gated on width, not height: a mobile viewport's height also changes for the
// keyboard and the collapsing URL bar, and re-measuring against those sized the
// sheet for a viewport it isn't living in — it jumped on every scroll and stole
// the breaks app.js drives while the keyboard is up. Orientation flips move the
// width too, and cupertino still re-anchors to the new screen height.
//
// Call this once per popover alongside watchMobilePaneContent, and use the
// returned cleanup the same way.
parcelHelpers.export(exports, "watchMobilePaneResize", ()=>watchMobilePaneResize);
// Small guarded wrapper for the programmatic break transitions search
// drives externally (focus → top, keyboard dismiss → middle, map tap →
// bottom) — a plain `paneRef.current?.moveToBreak(...)` would still throw
// cupertino's own "present pane before call moveToBreak()" warning if the
// pane hasn't been built yet (e.g. an event fires before the first
// present() resolves), and skip silently if it's already resting there.
parcelHelpers.export(exports, "movePaneToBreak", ()=>movePaneToBreak);
var _cupertinoPane = require("cupertino-pane");
var _mapOptimizations = require("./mapOptimizations");
const paneAppliesHere = (supportsTouch, breakpoint)=>supportsTouch && !breakpoint();
// Shortest list worth resting at. Half the screen is less than the sheet's
// own header on a short (landscape) viewport, which would otherwise leave a
// sheet with no list in it at all.
const MIN_LIST_HEIGHT = 96;
// Content-aware breaks: half the screen (or shorter, if the content is), and
// a "top" break to drag up to only if the content needs more than that,
// capped just short of fullscreen.
//
// destroy() leaves behind the inline `height` it force-set on the
// `[overflow-y]` region, so measuring without resetting it first reads that
// stale height back as the new content's natural size — permanently wrong,
// since every rebuild inherits it.
function computeBreaks(el) {
    const scrollEl = el.querySelector('[overflow-y]');
    const prevHeight = scrollEl === null || scrollEl === void 0 ? void 0 : scrollEl.style.height;
    if (scrollEl) scrollEl.style.height = 'auto';
    const contentHeight = el.scrollHeight;
    // Everything above the scroll region: handle, header, filter row.
    const chromeHeight = scrollEl ? scrollEl.getBoundingClientRect().top - el.getBoundingClientRect().top : 0;
    if (scrollEl) scrollEl.style.height = prevHeight || '';
    const vh = window.innerHeight;
    const maxTop = Math.round(vh * 0.9);
    const middleHeight = Math.min(contentHeight, maxTop, Math.max(Math.round(vh * 0.5), chromeHeight + MIN_LIST_HEIGHT));
    const topHeight = Math.min(contentHeight, maxTop);
    // "bottom" is a real resting peek (handle+header only) rather than a
    // 0-height dismiss threshold — the footer and scrollable body hide
    // themselves from there (see onBreakChange in app.js and the .pane's own
    // overflow:hidden, which clips the rest of the content out of view once
    // the sheet is this short). Actual dismissal still happens via
    // bottomClose/fastSwipeClose — dragging *past* this break, or a fast
    // swipe — not by merely resting here.
    const handle = el.querySelector('.popover-handle');
    const header = el.querySelector('header');
    const peekHeight = ((handle === null || handle === void 0 ? void 0 : handle.offsetHeight) || 0) + ((header === null || header === void 0 ? void 0 : header.offsetHeight) || 0);
    return {
        top: {
            enabled: topHeight > middleHeight + 4,
            height: topHeight
        },
        middle: {
            enabled: true,
            height: middleHeight
        },
        bottom: {
            enabled: true,
            height: Math.min(peekHeight, middleHeight)
        }
    };
}
function computeSearchBreaks(el) {
    const vh = window.innerHeight;
    // .popover-search's own min-height (see app.css) — showing at least this
    // much keeps the input bar itself on screen and tappable at "bottom".
    const peekHeight = 60;
    return {
        top: {
            enabled: true,
            height: Math.max(0, Math.floor(vh * 0.8))
        },
        middle: {
            enabled: true,
            height: Math.round(vh * 0.45)
        },
        bottom: {
            enabled: true,
            height: peekHeight
        }
    };
}
// Height of everything after the scroll region (our `.popover-footer`, with
// the Arrivals/passing-routes button). cupertino's setOverflowHeight()
// assumes nothing follows it, and would push the footer past the pane's own
// clipped height — it takes this back as an offset.
function trailingHeight(scrollEl) {
    let total = 0;
    for(let sib = scrollEl === null || scrollEl === void 0 ? void 0 : scrollEl.nextElementSibling; sib; sib = sib.nextElementSibling)total += sib.offsetHeight;
    return total;
}
// Break *heights* live in settings.breaks; breakpoints.breaks holds the
// derived translateY values instead.
const breakHeight = (pane, name)=>{
    var _pane_settings_breaks_name, _pane_settings_breaks, _pane_settings;
    return pane === null || pane === void 0 ? void 0 : (_pane_settings = pane.settings) === null || _pane_settings === void 0 ? void 0 : (_pane_settings_breaks = _pane_settings.breaks) === null || _pane_settings_breaks === void 0 ? void 0 : (_pane_settings_breaks_name = _pane_settings_breaks[name]) === null || _pane_settings_breaks_name === void 0 ? void 0 : _pane_settings_breaks_name.height;
};
const tallestBreak = (pane)=>{
    var _pane_settings;
    return Object.values((pane === null || pane === void 0 ? void 0 : (_pane_settings = pane.settings) === null || _pane_settings === void 0 ? void 0 : _pane_settings.breaks) || {}).reduce((max, b)=>(b === null || b === void 0 ? void 0 : b.enabled) ? Math.max(max, b.height || 0) : max, 0);
};
// cupertino sizes the scroll region to the *top* break, assuming content only
// scrolls fully expanded (its `topperOverflow` default, which we turn off so
// lists stay scrollable at every break). At any shorter break that leaves the
// region's last (top - current) pixels below the screen edge: unreachable
// however far you scroll, and not scrollable at all when the content is
// shorter than that inflated height. Size it to the break on screen instead.
//
// `height` defaults to the current break; callers pass the tallest one to
// pre-grow the region for a move that may end taller (see expandOverflow).
function sizeOverflow(pane, el, height) {
    var // The library call still sizes `.pane` itself — correctly, to the top
    // break, since the sheet's background has to cover the whole drag range.
    _pane_setOverflowHeight, _pane_currentBreak;
    // present()/setBreakpoints() continuations can land after a rapid switch
    // already destroyed this pane (syncMobilePane rebuilds on every content
    // change), leaving overflowEl unset.
    if (!(pane === null || pane === void 0 ? void 0 : pane.overflowEl)) return;
    const trailing = trailingHeight(el.querySelector('[overflow-y]'));
    (_pane_setOverflowHeight = pane.setOverflowHeight) === null || _pane_setOverflowHeight === void 0 ? void 0 : _pane_setOverflowHeight.call(pane, trailing);
    const visible = height !== null && height !== void 0 ? height : breakHeight(pane, (_pane_currentBreak = pane.currentBreak) === null || _pane_currentBreak === void 0 ? void 0 : _pane_currentBreak.call(pane));
    if (visible == null) return;
    const { style, offsetTop } = pane.overflowEl;
    style.height = `${Math.max(0, visible - offsetTop - trailing)}px`;
}
// Grow to the tallest break for the duration of a drag or move: going up, the
// area being revealed is already filled; going down, the surplus is clipped
// by `.pane`'s own overflow:hidden.
const expandOverflow = (pane, el)=>sizeOverflow(pane, el, tallestBreak(pane) || undefined);
// Resizes a live pane in place — the shared body of both watchers below.
// Skipped when the breaks come back unchanged: live arrivals refresh on a timer
// but rarely change the sheet's height, and re-applying identical breaks still
// costs a 300ms reposition.
function reapplyBreaks(paneRef, el) {
    var _pane_isPanePresented;
    const pane = paneRef.current;
    if (!(pane === null || pane === void 0 ? void 0 : (_pane_isPanePresented = pane.isPanePresented) === null || _pane_isPanePresented === void 0 ? void 0 : _pane_isPanePresented.call(pane))) return;
    const breaks = (pane._computeBreaksFn || computeBreaks)(el);
    const breaksKey = JSON.stringify(breaks);
    if (breaksKey === pane._breaksKey) return;
    pane._breaksKey = breaksKey;
    const restingBreak = pane.currentBreak() || 'middle';
    pane.setBreakpoints(breaks).then(()=>{
        var _breaks_restingBreak;
        if (paneRef.current !== pane) return; // superseded/destroyed meanwhile
        expandOverflow(pane, el);
        // A pane already resting at a break doesn't follow its own new numbers —
        // its reveal is governed by transform, not height. onTransitionEnd sizes
        // the scroll region once the move lands.
        pane.moveToBreak(((_breaks_restingBreak = breaks[restingBreak]) === null || _breaks_restingBreak === void 0 ? void 0 : _breaks_restingBreak.enabled) ? restingBreak : 'middle');
    });
}
// cupertino's keyboard handling has to go. fixBodyKeyboardResize() rewrites the
// document's `<meta name=viewport>` (plus html overflow / body min-height),
// relayouting the whole page — map canvas included — and firing another resize
// that re-enters the same path. destroyResets() calls it on every teardown, so
// it ran on ordinary sheet transitions too. onKeyboardShow/WillHide also move
// the sheet to heights of their own, fighting the breaks app.js drives from
// visualViewport. Nothing opts out (KeyboardEvents is a core class, not one of
// the optional `modules`), so blank the methods per instance.
function disableLibraryKeyboardHandling(pane) {
    const keyboard = pane === null || pane === void 0 ? void 0 : pane.keyboardEvents;
    if (!keyboard) return;
    keyboard.fixBodyKeyboardResize = ()=>{};
    keyboard.handleKeyboardFromResize = ()=>false; // false = carry on as a plain resize
    keyboard.onKeyboardShow = ()=>{};
    keyboard.onKeyboardWillHide = ()=>{};
}
// destroy() hands the element back still wearing cupertino's styles: display,
// an opacity transition, overflowX, and a forced height on `[overflow-y]`. The
// next present() overwrites them, so they only matter on the way out to desktop
// — where they'd override the floating-card CSS and leave it invisible and
// unanimated. `.pane-managed` goes too; it pins position:static.
function releaseToCSS(el) {
    if (!el) return;
    el.classList.remove('pane-managed');
    el.style.display = '';
    el.style.visibility = '';
    el.style.transition = '';
    el.style.overflowX = '';
    const scrollEl = el.querySelector('[overflow-y]');
    if (scrollEl) {
        scrollEl.style.height = '';
        scrollEl.style.overflowX = '';
        scrollEl.style.overscrollBehavior = '';
    }
}
// `paneOptions` (passed through from syncMobilePane's caller) lets a
// popover override the handful of things search needs different from
// stop/service/between/location's defaults — see the search wiring in
// app.js for the one place that does.
function buildPane(el, onDismiss, paneOptions = {}) {
    const { // cupertino-pane resolves `dragBy` selectors with a plain, unscoped
    // `document.querySelector` — every popover shares the `.popover-handle`
    // class, so an unqualified selector here would grab whichever popover's
    // handle happens to appear first in the DOM instead of this one's own.
    // Scoping by this element's id keeps each pane wired to its own handle.
    //
    // Includes `header` alongside the handle: the handle bar alone is a
    // small target (~13px tall), and a drag starting a few pixels off it
    // was landing on plain, undraggable content — with no `touch-action`
    // override there, the browser's own default touch handling (page
    // scroll / pull-to-refresh) won racing against cupertino's touchstart
    // listener, instead of the sheet actually grabbing the gesture. cupertino
    // already excludes real form controls (button/input/select/etc — see
    // isFormElement() in its Events class) from starting a drag even when
    // they're inside a dragBy target, so buttons/links in the header stay
    // tappable normally.
    //
    // Pass `dragHandleSelector: null` (or `[]`) to disable drag entirely —
    // search has neither a .popover-handle nor a header worth dragging by,
    // and opts out of bottomClose/fastSwipeClose too (see app.js).
    dragHandleSelector = el.id ? [
        `#${el.id} .popover-handle`,
        `#${el.id} header`
    ] : [
        '.popover-handle',
        'header'
    ], computeBreaksFn = computeBreaks, initialBreak = 'middle', // cupertino treats bottomClose as "any drag whose *closest* resting
    // point is bottom destroys the pane immediately" — not "dragging past
    // bottom dismisses". With a real bottom break now in play (see
    // computeBreaks above), true meant bottom could never actually be
    // rested at: landing near it destroyed the pane, landing further away
    // snapped back to middle instead.
    //
    // fastSwipeClose is still the right mechanism for "a genuine fast
    // swipe dismisses" — the problem was never that it exists, only that
    // the *trigger* for it (fastSwipeNext(), in the library's Events
    // class) isn't a real velocity check: it just compares the last two
    // recorded touchmove steps and fires whenever that last step moved
    // >= fastSwipeSensivity further than the one before it, regardless of
    // how much time elapsed between them. At the library's own default
    // (3px), an ordinary, unhurried drag's last recorded frame clears that
    // trivially — so it wasn't distinguishing "flicked it" from "gently
    // let go while still moving" at all, and was firing on nearly every
    // drag release. Raising the threshold to something only a genuinely
    // fast flick's last frame would clear (as opposed to a drag that's
    // decelerating into a deliberate rest) is the only lever the library
    // exposes for this — there's no true velocity/time-based option.
    // May need retuning against a real device; this is a starting point,
    // not a measured constant.
    bottomClose = false, fastSwipeClose = true, fastSwipeSensivity = 20, // Fires with the pane's new resting break name whenever a drag or
    // moveToBreak() settles — lets the caller react to "resting at bottom"
    // (e.g. hide a floating footer that lives outside the pane's own
    // clipped content) without this module knowing anything about that
    // caller-specific UI.
    onBreakChange, // Stacking order for this pane's wrapper. Without it the order is DOM
    // insertion order, which reverses between the two directions of a
    // handoff, putting the sheet meant to be underneath on top on the way
    // back.
    zIndex } = paneOptions;
    const dragBySelectors = dragHandleSelector ? Array.isArray(dragHandleSelector) ? dragHandleSelector : [
        dragHandleSelector
    ] : [];
    // el.parentElement right now is React's real, owned parent for this
    // element — capture it before cupertino moves el anywhere, so destroy()
    // can be corrected back to it (see the note on parentElement below).
    const reactOwnedParent = el.parentElement;
    const breaks = computeBreaksFn(el);
    const pane = new (0, _cupertinoPane.CupertinoPane)(el, {
        // Not el.parentElement directly: that's a React-managed DOM node, and
        // cupertino inserts its wrapper as a plain child of whatever
        // parentElement is, entirely outside React's virtual DOM. If that
        // specific parent ever re-renders for an unrelated reason (e.g.
        // between's async route results arriving), React reconciles its own
        // children against a wrapper it has no record of creating and can
        // remove it as collateral damage — document.body is never reconciled
        // by this app's component tree, so it can't be touched by a render.
        // destroy() restores el into *this* same parentElement afterward
        // though, which would leave it under body instead of back in React's
        // tree — syncMobilePane corrects that using reactOwnedParent below.
        parentElement: document.body,
        backdrop: false,
        showDraggable: false,
        // cupertino's own `.pane` wrapper ships an opaque white background —
        // our content div supplies its own translucent/blurred background, so
        // that opaque layer sits behind it and defeats the blur. Tagged here so
        // app.css can neutralize it (see `.popover-pane-wrapper .pane`).
        cssClass: 'popover-pane-wrapper',
        dragBy: dragBySelectors,
        buttonDestroy: false,
        bottomClose,
        fastSwipeClose,
        fastSwipeSensivity,
        // cupertino-pane's default only allows the content to scroll once
        // fully expanded to the "top" break — since we start at "middle" and
        // may not even have a "top" break for short content, the list needs to
        // stay scrollable regardless of which break it's resting at.
        topperOverflow: false,
        initialBreak,
        breaks,
        events: {
            onDidDismiss: ()=>{
                var _pane__onDismiss;
                return (_pane__onDismiss = pane._onDismiss) === null || _pane__onDismiss === void 0 ? void 0 : _pane__onDismiss.call(pane);
            },
            // present() builds the wrapper: `rendered` is the first point it
            // exists and the last before the transition, so stacking is settled
            // before anything paints.
            rendered: ()=>{
                if (zIndex != null && pane.wrapperEl) pane.wrapperEl.style.zIndex = zIndex;
            },
            // A drag can end at any break, so size for the tallest throughout or
            // dragging up reveals a blank strip. onTransitionEnd shrinks it back.
            onDragStart: ()=>expandOverflow(pane, el),
            // cupertino's own moveToBreak() only updates the bookkeeping
            // currentBreak() reads *after* this same transitionend-driven
            // promise resolves — so reading it synchronously from here (fired
            // from inside that same event, before the promise's continuation
            // runs) sees the *previous* break, one step behind, whenever this
            // was reached via moveToBreak() (a real drag updates that
            // bookkeeping earlier, before its own transition even starts, so
            // it isn't affected — only our own programmatic moves are). Defer
            // to a macrotask so the read happens after any pending microtasks,
            // moveToBreak's continuation included.
            onTransitionEnd: ()=>setTimeout(()=>{
                    var _pane_isPanePresented;
                    if (!((_pane_isPanePresented = pane.isPanePresented) === null || _pane_isPanePresented === void 0 ? void 0 : _pane_isPanePresented.call(pane))) return; // this was the dismiss transition
                    sizeOverflow(pane, el);
                    onBreakChange === null || onBreakChange === void 0 ? void 0 : onBreakChange(pane.currentBreak());
                }, 0)
        }
    });
    disableLibraryKeyboardHandling(pane);
    pane._onDismiss = onDismiss;
    pane._reactOwnedParent = reactOwnedParent;
    // Stashed so a later resize (see watchMobilePaneResize) can recompute
    // breaks with the same function this pane was actually built with —
    // search uses computeSearchBreaks, everything else computeBreaks.
    pane._computeBreaksFn = computeBreaksFn;
    pane._breaksKey = JSON.stringify(breaks);
    return pane;
}
// Reverses the parentElement substitution above: destroy() (called with
// animate:false, so this runs synchronously — see destroyResets() in the
// library, reached with no prior await in that branch) puts el back under
// document.body, not React's real parent. Left there, React's next render
// of that parent won't find the child it expects and the tree desyncs.
function restoreToReactParent(pane, el) {
    if ((pane === null || pane === void 0 ? void 0 : pane._reactOwnedParent) && el.parentElement !== pane._reactOwnedParent) pane._reactOwnedParent.appendChild(el);
}
// destroy()'s promise resolves off a `transitionend` DOM event, which can
// resolve slightly out of step with the actual wrapper removal in
// destroyResets() (or, rarely, be delayed/dropped altogether — a known
// class of CSS transitionend flakiness). Waiting for that promise still
// isn't a hard guarantee no wrapper containing `el` remains in the DOM —
// and cupertino-pane's present() silently no-ops with just a console
// warning if it finds one, rather than erroring, so a still-there wrapper
// otherwise produces a "pane" that was never actually shown, with nothing
// pointing that out except a console message nobody's watching in
// production. Force the issue directly: before building a new pane,
// physically detach `el` from any wrapper still holding it.
function forceDetachStaleWrapper(el, fallbackParent) {
    document.querySelectorAll('.cupertino-pane-wrapper').forEach((wrapper)=>{
        if (wrapper.contains(el)) {
            (fallbackParent || document.body).appendChild(el);
            wrapper.remove();
        }
    });
}
function syncMobilePane(paneRef, el, shouldShow, { onDismiss, paneOptions, release, animate = true, waitFor } = {}) {
    // Bumped on every call, whether or not it ends up building anything —
    // this is what lets a later call cancel an earlier one's in-flight
    // teardown/rebuild chain below, however far it's gotten.
    const gen = (paneRef._gen || 0) + 1;
    paneRef._gen = gen;
    const prevPane = paneRef.current;
    paneRef.current = null;
    // Clear any measure-window hiding a superseded call left behind (see below).
    if (el) el.style.visibility = '';
    const settle = ()=>new Promise((resolve)=>{
            if (paneRef._gen !== gen) return resolve(); // superseded while we were tearing down
            if (!shouldShow || !el) {
                if (release) releaseToCSS(el);
                return resolve();
            }
            el.classList.add('pane-managed');
            // destroy() leaves this element's inline `display: none` behind —
            // normally only undone by a *subsequent* present(), which happens
            // after we've already measured it below. Left alone, every rebuild
            // past the first measures a display:none element (always 0
            // scrollHeight) and ends up with degenerate breaks.
            el.style.display = '';
            // Displayed but not visible: `.pane-managed` already dropped the element to
            // position:static, so until the CupertinoPane constructor re-hides it, it
            // paints as a plain block in normal flow — a two-frame flash on every
            // rebuild. visibility:hidden still measures, unlike display:none.
            el.style.visibility = 'hidden';
            // A stop/service/location switch commits its new content-driving state
            // in the same render that flips (or keeps) shouldShow true, but the
            // *children* rendering off that state (BusServicesArrival's own
            // data-dependent render) aren't guaranteed to have painted yet —
            // measuring synchronously here can catch the DOM mid-update, sometimes
            // seeing near-empty content and building a near-zero-height pane.
            // Waiting a couple of frames lets layout settle first.
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (paneRef._gen !== gen || !el.isConnected) {
                        el.style.visibility = '';
                        return resolve();
                    }
                    forceDetachStaleWrapper(el, prevPane === null || prevPane === void 0 ? void 0 : prevPane._reactOwnedParent);
                    // buildPane measures, then the constructor sets display:none — the
                    // library owns visibility from here, so drop our inline override.
                    const pane = buildPane(el, onDismiss, paneOptions);
                    el.style.visibility = '';
                    paneRef.current = pane;
                    pane.present({
                        animate
                    }).then(()=>{
                        if (paneRef.current === pane) sizeOverflow(pane, el);
                        resolve();
                    });
                });
            });
        });
    // Our own teardown is never a user dismiss, whether we're closing or just
    // rebuilding for new content — only a library-triggered destroy (a real
    // swipe past bottomClose) should reach the callback. Cleared synchronously,
    // before any waiting below.
    if (prevPane) prevPane._onDismiss = null;
    const run = ()=>{
        var _prevPane_isPanePresented;
        if (paneRef._gen !== gen) return Promise.resolve(); // superseded while held
        if (prevPane === null || prevPane === void 0 ? void 0 : (_prevPane_isPanePresented = prevPane.isPanePresented) === null || _prevPane_isPanePresented === void 0 ? void 0 : _prevPane_isPanePresented.call(prevPane)) // Wait for the old pane's destroy to actually finish (its own
        // present()-side warning: "specified selector or DOM element already
        // in use") before building a new one against the same element —
        // an *animated* destroy (a real close) takes ~300ms, but React can
        // fire the next "reopen with new content" effect within a couple of
        // frames of it starting. Racing a rebuild against that in-flight
        // teardown used to attach a second pane to an element whose old
        // wrapper hadn't been removed yet; present() would silently warn and
        // bail, leaving paneRef.current pointing at a pane that was never
        // actually shown.
        //
        // Animate only a real close: a rebuild wants the element free now, and a
        // release is handing it to desktop CSS — neither should slide out first.
        return prevPane.destroy({
            animate: animate && !shouldShow && !release
        }).then(()=>{
            restoreToReactParent(prevPane, el);
            return settle();
        });
        return settle();
    };
    return waitFor ? Promise.resolve(waitFor).then(run) : run();
}
function watchMobilePaneContent(paneRef, el) {
    if (!el || !window.MutationObserver) return ()=>{};
    const scrollEl = el.querySelector('[overflow-y]') || el;
    const reapply = (0, _mapOptimizations.rafThrottle)(()=>reapplyBreaks(paneRef, el));
    const observer = new MutationObserver(reapply);
    observer.observe(scrollEl, {
        childList: true,
        subtree: true,
        characterData: true
    });
    return ()=>{
        reapply.cancel();
        observer.disconnect();
    };
}
function watchMobilePaneResize(paneRef, el) {
    if (!el) return ()=>{};
    let lastWidth = window.innerWidth;
    const reapply = (0, _mapOptimizations.rafThrottle)(()=>reapplyBreaks(paneRef, el));
    const handler = ()=>{
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        reapply();
    };
    window.addEventListener('resize', handler);
    return ()=>{
        reapply.cancel();
        window.removeEventListener('resize', handler);
    };
}
function movePaneToBreak(paneRef, breakName) {
    var _pane_isPanePresented;
    const pane = paneRef.current;
    if (!(pane === null || pane === void 0 ? void 0 : (_pane_isPanePresented = pane.isPanePresented) === null || _pane_isPanePresented === void 0 ? void 0 : _pane_isPanePresented.call(pane))) return;
    if (pane.currentBreak() === breakName) return;
    // As on drag start: pre-grow so a move to a taller break reveals content,
    // not a blank strip. onTransitionEnd settles it to the destination.
    expandOverflow(pane, pane.el);
    pane.moveToBreak(breakName);
}

},{"cupertino-pane":"i8ZqG","./mapOptimizations":"kixUx","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"i8ZqG":[function(require,module,exports,__globalThis) {
/**
 * Cupertino Pane 1.5.4
 * Cupertino Panes is multi-functional modals, cards & panes with touch technologies.
 * https://panejs.com
 *
 * Copyright 2019-2025 Roman Antonov (roman-rr)
 *
 * Released under the MIT License
 *
 * Released on: August 27, 2025
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CupertinoPane", ()=>CupertinoPane);
function __awaiter(t, e, i, s) {
    return new (i || (i = Promise))(function(n, r) {
        function a(t) {
            try {
                h(s.next(t));
            } catch (t) {
                r(t);
            }
        }
        function o(t) {
            try {
                h(s.throw(t));
            } catch (t) {
                r(t);
            }
        }
        function h(t) {
            var e;
            t.done ? n(t.value) : (e = t.value, e instanceof i ? e : new i(function(t) {
                t(e);
            })).then(a, o);
        }
        h((s = s.apply(t, e || [])).next());
    });
}
"function" == typeof SuppressedError && SuppressedError;
class Support {
    static get touch() {
        return window.Modernizr && !0 === window.Modernizr.touch || !!(window.navigator.maxTouchPoints > 0 || "ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch);
    }
    static get observer() {
        return "MutationObserver" in window || "WebkitMutationObserver" in window;
    }
    static get backdropFilter() {
        return CSS.supports("backdrop-filter", "blur(0px)") || CSS.supports("-webkit-backdrop-filter", "blur(0px)");
    }
    static get passiveListener() {
        let t = !1;
        try {
            const e = Object.defineProperty({}, "passive", {
                get () {
                    t = !0;
                }
            });
            window.addEventListener("testPassiveListener", null, e);
        } catch (t) {}
        return t;
    }
    static get gestures() {
        return "ongesturestart" in window;
    }
}
class Device {
    constructor(){
        this.ios = !1, this.android = !1, this.androidChrome = !1, this.desktop = !1, this.iphone = !1, this.ipod = !1, this.ipad = !1, this.edge = !1, this.ie = !1, this.firefox = !1, this.macos = !1, this.windows = !1, this.cordova = !(!window.cordova && !window.phonegap), this.phonegap = !(!window.cordova && !window.phonegap), this.electron = !1, this.ionic = !!document.querySelector("ion-app");
        const t = window.navigator.platform, e = window.navigator.userAgent, i = window.screen.width, s = window.screen.height;
        let n = e.match(/(Android);?[\s\/]+([\d.]+)?/), r = e.match(/(iPad).*OS\s([\d_]+)/), a = e.match(/(iPod)(.*OS\s([\d_]+))?/), o = !this.ipad && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/), h = e.indexOf("MSIE ") >= 0 || e.indexOf("Trident/") >= 0, l = e.indexOf("Edge/") >= 0, c = e.indexOf("Gecko/") >= 0 && e.indexOf("Firefox/") >= 0, d = "Win32" === t, p = e.toLowerCase().indexOf("electron") >= 0, u = "MacIntel" === t;
        !r && u && Support.touch && (1024 === i && 1366 === s || 834 === i && 1194 === s || 834 === i && 1112 === s || 768 === i && 1024 === s) && (r = e.match(/(Version)\/([\d.]+)/), u = !1), this.ie = h, this.edge = l, this.firefox = c, n && !d && (this.os = "android", this.osVersion = n[2], this.android = !0, this.androidChrome = e.toLowerCase().indexOf("chrome") >= 0), (r || o || a) && (this.os = "ios", this.ios = !0), o && !a && (this.osVersion = o[2].replace(/_/g, "."), this.iphone = !0), r && (this.osVersion = r[2].replace(/_/g, "."), this.ipad = !0), a && (this.osVersion = a[3] ? a[3].replace(/_/g, ".") : null, this.ipod = !0), this.ios && this.osVersion && e.indexOf("Version/") >= 0 && "10" === this.osVersion.split(".")[0] && (this.osVersion = e.toLowerCase().split("version/")[1].split(" ")[0]), this.webView = !(!(o || r || a) || !e.match(/.*AppleWebKit(?!.*Safari)/i) && !window.navigator.standalone) || window.matchMedia && window.matchMedia("(display-mode: standalone)").matches, this.webview = this.webView, this.standalone = this.webView, this.desktop = !(this.ios || this.android) || p, this.desktop && (this.electron = p, this.macos = u, this.windows = d, this.macos && (this.os = "macos"), this.windows && (this.os = "windows")), this.pixelRatio = window.devicePixelRatio || 1;
    }
}
class Events {
    getTouchEvents() {
        const t = [
            "touchstart",
            "touchmove",
            "touchend",
            "touchcancel"
        ];
        let e = [
            "mousedown",
            "mousemove",
            "mouseup",
            "mouseleave"
        ];
        const i = {
            start: t[0],
            move: t[1],
            end: t[2],
            cancel: t[3]
        }, s = {
            start: e[0],
            move: e[1],
            end: e[2],
            cancel: e[3]
        };
        return Support.touch || !this.settings.simulateTouch ? i : s;
    }
    attachAllEvents() {
        if (this.settings.dragBy ? this.settings.dragBy.forEach((t)=>{
            const e = document.querySelector(t);
            e && this.eventListeners("addEventListener", e);
        }) : this.eventListeners("addEventListener", this.instance.paneEl), this.settings.topperOverflow && this.instance.overflowEl.addEventListener("scroll", this.onScrollCb), this.settings.handleKeyboard && this.device.cordova && (window.addEventListener("keyboardWillShow", this.keyboardEvents.onKeyboardShowCb), window.addEventListener("keyboardWillHide", this.keyboardEvents.onKeyboardWillHideCb)), this.device.ionic && this.device.android) document.querySelectorAll(".ion-page").forEach((t)=>{
            t.addEventListener("scroll", (e)=>{
                t.scrollTop && t.scrollTo({
                    top: 0
                });
            });
        });
        window.addEventListener("resize", this.resizeEvents.onWindowResizeCb);
    }
    detachAllEvents() {
        this.settings.dragBy ? this.settings.dragBy.forEach((t)=>{
            const e = document.querySelector(t);
            e && this.eventListeners("removeEventListener", e);
        }) : this.eventListeners("removeEventListener", this.instance.paneEl), this.settings.topperOverflow && this.instance.overflowEl.removeEventListener("scroll", this.onScrollCb), this.settings.handleKeyboard && this.device.cordova && (window.removeEventListener("keyboardWillShow", this.keyboardEvents.onKeyboardShowCb), window.removeEventListener("keyboardWillHide", this.keyboardEvents.onKeyboardWillHideCb)), window.removeEventListener("resize", this.resizeEvents.onWindowResizeCb);
    }
    resetEvents() {
        this.detachAllEvents(), this.attachAllEvents();
    }
    eventListeners(t, e) {
        if (Support.touch) {
            const i = !("touchstart" !== this.touchEvents.start || !Support.passiveListener || !this.settings.passiveListeners) && {
                passive: !0,
                capture: !1
            };
            e[t](this.touchEvents.start, this.touchStartCb, i), e[t](this.touchEvents.move, this.touchMoveCb, !!Support.passiveListener && {
                passive: !1,
                capture: !1
            }), e[t](this.touchEvents.end, this.touchEndCb, i), e[t](this.touchEvents.cancel, this.touchEndCb, i);
        } else e[t](this.touchEvents.start, this.touchStartCb, !1), e[t](this.touchEvents.move, this.touchMoveCb, !1), e[t](this.touchEvents.end, this.touchEndCb, !1), e[t](this.touchEvents.cancel, this.touchEndCb, !1);
        this.settings.preventClicks && e[t]("click", this.onClickCb, !0);
    }
    touchStart(t) {
        if (this.instance.emit("onDragStart", t), this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = null, this.pendingMoveData = null), this.allowClick = !0, this.instance.disableDragEvents) return;
        this.disableDragAngle = !1, this.isScrolling = !1, this.instance.preventedDismiss = !1;
        const { clientY: e, clientX: i } = this.getEventClientYX(t, "touchstart");
        e && i && (this.startY = e, this.startX = i, "mousedown" === t.type && (this.mouseDown = !0), this.contentScrollTop && this.willScrolled() && !this.isDraggableElement(t) && (this.startY += this.contentScrollTop), this.steps.push({
            posY: this.startY,
            posX: this.startX,
            time: Date.now()
        }));
    }
    touchMove(t) {
        var e, i;
        if (this.instance.disableDragEvents) return void (this.steps = []);
        const { clientY: s, clientX: n, velocityY: r } = this.getEventClientYX(t, "touchmove");
        if (!s || !n) return;
        if ("mousemove" === t.type && !this.mouseDown) return;
        if (this.instance.disableDragEvents) return void (this.steps = []);
        if (this.steps.length || this.steps.push({
            posY: s,
            posX: n,
            time: Date.now()
        }), t.delta = (null === (e = this.steps[0]) || void 0 === e ? void 0 : e.posY) - s, this.allowClick = !1, this.isFormElement(t.target) && this.isElementScrollable(t.target)) return;
        if (this.disableDragAngle) return;
        if (this.instance.preventedDismiss) return;
        if (this.settings.touchMoveStopPropagation && t.stopPropagation(), 0 === this.contentScrollTop && "auto" === this.instance.overflowEl.style.overflowY && this.isElementScrollable(this.instance.overflowEl) && !this.isDraggableElement(t)) {
            const t = s - (null === (i = this.steps[this.steps.length - 1]) || void 0 === i ? void 0 : i.posY) || 0;
            if (!this.settings.scrollZeroDragBottom) return;
            if (t < 0) return;
        }
        const a = s - this.steps[this.steps.length - 1].posY, o = n - this.steps[this.steps.length - 1].posX;
        if (!Math.abs(a) && !Math.abs(o)) return;
        this.instance.emit("onDrag", t), this.instance.setGrabCursor(!0, !0);
        const h = this.instance.getPanelTransformY(), l = this.instance.getPanelTransformX();
        let c = h + a, d = l + o;
        if (this.steps.length < 2) {
            r < 1 && (c = h + a * r);
            let t = this.instance.parseTransform3d(this.instance.paneEl).y - h;
            Math.abs(t) && (c += t);
        }
        if (this.steps.length > 2 && this.isFormElement(document.activeElement) && !this.isFormElement(t.target) && (document.activeElement.blur(), this.keyboardEvents.inputBluredbyMove = !0), this.settings.touchAngle && !this.isScrolling) {
            let t;
            const e = n - this.startX, i = s - this.startY;
            if (t = 180 * Math.atan2(Math.abs(i), Math.abs(e)) / Math.PI, e * e + i * i >= 25 && 90 - t > this.settings.touchAngle && 1 === this.steps.length) return void (this.disableDragAngle = !0);
        }
        if ("auto" === this.instance.overflowEl.style.overflowY && this.scrollPreventDrag(t) && !this.isDraggableElement(t)) return;
        let p = this.handleSuperposition({
            clientX: n,
            clientY: s,
            newVal: c,
            newValX: d,
            diffY: a,
            diffX: o
        });
        if (p && (isNaN(p.y) || (c = p.y), isNaN(p.x) || (d = p.x)), !1 !== p && (h !== c || l !== d)) {
            if (!this.instance.preventedDismiss && this.instance.preventDismissEvent && this.settings.bottomClose) {
                if (c = h + a * (.5 - (-this.breakpoints.topper + this.breakpoints.topper - h) / this.breakpoints.topper / -8), -1 * (s - 220 - this.instance.screen_height) <= this.instance.screen_height - this.breakpoints.bottomer) return this.instance.preventedDismiss = !0, this.instance.emit("onWillDismiss", {
                    prevented: !0
                }), void this.instance.moveToBreak(this.breakpoints.prevBreakpoint);
            }
            this.pendingMoveData = {
                newVal: c,
                newValX: d,
                clientY: s,
                clientX: n
            }, this.rafId || (this.rafId = requestAnimationFrame(()=>this.applyMoveUpdate())), this.steps.push({
                posY: s,
                posX: n,
                time: Date.now()
            });
        }
    }
    applyMoveUpdate() {
        if (!this.pendingMoveData) return void (this.rafId = null);
        const { newVal: t, newValX: e } = this.pendingMoveData;
        this.instance.checkOpacityAttr(t), this.instance.checkOverflowAttr(t), this.transitions.doTransition({
            type: "move",
            translateY: t,
            translateX: e
        }), this.pendingMoveData = null, this.rafId = null;
    }
    touchEnd(t) {
        var e, i;
        return __awaiter(this, void 0, void 0, function*() {
            if (this.instance.disableDragEvents) return;
            if (this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = null, this.pendingMoveData && this.applyMoveUpdate()), "mouseleave" === t.type && !this.mouseDown) return;
            if ("mouseup" === t.type || "mouseleave" === t.type) {
                this.mouseDown = !1;
                let t = this.transitions.buildTransitionValue(!1, this.settings.animationDuration);
                this.instance.paneEl.style.setProperty("transition", t), this.instance.paneEl.offsetHeight;
            }
            let s, n = this.breakpoints.getClosestBreakY();
            const r = !this.allowClick && this.steps.length >= 2;
            r && this.fastSwipeNext("Y") && (n = this.instance.swipeNextPoint((null === (e = this.steps[this.steps.length - 1]) || void 0 === e ? void 0 : e.posY) - (null === (i = this.steps[this.steps.length - 2]) || void 0 === i ? void 0 : i.posY), this.swipeNextSensivity, n), s = this.settings.fastSwipeClose && this.breakpoints.currentBreakpoint < n), r && (this.breakpoints.currentBreakpoint = n);
            let a = !1;
            if (this.isFormElement(document.activeElement) && !this.isFormElement(t.target) && 2 === this.steps.length && (a = !0), this.instance.emit("onDragEnd", t), this.steps = [], delete this.startPointOverTop, this.allowClick || a) return;
            if (s) return void this.instance.destroy({
                animate: !0
            });
            if (this.instance.checkOpacityAttr(n), this.instance.checkOverflowAttr(n), this.instance.setGrabCursor(!0, !1), this.settings.bottomClose && n === this.breakpoints.breaks.bottom) return void this.instance.destroy({
                animate: !0
            });
            this.instance.getPanelTransformY() === n && this.instance.emit("onTransitionEnd", {
                target: this.instance.paneEl
            });
            const o = this.instance.getPanelTransformX();
            this.transitions.doTransition({
                type: "end",
                translateY: n,
                translateX: o
            });
        });
    }
    onScroll(t) {
        return __awaiter(this, void 0, void 0, function*() {
            this.isScrolling = !0, this.contentScrollTop = t.target.scrollTop, this.contentScrollTop > 0 ? this.instance.paneEl.classList.add("scrolled") : this.instance.paneEl.classList.remove("scrolled");
        });
    }
    onClick(t) {
        if (this.allowClick) {
            if (!this.device.cordova && this.device.android && this.isFormElement(t.target)) this.keyboardEvents.onKeyboardShowCb({
                keyboardHeight: this.instance.screen_height - window.innerHeight
            });
            else if (this.settings.clickBottomOpen) {
                if (this.isFormElement(document.activeElement)) return;
                if (this.breakpoints.breaks.bottom === this.instance.getPanelTransformY()) {
                    let t;
                    this.settings.breaks.top.enabled && (t = "top"), this.settings.breaks.middle.enabled && (t = "middle"), this.instance.moveToBreak(t);
                }
            }
        } else this.settings.preventClicks && (t.preventDefault(), t.stopPropagation(), t.stopImmediatePropagation());
    }
    fastSwipeNext(t) {
        var e, i;
        if (this.allowClick) return !1;
        if (this.steps.length < 2) return !1;
        const s = this.steps[this.steps.length - 1], n = this.steps[this.steps.length - 2], r = (null !== (e = null == s ? void 0 : s["pos" + t]) && void 0 !== e ? e : 0) - (null !== (i = null == n ? void 0 : n["pos" + t]) && void 0 !== i ? i : 0);
        return !!Number.isFinite(r) && Math.abs(r) >= this.swipeNextSensivity;
    }
    handleSuperposition(t) {
        if (!this.settings.upperThanTop && (t.newVal <= this.breakpoints.topper || t.clientY <= this.breakpoints.topper && !this.settings.zStack)) return this.steps = [], {
            y: this.breakpoints.topper
        };
        if (this.settings.upperThanTop && (t.newVal <= this.breakpoints.topper || this.startPointOverTop)) {
            this.startPointOverTop || (this.startPointOverTop = t.clientY), this.startPointOverTop < t.clientY && delete this.startPointOverTop;
            const e = this.instance.screen_height - this.instance.screenHeightOffset, i = (e - this.instance.getPanelTransformY()) / (e - this.breakpoints.topper) / 8;
            return {
                y: this.instance.getPanelTransformY() + t.diffY * i
            };
        }
        return !this.settings.lowerThanBottom && t.newVal >= this.breakpoints.bottomer ? {
            y: this.breakpoints.bottomer
        } : void 0;
    }
    getEventClientYX(t, e) {
        var i, s;
        const n = t.type === e && t.targetTouches && (t.targetTouches[0] || t.changedTouches[0]), r = t.type === e ? null == n ? void 0 : n.clientY : t.clientY, a = t.type === e ? null == n ? void 0 : n.clientX : t.clientX, o = Date.now() - ((null === (i = this.steps[this.steps.length - 1]) || void 0 === i ? void 0 : i.time) || 0);
        return {
            clientY: r,
            clientX: a,
            velocityY: Math.abs(r - ((null === (s = this.steps[this.steps.length - 1]) || void 0 === s ? void 0 : s.posY) || 0)) / o
        };
    }
    scrollPreventDrag(t) {
        let e = !1;
        return this.contentScrollTop > 0 && (e = !0), e;
    }
    willScrolled() {
        return !(!this.isElementScrollable(this.instance.overflowEl) || "hidden" === this.instance.overflowEl.style.overflow);
    }
    isDraggableElement(t) {
        return t.target === this.instance.draggableEl || t.target === this.instance.moveEl;
    }
    isFormElement(t) {
        return !!(t && t.tagName && [
            "input",
            "select",
            "option",
            "textarea",
            "button",
            "label"
        ].includes(t.tagName.toLowerCase()));
    }
    isElementScrollable(t) {
        return t.scrollHeight > t.clientHeight;
    }
    constructor(t){
        this.instance = t, this.allowClick = !0, this.disableDragAngle = !1, this.mouseDown = !1, this.contentScrollTop = 0, this.steps = [], this.isScrolling = !1, this.rafId = null, this.pendingMoveData = null, this.touchStartCb = (t)=>this.touchStart(t), this.touchMoveCb = (t)=>this.touchMove(t), this.touchEndCb = (t)=>this.touchEnd(t), this.onScrollCb = (t)=>this.onScroll(t), this.onClickCb = (t)=>this.onClick(t), this.settings = this.instance.settings, this.device = this.instance.device, this.breakpoints = this.instance.breakpoints, this.transitions = this.instance.transitions, this.keyboardEvents = this.instance.keyboardEvents, this.resizeEvents = this.instance.resizeEvents, this.touchEvents = this.getTouchEvents(), this.swipeNextSensivity = window.hasOwnProperty("cordova") ? this.settings.fastSwipeSensivity + 2 : this.settings.fastSwipeSensivity;
    }
}
class KeyboardEvents {
    onKeyboardShow(t) {
        return __awaiter(this, void 0, void 0, function*() {
            if (!this.isPaneDescendant(document.activeElement)) return;
            if (!this.isOnViewport()) return;
            this.keyboardVisibleResize = !0, this.fixBodyKeyboardResize(!0);
            let e = -1 * (this.instance.getPanelTransformY() - this.instance.screen_height);
            const i = document.activeElement, s = this.getActiveInputClientBottomRect(), n = this.instance.screen_height - s - this.inputBottomOffset;
            let r = this.device.cordova && this.device.android ? 130 : 100, a = 0, o = e + (t.keyboardHeight - n);
            if (this.prevNewHeight && (a = this.previousInputBottomOffset - s, o = this.prevNewHeight), !i.isEqualNode(this.prevFocusedElement) && t.keyboardHeight > n) {
                this.prevNewHeight = o - a, this.prevFocusedElement = document.activeElement;
                let e = o - a + r;
                e > this.instance.getPaneHeight() + t.keyboardHeight && (e = this.instance.getPaneHeight() + t.keyboardHeight), yield this.instance.moveToHeight(e);
                const i = this.getActiveInputClientBottomRect();
                this.previousInputBottomOffset = i, this.inputBottomOffset || (this.inputBottomOffset = s - i);
            }
        });
    }
    onKeyboardWillHide(t) {
        this.isOnViewport() && (this.fixBodyKeyboardResize(!1), this.inputBottomOffset = 0, this.previousInputBottomOffset = 0, this.prevNewHeight = 0, delete this.prevFocusedElement, this.inputBluredbyMove ? this.inputBluredbyMove = !1 : this.instance.isHidden() || this.instance.getPanelTransformY() !== this.breakpoints.breaks[this.breakpoints.prevBreakpoint] && this.instance.moveToBreak(this.breakpoints.prevBreakpoint));
    }
    handleKeyboardFromResize(t) {
        return this.isFormElement(document.activeElement) ? (this.device.cordova || this.onKeyboardShow({
            keyboardHeight: this.instance.screen_height - window.innerHeight
        }), !0) : !!this.keyboardVisibleResize && (this.keyboardVisibleResize = !1, this.device.cordova || this.onKeyboardWillHide({}), !0);
    }
    isPaneDescendant(t) {
        if (!t) return !1;
        let e = t.parentNode;
        for(; null != e;){
            if (e == this.instance.paneEl) return !0;
            e = e.parentNode;
        }
        return !1;
    }
    isFormElement(t) {
        return !!(t && t.tagName && [
            "input",
            "select",
            "option",
            "textarea",
            "button",
            "label"
        ].includes(t.tagName.toLowerCase()));
    }
    isOnViewport() {
        return !this.instance.paneEl || 0 !== this.instance.paneEl.offsetWidth || 0 !== this.instance.paneEl.offsetHeight;
    }
    getActiveInputClientBottomRect() {
        var t, e;
        if (document.activeElement.classList.contains("native-textarea") || document.activeElement.classList.contains("native-input")) return (null === (e = null === (t = document.activeElement.parentElement) || void 0 === t ? void 0 : t.parentElement) || void 0 === e ? void 0 : e.parentElement).getBoundingClientRect().bottom;
        return document.activeElement.getBoundingClientRect().bottom;
    }
    fixBodyKeyboardResize(t) {
        if (!this.instance.paneEl) return;
        const e = document.querySelector("meta[name=viewport]");
        window.requestAnimationFrame(()=>{
            t ? (document.documentElement.style.setProperty("overflow", "hidden"), document.body.style.setProperty("min-height", `${this.instance.screen_height}px`), e.setAttribute("content", "height=" + this.instance.screen_height + ", width=device-width, initial-scale=1.0")) : (document.documentElement.style.removeProperty("overflow"), document.body.style.removeProperty("min-height"), e.setAttribute("content", "viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"));
        });
    }
    constructor(t){
        this.instance = t, this.inputBluredbyMove = !1, this.keyboardVisibleResize = !1, this.inputBottomOffset = 0, this.previousInputBottomOffset = 0, this.prevNewHeight = 0, this.onKeyboardShowCb = (t)=>this.onKeyboardShow(t), this.onKeyboardWillHideCb = (t)=>this.onKeyboardWillHide(t), this.device = this.instance.device, this.breakpoints = this.instance.breakpoints;
    }
}
class ResizeEvents {
    onWindowResize(t) {
        return __awaiter(this, void 0, void 0, function*() {
            this.instance.keyboardEvents.handleKeyboardFromResize(t), this.instance.updateScreenHeights(), this.rafId && cancelAnimationFrame(this.rafId), this.rafId = requestAnimationFrame(()=>{
                this.breakpoints.buildBreakpoints(JSON.parse(this.breakpoints.lockedBreakpoints)), this.rafId = null;
            });
        });
    }
    isFormElement(t) {
        return !!(t && t.tagName && [
            "input",
            "select",
            "option",
            "textarea",
            "button",
            "label"
        ].includes(t.tagName.toLowerCase()));
    }
    constructor(t){
        this.instance = t, this.rafId = null, this.onWindowResizeCb = (t)=>this.onWindowResize(t), this.device = this.instance.device, this.breakpoints = this.instance.breakpoints;
    }
}
class Settings {
    constructor(){
        this.instance = {
            initialBreak: "middle",
            horizontal: !1,
            horizontalOffset: null,
            inverse: !1,
            parentElement: null,
            followerElement: null,
            cssClass: null,
            fitHeight: !1,
            maxFitHeight: null,
            fitScreenHeight: !0,
            ionContentScroll: !1,
            backdrop: !1,
            backdropBlur: !1,
            backdropOpacity: .6,
            animationType: "ease",
            animationDuration: 300,
            dragBy: null,
            bottomOffset: 0,
            bottomClose: !1,
            fastSwipeClose: !1,
            fastSwipeSensivity: 3,
            freeMode: !1,
            buttonDestroy: !0,
            topperOverflow: !0,
            topperOverflowOffset: 0,
            lowerThanBottom: !0,
            upperThanTop: !1,
            showDraggable: !0,
            draggableOver: !1,
            clickBottomOpen: !0,
            preventClicks: !0,
            handleKeyboard: !0,
            simulateTouch: !0,
            passiveListeners: !0,
            touchMoveStopPropagation: !1,
            touchAngle: 45,
            scrollZeroDragBottom: !0,
            breaks: {},
            modal: null,
            zStack: null,
            events: null,
            modules: null
        };
    }
}
class Breakpoints {
    buildBreakpoints(t, e = 0, i = !0) {
        var s, n;
        return __awaiter(this, void 0, void 0, function*() {
            if (this.breaks = Object.create(null), this.conf = t, this.settings.bottomOffset = e || this.settings.bottomOffset, yield this.beforeBuildBreakpoints(), [
                "top",
                "middle",
                "bottom"
            ].forEach((t)=>{
                var e;
                this.settings.breaks[t] || (this.settings.breaks[t] = this.defaultBreaksConf[t]), this.conf && this.conf[t] && (this.settings.breaks[t] = this.conf[t]), this.instance.emit("beforeBreakHeightApplied", {
                    break: t
                }), (null === (e = this.settings.breaks[t]) || void 0 === e ? void 0 : e.enabled) && (this.breaks[t] = this.instance.screenHeightOffset, this.breaks[t] -= this.settings.bottomOffset, this.breaks[t] -= this.settings.breaks[t].height);
            }), this.lockedBreakpoints || (this.lockedBreakpoints = JSON.stringify(this.settings.breaks)), this.instance.isPanePresented() || this.settings.breaks[this.settings.initialBreak].enabled || console.warn("Cupertino Pane: Please set initialBreak for enabled breakpoint"), this.settings.breaks.middle.height >= this.settings.breaks.top.height && console.warn("Cupertino Pane: Please set middle height lower than top height"), this.settings.breaks.middle.height <= this.settings.breaks.bottom.height && console.warn("Cupertino Pane: Please set bottom height lower than middle height"), this.brs = [], [
                "top",
                "middle",
                "bottom"
            ].forEach((t)=>{
                this.settings.breaks[t].enabled && this.brs.push(this.breaks[t]);
            }), this.topper = this.brs.reduce((t, e)=>e < t ? e : t), this.bottomer = this.brs.reduce((t, e)=>Math.abs(e) > Math.abs(t) ? e : t), this.instance.isPanePresented() || (this.currentBreakpoint = this.breaks[this.settings.initialBreak]), this.instance.isPanePresented() && ((null === (s = this.settings.breaks[this.prevBreakpoint]) || void 0 === s ? void 0 : s.enabled) && (this.instance.isHidden() || this.instance.moveToBreak(this.prevBreakpoint, i ? "breakpoint" : "move")), !(null === (n = this.settings.breaks[this.prevBreakpoint]) || void 0 === n ? void 0 : n.enabled) && !this.instance.isHidden())) {
                let t = this.instance.swipeNextPoint(1, 1, this.getClosestBreakY());
                const e = Object.entries(this.breaks).find((e)=>e[1] === t);
                this.instance.moveToBreak(e[0]);
            }
            this.instance.scrollElementInit(), this.instance.checkOpacityAttr(this.currentBreakpoint), this.instance.checkOverflowAttr(this.currentBreakpoint), this.instance.emit("buildBreakpointsCompleted");
        });
    }
    getCurrentBreakName() {
        return this.breaks.top === this.currentBreakpoint ? "top" : this.breaks.middle === this.currentBreakpoint ? "middle" : this.breaks.bottom === this.currentBreakpoint ? "bottom" : null;
    }
    getClosestBreakY() {
        const t = this.instance.getPanelTransformY();
        return this.brs.reduce((e, i)=>Math.abs(i - t) < Math.abs(e - t) ? i : e);
    }
    constructor(t){
        this.instance = t, this.breaks = {}, this.brs = [], this.beforeBuildBreakpoints = ()=>{}, this.defaultBreaksConf = {
            top: {
                enabled: !0,
                height: window.innerHeight - 47.25
            },
            middle: {
                enabled: !0,
                height: 300
            },
            bottom: {
                enabled: !0,
                height: 100
            }
        }, this.settings = this.instance.settings;
    }
}
var CupertinoTransition;
!function(t) {
    t.Present = "present", t.Destroy = "destroy", t.Move = "move", t.Breakpoint = "breakpoint", t.Hide = "hide", t.TouchEnd = "end";
}(CupertinoTransition || (CupertinoTransition = {}));
class Transitions {
    doTransition(t = {}) {
        return new Promise((e)=>__awaiter(this, void 0, void 0, function*() {
                var i, s;
                if (t.type === CupertinoTransition.Move) return this.instance.emit("onMoveTransitionStart", {
                    translateY: t.translateY
                }), "all 0ms linear 0ms" !== this.instance.paneEl.style.transition && (this.instance.paneEl.style.transition = "all 0ms linear 0ms"), this.setPaneElTransform(t), e(!0);
                const n = ()=>(t.type === CupertinoTransition.Destroy && this.instance.destroyResets(), this.instance.paneEl.style.transition = "initial", t.type === CupertinoTransition.Hide && (this.isPaneHidden = !0), t.type !== CupertinoTransition.Breakpoint && t.type !== CupertinoTransition.Present && t.type !== CupertinoTransition.TouchEnd || (this.isPaneHidden = !1), t.type !== CupertinoTransition.Hide && t.type !== CupertinoTransition.Destroy || !this.instance.ionContent || this.settings.ionContentScroll || this.doesPanesExists() || this.instance.ionContent.setAttribute("scroll-y", "true"), this.instance.emit("onTransitionEnd", {
                        type: t.type,
                        target: document.body.contains(this.instance.paneEl) ? this.instance.paneEl : null
                    }), this.instance.paneEl.removeEventListener("transitionend", n), e(!0));
                if (t.type === CupertinoTransition.Breakpoint || t.type === CupertinoTransition.TouchEnd || t.type === CupertinoTransition.Present || t.type === CupertinoTransition.Hide || t.type === CupertinoTransition.Destroy) {
                    let r = (null === (i = t.conf) || void 0 === i ? void 0 : i.transition) ? JSON.parse(JSON.stringify(t.conf.transition)) : {};
                    if (t.type === CupertinoTransition.TouchEnd && this.settings.freeMode) return e(!0);
                    const a = Object.entries(this.breakpoints.breaks).find((e)=>e[1] === t.translateY);
                    let o = a && (null === (s = this.settings.breaks[a[0]]) || void 0 === s ? void 0 : s.bounce), h = this.buildTransitionValue(o, r.duration);
                    if (this.instance.paneEl.style.setProperty("transition", h), this.instance.emit("onTransitionStart", {
                        type: t.type,
                        translateY: {
                            new: t.translateY
                        },
                        transition: this.instance.paneEl.style.transition
                    }), this.setPaneElTransform(t), r.to) {
                        if (!r.to.transform) {
                            const t = this.breakpoints.breaks[this.settings.initialBreak];
                            r.to.transform = this.instance.buildTransform3d(0, t, 0);
                        }
                        Object.assign(this.instance.paneEl.style, r.to);
                    }
                    let l = Object.entries(this.breakpoints.breaks).find((e)=>e[1] === t.translateY);
                    l && (this.breakpoints.prevBreakpoint = l[0]), this.instance.paneEl.addEventListener("transitionend", n);
                }
            }));
    }
    setPaneElTransform(t) {
        this.instance.currentTranslateY = t.translateY;
        const e = this.instance.buildTransform3d(this.instance.currentTranslateX, this.instance.currentTranslateY, 0);
        this.instance.paneEl.style.transform = e;
    }
    buildTransitionValue(t, e) {
        return t ? "all 300ms cubic-bezier(.155,1.105,.295,1.12)" : `all ${e || this.settings.animationDuration}ms ${this.settings.animationType}`;
    }
    doesPanesExists() {
        return !!document.querySelector(".cupertino-pane-wrapper");
    }
    constructor(t){
        this.instance = t, this.isPaneHidden = !1, this.settings = this.instance.settings, this.breakpoints = this.instance.breakpoints;
    }
}
function on(t, e, i) {
    if (!this.eventsListeners) return;
    if ("function" != typeof e) return;
    const s = i ? "unshift" : "push";
    t.split(" ").forEach((t)=>{
        this.eventsListeners[t] || (this.eventsListeners[t] = []), this.eventsListeners[t][s](e);
    });
}
function emit(...t) {
    if (!this.eventsListeners) return;
    let e = t[0], i = t.slice(1, t.length);
    (Array.isArray(e) ? e : e.split(" ")).forEach((t)=>{
        var e;
        (null === (e = this.eventsListeners) || void 0 === e ? void 0 : e[t]) && this.eventsListeners[t].forEach((t)=>t.apply(this, i));
    });
}
class ZStackModule {
    setZstackConfig(t) {
        this.settings.zStack = t ? Object.assign(Object.assign({}, this.zStackDefaults), t) : null;
    }
    pushTransition(t, e, i) {
        let s = this.settings.zStack.pushElements;
        t.style.transition = i, t.style.overflow = this.settings.zStack.cardBorderRadius && "hidden", e = this.instance.screenHeightOffset - e;
        const n = this.settings.zStack.minPushHeight ? this.settings.zStack.minPushHeight : this.instance.screenHeightOffset - this.breakpoints.bottomer, r = this.instance.screenHeightOffset - this.breakpoints.topper;
        let a = this.getPushMulitplicator(t), o = Math.pow(this.settings.zStack.cardZScale, a), h = Math.pow(this.settings.zStack.cardZScale, a - 1), l = 6 + this.settings.zStack.cardYOffset, c = l * a * -1, d = c + l, p = Math.pow(this.settings.zStack.cardContrast, a), u = Math.pow(this.settings.zStack.cardContrast, a - 1);
        const g = (i, n, r, a)=>{
            let o = Math.pow(i, this.settings.zStack.stackZAngle / 100);
            t.style.transform = this.instance.buildTransform3dWithScale(0, n * (o / i), 0, i), t.style.borderRadius = `${a}px`, t.style.filter = `contrast(${r})`;
            let h = document.querySelector(s[s.length - 1]);
            e || t.className !== h.className || this.clearPushMultiplicators();
        };
        if (e <= n) return void g(h, d, u, 0);
        const b = (t, i)=>{
            let s = -1 * (r * i - n * t);
            return s -= (t - i) * e, s /= n - r, s > i && (s = i), s < t && (s = t), s;
        };
        g(b(o, h), b(c, d), b(p, u), -1 * b(-1 * this.settings.zStack.cardBorderRadius, 0));
    }
    setPushMultiplicators() {
        this.settings.zStack.pushElements.forEach((t)=>{
            let e = document.querySelector(t), i = this.getPushMulitplicator(e);
            i = i ? i + 1 : 1, e.style.setProperty("--push-multiplicator", `${i}`);
        });
    }
    getPushMulitplicator(t) {
        let e = t.style.getPropertyValue("--push-multiplicator");
        return parseInt(e);
    }
    clearPushMultiplicators() {
        for(let t = 0; t < this.settings.zStack.pushElements.length; t++){
            let e = document.querySelector(this.settings.zStack.pushElements[t]), i = this.getPushMulitplicator(e);
            i -= 1, i ? e.style.setProperty("--push-multiplicator", `${i}`) : e.style.removeProperty("--push-multiplicator");
        }
    }
    constructor(t){
        this.instance = t, this.zStackDefaults = {
            pushElements: null,
            minPushHeight: null,
            cardBorderRadius: null,
            cardYOffset: 0,
            cardZScale: .93,
            cardContrast: .85,
            stackZAngle: 160
        }, this.breakpoints = this.instance.breakpoints, this.settings = this.instance.settings, this.settings.zStack && (this.instance.setZstackConfig = (t)=>__awaiter(this, void 0, void 0, function*() {
                return this.setZstackConfig(t);
            }), this.instance.on("rendered", ()=>{
            this.setZstackConfig(this.settings.zStack), this.setPushMultiplicators();
        }), this.instance.on("beforePresentTransition", (t)=>{
            t.animate || this.settings.zStack.pushElements.forEach((t)=>this.pushTransition(document.querySelector(t), this.breakpoints.breaks[this.settings.initialBreak], "unset"));
        }), this.instance.on("onMoveTransitionStart", ()=>{
            this.settings.zStack.pushElements.forEach((t)=>this.pushTransition(document.querySelector(t), this.instance.getPanelTransformY(), "all 0ms linear 0ms"));
        }), this.instance.on("onTransitionStart", (t)=>{
            this.settings.zStack.pushElements.forEach((e)=>this.pushTransition(document.querySelector(e), t.translateY.new, `all ${this.settings.animationDuration}ms ${this.settings.animationType} 0s`));
        }));
    }
}
class FollowerModule {
    constructor(t){
        this.instance = t, this.breakpoints = this.instance.breakpoints, this.transitions = this.instance.transitions, this.settings = this.instance.settings, this.settings.followerElement && (this.instance.on("rendered", ()=>{
            var t;
            document.querySelector(this.settings.followerElement) ? (this.followerEl = document.querySelector(this.settings.followerElement), this.followerEl.style.willChange = "transform, border-radius", this.followerEl.style.transform = this.instance.buildTransform3d(0, 0, 0), this.followerEl.style.transition = this.transitions.buildTransitionValue(null === (t = this.settings.breaks[this.instance.currentBreak()]) || void 0 === t ? void 0 : t.bounce)) : console.warn("Cupertino Pane: wrong follower element selector specified", this.settings.followerElement);
        }), this.instance.on("onMoveTransitionStart", (t)=>{
            this.followerEl.style.transition = "all 0ms linear 0ms", this.followerEl.style.transform = this.instance.buildTransform3d(0, t.translateY - this.breakpoints.breaks[this.settings.initialBreak], 0);
        }), this.instance.on("onMoveTransitionStart", (t)=>{
            this.followerEl.style.transition = "initial";
        }), this.instance.on("onTransitionStart", (t)=>{
            this.followerEl.style.transition = t.transition, this.followerEl.style.transform = this.instance.buildTransform3d(0, t.translateY.new - this.breakpoints.breaks[this.settings.initialBreak], 0);
        }));
    }
}
class BackdropModule {
    backdrop(t = {
        show: !0
    }) {
        var e, i;
        if (!this.instance.isPanePresented()) return console.warn("Cupertino Pane: Present pane before call backdrop()"), null;
        this.isBackdropPresented() || (this.renderBackdrop(), Support.touch && (null === (e = this.backdropEl) || void 0 === e || e.removeEventListener(this.events.touchEvents.move, this.touchMoveBackdropCb), null === (i = this.backdropEl) || void 0 === i || i.addEventListener(this.events.touchEvents.move, this.touchMoveBackdropCb, !!Support.passiveListener && {
            passive: !1,
            capture: !1
        })));
        const s = ()=>{
            this.backdropEl.style.transition = "initial", this.backdropEl.style.display = "none", this.backdropEl.removeEventListener("transitionend", s);
        };
        if (this.backdropEl.style.transition = `all ${this.settings.animationDuration}ms ${this.settings.animationType} 0s`, this.backdropEl.style.backgroundColor = "rgba(0,0,0,.0)", t.show) this.backdropEl.style.display = "block", setTimeout(()=>{
            this.backdropEl.style.backgroundColor = `rgba(0,0,0, ${this.settings.backdropOpacity})`;
        }, 50);
        else {
            if ("none" === this.backdropEl.style.display) return;
            this.backdropEl.addEventListener("transitionend", s);
        }
    }
    renderBackdrop() {
        this.backdropEl = document.createElement("div"), this.backdropEl.classList.add("backdrop"), this.backdropEl.style.transition = `all ${this.settings.animationDuration}ms ${this.settings.animationType} 0s`, this.backdropEl.style.backgroundColor = `rgba(0,0,0, ${this.settings.backdropOpacity})`, this.instance.wrapperEl.appendChild(this.backdropEl), this.backdropEl.addEventListener("click", (t)=>this.instance.emit("onBackdropTap", t));
    }
    isBackdropPresented() {
        return !!document.querySelector(".cupertino-pane-wrapper .backdrop");
    }
    touchMoveBackdrop(t) {
        this.settings.touchMoveStopPropagation && t.stopPropagation();
    }
    constructor(t){
        this.instance = t, this.touchMoveBackdropCb = (t)=>this.touchMoveBackdrop(t), this.settings = this.instance.settings, this.events = this.instance.events, this.settings.backdrop && (this.instance.backdrop = (t)=>this.backdrop(t), this.instance.on("rendered", ()=>{
            this.instance.addStyle(`\n        .cupertino-pane-wrapper .backdrop {\n          overflow: hidden;\n          position: fixed;\n          width: 100%;\n          bottom: 0;\n          right: 0;\n          left: 0;\n          top: 0;\n          display: none;\n          z-index: 10;\n          ${Support.backdropFilter && this.settings.backdropBlur ? "\n            backdrop-filter: saturate(180%) blur(10px);\n            -webkit-backdrop-filter: saturate(180%) blur(10px);\n          " : ""}\n        }\n      `), this.settings.backdrop && this.renderBackdrop();
        }), this.instance.on("beforePresentTransition", (t)=>{
            t.animate || (this.backdropEl.style.display = "block");
        }), this.instance.on("onTransitionStart", (t)=>{
            this.settings.backdrop && (this.instance.isHidden() || t.type === CupertinoTransition.Hide || t.type === CupertinoTransition.Destroy || t.type === CupertinoTransition.Present) && (this.backdropEl.style.backgroundColor = "rgba(0,0,0,.0)", this.backdropEl.style.transition = `all ${this.settings.animationDuration}ms ${this.settings.animationType} 0s`, t.type !== CupertinoTransition.Hide && t.type !== CupertinoTransition.Destroy && (this.backdropEl.style.display = "block", setTimeout(()=>{
                this.backdropEl.style.backgroundColor = `rgba(0,0,0, ${this.settings.backdropOpacity})`;
            }, 50)));
        }), this.instance.on("onTransitionEnd", (t)=>{
            this.backdropEl && (t.type !== CupertinoTransition.Destroy && t.type !== CupertinoTransition.Hide || (this.backdropEl.style.transition = "initial", this.backdropEl.style.display = "none"));
        }), Support.touch && (this.instance.on("onDidPresent", ()=>{
            var t;
            null === (t = this.backdropEl) || void 0 === t || t.addEventListener(this.events.touchEvents.move, this.touchMoveBackdropCb, !!Support.passiveListener && {
                passive: !1,
                capture: !1
            });
        }), this.instance.on("onDidDismiss", (t)=>{
            var e;
            null === (e = this.backdropEl) || void 0 === e || e.removeEventListener(this.events.touchEvents.move, this.touchMoveBackdropCb);
        })));
    }
}
class FitHeightModule {
    beforeBuildBreakpoints() {
        var t, e, i;
        return __awaiter(this, void 0, void 0, function*() {
            this.settings.fitScreenHeight = !1, this.settings.initialBreak = "top";
            let s = yield this.getPaneFitHeight();
            this.settings.maxFitHeight && s > this.settings.maxFitHeight && (s = this.settings.maxFitHeight), this.breakpoints.conf = {
                top: {
                    enabled: !0,
                    height: s
                },
                middle: {
                    enabled: !1
                }
            }, this.breakpoints.conf.top.bounce = null === (e = null === (t = this.settings.breaks) || void 0 === t ? void 0 : t.top) || void 0 === e ? void 0 : e.bounce, this.breakpoints.conf.bottom = (null === (i = this.settings.breaks) || void 0 === i ? void 0 : i.bottom) || {
                enabled: !0,
                height: 0
            };
        });
    }
    calcFitHeight(t = !0) {
        return __awaiter(this, void 0, void 0, function*() {
            return this.instance.wrapperEl && this.instance.el ? this.calcHeightInProcess ? (console.warn("Cupertino Pane: calcFitHeight() already in process"), null) : void (yield this.breakpoints.buildBreakpoints(this.breakpoints.lockedBreakpoints, null, t)) : null;
        });
    }
    setOverflowHeight(t = 0) {
        this.paneElHeight > this.instance.screen_height && (this.instance.paneEl.style.height = `${this.instance.getPaneHeight()}px`, this.instance.overflowEl.style.height = this.instance.getPaneHeight() - this.settings.topperOverflowOffset - this.instance.overflowEl.offsetTop - t + "px");
    }
    getPaneFitHeight() {
        return __awaiter(this, void 0, void 0, function*() {
            this.calcHeightInProcess = !0;
            let t = this.instance.el.querySelectorAll("img");
            this.instance.el.style.height = "unset", this.instance.rendered || (this.instance.el.style.visibility = "hidden", this.instance.el.style.pointerEvents = "none", this.instance.el.style.display = "block", this.instance.wrapperEl.style.visibility = "hidden", this.instance.wrapperEl.style.pointerEvents = "none", this.instance.wrapperEl.style.display = "block");
            let e = [];
            t.length && (e = Array.from(t).map((t)=>new Promise((e)=>{
                    if (t.height || t.complete && t.naturalHeight) return e(!0);
                    t.onload = ()=>e(!0), t.onerror = ()=>e(!0);
                }))), yield Promise.all(e), yield new Promise((t)=>requestAnimationFrame(t));
            let i = Math.floor(this.instance.paneEl.getBoundingClientRect().height);
            return this.paneElHeight !== i && (this.instance.paneEl.style.height = `${i <= this.paneElHeight ? this.paneElHeight : i}px`), this.instance.rendered || (this.instance.el.style.visibility = "unset", this.instance.el.style.pointerEvents = "unset", this.instance.el.style.display = "none", this.instance.wrapperEl.style.visibility = "unset", this.instance.wrapperEl.style.pointerEvents = "unset", this.instance.wrapperEl.style.display = "none"), this.calcHeightInProcess = !1, this.paneElHeight = i, this.paneElHeight;
        });
    }
    constructor(t){
        this.instance = t, this.calcHeightInProcess = !1, this.breakpoints = this.instance.breakpoints, this.settings = this.instance.settings, this.settings.fitHeight && (this.instance.calcFitHeight = (t)=>__awaiter(this, void 0, void 0, function*() {
                return this.calcFitHeight(t);
            }), this.instance.setOverflowHeight = ()=>this.setOverflowHeight(), this.instance.on("DOMElementsReady", ()=>{
            this.instance.wrapperEl.classList.add("fit-height");
        }), this.instance.on("onDidPresent", ()=>{
            this.instance.paneEl.style.height = "unset";
        }), this.instance.on("onTransitionEnd", ()=>{
            this.instance.paneEl.style.height = "unset", this.instance.setGrabCursor(!0, !1);
        }), this.instance.on("onWillPresent", ()=>{
            this.breakpoints.beforeBuildBreakpoints = ()=>this.beforeBuildBreakpoints();
        }), this.instance.on("beforeBreakHeightApplied", (t)=>{
            var e;
            this.settings.fitScreenHeight && ((null === (e = this.settings.breaks[t.break]) || void 0 === e ? void 0 : e.height) > this.instance.screen_height && (this.settings.breaks[t.break].height = this.instance.screen_height - this.settings.bottomOffset), this.settings.breaks.top && this.settings.breaks.middle && this.settings.breaks.top.height - 50 <= this.settings.breaks.middle.height && (this.settings.breaks.middle.enabled = !1, this.settings.initialBreak = "top")), "top" === t.break && (this.settings.breaks.top.height > this.instance.screen_height ? (this.settings.breaks.top.height = this.instance.screen_height - 2 * this.settings.bottomOffset, this.settings.topperOverflow = !0, this.settings.upperThanTop = !1) : this.instance.overflowEl && this.settings.maxFitHeight);
        }, !0));
    }
}
class InverseModule {
    getPaneHeight() {
        return this.breakpoints.bottomer - this.settings.bottomOffset;
    }
    updateScreenHeights() {
        this.instance.screen_height = window.innerHeight, this.instance.screenHeightOffset = 0;
    }
    setOverflowHeight() {
        this.instance.overflowEl.style.height = this.getPaneHeight() - 30 - this.settings.topperOverflowOffset - this.instance.overflowEl.offsetTop + "px";
    }
    checkOverflowAttr(t) {
        this.settings.topperOverflow && this.instance.overflowEl && (this.instance.overflowEl.style.overflowY = t >= this.breakpoints.bottomer ? "auto" : "hidden");
    }
    prepareBreaksSwipeNextPoint() {
        return {
            brs: Object.assign({}, this.breakpoints.breaks),
            settingsBreaks: Object.assign({}, this.settings.breaks)
        };
    }
    handleSuperposition(t) {
        if (t.newVal <= this.breakpoints.topper) return {
            y: this.breakpoints.topper
        };
        if (t.newVal >= this.breakpoints.bottomer) return {
            y: this.breakpoints.bottomer
        };
        if (t.newVal <= this.breakpoints.topper) {
            if (this.settings.upperThanTop) {
                this.events.startPointOverTop || (this.events.startPointOverTop = t.clientY), this.events.startPointOverTop > t.clientY && delete this.events.startPointOverTop;
                const e = this.instance.screen_height - this.instance.screenHeightOffset, i = (e - Math.abs(this.instance.getPanelTransformY())) / (e - Math.abs(this.breakpoints.topper)) / 8;
                return {
                    y: this.instance.getPanelTransformY() + t.diffY * i
                };
            }
            return {
                y: this.breakpoints.topper
            };
        }
    }
    scrollPreventDrag(t) {
        let e = !1;
        return this.events.willScrolled() && this.isOverflowEl(t.target) && (e = !0), e;
    }
    isOverflowEl(t) {
        if (!t) return !1;
        let e = t.parentNode;
        for(; null != e;){
            if (e == this.instance.overflowEl) return !0;
            e = e.parentNode;
        }
        return !1;
    }
    onScroll() {
        return __awaiter(this, void 0, void 0, function*() {
            this.events.isScrolling = !0;
        });
    }
    setPaneElTransform(t) {
        this.instance.currentTranslateY = t.translateY, this.instance.currentTranslateX = 0;
        const e = this.instance.buildTransform3d(0, this.instance.currentTranslateY, 0);
        this.instance.paneEl.style.transform = e;
    }
    fastSwipeNext(t) {
        var e, i;
        if (this.events.allowClick) return !1;
        if (this.events.steps.length < 2) return !1;
        const s = this.events.steps[this.events.steps.length - 1], n = this.events.steps[this.events.steps.length - 2], r = (null !== (e = null == s ? void 0 : s["pos" + t]) && void 0 !== e ? e : 0) - (null !== (i = null == n ? void 0 : n["pos" + t]) && void 0 !== i ? i : 0);
        return !!Number.isFinite(r) && Math.abs(r) >= this.events.swipeNextSensivity;
    }
    swipeNextPoint(t, e, i) {
        var s, n, r, a, o, h;
        const l = this.breakpoints.breaks, c = this.settings.breaks, d = this.instance.breakpoints.currentBreakpoint, p = l.top, u = l.middle, g = l.bottom;
        if (d === p) {
            if (t > e) {
                if (null === (s = c.middle) || void 0 === s ? void 0 : s.enabled) return u;
                if (null === (n = c.bottom) || void 0 === n ? void 0 : n.enabled) return g;
            }
            return p;
        }
        if (d === u) return t < -e && (null === (r = c.top) || void 0 === r ? void 0 : r.enabled) ? p : t > e && (null === (a = c.bottom) || void 0 === a ? void 0 : a.enabled) ? g : u;
        if (d === g) {
            if (t < -e) {
                if (null === (o = c.middle) || void 0 === o ? void 0 : o.enabled) return u;
                if (null === (h = c.top) || void 0 === h ? void 0 : h.enabled) return p;
            }
            return g;
        }
        return i;
    }
    beforeBuildBreakpoints() {}
    constructor(t){
        this.instance = t, this.breakpoints = this.instance.breakpoints, this.settings = this.instance.settings, this.events = this.instance.events, this.settings.inverse && (this.settings.buttonDestroy = !1, this.instance.getPaneHeight = ()=>this.getPaneHeight(), this.instance.updateScreenHeights = ()=>this.updateScreenHeights(), this.instance.setOverflowHeight = ()=>this.settings.fitHeight ? {} : this.setOverflowHeight(), this.instance.checkOpacityAttr = ()=>{}, this.instance.checkOverflowAttr = (t)=>this.checkOverflowAttr(t), this.instance.prepareBreaksSwipeNextPoint = ()=>this.prepareBreaksSwipeNextPoint(), this.instance.swipeNextPoint = (t, e, i)=>this.swipeNextPoint(t, e, i), this.events.fastSwipeNext = (t)=>this.fastSwipeNext(t), this.events.handleSuperposition = (t)=>this.handleSuperposition(t), this.events.scrollPreventDrag = (t)=>this.scrollPreventDrag(t), this.events.onScroll = ()=>this.onScroll(), this.instance.transitions.setPaneElTransform = (t)=>this.setPaneElTransform(t), this.instance.currentTranslateX = 0, this.instance.on("DOMElementsReady", ()=>{
            this.instance.wrapperEl.classList.add("inverse");
        }), this.instance.on("rendered", ()=>{
            this.instance.addStyle("\n        .cupertino-pane-wrapper.inverse .pane {\n          border-radius: 0 0 20px 20px;\n          border-radius: 0 0\n                        var(--cupertino-pane-border-radius, 20px) \n                        var(--cupertino-pane-border-radius, 20px);\n        }\n        .cupertino-pane-wrapper.inverse:not(.fit-height) .pane {\n          padding-bottom: 15px; \n        }\n        .cupertino-pane-wrapper.inverse .draggable {\n          bottom: 0;\n          top: initial;\n        }\n        .cupertino-pane-wrapper.inverse .draggable.over {\n          bottom: -30px;\n          top: initial;\n        }\n        .cupertino-pane-wrapper.inverse .move {\n          margin-top: 15px;\n        }\n        .cupertino-pane-wrapper.inverse .draggable.over .move {\n          margin-top: -5px;\n        }\n      ");
        }), this.instance.on("buildBreakpointsCompleted", ()=>{
            const t = Object.assign({}, this.breakpoints.breaks), e = this.instance.screen_height;
            [
                "top",
                "middle",
                "bottom"
            ].forEach((i)=>{
                var s;
                if (void 0 !== t[i] && (null === (s = this.settings.breaks[i]) || void 0 === s ? void 0 : s.enabled)) {
                    const t = this.settings.breaks[i].height, s = e - t - this.settings.bottomOffset;
                    this.breakpoints.breaks[i] = s;
                }
            });
            const i = Object.values(this.breakpoints.breaks).filter((t)=>"number" == typeof t), s = Math.min(...i), n = Math.max(...i);
            this.breakpoints.topper = s, this.breakpoints.bottomer = n, this.breakpoints.brs = i, this.instance.paneEl.style.top = `-${Math.abs(this.breakpoints.bottomer) - this.settings.bottomOffset}px`;
        }), this.instance.on("onWillPresent", ()=>{
            this.breakpoints.beforeBuildBreakpoints = ()=>this.beforeBuildBreakpoints();
        }));
    }
}
class HorizontalModule {
    static CollectSettings(t) {
        return t.horizontal ? Object.assign(Object.assign({}, t), HorizontalModule.forceSettings) : t;
    }
    parseInitialBreak() {
        const t = this.settings.initialBreak.split(" ");
        1 === t.length ? (this.initialBreakY = t[0], this.initialBreakX = "left") : 2 === t.length && (this.initialBreakY = t[0], this.initialBreakX = t[1]), [
            "top",
            "middle",
            "bottom"
        ].includes(this.initialBreakY) || (console.warn(`Cupertino Pane: Invalid Y breakpoint "${this.initialBreakY}", using "middle"`), this.initialBreakY = "middle"), [
            "left",
            "right"
        ].includes(this.initialBreakX) || (console.warn(`Cupertino Pane: Invalid X breakpoint "${this.initialBreakX}", using "left"`), this.initialBreakX = "left");
    }
    calcHorizontalBreaks() {
        var t;
        return __awaiter(this, void 0, void 0, function*() {
            const e = this.instance.paneEl.getBoundingClientRect().width, i = (window.innerWidth - e) / 2;
            this.defaultRect = {
                width: e,
                left: i,
                right: i + e
            };
            const s = null !== (t = this.settings.horizontalOffset) && void 0 !== t ? t : 0;
            this.horizontalBreaks = {
                left: Math.round(-this.defaultRect.left + s),
                right: Math.round(window.innerWidth - this.defaultRect.left - this.defaultRect.width - s)
            };
        });
    }
    scheduleCalcHorizontalBreaks() {
        this.recalcScheduled || (this.recalcScheduled = !0, requestAnimationFrame(()=>{
            this.recalcScheduled = !1, this.calcHorizontalBreaks();
        }));
    }
    overrideInitialPositioning() {
        const t = this.instance.breakpoints.breaks[this.initialBreakY], e = this.horizontalBreaks[this.initialBreakX];
        this.instance.paneEl.style.transform.includes(`${this.instance.screenHeightOffset}px`) ? (this.instance.currentTranslateX = e, this.instance.currentTranslateY = this.instance.screenHeightOffset, this.instance.paneEl.style.transform = this.instance.buildTransform3d(this.instance.currentTranslateX, this.instance.currentTranslateY, 0)) : (this.instance.currentTranslateX = e, this.instance.currentTranslateY = t, this.instance.paneEl.style.transform = this.instance.buildTransform3d(this.instance.currentTranslateX, this.instance.currentTranslateY, 0)), this.currentBreakpoint = this.initialBreakX, this.instance.breakpoints.currentBreakpoint = t;
    }
    setPaneElTransform(t) {
        this.horizontalBreaks || this.calcHorizontalBreaks();
        let e = t.translateY, i = t.translateX || this.instance.getPanelTransformX();
        "breakpoint" !== t.type || t.translateX || (i = this.horizontalBreaks[this.currentBreakpoint]), "end" === t.type && (e = this.instance.breakpoints.getClosestBreakY(), i = this.getClosestBreakX(), this.fastSwipeNext && ("left" === this.currentBreakpoint && this.instance.getPanelTransformX() > this.horizontalBreaks.left && (i = this.horizontalBreaks.right), "right" === this.currentBreakpoint && this.instance.getPanelTransformX() < this.horizontalBreaks.right && (i = this.horizontalBreaks.left)), this.currentBreakpoint = i === this.horizontalBreaks.left ? "left" : "right", this.instance.breakpoints.currentBreakpoint = e), this.instance.currentTranslateX = i || 0, this.instance.currentTranslateY = e || 0, this.instance.paneEl.style.transform = this.instance.buildTransform3d(this.instance.currentTranslateX, this.instance.currentTranslateY, 0);
    }
    getClosestBreakX() {
        this.horizontalBreaks || this.calcHorizontalBreaks();
        const t = this.instance.getPanelTransformX();
        return Math.abs(this.horizontalBreaks.left - t) < Math.abs(this.horizontalBreaks.right - t) ? this.horizontalBreaks.left : this.horizontalBreaks.right;
    }
    moveToHorizontalBreak(t) {
        this.horizontalBreaks || this.calcHorizontalBreaks();
        const e = this.instance.getPanelTransformY(), i = this.horizontalBreaks[t];
        this.instance.currentTranslateX = i, this.instance.currentTranslateY = e, this.instance.paneEl.style.transform = this.instance.buildTransform3d(this.instance.currentTranslateX, this.instance.currentTranslateY, 0), this.currentBreakpoint = t;
    }
    getCurrentHorizontalBreak() {
        return this.currentBreakpoint;
    }
    applyMoveUpdate() {
        const t = this.events.pendingMoveData;
        if (!t) return void (this.events.rafId = null);
        const { newVal: e, newValX: i } = t;
        this.instance.checkOpacityAttr(e), this.instance.checkOverflowAttr(e), this.transitions.doTransition({
            type: "move",
            translateY: e,
            translateX: i
        }), this.events.pendingMoveData = null, this.events.rafId = null;
    }
    moveToWidth(t, e) {
        return __awaiter(this, void 0, void 0, function*() {
            return this.instance.isPanePresented() ? (yield this.instance.transitions.doTransition({
                type: "breakpoint",
                translateX: t,
                translateY: e
            }), Promise.resolve(!0)) : (console.warn("Cupertino Pane: Present pane before call moveToWidth()"), null);
        });
    }
    constructor(t){
        if (this.instance = t, this.initialBreakX = "left", this.initialBreakY = "middle", this.recalcScheduled = !1, this.settings = this.instance.settings, this.transitions = this.instance.transitions, this.events = this.instance.events, !this.settings.horizontal) return null;
        this.parseInitialBreak(), this.transitions.setPaneElTransform = (t)=>this.setPaneElTransform(t), this.events.applyMoveUpdate = ()=>this.applyMoveUpdate(), this.instance.on("beforeBreakHeightApplied", (t)=>{
            this.scheduleCalcHorizontalBreaks();
        }), this.instance.on("beforePresentTransition", ()=>{
            this.calcHorizontalBreaks(), this.overrideInitialPositioning();
        }), this.instance.on("onTransitionEnd", (t)=>{
            "breakpoint" !== t.type && "present" !== t.type || this.instance.getPanelTransformX() || this.calcHorizontalBreaks();
        }), this.instance.on("onDidPresent", (t)=>{
            t.animate || this.calcHorizontalBreaks();
        }), this.instance.on("onDragEnd", (t)=>{
            this.fastSwipeNext = this.events.fastSwipeNext("X");
        });
    }
}
HorizontalModule.forceSettings = {
    touchAngle: null
};
class ModalModule {
    static CollectSettings(t) {
        return t.modal ? Object.assign(Object.assign({}, t), ModalModule.ForceSettings) : t;
    }
    setPaneElTransform(t) {
        let e, i = t.translateY;
        e = "end" === t.type ? 0 : void 0 !== t.translateX ? t.translateX : this.instance.getPanelTransformX(), this.instance.currentTranslateX = e, this.instance.currentTranslateY = i, this.instance.paneEl.style.transform = this.instance.buildTransform3d(this.instance.currentTranslateX, this.instance.currentTranslateY, 0);
    }
    present(t) {
        let { transition: e } = t;
        return e || (e = ModalModule.BuildInTransition[this.settings.modal.transition]), this.instance.customPresent(Object.assign(Object.assign({}, t), {
            transition: e
        }));
    }
    destroy(t) {
        let { transition: e } = t;
        if (e || (e = JSON.parse(JSON.stringify({
            duration: ModalModule.BuildInTransition[this.settings.modal.transition].duration,
            from: ModalModule.BuildInTransition[this.settings.modal.transition].to,
            to: ModalModule.BuildInTransition[this.settings.modal.transition].from
        }))), t.fromCurrentPosition) {
            let t = this.instance.parseTransform3d(this.instance.paneEl);
            e.to.transform = this.instance.buildTransform3d(t.x, t.y, 0);
        }
        return this.instance.customDestroy(Object.assign(Object.assign({}, t), {
            transition: e
        }));
    }
    handleSuperposition(t) {
        let e = Math.abs(this.instance.getPanelTransformY() - this.breakpoints.topper), i = Math.abs(this.instance.getPanelTransformX());
        if (this.settings.modal.dismissOnIntense && (e > 40 || i > 30)) return this.instance.disableDrag(), this.destroy({
            animate: !0,
            fromCurrentPosition: !0
        }), !1;
        const s = this.instance.getPanelTransformY() / this.breakpoints.topper / 8, n = this.instance.getPanelTransformX() / this.breakpoints.topper / 8;
        return {
            y: this.instance.getPanelTransformY() + t.diffY * (s + n),
            x: this.instance.getPanelTransformX() + t.diffX * (s + n)
        };
    }
    constructor(t){
        this.instance = t, this.modalDefaults = {
            transition: "fade",
            flying: !1,
            dismissOnIntense: !1
        }, this.settings = this.instance.settings, this.events = this.instance.events, this.breakpoints = this.instance.breakpoints, this.transitions = this.instance.transitions, this.settings.modal && (this.settings.modal = "object" == typeof this.settings.modal ? Object.assign(Object.assign({}, this.modalDefaults), this.settings.modal) : this.modalDefaults, this.instance.customPresent = this.instance.present, this.instance.present = (t)=>this.present(t), this.instance.customDestroy = this.instance.destroy, this.instance.destroy = (t)=>this.destroy(t), this.events.handleSuperposition = (t)=>this.handleSuperposition(t), this.transitions.setPaneElTransform = (t)=>this.setPaneElTransform(t), this.instance.on("beforeBreakHeightApplied", (t)=>{
            "top" === t.break && (this.settings.breaks.top.height -= 2 * this.settings.bottomOffset, this.settings.breaks.top.height += (this.instance.screen_height - this.settings.breaks.top.height) / 2), "bottom" === t.break && (this.settings.breaks.bottom = {
                enabled: !1
            }), this.instance.addStyle(`\n        .cupertino-pane-wrapper .pane {\n          transform-origin: center ${this.breakpoints.breaks[this.settings.initialBreak]}px\n        }\n      `);
        }), this.instance.on("rendered", ()=>{
            this.instance.addStyle("\n        .cupertino-pane-wrapper .pane {\n          border-radius: var(--cupertino-pane-border-radius, 20px) \n                         var(--cupertino-pane-border-radius, 20px)\n                         var(--cupertino-pane-border-radius, 20px)\n                         var(--cupertino-pane-border-radius, 20px);\n          width: calc(100% - 16px) !important;\n          margin: auto;\n        }\n        .cupertino-pane-wrapper .pane.modal-flying {\n          animation: modalFlyingX 2000ms ease-in-out infinite alternate,\n                     modalFlyingY 3000ms ease-in-out infinite alternate;\n        }\n        @keyframes modalFlyingX {\n          0% { left: -10px; }\n          100% { left: 10px; }\n        }\n        @keyframes modalFlyingY {\n          0% { top: -10px; }\n          100% { top: 0px; }\n        }\n      "), this.settings.modal.flying && this.instance.paneEl.classList.add("modal-flying"), this.settings.modal.dismissOnIntense && this.instance.enableDrag();
        }));
    }
}
ModalModule.BuildInTransition = {
    fade: {
        duration: 300,
        from: {
            opacity: 0
        },
        to: {
            opacity: 1
        }
    },
    zoom: {
        duration: 300,
        from: {
            opacity: 0,
            scale: .5
        },
        to: {
            opacity: 1,
            scale: 1
        }
    }
}, ModalModule.ForceSettings = {
    fitHeight: !0,
    touchAngle: null,
    showDraggable: !1
};
const Modules = {
    ZStackModule: ZStackModule,
    FollowerModule: FollowerModule,
    BackdropModule: BackdropModule,
    FitHeightModule: FitHeightModule,
    InverseModule: InverseModule,
    HorizontalModule: HorizontalModule,
    ModalModule: ModalModule
};
class CupertinoPane {
    drawBaseElements() {
        this.styleEl = document.createElement("style"), this.styleEl.id = `cupertino-pane-${(Math.random() + 1).toString(36).substring(7)}`, this.parentEl = this.settings.parentElement, this.wrapperEl = document.createElement("div"), this.wrapperEl.classList.add("cupertino-pane-wrapper"), this.settings.cssClass && this.settings.cssClass.split(" ").filter((t)=>!!t).forEach((t)=>this.wrapperEl.classList.add(t));
        let t = "";
        t += "\n      .cupertino-pane-wrapper {\n        display: none;\n        position: absolute;\n        top: 0;\n        left: 0;\n      }\n    ", this.paneEl = document.createElement("div"), this.paneEl.style.transform = this.buildTransform3d(0, this.screenHeightOffset, 0), this.currentTranslateY = this.screenHeightOffset, this.currentTranslateX = 0, this.paneEl.classList.add("pane"), t += "\n      .cupertino-pane-wrapper .pane {\n        position: fixed;\n        z-index: 11;\n        width: 100%;\n        max-width: 500px;\n        left: 0px;\n        right: 0px;\n        margin-left: auto;\n        margin-right: auto;\n        background: var(--cupertino-pane-background, #ffffff);\n        color: var(--cupertino-pane-color, #333333);\n        box-shadow: var(--cupertino-pane-shadow, 0 4px 16px rgba(0,0,0,.12));\n        will-change: transform;\n        padding-top: 15px; \n        border-radius: var(--cupertino-pane-border-radius, 20px) \n                       var(--cupertino-pane-border-radius, 20px) \n                       0 0;\n        -webkit-user-select: none;\n      }\n      .cupertino-pane-wrapper .pane img {\n        -webkit-user-drag: none;\n      }\n    ", this.draggableEl = document.createElement("div"), this.draggableEl.classList.add("draggable"), this.settings.draggableOver && this.draggableEl.classList.add("over"), t += "\n      .cupertino-pane-wrapper .draggable {\n        padding: 5px;\n        position: absolute;\n        left: 0;\n        right: 0;\n        margin-left: auto;\n        margin-right: auto;\n        height: 30px;\n        z-index: -1;\n        top: 0;\n        bottom: initial;\n      }\n      .cupertino-pane-wrapper .draggable.over {\n        top: -30px;\n        padding: 15px;\n      }\n    ", this.moveEl = document.createElement("div"), this.moveEl.classList.add("move"), t += `\n      .cupertino-pane-wrapper .move {\n        margin: 0 auto;\n        height: 5px;\n        background: var(--cupertino-pane-move-background, #c0c0c0);\n        width: 36px;\n        border-radius: 4px;\n      }\n      .cupertino-pane-wrapper .draggable.over .move {\n        width: 70px; \n        background: var(--cupertino-pane-move-background, rgba(225, 225, 225, 0.6));\n        ${Support.backdropFilter ? "\n          backdrop-filter: saturate(180%) blur(20px);\n          -webkit-backdrop-filter: saturate(180%) blur(20px);\n        " : ""}\n      }\n    `, this.destroyButtonEl = document.createElement("div"), this.destroyButtonEl.classList.add("destroy-button"), t += "\n      .cupertino-pane-wrapper .destroy-button {\n        width: 26px;\n        height: 26px;\n        cursor: pointer;\n        position: absolute;\n        background: var(--cupertino-pane-destroy-button-background, #ebebeb);\n        fill: var(--cupertino-pane-icon-close-color, #7a7a7e);\n        right: 20px;\n        z-index: 14;\n        border-radius: 100%;\n        top: 16px;\n      }\n    ", this.contentEl = this.el, this.contentEl.style.transition = `opacity ${this.settings.animationDuration}ms ${this.settings.animationType} 0s`, this.contentEl.style.overflowX = "hidden", this.styleEl.textContent = t.replace(/\s\s+/g, " "), document.head.prepend(this.styleEl), this.parentEl.appendChild(this.wrapperEl), this.wrapperEl.appendChild(this.paneEl), this.paneEl.appendChild(this.contentEl), this.settings.showDraggable && (this.paneEl.appendChild(this.draggableEl), this.draggableEl.appendChild(this.moveEl)), this.emit("DOMElementsReady");
    }
    present(t = {
        animate: !1
    }) {
        var e;
        return __awaiter(this, void 0, void 0, function*() {
            if (!this.el || !document.body.contains(this.el)) return void console.warn("Cupertino Pane: specified DOM element must be attached to the DOM");
            if (this.isPanePresented() && this.rendered) return void this.moveToBreak(this.settings.initialBreak);
            if (this.isPanePresented() && !this.rendered) return void console.warn("Cupertino Pane: specified selector or DOM element already in use", this.selector);
            t.animate && this.device.ionic && (this.ionApp.componentOnReady && (yield this.ionApp.componentOnReady()), yield new Promise((t)=>requestAnimationFrame(t))), this.emit("onWillPresent"), this.updateScreenHeights(), this.drawBaseElements(), yield this.setBreakpoints();
            let i = (null === (e = null == t ? void 0 : t.transition) || void 0 === e ? void 0 : e.from) ? JSON.parse(JSON.stringify(t.transition.from)) : null;
            return i && (i.transform || (i.transform = this.buildTransform3d(0, this.breakpoints.breaks[this.settings.initialBreak], 0)), Object.assign(this.paneEl.style, i)), this.wrapperEl.style.display = "block", this.contentEl.style.display = "block", this.wrapperEl.classList.add("rendered"), this.rendered = !0, this.scrollElementInit(), this.emit("rendered"), this.setGrabCursor(!0), this.settings.buttonDestroy && (this.paneEl.appendChild(this.destroyButtonEl), this.destroyButtonEl.addEventListener("click", (t)=>this.destroy({
                    animate: !0,
                    destroyButton: !0
                })), this.destroyButtonEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">\n          <path d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"/>\n        </svg>'), this.device.ionic && !this.settings.ionContentScroll && this.ionContent.setAttribute("scroll-y", "false"), this.settings.bottomClose && (this.settings.breaks.bottom.enabled = !0), this.settings.freeMode && (this.settings.lowerThanBottom = !1), this.device.android && (document.body.style.overscrollBehaviorY = "none"), this.emit("beforePresentTransition", {
                animate: t.animate
            }), yield new Promise((t)=>requestAnimationFrame(t)), t.animate ? yield this.transitions.doTransition({
                type: "present",
                conf: t,
                translateY: this.breakpoints.breaks[this.settings.initialBreak]
            }) : (this.breakpoints.prevBreakpoint = this.settings.initialBreak, this.currentTranslateY = this.breakpoints.breaks[this.settings.initialBreak], this.paneEl.style.transform = this.buildTransform3d(this.currentTranslateX, this.currentTranslateY, 0)), this.events.attachAllEvents(), this.emit("onDidPresent", {
                animate: t.animate
            }), this;
        });
    }
    getPaneHeight() {
        return this.screen_height - this.breakpoints.topper - this.settings.bottomOffset;
    }
    updateScreenHeights() {
        this.screen_height = window.innerHeight, this.screenHeightOffset = window.innerHeight;
    }
    scrollElementInit() {
        let t = this.el.querySelectorAll("[overflow-y]");
        !t.length || t.length > 1 ? this.overflowEl = this.contentEl : (this.overflowEl = t[0], this.overflowEl.style.overflowX = "hidden"), this.overflowEl.style.overscrollBehavior = "none", this.setOverflowHeight();
    }
    setOverflowHeight(t = 0) {
        this.paneEl.style.height = `${this.getPaneHeight()}px`, this.overflowEl.style.height = this.getPaneHeight() - this.settings.topperOverflowOffset - this.overflowEl.offsetTop - t + "px";
    }
    checkOpacityAttr(t) {
        let e = this.el.querySelectorAll("[hide-on-bottom]");
        if (!e.length) return;
        const i = t >= this.breakpoints.breaks.bottom;
        this.lastHideOnBottom !== i && (e.forEach((t)=>{
            t.style.transition = `opacity ${this.settings.animationDuration}ms ${this.settings.animationType} 0s`, t.style.opacity = i ? "0" : "1";
        }), this.lastHideOnBottom = i);
    }
    checkOverflowAttr(t) {
        if (!this.settings.topperOverflow || !this.overflowEl) return;
        const e = t <= this.breakpoints.topper;
        this.lastOverflowAuto !== e && (this.overflowEl.style.overflowY = e ? "auto" : "hidden", this.lastOverflowAuto = e, this.setGrabCursor(!0, !1));
    }
    isPanePresented() {
        let t = Array.from(document.querySelectorAll(".cupertino-pane-wrapper.rendered"));
        return !!t.length && !!t.find((t)=>t.contains(this.selector));
    }
    prepareBreaksSwipeNextPoint() {
        return {
            brs: Object.assign({}, this.breakpoints.breaks),
            settingsBreaks: Object.assign({}, this.settings.breaks)
        };
    }
    addStyle(t) {
        this.styleEl.textContent += t.replace(/\s\s+/g, " ");
    }
    buildTransform3d(t = 0, e = 0, i = 0) {
        return `translate3d(${t}px, ${e}px, ${i}px)`;
    }
    buildTransform3dWithScale(t = 0, e = 0, i = 0, s = 1) {
        return `translate3d(${t}px, ${e}px, ${i}px) scale(${s})`;
    }
    parseTransform3d(t) {
        const e = window.getComputedStyle(t).transform;
        if ("none" === e || !e) return {
            x: 0,
            y: 0,
            z: 0
        };
        if (e.startsWith("matrix3d(")) {
            const t = e.slice(9, -1).split(",").map((t)=>parseFloat(t.trim()));
            return {
                x: t[12] || 0,
                y: t[13] || 0,
                z: t[14] || 0
            };
        }
        if (e.startsWith("matrix(")) {
            const t = e.slice(7, -1).split(",").map((t)=>parseFloat(t.trim()));
            return {
                x: t[4] || 0,
                y: t[5] || 0,
                z: 0
            };
        }
        const i = e.match(/translate3d\(([^,]+),\s*([^,]+),\s*([^)]+)\)/);
        return i ? {
            x: parseFloat(i[1]) || 0,
            y: parseFloat(i[2]) || 0,
            z: parseFloat(i[3]) || 0
        } : {
            x: 0,
            y: 0,
            z: 0
        };
    }
    getModuleRef(t) {
        return (t.charAt(0).toLowerCase() + t.slice(1)).replace("Module", "");
    }
    getPanelTransformY() {
        return this.currentTranslateY;
    }
    getPanelTransformX() {
        return this.currentTranslateX;
    }
    preventDismiss(t = !1) {
        this.preventDismissEvent = t;
    }
    setGrabCursor(t, e) {
        if (!this.device.desktop) return;
        const i = t ? e ? "grabbing" : "grab" : "", s = !!this.overflowEl && "auto" === this.overflowEl.style.overflowY && this.overflowEl.scrollHeight > this.overflowEl.clientHeight;
        return t ? s ? (this.paneEl.style.cursor = "", void (this.draggableEl && (this.draggableEl.style.cursor = i))) : (this.paneEl.style.cursor = i, void (this.draggableEl && (this.draggableEl.style.cursor = i))) : (this.paneEl.style.cursor = "", void (this.draggableEl && (this.draggableEl.style.cursor = "")));
    }
    disableDrag() {
        this.disableDragEvents = !0, this.setGrabCursor(!1);
    }
    enableDrag() {
        this.disableDragEvents = !1, this.setGrabCursor(!0);
    }
    setBreakpoints(t, e) {
        return __awaiter(this, void 0, void 0, function*() {
            !this.isPanePresented() || t ? yield this.breakpoints.buildBreakpoints(t, e) : console.warn("Cupertino Pane: Provide any breaks configuration");
        });
    }
    moveToBreak(t, e = "breakpoint") {
        return __awaiter(this, void 0, void 0, function*() {
            return this.isPanePresented() ? this.settings.breaks[t].enabled ? (this.checkOpacityAttr(this.breakpoints.breaks[t]), this.checkOverflowAttr(this.breakpoints.breaks[t]), yield this.transitions.doTransition({
                type: e,
                translateY: this.breakpoints.breaks[t]
            }), this.breakpoints.currentBreakpoint = this.breakpoints.breaks[t], Promise.resolve(!0)) : void console.warn("Cupertino Pane: %s breakpoint disabled", t) : (console.warn("Cupertino Pane: Present pane before call moveToBreak()"), null);
        });
    }
    moveToHeight(t) {
        return __awaiter(this, void 0, void 0, function*() {
            if (!this.isPanePresented()) return console.warn("Cupertino Pane: Present pane before call moveToHeight()"), null;
            let e = this.screenHeightOffset ? this.screen_height - t : t;
            this.checkOpacityAttr(e), yield this.transitions.doTransition({
                type: "breakpoint",
                translateY: e
            });
        });
    }
    hide() {
        return __awaiter(this, void 0, void 0, function*() {
            return this.isPanePresented() ? this.isHidden() ? (console.warn("Cupertino Pane: Pane already hidden"), null) : void (yield this.transitions.doTransition({
                type: "hide",
                translateY: this.screenHeightOffset
            })) : (console.warn("Cupertino Pane: Present pane before call hide()"), null);
        });
    }
    isHidden() {
        return this.isPanePresented() ? this.transitions.isPaneHidden : (console.warn("Cupertino Pane: Present pane before call isHidden()"), null);
    }
    currentBreak() {
        return this.isPanePresented() ? this.breakpoints.getCurrentBreakName() : (console.warn("Cupertino Pane: Present pane before call currentBreak()"), null);
    }
    destroy(t = {
        animate: !1,
        destroyButton: !1
    }) {
        return __awaiter(this, void 0, void 0, function*() {
            if (!this.rendered) return console.warn("Cupertino Pane: Present pane before call destroy()"), null;
            this.preventDismissEvent ? this.preventedDismiss || (this.emit("onWillDismiss", {
                prevented: !0
            }), this.moveToBreak(this.breakpoints.prevBreakpoint)) : (this.emit("onWillDismiss"), t.animate ? yield this.transitions.doTransition({
                type: "destroy",
                conf: t,
                translateY: this.screenHeightOffset,
                destroyButton: t.destroyButton
            }) : this.destroyResets(), this.emit("onDidDismiss", {
                destroyButton: t.destroyButton
            }));
        });
    }
    destroyResets() {
        this.keyboardEvents.fixBodyKeyboardResize(!1), this.parentEl.appendChild(this.contentEl), this.wrapperEl.remove(), this.styleEl.remove(), this.events.detachAllEvents(), delete this.rendered, delete this.breakpoints.prevBreakpoint, this.contentEl.style.display = "none";
    }
    constructor(t, e = {}){
        if (this.selector = t, this.disableDragEvents = !1, this.preventDismissEvent = !1, this.preventedDismiss = !1, this.rendered = !1, this.currentTranslateY = 0, this.currentTranslateX = 0, this.settings = (new Settings).instance, this.device = new Device, this.modules = {}, this.eventsListeners = {}, this.on = on, this.emit = emit, this.calcFitHeight = ()=>{
            if (!this.settings.fitHeight) return console.warn("Cupertino Pane: calcFitHeight() should be used for auto-height panes with enabled fitHeight option"), null;
        }, this.swipeNextPoint = (t, e, i)=>{
            var s, n, r, a, o, h;
            const l = this.breakpoints.breaks, c = this.settings.breaks, d = this.breakpoints.currentBreakpoint, p = l.top, u = l.middle, g = l.bottom;
            if (d === p) {
                if (t > e) {
                    if (null === (s = c.middle) || void 0 === s ? void 0 : s.enabled) return u;
                    if (null === (n = c.bottom) || void 0 === n ? void 0 : n.enabled) return g;
                }
                return p;
            }
            if (d === u) return t < -e && (null === (r = c.top) || void 0 === r ? void 0 : r.enabled) ? p : t > e && (null === (a = c.bottom) || void 0 === a ? void 0 : a.enabled) ? g : u;
            if (d === g) {
                if (t < -e) {
                    if (null === (o = c.middle) || void 0 === o ? void 0 : o.enabled) return u;
                    if (null === (h = c.top) || void 0 === h ? void 0 : h.enabled) return p;
                }
                return g;
            }
            return i;
        }, t instanceof HTMLElement ? this.selector = t : this.selector = document.querySelector(t), !this.selector) return void console.warn("Cupertino Pane: wrong selector or DOM element specified", this.selector);
        if (this.isPanePresented()) return void console.error("Cupertino Pane: specified selector or DOM element already in use", this.selector);
        this.el = this.selector, this.el.style.display = "none", this.settings = Object.assign(Object.assign({}, this.settings), e);
        let i = Object.keys(Modules).map((t)=>Modules[t]), s = this.settings.modules || i;
        s.forEach((t)=>t.CollectSettings ? this.settings = t.CollectSettings(this.settings) : null);
        let n = this.el.parentElement;
        this.settings.parentElement && (n = this.settings.parentElement instanceof HTMLElement ? this.settings.parentElement : document.querySelector(this.settings.parentElement)), this.settings.parentElement = n, this.device.ionic && (this.ionContent = document.querySelector("ion-content"), this.ionApp = document.querySelector("ion-app")), this.settings.events && Object.keys(this.settings.events).forEach((t)=>this.on(t, this.settings.events[t])), this.breakpoints = new Breakpoints(this), this.transitions = new Transitions(this), this.keyboardEvents = new KeyboardEvents(this), this.resizeEvents = new ResizeEvents(this), this.events = new Events(this), s.forEach((t)=>this.modules[this.getModuleRef(t.name)] = new t(this));
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"kixUx":[function(require,module,exports,__globalThis) {
/**
 * Map rendering optimizations for MapLibre GL
 * These utilities help reduce unnecessary re-renders and improve performance
 */ /**
 * Reusable empty FeatureCollection to avoid creating new objects
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_FEATURE_COLLECTION", ()=>EMPTY_FEATURE_COLLECTION);
parcelHelpers.export(exports, "sourceHasFeatures", ()=>sourceHasFeatures);
parcelHelpers.export(exports, "batchClearSources", ()=>batchClearSources);
parcelHelpers.export(exports, "batchUpdateSources", ()=>batchUpdateSources);
parcelHelpers.export(exports, "rafThrottle", ()=>rafThrottle);
parcelHelpers.export(exports, "idleDebounce", ()=>idleDebounce);
parcelHelpers.export(exports, "batchSetFeatureState", ()=>batchSetFeatureState);
parcelHelpers.export(exports, "replaceFeatureStates", ()=>replaceFeatureStates);
parcelHelpers.export(exports, "createFeaturesOptimized", ()=>createFeaturesOptimized);
parcelHelpers.export(exports, "isMapAnimating", ()=>isMapAnimating);
parcelHelpers.export(exports, "whenMapIdle", ()=>whenMapIdle);
parcelHelpers.export(exports, "calculateBoundsOptimized", ()=>calculateBoundsOptimized);
parcelHelpers.export(exports, "boundsToArray", ()=>boundsToArray);
const EMPTY_FEATURE_COLLECTION = Object.freeze({
    type: 'FeatureCollection',
    features: []
});
const sourceHasFeatures = (map, sourceId)=>{
    var _data_features;
    const source = map.getSource(sourceId);
    if (!source) return false;
    const data = source._data;
    return (data === null || data === void 0 ? void 0 : (_data_features = data.features) === null || _data_features === void 0 ? void 0 : _data_features.length) > 0;
};
const batchClearSources = (map, sourceIds)=>{
    sourceIds.forEach((sourceId)=>{
        if (sourceHasFeatures(map, sourceId)) map.getSource(sourceId).setData(EMPTY_FEATURE_COLLECTION);
    });
};
const batchUpdateSources = (map, updates)=>{
    requestAnimationFrame(()=>{
        updates.forEach(({ sourceId, data })=>{
            const source = map.getSource(sourceId);
            if (source) source.setData(data);
        });
    });
};
const rafThrottle = (fn)=>{
    let rafId = null;
    let lastArgs = null;
    const throttled = (...args)=>{
        lastArgs = args;
        if (rafId === null) rafId = requestAnimationFrame(()=>{
            fn(...lastArgs);
            rafId = null;
        });
    };
    throttled.cancel = ()=>{
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
    };
    return throttled;
};
const idleDebounce = (fn, timeout = 100)=>{
    let idleId = null;
    const debounced = (...args)=>{
        if (idleId !== null) cancelIdleCallback(idleId);
        idleId = requestIdleCallback(()=>{
            fn(...args);
            idleId = null;
        }, {
            timeout
        });
    };
    debounced.cancel = ()=>{
        if (idleId !== null) {
            cancelIdleCallback(idleId);
            idleId = null;
        }
    };
    return debounced;
};
const batchSetFeatureState = (map, source, updates)=>{
    requestAnimationFrame(()=>{
        updates.forEach(({ id, state })=>{
            map.setFeatureState({
                source,
                id
            }, state);
        });
    });
};
const replaceFeatureStates = (map, source, updates)=>{
    // Clear all feature states at once (much faster than individual clears)
    map.removeFeatureState({
        source
    });
    // Set new states
    updates.forEach(({ id, state })=>{
        map.setFeatureState({
            source,
            id
        }, state);
    });
};
const createFeaturesOptimized = (items, mapper)=>{
    const features = new Array(items.length);
    for(let i = 0, len = items.length; i < len; i++)features[i] = mapper(items[i], i);
    return features;
};
const isMapAnimating = (map)=>{
    return map.isMoving() || map.isZooming() || map.isRotating();
};
const whenMapIdle = (map, callback, maxWait = 2000)=>{
    if (!isMapAnimating(map)) {
        callback();
        return;
    }
    const timeoutId = setTimeout(callback, maxWait);
    const onIdle = ()=>{
        clearTimeout(timeoutId);
        map.off('idle', onIdle);
        callback();
    };
    map.once('idle', onIdle);
};
const calculateBoundsOptimized = (items)=>{
    if (!items || items.length === 0) return null;
    let minLng = Infinity;
    let minLat = Infinity;
    let maxLng = -Infinity;
    let maxLat = -Infinity;
    for(let i = 0, len = items.length; i < len; i++){
        const [lng, lat] = items[i].coordinates;
        if (lng < minLng) minLng = lng;
        if (lng > maxLng) maxLng = lng;
        if (lat < minLat) minLat = lat;
        if (lat > maxLat) maxLat = lat;
    }
    return {
        minLng,
        minLat,
        maxLng,
        maxLat
    };
};
const boundsToArray = (bounds)=>{
    return [
        [
            bounds.minLng,
            bounds.minLat
        ],
        [
            bounds.maxLng,
            bounds.maxLat
        ]
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"buDVS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "insertNearest", ()=>insertNearest);
function insertNearest(results, entry, limit = 25) {
    if (results.length === limit && entry.distance >= results[results.length - 1].distance) return;
    let low = 0;
    let high = results.length;
    while(low < high){
        const mid = low + high >> 1;
        if (results[mid].distance <= entry.distance) low = mid + 1;
        else high = mid;
    }
    results.splice(low, 0, entry);
    if (results.length > limit) results.pop();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"gdEzT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COLLAPSED_SEARCH_LIMIT", ()=>COLLAPSED_SEARCH_LIMIT);
parcelHelpers.export(exports, "SEARCH_RESULT_LIMIT", ()=>SEARCH_RESULT_LIMIT);
const COLLAPSED_SEARCH_LIMIT = 25;
const SEARCH_RESULT_LIMIT = 50;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"8ZuIH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BusServicesArrival);
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _reactI18Next = require("react-i18next");
var _fuseJs = require("fuse.js");
var _fuseJsDefault = parcelHelpers.interopDefault(_fuseJs);
var _getRoute = require("../utils/getRoute");
var _getRouteDefault = parcelHelpers.interopDefault(_getRoute);
var _rafInterval = require("../utils/rafInterval");
var _bus = require("../utils/bus");
var _cityConfig = require("../city-config");
var _fetchCache = require("../utils/fetchCache");
var _fetchCacheDefault = parcelHelpers.interopDefault(_fetchCache);
var _fetchArrivals = require("../utils/fetchArrivals");
var _scheduleArrivals = require("../utils/scheduleArrivals");
var _arrivalTimeText = require("./ArrivalTimeText");
var _arrivalTimeTextDefault = parcelHelpers.interopDefault(_arrivalTimeText);
function BusServicesArrival({ services, id, map, active, showBusesOnMap, stopData, // Added to access destination groups
cityCode, // Optional city override for all-mode stop popovers
stopsData: stopsDataProp, // Optional stopsData override for all-mode (avoids window._data)
onLoadingChange, // Callback to notify parent of loading state
onErrorChange, // Callback to notify parent of error state
onSourceChange, // Callback to notify parent of the live data source ('api' | 'gtfs-rt' | null)
cancelRef, // Ref to expose cancel function to parent
destFilter = '', destFilterExact = false, onDestFilterChange = ()=>{} }) {
    var _getConfigForCity, _route_value;
    if (!id) return;
    const { t } = (0, _reactI18Next.useTranslation)();
    const [isLoading, setIsLoading] = (0, _hooks.useState)(false);
    const [hasError, setHasError] = (0, _hooks.useState)(false);
    const [servicesArrivals, setServicesArrivals] = (0, _hooks.useState)({});
    // True when live arrivals are unavailable; the whole stop falls back to the
    // static schedule (every route shows its next scheduled departure).
    const [staticFallback, setStaticFallback] = (0, _hooks.useState)(false);
    const [servicesIssues, setServicesIssues] = (0, _hooks.useState)([]);
    const [oneServiceHasMultipleDirections, setOneServiceHasMultipleDirections] = (0, _hooks.useState)(false);
    const [scheduleData, setScheduleData] = (0, _hooks.useState)(null);
    const route = (0, _getRouteDefault.default)();
    const isAllMode = route.city === 'all';
    const resolvedCity = cityCode !== null && cityCode !== void 0 ? cityCode : route.city;
    const resolvedCityPrefix = cityCode ? `/${cityCode}` : route.cityPrefix;
    // In all-mode, service links use city-qualified #/all/services/city^service format
    const makeServiceHref = (service)=>isAllMode && cityCode ? `#/all/services/${cityCode}^${encodeURIComponent(service)}` : `#${resolvedCityPrefix}/services/${encodeURIComponent(service)}`;
    // Recompute scheduled departures at most once per minute.
    //   scheduleOriginETAs — only routes that originate at this stop (live tracking
    //     has no data there until the bus departs), used alongside live arrivals.
    //   scheduleAllETAs — every route passing this stop, used as a full static
    //     fallback when live arrivals are unavailable.
    const etaMinute = Math.floor(Date.now() / 60000);
    const scheduleOriginETAs = (0, _hooks.useMemo)(()=>(0, _scheduleArrivals.scheduleETAByRoute)(scheduleData, {
            originStopId: id
        }), [
        scheduleData,
        id,
        etaMinute
    ]);
    const scheduleAllETAs = (0, _hooks.useMemo)(()=>(0, _scheduleArrivals.scheduleETAByRoute)(scheduleData), [
        scheduleData,
        etaMinute
    ]);
    // ETA for a route: live tracking ETA when available, otherwise a schedule ETA.
    // In static fallback (live data unavailable) every route uses its schedule ETA;
    // otherwise only origin-stop routes do. `scheduled` flags the schedule-based
    // ones so they can be styled differently.
    const getServiceETA = (service)=>{
        const live = servicesArrivals[service];
        if (live) return {
            ms: live,
            scheduled: false
        };
        const sched = (staticFallback ? scheduleAllETAs : scheduleOriginETAs).get(service);
        if (sched != null) return {
            ms: sched,
            scheduled: true
        };
        return null;
    };
    // Routes arriving within the city's maxArrivalTime window are shown in the
    // primary set; routes arriving later (or with no known ETA) are split out into
    // a separate second set, so the soon-arriving routes aren't buried among them.
    // A third set holds routes with no ETA at all (no live tracking and no
    // schedule). Each service falls into exactly one bucket.
    const maxArrivalTime = (_getConfigForCity = (0, _cityConfig.getConfigForCity)(resolvedCity)) === null || _getConfigForCity === void 0 ? void 0 : _getConfigForCity.maxArrivalTime;
    const arrivalBucket = (service)=>{
        const eta = getServiceETA(service);
        if (eta == null) return 'noETA';
        return eta.ms <= maxArrivalTime ? 'withinWindow' : 'beyondWindow';
    };
    // When filter is active, group services by which downstream stop name fuzzy-matches.
    // Each service may appear under multiple matching stop names.
    // Returns null when no filter is active.
    // The Fuse index is built lazily here — only when destFilter is non-empty — so
    // opening a stop popover without typing a filter carries no indexing cost.
    const matchingStopGroups = (0, _hooks.useMemo)(()=>{
        if (!destFilter.trim() || !(stopData === null || stopData === void 0 ? void 0 : stopData.destinationGroups)) return null;
        const names = new Set();
        services.forEach((service)=>{
            const serviceDestGroups = stopData.destinationGroups[service];
            if (!serviceDestGroups) return;
            Object.values(serviceDestGroups).forEach(({ routes })=>{
                routes.forEach((routeStops)=>{
                    const idx = routeStops.indexOf(stopData.number);
                    if (idx === -1) return;
                    routeStops.slice(idx + 1).forEach((stopId)=>{
                        var _stopId, _this, _window__data;
                        const stopName = (_this = stopsDataProp !== null && stopsDataProp !== void 0 ? stopsDataProp : (_window__data = window._data) === null || _window__data === void 0 ? void 0 : _window__data.stopsData) === null || _this === void 0 ? void 0 : (_stopId = _this[stopId]) === null || _stopId === void 0 ? void 0 : _stopId.name;
                        if (stopName) names.add(stopName);
                    });
                });
            });
        });
        const fuzzyMatches = destFilterExact ? new Set([
            destFilter.trim()
        ]) : new Set(new (0, _fuseJsDefault.default)(Array.from(names), {
            threshold: 0.35
        }).search(destFilter).map((r)=>r.item));
        if (fuzzyMatches.size === 0) return [];
        const stopNameToServices = new Map();
        services.forEach((service)=>{
            const serviceDestGroups = stopData.destinationGroups[service];
            if (!serviceDestGroups) return;
            // Track which stop names we've already added this service to (avoid duplicates)
            const matchedStopNames = new Set();
            Object.values(serviceDestGroups).forEach(({ routes })=>{
                routes.forEach((routeStops)=>{
                    const idx = routeStops.indexOf(stopData.number);
                    if (idx === -1) return;
                    routeStops.slice(idx + 1).forEach((stopId)=>{
                        var _stopId, _this, _window__data;
                        const stopName = (_this = stopsDataProp !== null && stopsDataProp !== void 0 ? stopsDataProp : (_window__data = window._data) === null || _window__data === void 0 ? void 0 : _window__data.stopsData) === null || _this === void 0 ? void 0 : (_stopId = _this[stopId]) === null || _stopId === void 0 ? void 0 : _stopId.name;
                        if (stopName && fuzzyMatches.has(stopName) && !matchedStopNames.has(stopName)) {
                            matchedStopNames.add(stopName);
                            if (!stopNameToServices.has(stopName)) stopNameToServices.set(stopName, new Set());
                            stopNameToServices.get(stopName).add(service);
                        }
                    });
                });
            });
        });
        return Array.from(stopNameToServices.entries()).map(([stopName, serviceSet])=>({
                stopName,
                services: Array.from(serviceSet).sort((0, _bus.sortServices))
            })).sort((a, b)=>b.services.length - a.services.length);
    }, [
        services,
        destFilter,
        destFilterExact,
        stopData,
        stopsDataProp
    ]);
    const controllerRef = (0, _hooks.useRef)(null);
    const fetchServices = (0, _hooks.useCallback)(async ()=>{
        setIsLoading(true);
        setHasError(false);
        onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(true);
        controllerRef.current = new AbortController();
        const { signal } = controllerRef.current;
        try {
            var _cityConfig_stopRoutes, _cityConfig_liveArrivals;
            const cityConfig = (0, _cityConfig.getConfigForCity)(resolvedCity);
            const stopRoutesApiPath = cityConfig === null || cityConfig === void 0 ? void 0 : (_cityConfig_stopRoutes = cityConfig.stopRoutes) === null || _cityConfig_stopRoutes === void 0 ? void 0 : _cityConfig_stopRoutes.apiPath;
            const arrivalsApiPath = stopRoutesApiPath || (cityConfig === null || cityConfig === void 0 ? void 0 : (_cityConfig_liveArrivals = cityConfig.liveArrivals) === null || _cityConfig_liveArrivals === void 0 ? void 0 : _cityConfig_liveArrivals.apiPath);
            if (!arrivalsApiPath) {
                // No live arrivals for this city: rely entirely on the static schedule.
                setStaticFallback(true);
                setIsLoading(false);
                setHasError(false);
                onErrorChange === null || onErrorChange === void 0 ? void 0 : onErrorChange(false);
                onSourceChange === null || onSourceChange === void 0 ? void 0 : onSourceChange(null);
                onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(false);
                return;
            }
            // Phase 1: Fetch routes/ETAs and render immediately
            const routeData = await (0, _fetchArrivals.fetchStopRoutes)(arrivalsApiPath, id, signal);
            if (routeData) {
                const { services, servicesArrivals, source } = routeData;
                setServicesArrivals(servicesArrivals);
                setStaticFallback(false);
                setIsLoading(false);
                setHasError(false);
                onErrorChange === null || onErrorChange === void 0 ? void 0 : onErrorChange(false);
                // A working feed with nothing due right now is a normal, common
                // state for a stop (not every stop has a bus/train due at any given
                // moment) — that's not an error, but it also isn't "live data
                // flowing" either, so the indicator shouldn't claim a source with
                // nothing behind it.
                onSourceChange === null || onSourceChange === void 0 ? void 0 : onSourceChange(services.length ? source : null);
                onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(false);
                // Check for issues (duplicate services, multiple visits)
                const servicesWithIssues = [];
                services.forEach((service, i)=>{
                    const hasDuplicateServices = services.findIndex((s)=>s.no === service.no) !== i;
                    if (hasDuplicateServices) servicesWithIssues.push(service.no);
                    const { next, next2, next3, next4, next5 } = service;
                    const hasMultipleVisits = (next === null || next === void 0 ? void 0 : next.visit_number) > 1 || (next2 === null || next2 === void 0 ? void 0 : next2.visit_number) > 1 || (next3 === null || next3 === void 0 ? void 0 : next3.visit_number) > 1 || (next4 === null || next4 === void 0 ? void 0 : next4.visit_number) > 1 || (next5 === null || next5 === void 0 ? void 0 : next5.visit_number) > 1;
                    if (hasMultipleVisits) servicesWithIssues.push(service.no);
                });
                setServicesIssues(servicesWithIssues);
                setOneServiceHasMultipleDirections(servicesWithIssues.length > 0);
            } else {
                // null means the live fetch failed (an empty-but-valid response comes
                // back as { services: [] }). Fall back to the static schedule, surface
                // the error indicator, and drop any stale live ETAs.
                setServicesArrivals({});
                setStaticFallback(true);
                setHasError(true);
                onErrorChange === null || onErrorChange === void 0 ? void 0 : onErrorChange(true);
                onSourceChange === null || onSourceChange === void 0 ? void 0 : onSourceChange(null);
                setIsLoading(false);
                onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(false);
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                setServicesArrivals({});
                setStaticFallback(true);
                setHasError(true);
                onErrorChange === null || onErrorChange === void 0 ? void 0 : onErrorChange(true);
                onSourceChange === null || onSourceChange === void 0 ? void 0 : onSourceChange(null);
                setIsLoading(false);
                onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(false);
                return;
            }
        } finally{
            setIsLoading(false);
            onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(false);
        }
    }, [
        id,
        resolvedCity,
        onLoadingChange,
        onErrorChange,
        onSourceChange
    ]);
    // Fetch schedule data to get trip_count for each service
    (0, _hooks.useEffect)(()=>{
        if (!id) return;
        const cityConfig = (0, _cityConfig.getConfigForCity)(resolvedCity);
        const scheduleJSONPath = `https://data.transitrouter.vonter.in/${resolvedCity}/schedule`;
        (0, _fetchCacheDefault.default)(`${scheduleJSONPath}/${id}.json`, 3600) // Cache for 1 hour
        .then((data)=>{
            setScheduleData(data);
        }).catch((error)=>{
            setScheduleData(null);
        });
    }, [
        id,
        resolvedCity
    ]);
    (0, _hooks.useEffect)(()=>{
        let intervalID;
        if (active) {
            var _localStorage_getItem;
            const sec = (0, _cityConfig.isDevMode)() ? Number((_localStorage_getItem = localStorage.getItem('refreshInterval')) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : 60) : 60;
            if (sec > 0) intervalID = (0, _rafInterval.setRafInterval)(fetchServices, sec * 1000);
        }
        return ()=>{
            var _controllerRef_current;
            (0, _rafInterval.clearRafInterval)(intervalID);
            (_controllerRef_current = controllerRef.current) === null || _controllerRef_current === void 0 ? void 0 : _controllerRef_current.abort();
        };
    }, [
        active,
        fetchServices
    ]);
    // Expose cancel function via ref
    (0, _hooks.useEffect)(()=>{
        if (cancelRef) cancelRef.current = ()=>{
            if (controllerRef.current) {
                controllerRef.current.abort();
                setIsLoading(false);
                setHasError(false);
                onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(false);
                onErrorChange === null || onErrorChange === void 0 ? void 0 : onErrorChange(false);
                onSourceChange === null || onSourceChange === void 0 ? void 0 : onSourceChange(null);
            }
        };
        return ()=>{
            if (cancelRef) cancelRef.current = null;
        };
    }, [
        onLoadingChange,
        onErrorChange,
        onSourceChange
    ]);
    // Notify parent of error state changes
    (0, _hooks.useEffect)(()=>{
        onErrorChange === null || onErrorChange === void 0 ? void 0 : onErrorChange(hasError);
    }, [
        hasError,
        onErrorChange
    ]);
    const servicesValue = ((_route_value = route.value) === null || _route_value === void 0 ? void 0 : _route_value.split('~')) || [];
    // Split routes into three sets — arriving within the maxArrivalTime window,
    // arriving later, and with no ETA at all — then group each set by terminal
    // destination. Only used when no destination filter is active.
    const groupedByDestination = (0, _hooks.useMemo)(()=>{
        const buckets = {
            withinWindow: [],
            beyondWindow: [],
            noETA: []
        };
        services.forEach((service)=>buckets[arrivalBucket(service)].push(service));
        const { withinWindow: withinWindowServices, beyondWindow: beyondWindowServices, noETA: noETAServices } = buckets;
        if (!(stopData === null || stopData === void 0 ? void 0 : stopData.destinationGroups)) // Fallback to old format if destinationGroups not available
        return {
            hasGroups: false,
            withinWindowServices: withinWindowServices.sort((0, _bus.sortServices)),
            beyondWindowServices: beyondWindowServices.sort((0, _bus.sortServices)),
            noETAServices: noETAServices.sort((0, _bus.sortServices))
        };
        // Build a map of service number to trip_count from schedule data
        const serviceTripCounts = new Map();
        if (scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.services) scheduleData.services.forEach((serviceData)=>{
            serviceTripCounts.set(serviceData.no, serviceData.trip_count || 0);
        });
        // Helper function to group services by destination
        const groupServicesByDestination = (serviceList)=>{
            const destinationMap = new Map();
            serviceList.forEach((service)=>{
                const destinationData = stopData.destinationGroups[service];
                if (destinationData) // For each destination this service goes to
                Object.keys(destinationData).forEach((destId)=>{
                    var _destId, _this, _window__data;
                    if (!destinationMap.has(destId)) destinationMap.set(destId, {
                        id: destId,
                        name: ((_this = stopsDataProp !== null && stopsDataProp !== void 0 ? stopsDataProp : (_window__data = window._data) === null || _window__data === void 0 ? void 0 : _window__data.stopsData) === null || _this === void 0 ? void 0 : (_destId = _this[destId]) === null || _destId === void 0 ? void 0 : _destId.name) || destId,
                        services: [],
                        maxStopCount: 0,
                        totalTripCount: 0
                    });
                    const dest = destinationMap.get(destId);
                    dest.services.push(service);
                    // Track the maximum stop count to this destination
                    const stopCount = destinationData[destId].stopCount || 0;
                    if (stopCount > dest.maxStopCount) dest.maxStopCount = stopCount;
                    // Add trip_count to total for this destination
                    const tripCount = serviceTripCounts.get(service) || 0;
                    dest.totalTripCount += tripCount;
                });
            });
            // Convert to array and sort by total trip_count (descending)
            return Array.from(destinationMap.values()).sort((a, b)=>{
                return b.totalTripCount - a.totalTripCount;
            });
        };
        const withinWindowDestinations = groupServicesByDestination(withinWindowServices);
        const beyondWindowDestinations = groupServicesByDestination(beyondWindowServices);
        const noETADestinations = groupServicesByDestination(noETAServices);
        return {
            hasGroups: true,
            withinWindowDestinations,
            beyondWindowDestinations,
            noETADestinations
        };
    }, [
        services,
        stopData,
        scheduleData,
        servicesArrivals,
        staticFallback,
        maxArrivalTime,
        scheduleOriginETAs,
        scheduleAllETAs,
        stopsDataProp
    ]);
    // Renders the ETA badge for a route. Schedule-based ETAs (origin stops) are
    // italicised and prefixed with "~" to distinguish them from live ETAs.
    const renderETA = (service)=>{
        const eta = getServiceETA(service);
        if (!eta) return null;
        return (0, _preact.h)("span", {
            class: eta.scheduled ? 'scheduled-eta' : ''
        }, eta.scheduled && '~', (0, _preact.h)((0, _arrivalTimeTextDefault.default), {
            ms: eta.ms
        }));
    };
    // Renders a list of service tags. Routes with a live ETA come first (soonest
    // first), then origin-stop routes shown with their schedule ETA, then the rest.
    const renderServiceTags = (serviceList)=>(0, _preact.h)("p", {
            class: `services-list ${isLoading ? 'loading' : ''}`,
            style: {
                marginTop: '4px'
            }
        }, [
            ...serviceList
        ].sort((a, b)=>{
            const ea = getServiceETA(a), eb = getServiceETA(b);
            const rank = (e)=>e ? e.scheduled ? 1 : 0 : 2;
            const ra = rank(ea), rb = rank(eb);
            if (ra !== rb) return ra - rb;
            if (ea && eb) return ea.ms - eb.ms;
            return (0, _bus.sortServices)(a, b);
        }).map((service)=>(0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("a", {
                href: makeServiceHref(service),
                class: `service-tag ${route.page === 'service' && servicesValue.includes(service) ? 'current' : ''}`
            }, service, renderETA(service)), ' ')));
    // Helper component to render a destination group (terminal destination header + routes)
    const renderDestinationGroup = (dest)=>(0, _preact.h)("div", {
            key: dest.id,
            class: "service-destination-group"
        }, (0, _preact.h)("p", {
            class: "service-destination-info"
        }, (0, _preact.h)("strong", null, dest.name)), renderServiceTags(dest.services));
    // Helper component to render a service list (for fallback when no destination groups)
    const renderServiceList = (serviceList)=>(0, _preact.h)("p", {
            class: `services-list ${isLoading ? 'loading' : ''}`
        }, serviceList.map((service)=>(0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("a", {
                href: makeServiceHref(service),
                class: `service-tag ${route.page === 'service' && servicesValue.includes(service) ? 'current' : ''}`
            }, service, servicesIssues.includes(service) && " \u26A0\uFE0F", renderETA(service)), ' ')));
    return (0, _preact.h)((0, _preact.Fragment), null, destFilter.trim() ? // Filter active: group routes by the downstream stop name that matched
    matchingStopGroups && matchingStopGroups.length > 0 ? (()=>{
        const renderDestGroup = (stopName, services)=>(0, _preact.h)("div", {
                class: "service-destination-group"
            }, (0, _preact.h)("p", {
                class: "service-destination-info"
            }, (0, _preact.h)("strong", {
                style: {
                    cursor: 'pointer'
                },
                onClick: ()=>onDestFilterChange(stopName, true)
            }, stopName)), renderServiceTags(services));
        return (0, _preact.h)("div", {
            class: "service-arrival-group"
        }, matchingStopGroups.map(({ stopName, services: svc })=>{
            const withETA = svc.filter((s)=>servicesArrivals[s]);
            return withETA.length > 0 ? renderDestGroup(stopName, withETA) : null;
        }), matchingStopGroups.map(({ stopName, services: svc })=>{
            const withoutETA = svc.filter((s)=>!servicesArrivals[s]);
            return withoutETA.length > 0 ? renderDestGroup(stopName, withoutETA) : null;
        }));
    })() : (0, _preact.h)("p", {
        class: "dest-filter-empty"
    }, "No routes to \"", destFilter, "\"") : // No filter: show existing terminal-destination grouping
    (0, _preact.h)((0, _preact.Fragment), null, groupedByDestination.hasGroups ? (0, _preact.h)((0, _preact.Fragment), null, groupedByDestination.withinWindowDestinations.length > 0 && (0, _preact.h)("div", {
        class: "service-arrival-group"
    }, groupedByDestination.withinWindowDestinations.map((dest)=>renderDestinationGroup(dest))), groupedByDestination.beyondWindowDestinations.length > 0 && (0, _preact.h)("div", {
        class: "service-arrival-group"
    }, groupedByDestination.beyondWindowDestinations.map((dest)=>renderDestinationGroup(dest))), groupedByDestination.noETADestinations.length > 0 && (0, _preact.h)("div", {
        class: "service-arrival-group"
    }, groupedByDestination.noETADestinations.map((dest)=>renderDestinationGroup(dest)))) : (0, _preact.h)((0, _preact.Fragment), null, groupedByDestination.withinWindowServices.length > 0 && (0, _preact.h)("div", {
        class: "service-arrival-group"
    }, renderServiceList(groupedByDestination.withinWindowServices)), groupedByDestination.beyondWindowServices.length > 0 && (0, _preact.h)("div", {
        class: "service-arrival-group"
    }, renderServiceList(groupedByDestination.beyondWindowServices)), groupedByDestination.noETAServices.length > 0 && (0, _preact.h)("div", {
        class: "service-arrival-group"
    }, renderServiceList(groupedByDestination.noETAServices)))));
}

},{"preact":"ej31g","preact/hooks":"gK13j","react-i18next":"d3rqO","fuse.js":"jdnFU","../utils/getRoute":"kYEZr","../utils/rafInterval":"aSR6k","../utils/bus":"4E495","../city-config":"7oMBO","../utils/fetchCache":"kNdlE","../utils/fetchArrivals":"awwGd","../utils/scheduleArrivals":"fwRP1","./ArrivalTimeText":"7XWv2","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"fe4TF":[function(require,module,exports,__globalThis) {
// SVG icon for close button - exported for reuse
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOSE_SVG", ()=>CLOSE_SVG);
const CLOSE_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
</svg>`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"kT5y8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GEOLOCATE_SVG", ()=>GEOLOCATE_SVG);
// A fork of Mapbox GL JS's GeolocateControl, simplified + compass support
parcelHelpers.export(exports, "default", ()=>GeolocateControl);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _maplibreGl = require("maplibre-gl");
var _maplibreGlDefault = parcelHelpers.interopDefault(_maplibreGl);
var _checkGeolocationSupport = require("../utils/checkGeolocationSupport");
var _checkGeolocationSupportDefault = parcelHelpers.interopDefault(_checkGeolocationSupport);
var _compassHeading = require("../utils/compassHeading");
var _compassHeadingDefault = parcelHelpers.interopDefault(_compassHeading);
const GEOLOCATE_SVG = `<svg viewBox="0 0 16 15" width="18" height="18">
    <path d="M.75 5.94c-.3.14-.51.33-.63.57a1.12 1.12 0 00.3 1.38c.2.17.47.26.8.27l5.54.02c.06 0 .09 0 .1.02.02.02.02.05.02.1l.02 5.5c.01.35.1.62.28.82.17.2.39.33.64.37.26.04.51-.01.77-.14.25-.14.45-.37.6-.7l5.7-12.34c.16-.32.22-.61.18-.87a1.05 1.05 0 00-.32-.65c-.17-.16-.4-.26-.67-.28-.28-.03-.58.03-.9.18L.75 5.94z"/>
    <path fill="#fff" class="inner" d="M2.37 6.74h-.02c0-.01 0-.02.02-.03l10.9-4.95h.03l-.01.03-4.97 10.88c0 .02-.01.02-.02.02v-.02l.04-5.31a.64.64 0 00-.66-.66l-5.31.04z"/>
  </svg>`;
class GeolocateControl {
    onAdd(map) {
        this._map = map;
        const container = document.createElement('div');
        container.className = 'maplibregl-ctrl maplibregl-ctrl-group';
        this._container = container;
        (0, _checkGeolocationSupportDefault.default)(this._setupUI);
        return this._container;
    }
    constructor(options){
        (0, _defineProperty._)(this, "_watching", false);
        (0, _defineProperty._)(this, "_locking", false);
        (0, _defineProperty._)(this, "_setup", false);
        (0, _defineProperty._)(this, "_currentLocation", null);
        (0, _defineProperty._)(this, "_buttonClicked", false);
        (0, _defineProperty._)(this, "_orientationGranted", false);
        (0, _defineProperty._)(this, "_retries", 0);
        (0, _defineProperty._)(this, "_externalButtons", []) // Track external buttons for state updates
        ;
        (0, _defineProperty._)(this, "_setupUI", (supported)=>{
            supported;
            // Only create the map control button if showMapControl is true
            if (this.options.showMapControl) {
                const button = document.createElement('button');
                button.className = 'maplibregl-ctrl-icon maplibregl-ctrl-custom-geolocate';
                button.type = 'button';
                button.innerHTML = GEOLOCATE_SVG;
                button.addEventListener('click', this._clickButton, false);
                this._button = button;
                this._container.appendChild(this._button);
            }
            const dot = document.createElement('div');
            dot.innerHTML = `<div class="user-location-dot"></div>
      <div class="user-location-compass" hidden></div>`;
            // <div class="user-location-accuracy"></div>`;
            dot.className = 'user-location';
            this._dot = new (0, _maplibreGlDefault.default).Marker({
                element: dot,
                rotationAlignment: 'map'
            });
            const dotElement = this._dot.getElement();
            this._compass = dotElement.querySelector('.user-location-compass');
            // this._accuracy = dotElement.querySelector('.user-location-accuracy');
            this._map.on('movestart', (e)=>{
                if (!e.geolocateSource && this._locking) {
                    this._locking = false;
                    this._updateButtonState(null);
                }
            });
            this._setup = true;
            const isStandalone = window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
            // Auto-trigger in two cases:
            // 1. Permission explicitly granted (from Permissions API)
            // 2. Running as installed PWA and permission isn't explicitly denied
            //    (iOS PWA often returns 'prompt' even when previously granted)
            if (supported === 'granted' || isStandalone && supported !== false && supported !== 'denied') this._clickButton(null, false);
        });
        (0, _defineProperty._)(this, "registerExternalButton", (btn)=>this._externalButtons.push(btn));
        (0, _defineProperty._)(this, "trigger", ()=>this._clickButton(null, true));
        (0, _defineProperty._)(this, "_updateButtonState", (state)=>{
            // Update map control button and all external buttons
            [
                this._button,
                ...this._externalButtons
            ].filter(Boolean).forEach((btn)=>{
                btn.classList.remove('loading', 'active');
                if (state) btn.classList.add(state);
            });
        });
        (0, _defineProperty._)(this, "_flyToCurrentLocation", ()=>{
            const map = this._map;
            const { _currentLocation: center } = this;
            const { offset: _offset } = this.options;
            const offset = typeof _offset === 'function' ? _offset() : _offset;
            const { x, y } = map.project(center);
            const { offsetWidth, offsetHeight, offsetLeft, offsetTop } = map.getContainer();
            const margin = Math.max(offsetWidth, offsetHeight);
            const withinBounds = x > offsetLeft - margin && x < offsetWidth + margin && y > offsetTop - margin && y < offsetHeight + margin;
            // console.log(center, x, y, offsetLeft, offsetTop, offsetWidth, offsetHeight);
            const eventData = {
                geolocateSource: true
            };
            if (withinBounds) {
                if (map.getZoom() < 14) map.easeTo({
                    center,
                    zoom: 18,
                    duration: 300,
                    offset,
                    animate: false
                }, eventData);
                else map.flyTo({
                    center,
                    zoom: 18,
                    speed: 1.5,
                    duration: 2000,
                    offset
                }, eventData);
            } else map.easeTo({
                center,
                zoom: 18,
                duration: 300,
                offset,
                animate: false
            }, eventData);
        });
        (0, _defineProperty._)(this, "_setHeading", (e)=>{
            if (!this._watching) return;
            if (!e || e.alpha === null) return;
            this._compass.hidden = false;
            const heading = e.compassHeading || e.webkitCompassHeading || (0, _compassHeadingDefault.default)(e.alpha, e.beta, e.gamma);
            // -60deg rotateX is for *tilting* the compass "box" to look like a trapezoid
            // this._compass.style.transform = `rotate(${Math.round(
            //   heading,
            // )}deg) scale(4)`;
            this._dot.setRotation(heading);
        });
        (0, _defineProperty._)(this, "_clickButton", (e, locking = true)=>{
            if (e) e.preventDefault();
            if (!this._setup) return;
            const { onClick } = this.options;
            if (this._watching) {
                this._updateButtonState('active');
                this._flyToCurrentLocation();
                this._locking = true;
                onClick(this._currentLocation);
            } else {
                this._updateButtonState('loading');
                this._buttonClicked = true;
                this._locking = locking;
                let deviceorientation;
                this._watching = navigator.geolocation.watchPosition((position)=>{
                    const { latitude, longitude } = position.coords;
                    if (`${[
                        latitude,
                        longitude
                    ]}` === `${this._currentLocation}`) return; // No idea why
                    // console.log({ latitude, longitude });
                    this._currentLocation = [
                        longitude,
                        latitude
                    ];
                    this._dot.setLngLat(this._currentLocation);
                    if (!this._dot._addedToMap) {
                        this._dot.addTo(this._map);
                        this._dot._addedToMap = true;
                    }
                    if (this._locking) {
                        this._updateButtonState('active');
                        this._flyToCurrentLocation();
                    } else this._updateButtonState(null);
                    if (this._buttonClicked) {
                        // Only call onClick when button was clicked, not on continuous location updates
                        // Differentiate between initiated from button click or watchPosition subsequent runs
                        this._buttonClicked = false;
                        onClick(this._currentLocation);
                    }
                    this._watching = true;
                }, (e)=>{
                    this._locking = false;
                    this._watching = false;
                    this._buttonClicked = false;
                    this._updateButtonState(null);
                    navigator.geolocation.clearWatch(this._watching);
                    if (deviceorientation) window.removeEventListener(deviceorientation, this._setHeading);
                    this._retries++;
                    if (e.code === 1) // PERMISSION_DENIED
                    alert('Looks like location tracking is blocked on your browser. Please enable it in the settings to use this feature. For the best experience, choose "Always" when prompted for location access.');
                    else {
                        if (this._retries > 3) return;
                        // Retry again
                        this._clickButton();
                    }
                }, {
                    enableHighAccuracy: true,
                    timeout: 60000,
                    // 1min
                    maximumAge: 1000 // 1s
                });
                if (window.DeviceOrientationEvent) {
                    // https://developers.google.com/web/updates/2016/03/device-orientation-changes
                    // https://stackoverflow.com/a/47870694/20838
                    if (location.hostname === 'localhost') // Stupid bug with Chrome
                    // `ondeviceorientationabsolute` is true but always return empty values
                    deviceorientation = 'deviceorientation';
                    else deviceorientation = 'ondeviceorientationabsolute' in window ? 'deviceorientationabsolute' : 'deviceorientation';
                    window.addEventListener(deviceorientation, this._setHeading, false);
                    if (!this._orientationGranted) {
                        if (typeof DeviceOrientationEvent.requestPermission === 'function') DeviceOrientationEvent.requestPermission().then(function(permissionState) {
                            if (permissionState === 'granted') this._orientationGranted = true;
                        }).catch((e)=>{});
                    }
                }
            }
        });
        this.options = Object.assign({
            offset: [
                0,
                0
            ],
            onClick: ()=>{},
            showMapControl: true // Whether to show the map control button
        }, options);
    }
}

},{"@swc/helpers/_/_define_property":"24f9u","maplibre-gl":"gacdv","../utils/checkGeolocationSupport":"1Knwb","../utils/compassHeading":"3BXuA","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"1Knwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>checkGeolocationSupport);
let supportsGeolocation;
function checkGeolocationSupport(callback) {
    if (supportsGeolocation !== undefined) callback(supportsGeolocation);
    else if (window.navigator.permissions !== undefined) // navigator.permissions has incomplete browser support
    // http://caniuse.com/#feat=permissions-api
    // Test for the case where a browser disables Geolocation because of an
    // insecure origin
    window.navigator.permissions.query({
        name: 'geolocation'
    }).then((p)=>{
        supportsGeolocation = p.state === 'denied' ? false : p.state;
        callback(supportsGeolocation);
    });
    else {
        supportsGeolocation = !!window.navigator.geolocation;
        callback(supportsGeolocation);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"3BXuA":[function(require,module,exports,__globalThis) {
// https://stackoverflow.com/a/21829819/20838
// http://w3c.github.io/deviceorientation/spec-source-orientation.html#worked-example
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>compassHeading);
const degtorad = Math.PI / 180; // Degree-to-Radian conversion
function compassHeading(alpha, beta, gamma) {
    const _x = beta ? beta * degtorad : 0; // beta value
    const _y = gamma ? gamma * degtorad : 0; // gamma value
    const _z = alpha ? alpha * degtorad : 0; // alpha value
    const cX = Math.cos(_x);
    const cY = Math.cos(_y);
    const cZ = Math.cos(_z);
    const sX = Math.sin(_x);
    const sY = Math.sin(_y);
    const sZ = Math.sin(_z);
    // Calculate Vx and Vy components
    const Vx = -cZ * sY - sZ * sX * cY;
    const Vy = -sZ * sY + cZ * sX * cY;
    // Calculate compass heading
    let compassHeading = Math.atan(Vx / Vy);
    // Convert compass heading to use whole unit circle
    if (Vy < 0) compassHeading += Math.PI;
    else if (Vx < 0) compassHeading += 2 * Math.PI;
    return compassHeading * (180 / Math.PI); // Compass Heading (in degrees)
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"6sgRh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sortAndFilterResults", ()=>sortAndFilterResults);
parcelHelpers.export(exports, "default", ()=>BetweenRoutes);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _cityConfig = require("../city-config");
var _theme = require("../utils/theme");
const ONE_HOUR_MS = 3600000;
// Mirrors raptor.js's WALK_SPEED_MPS — used only to *display* an estimated
// walk duration; the search itself already baked the real figure into
// alightTime, which isn't carried on the leg as a bare duration.
const WALK_SPEED_MPS = 1.1;
// Same start/end pair the between-popover list already uses for its
// start(red)→end(purple) gradient (see #between-popover .between-stops in
// app.css) — reused here so the detail timeline reads as the same visual
// language rather than introducing a new accent color.
const TIMELINE_START_COLOR = (0, _theme.isDark) ? '#ff4d6d' : '#f01b48';
const TIMELINE_END_COLOR = (0, _theme.isDark) ? '#b967ff' : '#972ffe';
function hexToRgb(hex) {
    const n = parseInt(hex.slice(1), 16);
    return {
        r: n >> 16 & 255,
        g: n >> 8 & 255,
        b: n & 255
    };
}
const START_RGB = hexToRgb(TIMELINE_START_COLOR);
const END_RGB = hexToRgb(TIMELINE_END_COLOR);
function timelineColor(t) {
    const r = Math.round(START_RGB.r + (END_RGB.r - START_RGB.r) * t);
    const g = Math.round(START_RGB.g + (END_RGB.g - START_RGB.g) * t);
    const b = Math.round(START_RGB.b + (END_RGB.b - START_RGB.b) * t);
    return `rgb(${r}, ${g}, ${b})`;
}
// Day offset relative to today, e.g. a 01:30 departure for a trip that
// starts tonight is "+1d" — riders need this since RAPTOR itineraries can
// span midnight.
function dayOffsetSuffix(epochMinutes) {
    const d = new Date(epochMinutes * 60000);
    const dayStart = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const today = new Date();
    const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
    const offset = Math.round((dayStart - todayStart) / 86400000);
    if (offset === 0) return '';
    return ` (${offset > 0 ? '+' : ''}${offset}d)`;
}
function formatEpochMinutes(mins) {
    if (typeof mins !== 'number' || Number.isNaN(mins)) return null;
    const d = new Date(mins * 60000);
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}${dayOffsetSuffix(mins)}`;
}
// `realBoardTime` (from refineWithSchedule) is a bare "HH:MM" string with no
// date attached, so the day offset is derived from the estimated `boardTime`
// epoch instead — the clock reading is real, the day label is approximate.
function formatBoardTime(leg) {
    if (leg.realBoardTime) return `${leg.realBoardTime}${dayOffsetSuffix(leg.boardTime)}`;
    return formatEpochMinutes(leg.boardTime);
}
function formatWalkMinutes(distanceMeters) {
    if (!distanceMeters) return null;
    return Math.max(1, Math.round(distanceMeters / WALK_SPEED_MPS / 60));
}
// A location endpoint has no graph-precomputed distance to any given stop
// (unlike stop-to-stop transfers/clusters, which are Voronoi-derived at
// build time) — its walk leg is computed on the fly from real coordinates.
function haversineMeters(lat1, lon1, lat2, lon2) {
    const R = 6371000;
    const toRad = (d)=>d * Math.PI / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.asin(Math.sqrt(a));
}
// stop.coordinates is [lng, lat] (see app.js's stopsData/cityDataMap).
function locationToStopMeters(location, stop) {
    if (!location || !(stop === null || stop === void 0 ? void 0 : stop.coordinates)) return null;
    const [lng, lat] = stop.coordinates;
    return haversineMeters(location.lat, location.lon, lat, lng);
}
// Total door-to-door minutes for a RAPTOR itinerary, including a location
// endpoint's walk to/from its nearest stop (not captured by the search
// itself — every candidate cluster stop is seeded at the same start time,
// so RAPTOR's own timing never includes "walk from the actual point to
// whichever stop was used"). Only itineraries carry real board/alight times
// (epoch-minutes) — legacy single-city itineraries have no timing data at
// all, just a topological route match, so there's no reliable basis to show
// a duration for those.
function computeItineraryDurationMinutes(itinerary, cityDataMap, startLocation, endLocation) {
    const legs = itinerary === null || itinerary === void 0 ? void 0 : itinerary.legs;
    if (!(legs === null || legs === void 0 ? void 0 : legs.length)) return null;
    const first = legs[0];
    const last = legs[legs.length - 1];
    if (typeof last.alightTime !== 'number') return null;
    let startTime;
    if (first.kind === 'ride' && typeof first.boardTime === 'number') startTime = first.boardTime;
    else if (first.kind === 'walk' && typeof first.alightTime === 'number') startTime = first.alightTime - (formatWalkMinutes(first.distanceMeters) || 0);
    else return null;
    let totalMinutes = last.alightTime - startTime;
    if (startLocation) {
        var _cityDataMap_get_stopsData, _cityDataMap_get;
        const [startCity, startStopNum] = itinerary.startId.split('^');
        const firstStop = cityDataMap === null || cityDataMap === void 0 ? void 0 : (_cityDataMap_get = cityDataMap.get(startCity)) === null || _cityDataMap_get === void 0 ? void 0 : (_cityDataMap_get_stopsData = _cityDataMap_get.stopsData) === null || _cityDataMap_get_stopsData === void 0 ? void 0 : _cityDataMap_get_stopsData[startStopNum];
        totalMinutes += formatWalkMinutes(locationToStopMeters(startLocation, firstStop)) || 0;
    }
    if (endLocation) {
        var _cityDataMap_get_stopsData1, _cityDataMap_get1;
        const [endCity, endStopNum] = last.to.split('^');
        const lastStop = cityDataMap === null || cityDataMap === void 0 ? void 0 : (_cityDataMap_get1 = cityDataMap.get(endCity)) === null || _cityDataMap_get1 === void 0 ? void 0 : (_cityDataMap_get_stopsData1 = _cityDataMap_get1.stopsData) === null || _cityDataMap_get_stopsData1 === void 0 ? void 0 : _cityDataMap_get_stopsData1[endStopNum];
        totalMinutes += formatWalkMinutes(locationToStopMeters(endLocation, lastStop)) || 0;
    }
    return totalMinutes;
}
function formatDuration(minutes) {
    if (typeof minutes !== 'number' || Number.isNaN(minutes) || minutes < 0) return null;
    const h = Math.floor(minutes / 60);
    const m = Math.round(minutes % 60);
    if (h === 0) return `${m} min`;
    if (m === 0) return `${h} h`;
    return `${h}h ${m}m`;
}
function getArrivals(service) {
    return service.arrivals || [
        service.next,
        service.next2,
        service.next3,
        service.next4,
        service.next5
    ].filter(Boolean);
}
function getAvailableServices(arrivalData) {
    if (!(arrivalData === null || arrivalData === void 0 ? void 0 : arrivalData.length)) return new Set();
    const services = new Set();
    for (const service of arrivalData){
        if (!(service === null || service === void 0 ? void 0 : service.no)) continue;
        const hasUpcoming = getArrivals(service).some((a)=>a && typeof a.duration_ms === 'number' && a.duration_ms >= 0 && a.duration_ms <= ONE_HOUR_MS);
        if (hasUpcoming) services.add(String(service.no));
    }
    return services;
}
function getServiceArrivalInfo(arrivalByService, serviceNo) {
    if (!(arrivalByService === null || arrivalByService === void 0 ? void 0 : arrivalByService.size)) return null;
    const service = arrivalByService.get(String(serviceNo));
    if (!service) return null;
    const arrivals = getArrivals(service);
    const earliest = arrivals.reduce((best, a)=>{
        if (!a || typeof a.duration_ms !== 'number') return best;
        if (!best || a.duration_ms < best.duration_ms) return a;
        return best;
    }, null);
    var _earliest_duration_ms;
    return {
        earliestMs: (_earliest_duration_ms = earliest === null || earliest === void 0 ? void 0 : earliest.duration_ms) !== null && _earliest_duration_ms !== void 0 ? _earliest_duration_ms : null,
        frequency: service.frequency || arrivals.length || 0
    };
}
function calculateScore(itinerary, arrivalByService, staticFrequency) {
    var _rideLegs_, _itinerary_legs__transferCandidates, _itinerary_legs_;
    const rideLegs = itinerary.legs.filter((leg)=>leg.kind === 'ride');
    const startService = (_rideLegs_ = rideLegs[0]) === null || _rideLegs_ === void 0 ? void 0 : _rideLegs_.service;
    const isDirect = rideLegs.length <= 1;
    // stopsBetween.length equivalent — candidate transfer stops riding along on
    // the first ride leg (see dataWorker.js's handleBetweenRoutes); always 0 for
    // a direct itinerary or a RAPTOR one (which never sets transferCandidates).
    const transferCandidateCount = ((_itinerary_legs_ = itinerary.legs[0]) === null || _itinerary_legs_ === void 0 ? void 0 : (_itinerary_legs__transferCandidates = _itinerary_legs_.transferCandidates) === null || _itinerary_legs__transferCandidates === void 0 ? void 0 : _itinerary_legs__transferCandidates.length) || 0;
    const interchangeScore = isDirect ? 10000 : 0;
    const stopsScore = 1000 / (transferCandidateCount + 1);
    let arrivalTimeScore = 0;
    let frequencyScore = 0;
    const hasData = (arrivalByService === null || arrivalByService === void 0 ? void 0 : arrivalByService.size) > 0;
    if (!itinerary._nearbyStart && startService && hasData) {
        const info = getServiceArrivalInfo(arrivalByService, startService);
        if (info) {
            if (info.earliestMs !== null && info.earliestMs >= 0) arrivalTimeScore = 100 / (info.earliestMs / 60000 + 1);
            frequencyScore = Math.min(250, 100 * info.frequency);
        }
    }
    if (arrivalTimeScore > 0) return interchangeScore + stopsScore + arrivalTimeScore + frequencyScore;
    if (frequencyScore > 0) return interchangeScore + stopsScore + frequencyScore;
    const staticTrips = startService && (staticFrequency === null || staticFrequency === void 0 ? void 0 : staticFrequency[startService]);
    if (staticTrips > 0) {
        const staticScore = Math.min(250, staticTrips);
        return interchangeScore + stopsScore + staticScore;
    }
    return hasData ? 0 : interchangeScore + stopsScore;
}
function sortAndFilterResults(results, arrivalData, staticFrequency) {
    if (!results.length) return [];
    const startServiceOf = (itinerary)=>{
        var _itinerary_legs_find;
        return (_itinerary_legs_find = itinerary.legs.find((leg)=>leg.kind === 'ride')) === null || _itinerary_legs_find === void 0 ? void 0 : _itinerary_legs_find.service;
    };
    const available = getAvailableServices(arrivalData);
    const filtered = available.size > 0 ? results.filter((r)=>{
        const s = startServiceOf(r);
        return s && available.has(String(s));
    }) : results;
    const arrivalByService = new Map((arrivalData || []).map((s)=>[
            String(s.no),
            s
        ]));
    const scored = filtered.map((result)=>({
            result,
            score: calculateScore(result, arrivalByService, staticFrequency)
        })).filter((item)=>item.score > 0).sort((a, b)=>b.score - a.score).slice(0, 30);
    if (!scored.length) return [];
    const topScore = scored[0].score;
    const threshold = topScore * 0.25;
    return scored.filter((item)=>item.score >= threshold).map((item)=>item.result);
}
function getCityName(cityCode) {
    var _getConfigForCity_city, _getConfigForCity;
    return ((_getConfigForCity = (0, _cityConfig.getConfigForCity)(cityCode)) === null || _getConfigForCity === void 0 ? void 0 : (_getConfigForCity_city = _getConfigForCity.city) === null || _getConfigForCity_city === void 0 ? void 0 : _getConfigForCity_city.name) || cityCode;
}
// Shared between legacy (single-city, no timing) and RAPTOR (cross-city,
// timed) itineraries — both now use the same {startId, legs} shape (see
// dataWorker.js's handleBetweenRoutes). `resolveStop(id)` is the one thing
// that differs by mode: legacy ids are bare stop numbers looked up in
// `stopsData`; RAPTOR ids are `city^number` looked up via `cityDataMap`. A
// legacy itinerary's `_nearbyStart`/`_nearbyEnd` flags stand in for a real
// leading/trailing walk leg, which the worker never materializes (unlike
// RAPTOR, whose own search already produces one when needed).
function ItineraryItem({ itinerary, resolveStop, startLocation, endLocation, onClickRoute }) {
    var _rides_, _rides_1, _legs_, _resolveStop, _resolveStop1, _resolveStop2, _resolveStop3;
    const legs = itinerary.legs;
    const rides = legs.filter((leg)=>leg.kind === 'ride');
    const isDirect = rides.length <= 1;
    const startService = (_rides_ = rides[0]) === null || _rides_ === void 0 ? void 0 : _rides_.service;
    const endService = isDirect ? null : (_rides_1 = rides[rides.length - 1]) === null || _rides_1 === void 0 ? void 0 : _rides_1.service;
    const hasLeadingWalk = ((_legs_ = legs[0]) === null || _legs_ === void 0 ? void 0 : _legs_.kind) === 'walk';
    const nearbyStart = hasLeadingWalk || itinerary._nearbyStart === true;
    const nearbyEnd = legs.length > 1 && legs[legs.length - 1].kind === 'walk' || itinerary._nearbyEnd === true;
    const startId = hasLeadingWalk ? legs[0].to : itinerary.startId;
    const startName = ((_resolveStop = resolveStop(startId)) === null || _resolveStop === void 0 ? void 0 : _resolveStop.name) || startId;
    const lastLeg = legs[legs.length - 1];
    const endName = ((_resolveStop1 = resolveStop(lastLeg.to)) === null || _resolveStop1 === void 0 ? void 0 : _resolveStop1.name) || lastLeg.to;
    const interchangeStops = legs.slice(hasLeadingWalk ? 1 : 0, -1).map((leg)=>leg.to);
    const interchangeCount = interchangeStops.length;
    // A location endpoint never produces a leading/trailing walk *leg* (every
    // candidate cluster stop is seeded equally, see computeRaptorRoute), so it
    // needs its own flag alongside nearbyStart/nearbyEnd for the same "you'll
    // need to walk" visual treatment.
    const classes = [
        'between-item',
        (nearbyStart || startLocation) && 'nearby-start',
        (nearbyEnd || endLocation) && 'nearby-end'
    ].filter(Boolean).join(' ');
    const visitedCities = [
        ...new Set([
            (_resolveStop2 = resolveStop(itinerary.startId)) === null || _resolveStop2 === void 0 ? void 0 : _resolveStop2.city,
            ...legs.map((leg)=>{
                var _resolveStop;
                return (_resolveStop = resolveStop(leg.to)) === null || _resolveStop === void 0 ? void 0 : _resolveStop.city;
            })
        ])
    ].filter(Boolean);
    const isMultiCity = visitedCities.length > 1;
    return (0, _preact.h)("div", {
        class: classes,
        onClick: (e)=>onClickRoute(e, itinerary)
    }, (0, _preact.h)("div", {
        class: "between-inner"
    }, (0, _preact.h)("div", {
        class: `between-services ${isDirect ? 'full' : ''}`
    }, (0, _preact.h)("span", {
        class: "start"
    }, startService), !isDirect && (0, _preact.h)("span", {
        class: "end"
    }, endService)), (0, _preact.h)("div", {
        class: `between-stops ${interchangeCount ? '' : 'nada'}`
    }, (0, _preact.h)("span", {
        class: "start"
    }, startName), (0, _preact.h)("span", {
        class: `betweens betweens-${Math.min(6, interchangeCount)}`
    }, interchangeCount > 0 && (interchangeCount === 1 ? (_resolveStop3 = resolveStop(interchangeStops[0])) === null || _resolveStop3 === void 0 ? void 0 : _resolveStop3.name : `${interchangeCount} stops`)), (0, _preact.h)("span", {
        class: "end"
    }, endName))), isMultiCity && (0, _preact.h)("div", {
        class: "between-item-leg-city"
    }, "via ", visitedCities.map((c)=>getCityName(c)).join(" \xb7 ")));
}
// Normalizes an itinerary's legs into a stop/segment timeline for
// `ItineraryDetail` — shared by both RAPTOR itineraries (real board/alight
// times, cross-city, own walk legs already baked in by the search) and
// legacy single-city results (no timing, single-city, a leading/trailing
// walk only ever implied by `_nearbyStart`/`_nearbyEnd` since the worker
// never materializes a real walk leg — `literalStartStop`/`literalEndStop`
// exist purely to let this fall-back walk annotation compare against the
// stop the user actually picked; RAPTOR callers never pass them, since a
// walk leg already exists in `legs` whenever one applies).
function buildSteps(itinerary, { resolveStop, startLocation, endLocation, literalStartStop, literalEndStop }) {
    const nameOf = (stop)=>{
        var _resolveStop;
        return (stop === null || stop === void 0 ? void 0 : stop.name) || ((_resolveStop = resolveStop(stop === null || stop === void 0 ? void 0 : stop.number)) === null || _resolveStop === void 0 ? void 0 : _resolveStop.name) || (stop === null || stop === void 0 ? void 0 : stop.number);
    };
    const stopIds = [
        itinerary.startId,
        ...itinerary.legs.map((l)=>l.to)
    ];
    const stops = stopIds.map((id, i)=>{
        var _incoming_transferCandidates;
        const incoming = itinerary.legs[i - 1];
        const outgoing = itinerary.legs[i];
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, resolveStop(id)), {
            isStart: i === 0 && !startLocation,
            isEnd: i === stopIds.length - 1 && !endLocation,
            arrive: (incoming === null || incoming === void 0 ? void 0 : incoming.kind) === 'ride' ? formatEpochMinutes(incoming.alightTime) : null,
            depart: (outgoing === null || outgoing === void 0 ? void 0 : outgoing.kind) === 'ride' ? formatBoardTime(outgoing) : null,
            extra: (incoming === null || incoming === void 0 ? void 0 : (_incoming_transferCandidates = incoming.transferCandidates) === null || _incoming_transferCandidates === void 0 ? void 0 : _incoming_transferCandidates.length) > 1 ? `+${incoming.transferCandidates.length - 1} more possible transfer stop(s)` : null
        });
    });
    const segments = itinerary.legs.map((leg)=>{
        var _leg_fromStop;
        return {
            kind: leg.kind,
            service: leg.service,
            city: (_leg_fromStop = leg.fromStop) === null || _leg_fromStop === void 0 ? void 0 : _leg_fromStop.split('^')[0],
            walkMinutes: leg.kind === 'walk' ? formatWalkMinutes(leg.distanceMeters) : null,
            alternates: leg.alternates || null
        };
    });
    // A location endpoint never produces a real leading/trailing walk leg
    // (every candidate cluster stop is seeded equally) — add one here purely
    // for display, from the actual searched point to whichever stop the
    // itinerary boarded/alighted at.
    if (startLocation) {
        const firstStop = resolveStop(itinerary.startId);
        stops.unshift({
            name: startLocation.name || 'Selected Location',
            isStart: true,
            isLocation: true
        });
        segments.unshift({
            kind: 'walk',
            walkMinutes: formatWalkMinutes(locationToStopMeters(startLocation, firstStop))
        });
    } else if (literalStartStop && String(itinerary.startId) !== String(literalStartStop.number)) {
        stops[0].isStart = false;
        stops.unshift({
            number: literalStartStop.number,
            name: nameOf(literalStartStop),
            isStart: true
        });
        segments.unshift({
            kind: 'walk'
        });
    }
    const lastLegTo = itinerary.legs[itinerary.legs.length - 1].to;
    if (endLocation) {
        const lastStop = resolveStop(lastLegTo);
        stops[stops.length - 1].isEnd = false;
        segments.push({
            kind: 'walk',
            walkMinutes: formatWalkMinutes(locationToStopMeters(endLocation, lastStop))
        });
        stops.push({
            name: endLocation.name || 'Selected Location',
            isEnd: true,
            isLocation: true
        });
    } else if (literalEndStop && String(lastLegTo) !== String(literalEndStop.number)) {
        stops[stops.length - 1].isEnd = false;
        segments.push({
            kind: 'walk'
        });
        stops.push({
            number: literalEndStop.number,
            name: nameOf(literalEndStop),
            isEnd: true
        });
    }
    return {
        stops,
        segments
    };
}
function oxfordJoin(items) {
    if (items.length <= 1) return items.join('');
    if (items.length === 2) return items.join(' or ');
    return `${items.slice(0, -1).join(', ')}, or ${items[items.length - 1]}`;
}
// "Alternatively at 14:00, 14:05, or 210-ND at 14:10" — groups a leg's
// alternates by route number: the *same* service as the one actually ridden
// is shown as bare times (no need to repeat its name, since it's already the
// service shown for this leg), while any genuinely different service gets
// its own name attached, with its own times comma-grouped together rather
// than repeating the service name per departure.
function formatAlternatesText(mainService, alternates) {
    if (!(alternates === null || alternates === void 0 ? void 0 : alternates.length)) return null;
    const ownTimes = [];
    const otherTimesByService = new Map();
    alternates.forEach(({ service, time })=>{
        if (service === mainService) {
            ownTimes.push(time);
            return;
        }
        if (!otherTimesByService.has(service)) otherTimesByService.set(service, []);
        otherTimesByService.get(service).push(time);
    });
    const items = [
        ...ownTimes
    ];
    for (const [service, times] of otherTimesByService)items.push(`${service} at ${times.join(', ')}`);
    if (!items.length) return null;
    const prefix = ownTimes.length ? 'Alternatively at ' : 'Alternatively, ';
    return prefix + oxfordJoin(items);
}
function ItineraryDetail({ stops, segments, getServiceHref }) {
    const n = stops.length;
    return (0, _preact.h)("div", {
        class: "itinerary-detail"
    }, (0, _preact.h)("div", {
        class: "itinerary-timeline"
    }, stops.map((stop, i)=>{
        var _segments_i_alternates;
        const color = timelineColor(n > 1 ? i / (n - 1) : 0);
        return (0, _preact.h)((0, _preact.Fragment), {
            key: i
        }, (0, _preact.h)("div", {
            class: "itin-stop-row"
        }, (0, _preact.h)("div", {
            class: "itin-rail"
        }, (0, _preact.h)("span", {
            class: "itin-dot",
            style: {
                borderColor: color
            }
        })), (0, _preact.h)("div", {
            class: "itin-stop-info"
        }, (0, _preact.h)("span", {
            class: "itin-stop-name"
        }, stop.name), stop.extra && (0, _preact.h)("span", {
            class: "itin-stop-extra"
        }, stop.extra), stop.arrive && (0, _preact.h)("span", {
            class: "itin-time arrive"
        }, "Arrive ", stop.arrive), stop.depart && (0, _preact.h)("span", {
            class: "itin-time depart"
        }, "Depart ", stop.depart))), segments[i] && (0, _preact.h)("div", {
            class: `itin-seg-row ${segments[i].kind}`
        }, (0, _preact.h)("div", {
            class: "itin-rail"
        }, (0, _preact.h)("span", {
            class: "itin-line",
            style: segments[i].kind === 'walk' ? {
                borderLeftColor: timelineColor((i + 0.5) / (n - 1))
            } : {
                backgroundColor: timelineColor((i + 0.5) / (n - 1))
            }
        })), (0, _preact.h)("div", {
            class: "itin-seg-info"
        }, segments[i].kind === 'ride' ? (0, _preact.h)("a", {
            class: "service-tag",
            href: getServiceHref === null || getServiceHref === void 0 ? void 0 : getServiceHref(segments[i].service, segments[i].city)
        }, segments[i].service) : (0, _preact.h)("span", {
            class: "itin-walk-label"
        }, "Walk", segments[i].walkMinutes ? ` \xb7 ${segments[i].walkMinutes} min` : ''), ((_segments_i_alternates = segments[i].alternates) === null || _segments_i_alternates === void 0 ? void 0 : _segments_i_alternates.length) > 0 && (0, _preact.h)("span", {
            class: "itin-seg-alternates"
        }, formatAlternatesText(segments[i].service, segments[i].alternates)))));
    })));
}
function BetweenRoutes({ results, itineraries, onClickRoute, stopsData, cityDataMap, arrivalData, staticFrequency, selectedIndex, getServiceHref, startStop, endStop, startLocation, endLocation }) {
    const isAllMode = !!itineraries;
    // Legacy results still need scoring/filtering (no arrival-aware ranking
    // happens before they reach here); RAPTOR itineraries arrive pre-sorted by
    // the search itself.
    const sortedResults = (0, _hooks.useMemo)(()=>isAllMode ? itineraries : sortAndFilterResults(results || [], arrivalData, staticFrequency), [
        isAllMode,
        itineraries,
        results,
        arrivalData,
        staticFrequency
    ]);
    // `city^number` (RAPTOR) vs bare stop number (legacy, single-city) — see
    // dataWorker.js's handleBetweenRoutes and raptor.js for where each side of
    // this shape originates.
    const resolveStop = isAllMode ? (id)=>{
        var _cityDataMap_get_stopsData, _cityDataMap_get;
        const [city, number] = String(id).split('^');
        const s = cityDataMap === null || cityDataMap === void 0 ? void 0 : (_cityDataMap_get = cityDataMap.get(city)) === null || _cityDataMap_get === void 0 ? void 0 : (_cityDataMap_get_stopsData = _cityDataMap_get.stopsData) === null || _cityDataMap_get_stopsData === void 0 ? void 0 : _cityDataMap_get_stopsData[number];
        return {
            name: (s === null || s === void 0 ? void 0 : s.name) || number,
            coordinates: s === null || s === void 0 ? void 0 : s.coordinates,
            city,
            number
        };
    } : (id)=>{
        const s = stopsData === null || stopsData === void 0 ? void 0 : stopsData[id];
        return {
            name: (s === null || s === void 0 ? void 0 : s.name) || id,
            coordinates: s === null || s === void 0 ? void 0 : s.coordinates,
            city: undefined,
            number: id
        };
    };
    if (!sortedResults.length) return (0, _preact.h)("div", {
        class: "between-block between-nada"
    }, isAllMode ? 'No route found.' : 'No upcoming connecting routes');
    if (selectedIndex != null && sortedResults[selectedIndex]) {
        const { stops, segments } = buildSteps(sortedResults[selectedIndex], {
            resolveStop,
            startLocation,
            endLocation,
            literalStartStop: isAllMode ? undefined : startStop,
            literalEndStop: isAllMode ? undefined : endStop
        });
        return (0, _preact.h)(ItineraryDetail, {
            stops: stops,
            segments: segments,
            getServiceHref: getServiceHref
        });
    }
    return (0, _preact.h)("div", {
        class: "between-block"
    }, sortedResults.map((itinerary, i)=>(0, _preact.h)(ItineraryItem, {
            key: i,
            itinerary: itinerary,
            resolveStop: resolveStop,
            startLocation: startLocation,
            endLocation: endLocation,
            onClickRoute: (e)=>onClickRoute(e, itinerary, i)
        })));
}

},{"@swc/helpers/_/_object_spread":"2eaR5","@swc/helpers/_/_object_spread_props":"kR5CL","preact":"ej31g","preact/hooks":"gK13j","../city-config":"7oMBO","../utils/theme":"64PZj","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"M6shC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ScrollableContainer);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _useResizeObserver = require("../utils/useResizeObserver");
var _useResizeObserverDefault = parcelHelpers.interopDefault(_useResizeObserver);
function ScrollableContainer(props) {
    const { children, scrollToTopKey } = props, otherProps = (0, _objectWithoutProperties._)(props, [
        "children",
        "scrollToTopKey"
    ]);
    const ref = (0, _hooks.useRef)(null);
    const { width, height } = (0, _useResizeObserverDefault.default)({
        ref
    });
    const [scrollShadow, setScrollShadow] = (0, _hooks.useState)('bottom');
    (0, _hooks.useEffect)(()=>{
        // console.log('TRIGGER');
        const { current: el } = ref;
        const { scrollHeight, offsetHeight } = el;
        const handleScroll = ()=>{
            // console.log('SCROLL');
            if (el.scrollTop <= 0) setScrollShadow('bottom');
            else if (el.scrollTop + el.offsetHeight >= el.scrollHeight) setScrollShadow('top');
            else setScrollShadow('both');
        };
        const scrollable = scrollHeight > offsetHeight + 5; // Magic threshold
        if (scrollable) {
            handleScroll();
            el.addEventListener('scroll', handleScroll, {
                passive: true
            });
        } else setScrollShadow('');
        return ()=>el.removeEventListener('scroll', handleScroll);
    }, [
        width,
        height
    ]);
    // Scroll to top when `scrollToTopKey` changes
    (0, _hooks.useEffect)(()=>{
        ref.current.scrollTop = 0;
    }, [
        scrollToTopKey
    ]);
    return (0, _preact.h)("div", (0, _extendsDefault.default)({}, otherProps, {
        ref: ref,
        "data-scroll-shadow": scrollShadow
    }), children);
}

},{"@swc/helpers/_/_object_without_properties":"87mRe","@babel/runtime/helpers/esm/extends":"aqsOV","preact":"ej31g","preact/hooks":"gK13j","../utils/useResizeObserver":"jhUUF","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"jhUUF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _resizeObserver = require("@juggle/resize-observer");
var _useResizeObserver = require("use-resize-observer");
var _useResizeObserverDefault = parcelHelpers.interopDefault(_useResizeObserver);
if (!window.ResizeObserver) window.ResizeObserver = (0, _resizeObserver.ResizeObserver);
exports.default = (0, _useResizeObserverDefault.default);

},{"@juggle/resize-observer":"kPMMf","use-resize-observer":"4j1zs","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"kPMMf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserver", ()=>(0, _resizeObserver.ResizeObserver));
parcelHelpers.export(exports, "ResizeObserverEntry", ()=>(0, _resizeObserverEntry.ResizeObserverEntry));
parcelHelpers.export(exports, "ResizeObserverSize", ()=>(0, _resizeObserverSize.ResizeObserverSize));
var _resizeObserver = require("../ResizeObserver");
var _resizeObserverEntry = require("../ResizeObserverEntry");
var _resizeObserverSize = require("../ResizeObserverSize");

},{"../ResizeObserver":"3a7SX","../ResizeObserverEntry":"kbwxA","../ResizeObserverSize":"9tDbH","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"3a7SX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserver", ()=>ResizeObserver);
var _resizeObserverController = require("./ResizeObserverController");
var _element = require("./utils/element");
var ResizeObserver = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, _resizeObserverController.ResizeObserverController).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, _element.isElement)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, _resizeObserverController.ResizeObserverController).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, _element.isElement)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, _resizeObserverController.ResizeObserverController).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, _resizeObserverController.ResizeObserverController).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();

},{"./ResizeObserverController":"1Ul6O","./utils/element":"lGvkG","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"1Ul6O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverController", ()=>ResizeObserverController);
var _scheduler = require("./utils/scheduler");
var _resizeObservation = require("./ResizeObservation");
var _resizeObserverDetail = require("./ResizeObserverDetail");
var _resizeObservers = require("./utils/resizeObservers");
var observerMap = new WeakMap();
var getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var ResizeObserverController = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, _resizeObserverDetail.ResizeObserverDetail)(resizeObserver, callback);
        observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if (getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, _resizeObservers.resizeObservers).push(detail);
            detail.observationTargets.push(new (0, _resizeObservation.ResizeObservation)(target, options && options.box));
            (0, _scheduler.updateCount)(1);
            (0, _scheduler.scheduler).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = observerMap.get(resizeObserver);
        var index = getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, _resizeObservers.resizeObservers).splice((0, _resizeObservers.resizeObservers).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, _scheduler.updateCount)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();

},{"./utils/scheduler":"cBQqN","./ResizeObservation":"eWx1c","./ResizeObserverDetail":"3h46U","./utils/resizeObservers":"dhInE","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"cBQqN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduler", ()=>scheduler);
parcelHelpers.export(exports, "updateCount", ()=>updateCount);
var _process = require("./process");
var _global = require("./global");
var _queueResizeObserver = require("./queueResizeObserver");
var watching = 0;
var isWatching = function() {
    return !!watching;
};
var CATCH_PERIOD = 250;
var observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var scheduled = false;
var Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = CATCH_PERIOD;
        if (scheduled) return;
        scheduled = true;
        var until = time(timeout);
        (0, _queueResizeObserver.queueResizeObserver)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, _process.process)();
            } finally{
                scheduled = false;
                timeout = until - time();
                if (!isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, observerConfig);
        };
        document.body ? cb() : (0, _global.global).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            events.forEach(function(name) {
                return (0, _global.global).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function(name) {
                return (0, _global.global).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var scheduler = new Scheduler();
var updateCount = function(n) {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};

},{"./process":"8ICQT","./global":"bXE7t","./queueResizeObserver":"32nTA","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"8ICQT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "process", ()=>process);
var _hasActiveObservations = require("../algorithms/hasActiveObservations");
var _hasSkippedObservations = require("../algorithms/hasSkippedObservations");
var _deliverResizeLoopError = require("../algorithms/deliverResizeLoopError");
var _broadcastActiveObservations = require("../algorithms/broadcastActiveObservations");
var _gatherActiveObservationsAtDepth = require("../algorithms/gatherActiveObservationsAtDepth");
var process = function() {
    var depth = 0;
    (0, _gatherActiveObservationsAtDepth.gatherActiveObservationsAtDepth)(depth);
    while((0, _hasActiveObservations.hasActiveObservations)()){
        depth = (0, _broadcastActiveObservations.broadcastActiveObservations)();
        (0, _gatherActiveObservationsAtDepth.gatherActiveObservationsAtDepth)(depth);
    }
    if ((0, _hasSkippedObservations.hasSkippedObservations)()) (0, _deliverResizeLoopError.deliverResizeLoopError)();
    return depth > 0;
};

},{"../algorithms/hasActiveObservations":"7s8hs","../algorithms/hasSkippedObservations":"9Nij1","../algorithms/deliverResizeLoopError":"gfauF","../algorithms/broadcastActiveObservations":"lR2OC","../algorithms/gatherActiveObservationsAtDepth":"il9KI","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"7s8hs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasActiveObservations", ()=>hasActiveObservations);
var _resizeObservers = require("../utils/resizeObservers");
var hasActiveObservations = function() {
    return (0, _resizeObservers.resizeObservers).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};

},{"../utils/resizeObservers":"dhInE","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"dhInE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeObservers", ()=>resizeObservers);
var resizeObservers = [];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"9Nij1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSkippedObservations", ()=>hasSkippedObservations);
var _resizeObservers = require("../utils/resizeObservers");
var hasSkippedObservations = function() {
    return (0, _resizeObservers.resizeObservers).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};

},{"../utils/resizeObservers":"dhInE","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"gfauF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deliverResizeLoopError", ()=>deliverResizeLoopError);
var msg = 'ResizeObserver loop completed with undelivered notifications.';
var deliverResizeLoopError = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = msg;
    }
    window.dispatchEvent(event);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"lR2OC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "broadcastActiveObservations", ()=>broadcastActiveObservations);
var _resizeObservers = require("../utils/resizeObservers");
var _resizeObserverEntry = require("../ResizeObserverEntry");
var _calculateDepthForNode = require("./calculateDepthForNode");
var _calculateBoxSize = require("./calculateBoxSize");
var broadcastActiveObservations = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, _resizeObservers.resizeObservers).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, _resizeObserverEntry.ResizeObserverEntry)(ot.target);
            var targetDepth = (0, _calculateDepthForNode.calculateDepthForNode)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, _calculateBoxSize.calculateBoxSize)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};

},{"../utils/resizeObservers":"dhInE","../ResizeObserverEntry":"kbwxA","./calculateDepthForNode":"gLrXE","./calculateBoxSize":"l3WVK","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"kbwxA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverEntry", ()=>ResizeObserverEntry);
var _calculateBoxSize = require("./algorithms/calculateBoxSize");
var _freeze = require("./utils/freeze");
var ResizeObserverEntry = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, _calculateBoxSize.calculateBoxSizes)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, _freeze.freeze)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, _freeze.freeze)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, _freeze.freeze)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();

},{"./algorithms/calculateBoxSize":"l3WVK","./utils/freeze":"7lFv2","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"l3WVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBoxSize", ()=>calculateBoxSize);
parcelHelpers.export(exports, "calculateBoxSizes", ()=>calculateBoxSizes);
var _resizeObserverBoxOptions = require("../ResizeObserverBoxOptions");
var _resizeObserverSize = require("../ResizeObserverSize");
var _domrectReadOnly = require("../DOMRectReadOnly");
var _element = require("../utils/element");
var _freeze = require("../utils/freeze");
var _global = require("../utils/global");
var cache = new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = /msie|trident/i.test((0, _global.global).navigator && (0, _global.global).navigator.userAgent);
var parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, _resizeObserverSize.ResizeObserverSize)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = (0, _freeze.freeze)({
    devicePixelContentBoxSize: size(),
    borderBoxSize: size(),
    contentBoxSize: size(),
    contentRect: new (0, _domrectReadOnly.DOMRectReadOnly)(0, 0, 0, 0)
});
var calculateBoxSizes = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if (cache.has(target) && !forceRecalculation) return cache.get(target);
    if ((0, _element.isHidden)(target)) {
        cache.set(target, zeroBoxes);
        return zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, _element.isSVG)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !IE && cs.boxSizing === 'border-box';
    var switchSizes = verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, _freeze.freeze)({
        devicePixelContentBoxSize: size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, _domrectReadOnly.DOMRectReadOnly)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    cache.set(target, boxes);
    return boxes;
};
var calculateBoxSize = function(target, observedBox, forceRecalculation) {
    var _a = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, _resizeObserverBoxOptions.ResizeObserverBoxOptions).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, _resizeObserverBoxOptions.ResizeObserverBoxOptions).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};

},{"../ResizeObserverBoxOptions":"7si01","../ResizeObserverSize":"9tDbH","../DOMRectReadOnly":"l8ecN","../utils/element":"lGvkG","../utils/freeze":"7lFv2","../utils/global":"bXE7t","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"7si01":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverBoxOptions", ()=>ResizeObserverBoxOptions);
var ResizeObserverBoxOptions;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"9tDbH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverSize", ()=>ResizeObserverSize);
var _freeze = require("./utils/freeze");
var ResizeObserverSize = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, _freeze.freeze)(this);
    }
    return ResizeObserverSize;
}();

},{"./utils/freeze":"7lFv2","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"7lFv2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "freeze", ()=>freeze);
var freeze = function(obj) {
    return Object.freeze(obj);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"l8ecN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMRectReadOnly", ()=>DOMRectReadOnly);
var _freeze = require("./utils/freeze");
var DOMRectReadOnly = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, _freeze.freeze)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();

},{"./utils/freeze":"7lFv2","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"lGvkG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVG", ()=>isSVG);
parcelHelpers.export(exports, "isHidden", ()=>isHidden);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isReplacedElement", ()=>isReplacedElement);
var isSVG = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var isHidden = function(target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var isReplacedElement = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"bXE7t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "global", ()=>global);
var global = typeof window !== 'undefined' ? window : {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"gLrXE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateDepthForNode", ()=>calculateDepthForNode);
var _element = require("../utils/element");
var calculateDepthForNode = function(node) {
    if ((0, _element.isHidden)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};

},{"../utils/element":"lGvkG","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"il9KI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gatherActiveObservationsAtDepth", ()=>gatherActiveObservationsAtDepth);
var _resizeObservers = require("../utils/resizeObservers");
var _calculateDepthForNode = require("./calculateDepthForNode");
var gatherActiveObservationsAtDepth = function(depth) {
    (0, _resizeObservers.resizeObservers).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, _calculateDepthForNode.calculateDepthForNode)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};

},{"../utils/resizeObservers":"dhInE","./calculateDepthForNode":"gLrXE","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"32nTA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueResizeObserver", ()=>queueResizeObserver);
var _queueMicroTask = require("./queueMicroTask");
var queueResizeObserver = function(cb) {
    (0, _queueMicroTask.queueMicroTask)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};

},{"./queueMicroTask":"aXUBD","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"aXUBD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueMicroTask", ()=>queueMicroTask);
var trigger;
var callbacks = [];
var notify = function() {
    return callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var queueMicroTask = function(callback) {
    if (!trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return notify();
        }).observe(el_1, config);
        trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    callbacks.push(callback);
    trigger();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"eWx1c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObservation", ()=>ResizeObservation);
var _resizeObserverBoxOptions = require("./ResizeObserverBoxOptions");
var _calculateBoxSize = require("./algorithms/calculateBoxSize");
var _element = require("./utils/element");
var skipNotifyOnElement = function(target) {
    return !(0, _element.isSVG)(target) && !(0, _element.isReplacedElement)(target) && getComputedStyle(target).display === 'inline';
};
var ResizeObservation = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, _resizeObserverBoxOptions.ResizeObserverBoxOptions).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, _calculateBoxSize.calculateBoxSize)(this.target, this.observedBox, true);
        if (skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();

},{"./ResizeObserverBoxOptions":"7si01","./algorithms/calculateBoxSize":"l3WVK","./utils/element":"lGvkG","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"3h46U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverDetail", ()=>ResizeObserverDetail);
var ResizeObserverDetail = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"4j1zs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useResizeObserver);
var _react = require("react");
// This could've been more streamlined with internal state instead of abusing
// refs to such extent, but then composing hooks and components could not opt out of unnecessary renders.
function useResolvedElement(subscriber, refOrElement) {
    var lastReportRef = (0, _react.useRef)(null);
    var refOrElementRef = (0, _react.useRef)(null);
    refOrElementRef.current = refOrElement;
    var cbElementRef = (0, _react.useRef)(null); // Calling re-evaluation after each render without using a dep array,
    // as the ref object's current value could've changed since the last render.
    (0, _react.useEffect)(function() {
        evaluateSubscription();
    });
    var evaluateSubscription = (0, _react.useCallback)(function() {
        var cbElement = cbElementRef.current;
        var refOrElement = refOrElementRef.current; // Ugly ternary. But smaller than an if-else block.
        var element = cbElement ? cbElement : refOrElement ? refOrElement instanceof Element ? refOrElement : refOrElement.current : null;
        if (lastReportRef.current && lastReportRef.current.element === element && lastReportRef.current.subscriber === subscriber) return;
        if (lastReportRef.current && lastReportRef.current.cleanup) lastReportRef.current.cleanup();
        lastReportRef.current = {
            element: element,
            subscriber: subscriber,
            // Only calling the subscriber, if there's an actual element to report.
            // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
            cleanup: element ? subscriber(element) : undefined
        };
    }, [
        subscriber
    ]); // making sure we call the cleanup function on unmount
    (0, _react.useEffect)(function() {
        return function() {
            if (lastReportRef.current && lastReportRef.current.cleanup) {
                lastReportRef.current.cleanup();
                lastReportRef.current = null;
            }
        };
    }, []);
    return (0, _react.useCallback)(function(element) {
        cbElementRef.current = element;
        evaluateSubscription();
    }, [
        evaluateSubscription
    ]);
}
// We're only using the first element of the size sequences, until future versions of the spec solidify on how
// exactly it'll be used for fragments in multi-column scenarios:
// From the spec:
// > The box size properties are exposed as FrozenArray in order to support elements that have multiple fragments,
// > which occur in multi-column scenarios. However the current definitions of content rect and border box do not
// > mention how those boxes are affected by multi-column layout. In this spec, there will only be a single
// > ResizeObserverSize returned in the FrozenArray, which will correspond to the dimensions of the first column.
// > A future version of this spec will extend the returned FrozenArray to contain the per-fragment size information.
// (https://drafts.csswg.org/resize-observer/#resize-observer-entry-interface)
//
// Also, testing these new box options revealed that in both Chrome and FF everything is returned in the callback,
// regardless of the "box" option.
// The spec states the following on this:
// > This does not have any impact on which box dimensions are returned to the defined callback when the event
// > is fired, it solely defines which box the author wishes to observe layout changes on.
// (https://drafts.csswg.org/resize-observer/#resize-observer-interface)
// I'm not exactly clear on what this means, especially when you consider a later section stating the following:
// > This section is non-normative. An author may desire to observe more than one CSS box.
// > In this case, author will need to use multiple ResizeObservers.
// (https://drafts.csswg.org/resize-observer/#resize-observer-interface)
// Which is clearly not how current browser implementations behave, and seems to contradict the previous quote.
// For this reason I decided to only return the requested size,
// even though it seems we have access to results for all box types.
// This also means that we get to keep the current api, being able to return a simple { width, height } pair,
// regardless of box option.
function extractSize(entry, boxProp, sizeType) {
    if (!entry[boxProp]) {
        if (boxProp === "contentBoxSize") // The dimensions in `contentBoxSize` and `contentRect` are equivalent according to the spec.
        // See the 6th step in the description for the RO algorithm:
        // https://drafts.csswg.org/resize-observer/#create-and-populate-resizeobserverentry-h
        // > Set this.contentRect to logical this.contentBoxSize given target and observedBox of "content-box".
        // In real browser implementations of course these objects differ, but the width/height values should be equivalent.
        return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return undefined;
    } // A couple bytes smaller than calling Array.isArray() and just as effective here.
    return entry[boxProp][0] ? entry[boxProp][0][sizeType] : // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    entry[boxProp][sizeType];
}
function useResizeObserver(opts) {
    if (opts === void 0) opts = {};
    // Saving the callback as a ref. With this, I don't need to put onResize in the
    // effect dep array, and just passing in an anonymous function without memoising
    // will not reinstantiate the hook's ResizeObserver.
    var onResize = opts.onResize;
    var onResizeRef = (0, _react.useRef)(undefined);
    onResizeRef.current = onResize;
    var round = opts.round || Math.round; // Using a single instance throughout the hook's lifetime
    var resizeObserverRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)({
        width: undefined,
        height: undefined
    }), size = _useState[0], setSize = _useState[1]; // In certain edge cases the RO might want to report a size change just after
    // the component unmounted.
    var didUnmount = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        didUnmount.current = false;
        return function() {
            didUnmount.current = true;
        };
    }, []); // Using a ref to track the previous width / height to avoid unnecessary renders.
    var previous = (0, _react.useRef)({
        width: undefined,
        height: undefined
    }); // This block is kinda like a useEffect, only it's called whenever a new
    // element could be resolved based on the ref option. It also has a cleanup
    // function.
    var refCallback = useResolvedElement((0, _react.useCallback)(function(element) {
        // We only use a single Resize Observer instance, and we're instantiating it on demand, only once there's something to observe.
        // This instance is also recreated when the `box` option changes, so that a new observation is fired if there was a previously observed element with a different box option.
        if (!resizeObserverRef.current || resizeObserverRef.current.box !== opts.box || resizeObserverRef.current.round !== round) resizeObserverRef.current = {
            box: opts.box,
            round: round,
            instance: new ResizeObserver(function(entries) {
                var entry = entries[0];
                var boxProp = opts.box === "border-box" ? "borderBoxSize" : opts.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
                var reportedWidth = extractSize(entry, boxProp, "inlineSize");
                var reportedHeight = extractSize(entry, boxProp, "blockSize");
                var newWidth = reportedWidth ? round(reportedWidth) : undefined;
                var newHeight = reportedHeight ? round(reportedHeight) : undefined;
                if (previous.current.width !== newWidth || previous.current.height !== newHeight) {
                    var newSize = {
                        width: newWidth,
                        height: newHeight
                    };
                    previous.current.width = newWidth;
                    previous.current.height = newHeight;
                    if (onResizeRef.current) onResizeRef.current(newSize);
                    else if (!didUnmount.current) setSize(newSize);
                }
            })
        };
        resizeObserverRef.current.instance.observe(element, {
            box: opts.box
        });
        return function() {
            if (resizeObserverRef.current) resizeObserverRef.current.instance.unobserve(element);
        };
    }, [
        opts.box,
        round
    ]), opts.ref);
    return (0, _react.useMemo)(function() {
        return {
            ref: refCallback,
            width: size.width,
            height: size.height
        };
    }, [
        refCallback,
        size.width,
        size.height
    ]);
}

},{"react":"9Fh1y","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"cMevO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _compat = require("preact/compat");
var _getRoute = require("../utils/getRoute");
var _getRouteDefault = parcelHelpers.interopDefault(_getRoute);
var _cityConfig = require("../city-config");
var _vehicleChip = require("./VehicleChip");
var _vehicleChipDefault = parcelHelpers.interopDefault(_vehicleChip);
function rowSpaner(stopGrid, column, rowIndex) {
    let span = 1;
    while(stopGrid[++rowIndex] && !stopGrid[rowIndex][column]){
        stopGrid[rowIndex][column] = '___';
        span++;
    }
    return span;
}
const oppositeStopsCache = new WeakMap();
function getOppositeStops(stopsData) {
    if (oppositeStopsCache.has(stopsData)) return oppositeStopsCache.get(stopsData);
    const byParent = new Map();
    Object.values(stopsData).forEach((stop)=>{
        if (!stop.parentStopID) return;
        const siblings = byParent.get(stop.parentStopID) || [];
        siblings.push(stop.number);
        byParent.set(stop.parentStopID, siblings);
    });
    const opposites = new Map();
    byParent.forEach((siblings)=>{
        if (siblings.length < 2) return;
        siblings.forEach((stop)=>{
            opposites.set(stop, siblings.find((candidate)=>candidate !== stop));
        });
    });
    oppositeStopsCache.set(stopsData, opposites);
    return opposites;
}
const isOpposite = (stop, oppositeStops)=>oppositeStops.has(stop);
const getOpposite = (stop, oppositeStops)=>oppositeStops.get(stop) || null;
function areOpposite(stop1, stop2, stopsData) {
    if (!stop1 || !stop2 || !stopsData) return false;
    if (stop1 === stop2) return false;
    const stop1Info = stopsData[stop1];
    const stop2Info = stopsData[stop2];
    if (!stop1Info || !stop2Info) return false;
    return stop1Info.parentStopID && stop1Info.parentStopID === stop2Info.parentStopID;
}
function StopsList(props) {
    const route = (0, _getRouteDefault.default)();
    const { routes, stopsData, cityCode, vehicles = [], onVehicleClick, stopTimeLabels } = props;
    if (!routes || !routes.length || !stopsData) return null;
    const oppositeStops = getOppositeStops(stopsData);
    // If there are more than 2 routes, select the 2 routes with the most stops
    let selectedRoutes = routes;
    if (routes.length > 2) {
        // Sort routes by length (number of stops) in descending order
        const sortedRoutes = [
            ...routes
        ].sort((a, b)=>b.length - a.length);
        // Take the top 2 routes with the most stops
        selectedRoutes = sortedRoutes.slice(0, 2);
    }
    // Validate selected routes - ensure at least one route has more than 1 stop
    if (!selectedRoutes.length || !selectedRoutes.some((route)=>route && route.length > 1)) return null;
    const [route1, route2] = selectedRoutes;
    // Ensure route1 exists before proceeding
    if (!route1) return null;
    const route1Len = route1.length;
    if (route1 && route2) {
        route1[0], route2[0];
        route1[route1.length - 1], route2[route2.length - 1];
        route1[route1.length - 1] === route2[0] && (route2[route2.length - 1], route1[0]);
    }
    const route1FirstStop = route1[0];
    const route1LastStop = route1[route1Len - 1];
    const lastStop = (0, _hooks.useRef)();
    // Map vehicles to their positions based on API data
    const vehiclePositions = (0, _hooks.useMemo)(()=>{
        if (!vehicles || vehicles.length === 0) return new Map();
        const positions = new Map();
        vehicles.forEach((vehicle)=>{
            // Use the stop information from the API response
            // Vehicle is between "last" stop and "current/next" stop
            // We'll display the vehicle after the stop it has passed (lastLocationId)
            let stopKey = null;
            if (vehicle.stops) {
                // Priority: lastLocationId > currentLocationId > nextLocationId
                // This determines where we show the vehicle in the route list
                if (vehicle.stops.lastLocationId) stopKey = String(vehicle.stops.lastLocationId);
                else if (vehicle.stops.currentLocationId) stopKey = String(vehicle.stops.currentLocationId);
                else if (vehicle.stops.nextLocationId) {
                    // Vehicles render after their key stop, so to show one before the
                    // next stop it goes after the stop preceding it on the route.
                    stopKey = String(vehicle.stops.nextLocationId);
                    for (const route of [
                        route1,
                        route2
                    ]){
                        const nextIndex = route ? route.indexOf(stopKey) : -1;
                        if (nextIndex > 0) {
                            stopKey = String(route[nextIndex - 1]);
                            break;
                        }
                    }
                }
            }
            if (stopKey) {
                if (!positions.has(stopKey)) positions.set(stopKey, []);
                positions.get(stopKey).push(vehicle);
            }
        });
        return positions;
    }, [
        vehicles,
        route1,
        route2
    ]);
    const StopLink = ({ stop })=>{
        if (!stop || !stopsData[stop]) return null;
        const cityConfig = (0, _cityConfig.getConfigForCity)(route.city);
        const disableStopID = (cityConfig === null || cityConfig === void 0 ? void 0 : cityConfig.disableStopID) || false;
        const stopHref = cityCode && route.city === 'all' ? `#/all/stops/${cityCode}^${stop}` : `#${route.cityPrefix}/stops/${stop}`;
        return (0, _preact.h)("a", {
            href: stopHref,
            "data-stop": stop,
            onClick: (e)=>{
                e.preventDefault();
                // Only drive navigation through the hash — it already triggers
                // the app's hashchange handler, which shows the stop popover.
                // Also calling onStopClick(stop) here used to fire that same
                // popover-setup logic a second time, synchronously, racing the
                // async hashchange-driven one (each with their own setState +
                // requestAnimationFrame + map.setFeatureState calls) — the
                // overlapping renders could wedge Preact's render scheduler,
                // freezing the popover until a full page reload.
                location.hash = stopHref;
                lastStop.current = stop;
            }
        }, disableStopID ? (0, _preact.h)((0, _preact.Fragment), null, stopsData[stop].name) : (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("b", {
            class: "mini-stop-tag"
        }, stop), (0, _preact.h)("br", null), stopsData[stop].name), (stopTimeLabels === null || stopTimeLabels === void 0 ? void 0 : stopTimeLabels[stop]) && (0, _preact.h)("span", {
            class: "stop-eta"
        }, stopTimeLabels[stop]));
    };
    // Render vehicle indicator
    const VehicleIndicator = ({ vehicle })=>(0, _preact.h)((0, _vehicleChipDefault.default), {
            number: vehicle.vehicleNumber,
            load: vehicle.load,
            title: vehicle.serviceType ? `${vehicle.vehicleNumber} - ${vehicle.serviceType}` : vehicle.vehicleNumber,
            onClick: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                if (onVehicleClick && vehicle.vehicleId) onVehicleClick(vehicle.vehicleId);
            },
            style: {
                cursor: onVehicleClick ? 'pointer' : 'default'
            }
        });
    // Render vehicles after a stop
    const VehiclesAfterStop = ({ stop })=>{
        // Ensure stop is a string for consistent lookup
        const stopKey = String(stop);
        const vehiclesHere = vehiclePositions.get(stopKey);
        if (!vehiclesHere || vehiclesHere.length === 0) return null;
        return (0, _preact.h)("div", {
            class: "vehicles-at-stop"
        }, vehiclesHere.map((vehicle)=>(0, _preact.h)(VehicleIndicator, {
                key: vehicle.vehicleId,
                vehicle: vehicle
            })));
    };
    // Only 1 route & not a loop
    if (!route2 && route1FirstStop !== route1LastStop) {
        // Contains duplicates
        new Set(route1).size, route1.length;
        return (0, _preact.h)("ol", {
            class: "stops-list"
        }, route1.map((s, index)=>(0, _preact.h)("li", {
                key: `${s}-${index}`
            }, (0, _preact.h)(StopLink, {
                stop: s
            }), (0, _preact.h)(VehiclesAfterStop, {
                stop: s
            }))));
    } else {
        // Complex table layout for complex routes yo
        const stopGrid = [];
        // Create mutable copies
        let route1Copy, route2Copy;
        let loopRoute = false; // A->A
        if (route2) {
            route1Copy = route1.slice();
            route2Copy = route2.slice().reverse(); // Reverse for easier index reference
        } else {
            // Mostly likely a loop route A⟲B
            // So, split route1 into two routes
            loopRoute = true;
            let half;
            let hasMidStop = false;
            const hasDupStops = [];
            for(let i = 1, j = route1Len - 2; route1Len > 3 && !half; i++, j--){
                const stop = route1[i];
                // console.log(i, j, route1, 1, stop);
                if (isOpposite(stop, oppositeStops)) {
                    // WEIRD CASE: the route has duplicate stops!
                    // Don't check first item because last item is its duplicate in loop route
                    if (i !== route1.lastIndexOf(stop)) // TODO: Handle this usecase?
                    // Do nothing for now
                    hasDupStops.push(stop);
                    else {
                        // Normal case, let's find the middle index
                        const opStop = getOpposite(route1[i], oppositeStops);
                        if (opStop) {
                            const index = route1.lastIndexOf(opStop);
                            if (index > 0) j = index;
                        }
                    }
                }
                if (i === j - 1) half = j;
                else if (i === j) {
                    half = j;
                    hasMidStop = true;
                }
            }
            hasDupStops.length;
            route1Copy = route1.slice(0, half);
            route2Copy = route1.slice(-(route1Len - half - (hasMidStop ? 1 : 0))).reverse();
            // console.log('x', half, route1, route1Copy, route2Copy);
            /*
      const half = Math.floor(route1Len / 2);
      route1Copy = route1.slice(0, half);
      route2Copy = route1.slice(-half).reverse();
      */ if (hasMidStop) {
                // Odd
                const midStop = route1[half];
                if (areOpposite(midStop, route1[half - 1], stopsData)) {
                    // ~~~ = Dummy stop to connect at the end
                    route2Copy.push(midStop, '~~~');
                    route1Copy.push('~~~');
                } else if (areOpposite(midStop, route1[half + 1], stopsData)) {
                    route1Copy.push(midStop, '~~~');
                    route2Copy.push('~~~');
                } else {
                    // Throw in both because it'll be merged and rendered as a single stop later
                    route1Copy.push(midStop);
                    route2Copy.push(midStop);
                }
            } else {
                // Even
                route1Copy.push('~~~');
                route2Copy.push('~~~');
            }
        }
        // const oppositeStops = [];
        // route1Copy.forEach((s, i) => {
        //   const opS = getOpposite(s);
        //   if (opS) {
        //     if (
        //       route2Copy.includes(opS) &&
        //       !route1Copy.includes(opS) &&
        //       !route2Copy.includes(s)
        //     ) {
        //       oppositeStops.push(s, opS);
        //     }
        //   }
        // });
        let i = 0;
        const maxLoopCount = route1Copy.length + route2Copy.length;
        let col1IsEmpty = true, col2IsEmpty = true;
        let col1FirstStop = false, col2FirstStop = false, col1LastStop = false, col2LastStop = false;
        do {
            var _stopGrid_i, _stopGrid_i1, _stopGrid_i2, _stopGrid_i3, _stopGrid_i4, _stopGrid_i5, // Final metadata push
            _stopGrid_i6;
            const stop1Opposite = getOpposite(route1Copy[0], oppositeStops);
            const stop2Opposite = getOpposite(route2Copy[0], oppositeStops);
            const stop1HasOpposite = stop1Opposite && route2Copy.includes(stop1Opposite);
            const stop2HasOpposite = stop2Opposite && route1Copy.includes(stop2Opposite);
            const stop1IsLast = route1Copy.length === 1 || !route1Copy.length;
            const stop2IsLast = route2Copy.length === 1 || !route2Copy.length;
            if (loopRoute && i === 0) stopGrid[i] = [
                route1Copy.shift(),
                route2Copy.shift()
            ];
            else if (stop1HasOpposite && !stop2HasOpposite || stop1IsLast && !stop1HasOpposite && !stop2IsLast && !stop2HasOpposite) stopGrid[i] = [
                null,
                route2Copy.shift()
            ];
            else if (!stop1HasOpposite && stop2HasOpposite || stop2IsLast && !stop2HasOpposite && !stop1IsLast && !stop1HasOpposite) stopGrid[i] = [
                route1Copy.shift(),
                null
            ];
            else stopGrid[i] = [
                route1Copy.shift(),
                route2Copy.shift()
            ];
            // Check empty columns
            if (((_stopGrid_i = stopGrid[i]) === null || _stopGrid_i === void 0 ? void 0 : _stopGrid_i[0]) && col1IsEmpty) col1IsEmpty = false;
            else if (!((_stopGrid_i1 = stopGrid[i]) === null || _stopGrid_i1 === void 0 ? void 0 : _stopGrid_i1[0]) && !route1Copy.length) col1IsEmpty = true;
            if (((_stopGrid_i2 = stopGrid[i]) === null || _stopGrid_i2 === void 0 ? void 0 : _stopGrid_i2[1]) && col2IsEmpty) col2IsEmpty = false;
            else if (!((_stopGrid_i3 = stopGrid[i]) === null || _stopGrid_i3 === void 0 ? void 0 : _stopGrid_i3[1]) && !route2Copy.length) col2IsEmpty = true;
            // Extra metadata
            const metadata = {
                isSame: stopGrid[i][0] === stopGrid[i][1],
                // Same stop (very lazy check, no snapping)
                isOpposite: areOpposite(stopGrid[i][0], stopGrid[i][1], stopsData),
                col1IsEmpty,
                col2IsEmpty
            };
            // Check first/last stops
            if (((_stopGrid_i4 = stopGrid[i]) === null || _stopGrid_i4 === void 0 ? void 0 : _stopGrid_i4[0]) && !col1FirstStop) metadata.col1FirstStop = col1FirstStop = true;
            if (((_stopGrid_i5 = stopGrid[i]) === null || _stopGrid_i5 === void 0 ? void 0 : _stopGrid_i5[1]) && !col2FirstStop) metadata.col2FirstStop = col2FirstStop = true;
            if (!route1Copy.length && !col1LastStop) metadata.col1LastStop = col1LastStop = true;
            if (!route2Copy.length && !col2LastStop) metadata.col2LastStop = col2LastStop = true;
            (_stopGrid_i6 = stopGrid[i]) === null || _stopGrid_i6 === void 0 ? void 0 : _stopGrid_i6.push(metadata);
            // Infinite loop guard
            if (i > maxLoopCount + 2) return null;
            i++;
        }while (route1Copy[0] || route2Copy[0]);
        // Postfix for loop routes (A->A)
        if (loopRoute) {
            const lastRow = stopGrid[stopGrid.length - 1];
            const last2ndRow = stopGrid[stopGrid.length - 2];
            if (lastRow[0] === lastRow[1] && (last2ndRow === null || last2ndRow === void 0 ? void 0 : last2ndRow.includes(null))) {
                const [s1, s2, meta] = last2ndRow;
                if (lastRow[0] === '~~~') {
                    const theStop = /\d/.test(s1) ? s1 : s2;
                    stopGrid[stopGrid.length - 2] = [
                        theStop,
                        theStop,
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, meta), {
                            col1LastStop: true,
                            col2LastStop: true
                        })
                    ];
                    stopGrid.pop();
                } else if (lastRow[0]) {
                    if (!s1) last2ndRow[0] = lastRow[0];
                    if (!s2) last2ndRow[1] = lastRow[0];
                    if (!s1 || !s2) stopGrid[stopGrid.length - 1] = [
                        '~~~',
                        '~~~',
                        {
                            col1LastStop: true,
                            col2LastStop: true
                        }
                    ];
                }
            }
        }
        const stopGridStops = [
            ...new Set(stopGrid.flat().filter((value)=>typeof value === 'string' && /\d/.test(value)))
        ];
        const routeStops = [
            ...new Set([
                ...route1,
                ...route2 || []
            ])
        ];
        stopGridStops.length, routeStops.length;
        return (0, _preact.h)("table", {
            class: "stops-table"
        }, (0, _preact.h)("colgroup", null, (0, _preact.h)("col", {
            class: "stop"
        }), (0, _preact.h)("col", {
            class: "middle"
        }), (0, _preact.h)("col", {
            class: "stop"
        })), stopGrid.map(([s1, s2, { isSame, isOpposite, col1IsEmpty, col2IsEmpty, col1FirstStop, col2FirstStop, col1LastStop, col2LastStop }], index)=>{
            const isEdgeRows = (index === 0 || index === stopGrid.length - 1) && s1 === s2;
            return (0, _preact.h)((0, _preact.Fragment), {
                key: `row-${index}`
            }, index === 0 && (0, _preact.h)("tr", null, (0, _preact.h)("td", {
                colspan: "3"
            })), (0, _preact.h)("tr", {
                class: isEdgeRows ? 'edge' : ''
            }, isEdgeRows ? (0, _preact.h)("td", {
                class: `stop-${s1 === '~~~' ? 'u' : index === 0 ? 'start' : 'end'} ${loopRoute ? 'loop' : ''}`,
                colspan: "3"
            }, s1 !== '~~~' && (0, _preact.h)(StopLink, {
                stop: s1
            }), s1 !== '~~~' && (0, _preact.h)(VehiclesAfterStop, {
                stop: s1
            })) : (0, _preact.h)((0, _preact.Fragment), null, s1 ? s1 !== '___' && (0, _preact.h)("td", {
                class: `${col1IsEmpty ? '' : 'stop'} ${col1FirstStop ? 'first' : ''} ${col1LastStop ? 'last' : ''}`,
                rowspan: isOpposite || index === stopGrid.length - 1 || index === 0 ? 1 : rowSpaner(stopGrid, 0, index)
            }, (0, _preact.h)(StopLink, {
                stop: s1
            }), (0, _preact.h)(VehiclesAfterStop, {
                stop: s1
            })) : (0, _preact.h)("td", {
                class: col1IsEmpty ? '' : 'empty'
            }), (0, _preact.h)("td", {
                class: isOpposite ? 'opposite' : isSame ? 'same' : ''
            }), s2 ? s2 !== '___' && (0, _preact.h)("td", {
                class: `${col2IsEmpty ? '' : 'stop'} ${col2FirstStop ? 'first' : ''} ${col2LastStop ? 'last' : ''}`,
                rowspan: isOpposite || index === stopGrid.length - 1 || index === 0 ? 1 : rowSpaner(stopGrid, 1, index)
            }, (0, _preact.h)(StopLink, {
                stop: s2
            }), (0, _preact.h)(VehiclesAfterStop, {
                stop: s2
            })) : (0, _preact.h)("td", {
                class: col2IsEmpty ? '' : 'empty'
            }))));
        }));
    }
    return null;
}
exports.default = (0, _compat.memo)(StopsList);

},{"@swc/helpers/_/_object_spread":"2eaR5","@swc/helpers/_/_object_spread_props":"kR5CL","preact":"ej31g","preact/hooks":"gK13j","preact/compat":"9Fh1y","../utils/getRoute":"kYEZr","../city-config":"7oMBO","./VehicleChip":"8XQvj","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"25zZC":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1mZqJ");

},{}],"cM1DV":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("eVywM");

},{}],"8K34h":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("d20QM");

},{}],"i17Kp":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("bEn0N");

},{}],"fObxN":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kOgQG");

},{}],"faAC3":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5wan8");

},{}],"4RZ4f":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("73tV7");

},{}],"dtx4r":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("6BQE0");

},{}],"lFVpO":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("djSW0");

},{}],"5me7G":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3cARN");

},{}]},["gwEZR","iC1JR"], "iC1JR", "parcelRequire5b81", {}, "./", "/")

//# sourceMappingURL=transitrouter.be8905a8.js.map
